import pr, { useState as Pr, useEffect as bt, createContext as Qv, forwardRef as em, createElement as yr, useContext as tm, useImperativeHandle as rm, Children as wl, useRef as Xn, useReducer as nm, useCallback as Je, useMemo as hf, useLayoutEffect as im, Component as am, Fragment as sm } from "react";
import { Button as oo, ActionIcon as ir, CopyButton as om, Tooltip as um, Menu as Xe, Card as Gt, Group as ee, Skeleton as Ge, Divider as yf, SimpleGrid as uo, Stack as Ue, NavLink as Cn, Title as _t, ThemeIcon as lm, Text as Ve, Paper as cm, Center as jt, Container as fm, Grid as Vt, Checkbox as qi, Table as ut, Badge as Sl, Modal as uh, JsonInput as lh, useCombobox as ch, Pill as gf, Combobox as Bt, CheckIcon as dm, PillsInput as pf, Select as xl, Box as lt, Input as Zi, Textarea as fh, FileInput as hm, Image as dh, TextInput as Ru, NumberInput as vf, CloseButton as ym, PasswordInput as gm, Radio as An, Slider as pm, Switch as vm, Accordion as gs, Fieldset as mm, Anchor as hu, Avatar as Iu, Loader as bm, AppShell as yu, ScrollArea as _m, Tabs as ps, Pagination as wm } from "@mantine/core";
import { NavLink as Ra, useNavigate as lo } from "react-router-dom";
import { useDisclosure as hh } from "@mantine/hooks";
import { DatePickerInput as Sm } from "@mantine/dates";
const xm = {
  roleName: "Admin",
  permissionStatements: [
    {
      Effect: "Allow",
      Action: ["*"],
      Resource: "*"
    }
  ]
}, Tl = "-pac-app-rbac", Tm = {
  Admin: "^admin",
  PowerUser: "^power_user$",
  PowerUserReadOnly: "^power_user_readonly$",
  TenantAdmin: "^tenant_admin",
  AppAdmin: "^app_admin",
  ServiceAdmin: "^service_admin",
  UserAdmin: "^user_admin",
  AppDeveloper: "^developer",
  User: "^us-west-2_"
}, Em = [], Om = {
  roles: [
    { name: "Admin" },
    { name: "PowerUser" },
    { name: "PowerUserReadOnly" },
    { name: "TenantAdmin" },
    { name: "AppAdmin" },
    { name: "ServiceAdmin" },
    { name: "UserAdmin" },
    { name: "AppDeveloper" },
    { name: "User" }
  ],
  policies: [],
  statements: [],
  routes: {
    "/applications/{id}-get": {
      path: "/applications/{id}",
      httpMethod: "GET",
      actionName: "GetApplication"
    }
  },
  permissions: Em.concat(xm)
}, Cm = (e, r, t) => (console.log("RBAC EVALUATE RESOURCE ", t), km(e, r)), km = (e, r) => {
  const t = e.Action;
  return Array.isArray(t) ? t.indexOf("*") !== -1 || // Boolean(policyAction.indexOf(action) !== -1)
  !!t.includes(r) : t === "*" || t === r;
}, V9 = (e, r) => {
  const t = e.Resource;
  return typeof t == "object" && t instanceof Array ? t.indexOf("*") !== -1 || t.indexOf(r) !== -1 : t === "*" || t === r;
};
var Dm = "Logging", jm = globalThis && globalThis.__values || function(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ai = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, Ri = globalThis && globalThis.__spreadArray || function(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}, mf = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5
}, dr;
(function(e) {
  e.DEBUG = "DEBUG", e.ERROR = "ERROR", e.INFO = "INFO", e.WARN = "WARN", e.VERBOSE = "VERBOSE";
})(dr || (dr = {}));
var et = (
  /** @class */
  function() {
    function e(r, t) {
      t === void 0 && (t = dr.WARN), this.name = r, this.level = t, this._pluggables = [];
    }
    return e.prototype._padding = function(r) {
      return r < 10 ? "0" + r : "" + r;
    }, e.prototype._ts = function() {
      var r = /* @__PURE__ */ new Date();
      return [this._padding(r.getMinutes()), this._padding(r.getSeconds())].join(":") + "." + r.getMilliseconds();
    }, e.prototype.configure = function(r) {
      return r ? (this._config = r, this._config) : this._config;
    }, e.prototype._log = function(r) {
      for (var t, n, a = [], i = 1; i < arguments.length; i++)
        a[i - 1] = arguments[i];
      var o = this.level;
      e.LOG_LEVEL && (o = e.LOG_LEVEL), typeof window < "u" && window.LOG_LEVEL && (o = window.LOG_LEVEL);
      var l = mf[o], h = mf[r];
      if (h >= l) {
        var s = console.log.bind(console);
        r === dr.ERROR && console.error && (s = console.error.bind(console)), r === dr.WARN && console.warn && (s = console.warn.bind(console));
        var f = "[".concat(r, "] ").concat(this._ts(), " ").concat(this.name), p = "";
        if (a.length === 1 && typeof a[0] == "string")
          p = "".concat(f, " - ").concat(a[0]), s(p);
        else if (a.length === 1)
          p = "".concat(f, " ").concat(a[0]), s(f, a[0]);
        else if (typeof a[0] == "string") {
          var m = a.slice(1);
          m.length === 1 && (m = m[0]), p = "".concat(f, " - ").concat(a[0], " ").concat(m), s("".concat(f, " - ").concat(a[0]), m);
        } else
          p = "".concat(f, " ").concat(a), s(f, a);
        try {
          for (var w = jm(this._pluggables), S = w.next(); !S.done; S = w.next()) {
            var E = S.value, x = { message: p, timestamp: Date.now() };
            E.pushLogs([x]);
          }
        } catch (j) {
          t = { error: j };
        } finally {
          try {
            S && !S.done && (n = w.return) && n.call(w);
          } finally {
            if (t)
              throw t.error;
          }
        }
      }
    }, e.prototype.log = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.INFO], Ai(r), !1));
    }, e.prototype.info = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.INFO], Ai(r), !1));
    }, e.prototype.warn = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.WARN], Ai(r), !1));
    }, e.prototype.error = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.ERROR], Ai(r), !1));
    }, e.prototype.debug = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.DEBUG], Ai(r), !1));
    }, e.prototype.verbose = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      this._log.apply(this, Ri([dr.VERBOSE], Ai(r), !1));
    }, e.prototype.addPluggable = function(r) {
      r && r.getCategoryName() === Dm && (this._pluggables.push(r), r.configure(this._config));
    }, e.prototype.listPluggables = function() {
      return this._pluggables;
    }, e.LOG_LEVEL = null, e;
  }()
), Mm = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, gu = new et("Amplify"), Pm = (
  /** @class */
  function() {
    function e() {
      this._components = [], this._config = {}, this._modules = {}, this.Auth = null, this.Analytics = null, this.API = null, this.Credentials = null, this.Storage = null, this.I18n = null, this.Cache = null, this.PubSub = null, this.Interactions = null, this.Pushnotification = null, this.UI = null, this.XR = null, this.Predictions = null, this.DataStore = null, this.Geo = null, this.Notifications = null, this.Logger = et, this.ServiceWorker = null;
    }
    return e.prototype.register = function(r) {
      gu.debug("component registered in amplify", r), this._components.push(r), typeof r.getModuleName == "function" ? (this._modules[r.getModuleName()] = r, this[r.getModuleName()] = r) : gu.debug("no getModuleName method for component", r), r.configure(this._config);
    }, e.prototype.configure = function(r) {
      var t = this;
      return r ? (this._config = Object.assign(this._config, r), gu.debug("amplify config", this._config), Object.entries(this._modules).forEach(function(n) {
        var a = Mm(n, 2);
        a[0];
        var i = a[1];
        Object.keys(i).forEach(function(o) {
          t._modules[o] && (i[o] = t._modules[o]);
        });
      }), this._components.map(function(n) {
        n.configure(t._config);
      }), this._config) : this._config;
    }, e.prototype.addPluggable = function(r) {
      r && r.getCategory && typeof r.getCategory == "function" && this._components.map(function(t) {
        t.addPluggable && typeof t.addPluggable == "function" && t.addPluggable(r);
      });
    }, e;
  }()
), Ka = new Pm(), We;
(function(e) {
  e.WebUnknown = "0", e.React = "1", e.NextJs = "2", e.Angular = "3", e.VueJs = "4", e.Nuxt = "5", e.Svelte = "6", e.ServerSideUnknown = "100", e.ReactSSR = "101", e.NextJsSSR = "102", e.AngularSSR = "103", e.VueJsSSR = "104", e.NuxtSSR = "105", e.SvelteSSR = "106", e.ReactNative = "201", e.Expo = "202";
})(We || (We = {}));
var Nu;
(function(e) {
  e.API = "api", e.Auth = "auth", e.Analytics = "analytics", e.DataStore = "datastore", e.Geo = "geo", e.InAppMessaging = "inappmessaging", e.Interactions = "interactions", e.Predictions = "predictions", e.PubSub = "pubsub", e.PushNotification = "pushnotification", e.Storage = "storage";
})(Nu || (Nu = {}));
var bf;
(function(e) {
  e.Record = "1", e.UpdateEndpoint = "2";
})(bf || (bf = {}));
var _f;
(function(e) {
  e.GraphQl = "1", e.Get = "2", e.Post = "3", e.Put = "4", e.Patch = "5", e.Del = "6", e.Head = "7";
})(_f || (_f = {}));
var wf;
(function(e) {
  e.FederatedSignIn = "30";
})(wf || (wf = {}));
var Sf;
(function(e) {
  e.Subscribe = "1", e.GraphQl = "2";
})(Sf || (Sf = {}));
var xf;
(function(e) {
  e.None = "0";
})(xf || (xf = {}));
var Tf;
(function(e) {
  e.None = "0";
})(Tf || (Tf = {}));
var Ef;
(function(e) {
  e.None = "0";
})(Ef || (Ef = {}));
var Of;
(function(e) {
  e.Convert = "1", e.Identify = "2", e.Interpret = "3";
})(Of || (Of = {}));
var Cf;
(function(e) {
  e.Subscribe = "1";
})(Cf || (Cf = {}));
var kf;
(function(e) {
  e.None = "0";
})(kf || (kf = {}));
var an;
(function(e) {
  e.Put = "1", e.Get = "2", e.List = "3", e.Copy = "4", e.Remove = "5", e.GetProperties = "6";
})(an || (an = {}));
var yh = "5.3.26", co = function() {
  return typeof global < "u";
}, ta = function() {
  return typeof window < "u";
}, gh = function() {
  return typeof document < "u";
}, El = function() {
  return typeof process < "u";
}, Ia = function(e, r) {
  return !!Object.keys(e).find(function(t) {
    return t.startsWith(r);
  });
};
function Am() {
  var e = function(n) {
    return n.startsWith("_react") || n.startsWith("__react");
  }, r = function(n) {
    return Object.keys(n).find(e);
  }, t = function() {
    return Array.from(document.querySelectorAll("[id]"));
  };
  return gh() && t().some(r);
}
function Rm() {
  return El() && typeof process.env < "u" && !!Object.keys(process.env).find(function(e) {
    return e.includes("react");
  });
}
function Im() {
  return ta() && Ia(window, "__VUE");
}
function Nm() {
  return co() && Ia(global, "__VUE");
}
function Lm() {
  return ta() && Ia(window, "__SVELTE");
}
function Fm() {
  return El() && typeof process.env < "u" && !!Object.keys(process.env).find(function(e) {
    return e.includes("svelte");
  });
}
function $m() {
  return ta() && window.next && typeof window.next == "object";
}
function Ym() {
  return co() && (Ia(global, "__next") || Ia(global, "__NEXT"));
}
function Um() {
  return ta() && // @ts-ignore
  (window.__NUXT__ !== void 0 || window.$nuxt !== void 0);
}
function zm() {
  return co() && typeof global.__NUXT_PATHS__ < "u";
}
function Wm() {
  var e = !!(gh() && document.querySelector("[ng-version]")), r = !!// @ts-ignore
  (ta() && typeof window.ng < "u");
  return e || r;
}
function Bm() {
  var e;
  return El() && typeof process.env == "object" && ((e = process.env.npm_lifecycle_script) === null || e === void 0 ? void 0 : e.startsWith("ng ")) || !1;
}
function Hm() {
  return typeof navigator < "u" && typeof navigator.product < "u" && navigator.product === "ReactNative";
}
function Gm() {
  return co() && typeof global.expo < "u";
}
function Vm() {
  return ta();
}
var Km = [
  // First, detect mobile
  { platform: We.Expo, detectionMethod: Gm },
  { platform: We.ReactNative, detectionMethod: Hm },
  // Next, detect web frameworks
  { platform: We.NextJs, detectionMethod: $m },
  { platform: We.Nuxt, detectionMethod: Um },
  { platform: We.Angular, detectionMethod: Wm },
  { platform: We.React, detectionMethod: Am },
  { platform: We.VueJs, detectionMethod: Im },
  { platform: We.Svelte, detectionMethod: Lm },
  { platform: We.WebUnknown, detectionMethod: Vm },
  // Last, detect ssr frameworks
  { platform: We.NextJsSSR, detectionMethod: Ym },
  { platform: We.NuxtSSR, detectionMethod: zm },
  { platform: We.ReactSSR, detectionMethod: Rm },
  { platform: We.VueJsSSR, detectionMethod: Nm },
  { platform: We.AngularSSR, detectionMethod: Bm },
  { platform: We.SvelteSSR, detectionMethod: Fm }
];
function qm() {
  var e;
  return ((e = Km.find(function(r) {
    return r.detectionMethod();
  })) === null || e === void 0 ? void 0 : e.platform) || We.ServerSideUnknown;
}
var xa, Ds = [], Ns = !1, Zm = 10, Jm = 10, Xm = 1e3, Ol = function() {
  if (!xa) {
    if (xa = qm(), Ns)
      for (; Ds.length; )
        Ds.pop()();
    else
      Ds.forEach(function(e) {
        return e();
      });
    Df(We.ServerSideUnknown, Zm), Df(We.WebUnknown, Jm);
  }
  return xa;
}, ph = function(e) {
  Ns || Ds.push(e);
};
function Qm() {
  xa = void 0;
}
function Df(e, r) {
  xa === e && !Ns && setTimeout(function() {
    Qm(), Ns = !0, setTimeout(Ol, Xm);
  }, r);
}
var e2 = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, vh = "aws-amplify";
(function() {
  function e() {
    this.userAgent = "".concat(vh, "/").concat(yh);
  }
  return Object.defineProperty(e.prototype, "framework", {
    get: function() {
      return Ol();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isReactNative", {
    get: function() {
      return this.framework === We.ReactNative || this.framework === We.Expo;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.observeFrameworkChanges = function(r) {
    ph(r);
  }, e;
})();
var t2 = function(e) {
  var r = e === void 0 ? {} : e, t = r.category, n = r.action;
  r.framework;
  var a = [[vh, yh]];
  return t && a.push([t, n]), a.push(["framework", Ol()]), a;
}, fo = function(e) {
  var r = t2(e), t = r.map(function(n) {
    var a = e2(n, 2), i = a[0], o = a[1];
    return "".concat(i, "/").concat(o);
  }).join(" ");
  return t;
}, Ta = globalThis && globalThis.__assign || function() {
  return Ta = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ta.apply(this, arguments);
}, pu = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, jf = globalThis && globalThis.__spreadArray || function(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}, Jr = new et("Hub"), r2 = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function n2(e) {
  return e.onHubCapsule !== void 0;
}
var i2 = (
  /** @class */
  function() {
    function e(r) {
      this.listeners = [], this.patterns = [], this.protectedChannels = [
        "core",
        "auth",
        "api",
        "analytics",
        "interactions",
        "pubsub",
        "storage",
        "ui",
        "xr"
      ], this.name = r;
    }
    return e.prototype._remove = function(r, t) {
      if (r instanceof RegExp) {
        var n = this.patterns.find(function(i) {
          var o = i.pattern;
          return o.source === r.source;
        });
        if (!n) {
          Jr.warn("No listeners for ".concat(r));
          return;
        }
        this.patterns = jf([], pu(this.patterns.filter(function(i) {
          return i !== n;
        })), !1);
      } else {
        var a = this.listeners[r];
        if (!a) {
          Jr.warn("No listeners for ".concat(r));
          return;
        }
        this.listeners[r] = jf([], pu(a.filter(function(i) {
          var o = i.callback;
          return o !== t;
        })), !1);
      }
    }, e.prototype.remove = function(r, t) {
      this._remove(r, t);
    }, e.prototype.dispatch = function(r, t, n, a) {
      if (n === void 0 && (n = ""), this.protectedChannels.indexOf(r) > -1) {
        var i = a === r2;
        i || Jr.warn("WARNING: ".concat(r, " is protected and dispatching on it can have unintended consequences"));
      }
      var o = {
        channel: r,
        payload: Ta({}, t),
        source: n,
        patternInfo: []
      };
      try {
        this._toListeners(o);
      } catch (l) {
        Jr.error(l);
      }
    }, e.prototype.listen = function(r, t, n) {
      var a = this;
      n === void 0 && (n = "noname");
      var i;
      if (n2(t))
        Jr.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback."), i = t.onHubCapsule.bind(t);
      else {
        if (typeof t != "function")
          throw new Error("No callback supplied to Hub");
        i = t;
      }
      if (r instanceof RegExp)
        this.patterns.push({
          pattern: r,
          callback: i
        });
      else {
        var o = this.listeners[r];
        o || (o = [], this.listeners[r] = o), o.push({
          name: n,
          callback: i
        });
      }
      return function() {
        a._remove(r, i);
      };
    }, e.prototype._toListeners = function(r) {
      var t = r.channel, n = r.payload, a = this.listeners[t];
      if (a && a.forEach(function(o) {
        Jr.debug("Dispatching to ".concat(t, " with "), n);
        try {
          o.callback(r);
        } catch (l) {
          Jr.error(l);
        }
      }), this.patterns.length > 0) {
        if (!n.message) {
          Jr.warn("Cannot perform pattern matching without a message key");
          return;
        }
        var i = n.message;
        this.patterns.forEach(function(o) {
          var l = i.match(o.pattern);
          if (l) {
            var h = pu(l), s = h.slice(1), f = Ta(Ta({}, r), { patternInfo: s });
            try {
              o.callback(f);
            } catch (p) {
              Jr.error(p);
            }
          }
        });
      }
    }, e;
  }()
), Na = new i2("__default__"), Ls = globalThis && globalThis.__assign || function() {
  return Ls = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ls.apply(this, arguments);
}, a2 = new et("I18n"), Mf = (
  /** @class */
  function() {
    function e(r) {
      this._options = null, this._lang = null, this._dict = {}, this._options = Object.assign({}, r), this._lang = this._options.language, !this._lang && typeof window < "u" && window && window.navigator && (this._lang = window.navigator.language), a2.debug(this._lang);
    }
    return e.prototype.setLanguage = function(r) {
      this._lang = r;
    }, e.prototype.get = function(r, t) {
      if (t === void 0 && (t = void 0), !this._lang)
        return typeof t < "u" ? t : r;
      var n = this._lang, a = this.getByLanguage(r, n);
      return a || (n.indexOf("-") > 0 && (a = this.getByLanguage(r, n.split("-")[0])), a) ? a : typeof t < "u" ? t : r;
    }, e.prototype.getByLanguage = function(r, t, n) {
      if (n === void 0 && (n = null), !t)
        return n;
      var a = this._dict[t];
      return a ? a[r] : n;
    }, e.prototype.putVocabulariesForLanguage = function(r, t) {
      var n = this._dict[r];
      n || (n = this._dict[r] = {}), this._dict[r] = Ls(Ls({}, n), t);
    }, e.prototype.putVocabularies = function(r) {
      var t = this;
      Object.keys(r).map(function(n) {
        t.putVocabulariesForLanguage(n, r[n]);
      });
    }, e;
  }()
), Pf = new et("I18n"), Ii = null, En = null, De = (
  /** @class */
  function() {
    function e() {
    }
    return e.configure = function(r) {
      return Pf.debug("configure I18n"), r && (Ii = Object.assign({}, Ii, r.I18n || r), e.createInstance()), Ii;
    }, e.getModuleName = function() {
      return "I18n";
    }, e.createInstance = function() {
      Pf.debug("create I18n instance"), !En && (En = new Mf(Ii));
    }, e.setLanguage = function(r) {
      return e.checkConfig(), En.setLanguage(r);
    }, e.get = function(r, t) {
      return e.checkConfig() ? En.get(r, t) : typeof t > "u" ? r : t;
    }, e.putVocabulariesForLanguage = function(r, t) {
      return e.checkConfig(), En.putVocabulariesForLanguage(r, t);
    }, e.putVocabularies = function(r) {
      return e.checkConfig(), En.putVocabularies(r);
    }, e.checkConfig = function() {
      return En || (En = new Mf(Ii)), !0;
    }, e;
  }()
);
Ka.register(De);
var s2 = function(e) {
  if (e.isResolved)
    return e;
  var r = !0, t = !1, n = !1, a = e.then(function(i) {
    return n = !0, r = !1, i;
  }, function(i) {
    throw t = !0, r = !1, i;
  });
  return a.isFullfilled = function() {
    return n;
  }, a.isPending = function() {
    return r;
  }, a.isRejected = function() {
    return t;
  }, a;
}, ho = function() {
  var e = typeof window < "u" && typeof window.document < "u", r = typeof process < "u" && process.versions != null && process.versions.node != null;
  return {
    isBrowser: e,
    isNode: r
  };
}, o2 = globalThis && globalThis.__extends || function() {
  var e = function(r, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (n[i] = a[i]);
    }, e(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(r, t);
    function n() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Af = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, vu = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, u2 = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, l2 = globalThis && globalThis.__spreadArray || function(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}, vs = new et("Util"), ni = (
  /** @class */
  function(e) {
    o2(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.nonRetryable = !0, n;
    }
    return r;
  }(Error)
), c2 = function(e) {
  var r = "nonRetryable";
  return e && e[r];
};
function f2(e, r, t, n) {
  return Af(this, void 0, void 0, function() {
    var a = this;
    return vu(this, function(i) {
      if (typeof e != "function")
        throw Error("functionToRetry must be a function");
      return [2, new Promise(function(o, l) {
        return Af(a, void 0, void 0, function() {
          var h, s, f, p, m, w, S;
          return vu(this, function(E) {
            switch (E.label) {
              case 0:
                h = 0, s = !1, p = function() {
                }, n && n.then(function() {
                  s = !0, clearTimeout(f), p();
                }), w = function() {
                  var x, j, O, I;
                  return vu(this, function(M) {
                    switch (M.label) {
                      case 0:
                        h++, vs.debug("".concat(e.name, " attempt #").concat(h, " with this vars: ").concat(JSON.stringify(r))), M.label = 1;
                      case 1:
                        return M.trys.push([1, 3, , 7]), x = {}, j = o, [4, e.apply(void 0, l2([], u2(r), !1))];
                      case 2:
                        return [2, (x.value = j.apply(void 0, [M.sent()]), x)];
                      case 3:
                        return O = M.sent(), m = O, vs.debug("error on ".concat(e.name), O), c2(O) ? (vs.debug("".concat(e.name, " non retryable error"), O), [2, { value: l(O) }]) : (I = t(h, r, O), vs.debug("".concat(e.name, " retrying in ").concat(I, " ms")), I === !1 || s ? [2, { value: l(O) }] : [3, 4]);
                      case 4:
                        return [4, new Promise(function(k) {
                          p = k, f = setTimeout(p, I);
                        })];
                      case 5:
                        M.sent(), M.label = 6;
                      case 6:
                        return [3, 7];
                      case 7:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                }, E.label = 1;
              case 1:
                return s ? [3, 3] : [5, w()];
              case 2:
                return S = E.sent(), typeof S == "object" ? [2, S.value] : [3, 1];
              case 3:
                return l(m), [
                  2
                  /*return*/
                ];
            }
          });
        });
      })];
    });
  });
}
var mh = 5 * 60 * 1e3;
function bh(e) {
  e === void 0 && (e = mh);
  var r = 100, t = 100;
  return function(n) {
    var a = Math.pow(2, n) * r + t * Math.random();
    return a > e ? !1 : a;
  };
}
var d2 = function(e, r, t, n) {
  return t === void 0 && (t = mh), f2(e, r, bh(t), n);
}, h2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Cl(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var _h = function(e) {
  return Object.keys(e).map(function(r) {
    return r.toLowerCase();
  }).sort().join(";");
}, y2 = "X-Amz-Algorithm", wh = "X-Amz-Date", g2 = "X-Amz-Credential", p2 = "X-Amz-Expires", v2 = "X-Amz-Signature", m2 = "X-Amz-SignedHeaders", Sh = "X-Amz-Security-Token", b2 = "authorization", Lu = "host", _2 = wh.toLowerCase(), w2 = Sh.toLowerCase(), xh = "aws4_request", kl = "AWS4-HMAC-SHA256", S2 = "AWS4", Th = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855", x2 = "UNSIGNED-PAYLOAD", T2 = function(e, r, t) {
  return "".concat(e, "/").concat(r, "/").concat(t, "/").concat(xh);
}, E2 = function(e) {
  var r = e.toISOString().replace(/[:\-]|\.\d{3}/g, "");
  return {
    longDate: r,
    shortDate: r.slice(0, 8)
  };
}, Eh = function(e) {
  var r = e.credentials, t = e.signingDate, n = t === void 0 ? /* @__PURE__ */ new Date() : t, a = e.signingRegion, i = e.signingService, o = e.uriEscapePath, l = o === void 0 ? !0 : o, h = r.accessKeyId, s = r.secretAccessKey, f = r.sessionToken, p = E2(n), m = p.longDate, w = p.shortDate, S = T2(w, a, i);
  return {
    accessKeyId: h,
    credentialScope: S,
    longDate: m,
    secretAccessKey: s,
    sessionToken: f,
    shortDate: w,
    signingRegion: a,
    signingService: i,
    uriEscapePath: l
  };
}, Oh = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Fu = function(e, r) {
  return Fu = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n)
      n.hasOwnProperty(a) && (t[a] = n[a]);
  }, Fu(e, r);
};
function O2(e, r) {
  Fu(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var $u = function() {
  return $u = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, $u.apply(this, arguments);
};
function C2(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
function k2(e, r, t, n) {
  var a = arguments.length, i = a < 3 ? r : n === null ? n = Object.getOwnPropertyDescriptor(r, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    i = Reflect.decorate(e, r, t, n);
  else
    for (var l = e.length - 1; l >= 0; l--)
      (o = e[l]) && (i = (a < 3 ? o(i) : a > 3 ? o(r, t, i) : o(r, t)) || i);
  return a > 3 && i && Object.defineProperty(r, t, i), i;
}
function D2(e, r) {
  return function(t, n) {
    r(t, n, e);
  };
}
function j2(e, r) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, r);
}
function M2(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}
function P2(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
function A2(e, r, t, n) {
  n === void 0 && (n = t), e[n] = r[t];
}
function R2(e, r) {
  for (var t in e)
    t !== "default" && !r.hasOwnProperty(t) && (r[t] = e[t]);
}
function Yu(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ch(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}
function I2() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e = e.concat(Ch(arguments[r]));
  return e;
}
function N2() {
  for (var e = 0, r = 0, t = arguments.length; r < t; r++)
    e += arguments[r].length;
  for (var n = Array(e), a = 0, r = 0; r < t; r++)
    for (var i = arguments[r], o = 0, l = i.length; o < l; o++, a++)
      n[a] = i[o];
  return n;
}
function La(e) {
  return this instanceof La ? (this.v = e, this) : new La(e);
}
function L2(e, r, t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = t.apply(e, r || []), a, i = [];
  return a = {}, o("next"), o("throw"), o("return"), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function o(m) {
    n[m] && (a[m] = function(w) {
      return new Promise(function(S, E) {
        i.push([m, w, S, E]) > 1 || l(m, w);
      });
    });
  }
  function l(m, w) {
    try {
      h(n[m](w));
    } catch (S) {
      p(i[0][3], S);
    }
  }
  function h(m) {
    m.value instanceof La ? Promise.resolve(m.value.v).then(s, f) : p(i[0][2], m);
  }
  function s(m) {
    l("next", m);
  }
  function f(m) {
    l("throw", m);
  }
  function p(m, w) {
    m(w), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function F2(e) {
  var r, t;
  return r = {}, n("next"), n("throw", function(a) {
    throw a;
  }), n("return"), r[Symbol.iterator] = function() {
    return this;
  }, r;
  function n(a, i) {
    r[a] = e[a] ? function(o) {
      return (t = !t) ? { value: La(e[a](o)), done: a === "return" } : i ? i(o) : o;
    } : i;
  }
}
function $2(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = e[Symbol.asyncIterator], t;
  return r ? r.call(e) : (e = typeof Yu == "function" ? Yu(e) : e[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(i) {
    t[i] = e[i] && function(o) {
      return new Promise(function(l, h) {
        o = e[i](o), a(l, h, o.done, o.value);
      });
    };
  }
  function a(i, o, l, h) {
    Promise.resolve(h).then(function(s) {
      i({ value: s, done: l });
    }, o);
  }
}
function Y2(e, r) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: r }) : e.raw = r, e;
}
function U2(e) {
  if (e && e.__esModule)
    return e;
  var r = {};
  if (e != null)
    for (var t in e)
      Object.hasOwnProperty.call(e, t) && (r[t] = e[t]);
  return r.default = e, r;
}
function z2(e) {
  return e && e.__esModule ? e : { default: e };
}
function W2(e, r) {
  if (!r.has(e))
    throw new TypeError("attempted to get private field on non-instance");
  return r.get(e);
}
function B2(e, r, t) {
  if (!r.has(e))
    throw new TypeError("attempted to set private field on non-instance");
  return r.set(e, t), t;
}
const H2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return $u;
  },
  __asyncDelegator: F2,
  __asyncGenerator: L2,
  __asyncValues: $2,
  __await: La,
  __awaiter: M2,
  __classPrivateFieldGet: W2,
  __classPrivateFieldSet: B2,
  __createBinding: A2,
  __decorate: k2,
  __exportStar: R2,
  __extends: O2,
  __generator: P2,
  __importDefault: z2,
  __importStar: U2,
  __makeTemplateObject: Y2,
  __metadata: j2,
  __param: D2,
  __read: Ch,
  __rest: C2,
  __spread: I2,
  __spreadArrays: N2,
  __values: Yu
}, Symbol.toStringTag, { value: "Module" })), kh = /* @__PURE__ */ Cl(H2);
var go = {}, Ht = {};
Object.defineProperty(Ht, "__esModule", { value: !0 });
Ht.MAX_HASHABLE_LENGTH = Ht.INIT = Ht.KEY = Ht.DIGEST_LENGTH = Ht.BLOCK_SIZE = void 0;
Ht.BLOCK_SIZE = 64;
Ht.DIGEST_LENGTH = 32;
Ht.KEY = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
Ht.INIT = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
];
Ht.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
var po = {};
Object.defineProperty(po, "__esModule", { value: !0 });
po.RawSha256 = void 0;
var er = Ht, G2 = (
  /** @class */
  function() {
    function e() {
      this.state = Int32Array.from(er.INIT), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return e.prototype.update = function(r) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var t = 0, n = r.byteLength;
      if (this.bytesHashed += n, this.bytesHashed * 8 > er.MAX_HASHABLE_LENGTH)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; n > 0; )
        this.buffer[this.bufferLength++] = r[t++], n--, this.bufferLength === er.BLOCK_SIZE && (this.hashBuffer(), this.bufferLength = 0);
    }, e.prototype.digest = function() {
      if (!this.finished) {
        var r = this.bytesHashed * 8, t = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), n = this.bufferLength;
        if (t.setUint8(this.bufferLength++, 128), n % er.BLOCK_SIZE >= er.BLOCK_SIZE - 8) {
          for (var a = this.bufferLength; a < er.BLOCK_SIZE; a++)
            t.setUint8(a, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var a = this.bufferLength; a < er.BLOCK_SIZE - 8; a++)
          t.setUint8(a, 0);
        t.setUint32(er.BLOCK_SIZE - 8, Math.floor(r / 4294967296), !0), t.setUint32(er.BLOCK_SIZE - 4, r), this.hashBuffer(), this.finished = !0;
      }
      for (var i = new Uint8Array(er.DIGEST_LENGTH), a = 0; a < 8; a++)
        i[a * 4] = this.state[a] >>> 24 & 255, i[a * 4 + 1] = this.state[a] >>> 16 & 255, i[a * 4 + 2] = this.state[a] >>> 8 & 255, i[a * 4 + 3] = this.state[a] >>> 0 & 255;
      return i;
    }, e.prototype.hashBuffer = function() {
      for (var r = this, t = r.buffer, n = r.state, a = n[0], i = n[1], o = n[2], l = n[3], h = n[4], s = n[5], f = n[6], p = n[7], m = 0; m < er.BLOCK_SIZE; m++) {
        if (m < 16)
          this.temp[m] = (t[m * 4] & 255) << 24 | (t[m * 4 + 1] & 255) << 16 | (t[m * 4 + 2] & 255) << 8 | t[m * 4 + 3] & 255;
        else {
          var w = this.temp[m - 2], S = (w >>> 17 | w << 15) ^ (w >>> 19 | w << 13) ^ w >>> 10;
          w = this.temp[m - 15];
          var E = (w >>> 7 | w << 25) ^ (w >>> 18 | w << 14) ^ w >>> 3;
          this.temp[m] = (S + this.temp[m - 7] | 0) + (E + this.temp[m - 16] | 0);
        }
        var x = (((h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7)) + (h & s ^ ~h & f) | 0) + (p + (er.KEY[m] + this.temp[m] | 0) | 0) | 0, j = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & i ^ a & o ^ i & o) | 0;
        p = f, f = s, s = h, h = l + x | 0, l = o, o = i, i = a, a = x + j | 0;
      }
      n[0] += a, n[1] += i, n[2] += o, n[3] += l, n[4] += h, n[5] += s, n[6] += f, n[7] += p;
    }, e;
  }()
);
po.RawSha256 = G2;
var Dh = {}, vo = {}, V2 = function(e) {
  for (var r = [], t = 0, n = e.length; t < n; t++) {
    var a = e.charCodeAt(t);
    if (a < 128)
      r.push(a);
    else if (a < 2048)
      r.push(a >> 6 | 192, a & 63 | 128);
    else if (t + 1 < e.length && (a & 64512) === 55296 && (e.charCodeAt(t + 1) & 64512) === 56320) {
      var i = 65536 + ((a & 1023) << 10) + (e.charCodeAt(++t) & 1023);
      r.push(i >> 18 | 240, i >> 12 & 63 | 128, i >> 6 & 63 | 128, i & 63 | 128);
    } else
      r.push(a >> 12 | 224, a >> 6 & 63 | 128, a & 63 | 128);
  }
  return Uint8Array.from(r);
}, K2 = function(e) {
  for (var r = "", t = 0, n = e.length; t < n; t++) {
    var a = e[t];
    if (a < 128)
      r += String.fromCharCode(a);
    else if (192 <= a && a < 224) {
      var i = e[++t];
      r += String.fromCharCode((a & 31) << 6 | i & 63);
    } else if (240 <= a && a < 365) {
      var o = [a, e[++t], e[++t], e[++t]], l = "%" + o.map(function(h) {
        return h.toString(16);
      }).join("%");
      r += decodeURIComponent(l);
    } else
      r += String.fromCharCode((a & 15) << 12 | (e[++t] & 63) << 6 | e[++t] & 63);
  }
  return r;
};
function q2(e) {
  return new TextEncoder().encode(e);
}
function Z2(e) {
  return new TextDecoder("utf-8").decode(e);
}
var jh = function(e) {
  return typeof TextEncoder == "function" ? q2(e) : V2(e);
}, J2 = function(e) {
  return typeof TextDecoder == "function" ? Z2(e) : K2(e);
};
const X2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromUtf8: jh,
  toUtf8: J2
}, Symbol.toStringTag, { value: "Module" })), Q2 = /* @__PURE__ */ Cl(X2);
Object.defineProperty(vo, "__esModule", { value: !0 });
vo.convertToBuffer = void 0;
var eb = Q2, tb = typeof Buffer < "u" && Buffer.from ? function(e) {
  return Buffer.from(e, "utf8");
} : eb.fromUtf8;
function rb(e) {
  return e instanceof Uint8Array ? e : typeof e == "string" ? tb(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e);
}
vo.convertToBuffer = rb;
var mo = {};
Object.defineProperty(mo, "__esModule", { value: !0 });
mo.isEmptyData = void 0;
function nb(e) {
  return typeof e == "string" ? e.length === 0 : e.byteLength === 0;
}
mo.isEmptyData = nb;
var bo = {};
Object.defineProperty(bo, "__esModule", { value: !0 });
bo.numToUint8 = void 0;
function ib(e) {
  return new Uint8Array([
    (e & 4278190080) >> 24,
    (e & 16711680) >> 16,
    (e & 65280) >> 8,
    e & 255
  ]);
}
bo.numToUint8 = ib;
var _o = {};
Object.defineProperty(_o, "__esModule", { value: !0 });
_o.uint32ArrayFrom = void 0;
function ab(e) {
  if (!Array.from) {
    for (var r = new Uint32Array(e.length), t = 0; t < e.length; )
      r[t] = e[t];
    return r;
  }
  return Uint32Array.from(e);
}
_o.uint32ArrayFrom = ab;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.uint32ArrayFrom = e.numToUint8 = e.isEmptyData = e.convertToBuffer = void 0;
  var r = vo;
  Object.defineProperty(e, "convertToBuffer", { enumerable: !0, get: function() {
    return r.convertToBuffer;
  } });
  var t = mo;
  Object.defineProperty(e, "isEmptyData", { enumerable: !0, get: function() {
    return t.isEmptyData;
  } });
  var n = bo;
  Object.defineProperty(e, "numToUint8", { enumerable: !0, get: function() {
    return n.numToUint8;
  } });
  var a = _o;
  Object.defineProperty(e, "uint32ArrayFrom", { enumerable: !0, get: function() {
    return a.uint32ArrayFrom;
  } });
})(Dh);
Object.defineProperty(go, "__esModule", { value: !0 });
go.Sha256 = void 0;
var Rf = kh, Fs = Ht, Uu = po, zu = Dh, sb = (
  /** @class */
  function() {
    function e(r) {
      if (this.hash = new Uu.RawSha256(), r) {
        this.outer = new Uu.RawSha256();
        var t = ob(r), n = new Uint8Array(Fs.BLOCK_SIZE);
        n.set(t);
        for (var a = 0; a < Fs.BLOCK_SIZE; a++)
          t[a] ^= 54, n[a] ^= 92;
        this.hash.update(t), this.outer.update(n);
        for (var a = 0; a < t.byteLength; a++)
          t[a] = 0;
      }
    }
    return e.prototype.update = function(r) {
      if (!((0, zu.isEmptyData)(r) || this.error))
        try {
          this.hash.update((0, zu.convertToBuffer)(r));
        } catch (t) {
          this.error = t;
        }
    }, e.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, e.prototype.digest = function() {
      return (0, Rf.__awaiter)(this, void 0, void 0, function() {
        return (0, Rf.__generator)(this, function(r) {
          return [2, this.digestSync()];
        });
      });
    }, e;
  }()
);
go.Sha256 = sb;
function ob(e) {
  var r = (0, zu.convertToBuffer)(e);
  if (r.byteLength > Fs.BLOCK_SIZE) {
    var t = new Uu.RawSha256();
    t.update(r), r = t.digest();
  }
  var n = new Uint8Array(Fs.BLOCK_SIZE);
  return n.set(r), n;
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var r = kh;
  (0, r.__exportStar)(go, e);
})(Oh);
var Mh = {};
for (var ms = 0; ms < 256; ms++) {
  var bs = ms.toString(16).toLowerCase();
  bs.length === 1 && (bs = "0" + bs), Mh[ms] = bs;
}
function ub(e) {
  for (var r = "", t = 0; t < e.byteLength; t++)
    r += Mh[e[t]];
  return r;
}
var wa = function(e, r) {
  var t = new Oh.Sha256(e);
  t.update(r);
  var n = t.digestSync();
  return n;
}, Wu = function(e, r) {
  var t = wa(e, r);
  return ub(t);
}, lb = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, cb = function(e) {
  return Object.entries(e).map(function(r) {
    var t, n = lb(r, 2), a = n[0], i = n[1];
    return {
      key: a.toLowerCase(),
      value: (t = i == null ? void 0 : i.trim().replace(/\s+/g, " ")) !== null && t !== void 0 ? t : ""
    };
  }).sort(function(r, t) {
    return r.key < t.key ? -1 : 1;
  }).map(function(r) {
    return "".concat(r.key, ":").concat(r.value, `
`);
  }).join("");
}, mu = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, fb = function(e) {
  return Array.from(e).sort(function(r, t) {
    var n = mu(r, 2), a = n[0], i = n[1], o = mu(t, 2), l = o[0], h = o[1];
    return a === l ? i < h ? -1 : 1 : a < l ? -1 : 1;
  }).map(function(r) {
    var t = mu(r, 2), n = t[0], a = t[1];
    return "".concat(If(n), "=").concat(If(a));
  }).join("&");
}, If = function(e) {
  return encodeURIComponent(e).replace(/[!'()*]/g, db);
}, db = function(e) {
  return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
}, hb = function(e, r) {
  return r === void 0 && (r = !0), e ? r ? encodeURIComponent(e).replace(/%2F/g, "/") : e : "/";
}, Ph = function(e) {
  if (e == null)
    return Th;
  if (yb(e)) {
    var r = Wu(null, e);
    return r;
  }
  return x2;
}, yb = function(e) {
  return typeof e == "string" || ArrayBuffer.isView(e) || gb(e);
}, gb = function(e) {
  return typeof ArrayBuffer == "function" && e instanceof ArrayBuffer || Object.prototype.toString.call(e) === "[object ArrayBuffer]";
}, pb = function(e, r) {
  var t = e.body, n = e.headers, a = e.method, i = e.url;
  return r === void 0 && (r = !0), [
    a,
    hb(i.pathname, r),
    fb(i.searchParams),
    cb(n),
    _h(n),
    Ph(t)
  ].join(`
`);
}, vb = function(e, r, t, n) {
  var a = "".concat(S2).concat(e), i = wa(a, r), o = wa(i, t), l = wa(o, n), h = wa(l, xh);
  return h;
}, mb = function(e, r, t) {
  return [kl, e, r, t].join(`
`);
}, Ah = function(e, r) {
  var t = r.credentialScope, n = r.longDate, a = r.secretAccessKey, i = r.shortDate, o = r.signingRegion, l = r.signingService, h = r.uriEscapePath, s = pb(e, h), f = Wu(null, s), p = mb(n, t, f), m = Wu(vb(a, i, o, l), p);
  return m;
}, Ea = globalThis && globalThis.__assign || function() {
  return Ea = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ea.apply(this, arguments);
}, bb = function(e, r) {
  var t = Eh(r), n = t.accessKeyId, a = t.credentialScope, i = t.longDate, o = t.sessionToken, l = Ea({}, e.headers);
  l[Lu] = e.url.host, l[_2] = i, o && (l[w2] = o);
  var h = Ea(Ea({}, e), { headers: l }), s = Ah(h, t), f = "Credential=".concat(n, "/").concat(a), p = "SignedHeaders=".concat(_h(l)), m = "Signature=".concat(s);
  return l[b2] = "".concat(kl, " ").concat(f, ", ").concat(p, ", ").concat(m), h;
}, $s = globalThis && globalThis.__assign || function() {
  return $s = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, $s.apply(this, arguments);
}, _b = globalThis && globalThis.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}, wb = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, Sb = function(e, r) {
  var t, n, a, i, o = e.body, l = e.method, h = l === void 0 ? "GET" : l, s = e.url, f = r.expiration, p = _b(r, ["expiration"]), m = Eh(p), w = m.accessKeyId, S = m.credentialScope, E = m.longDate, x = m.sessionToken, j = new URL(s);
  Object.entries($s($s((t = {}, t[y2] = kl, t[g2] = "".concat(w, "/").concat(S), t[wh] = E, t[m2] = Lu, t), f && (n = {}, n[p2] = f.toString(), n)), x && (a = {}, a[Sh] = x, a))).forEach(function(M) {
    var k = wb(M, 2), fe = k[0], ae = k[1];
    j.searchParams.append(fe, ae);
  });
  var O = {
    body: o,
    headers: (i = {}, i[Lu] = s.host, i),
    method: h,
    url: j
  }, I = Ah(O, m);
  return j.searchParams.append(v2, I), j;
}, Ys = globalThis && globalThis.__assign || function() {
  return Ys = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ys.apply(this, arguments);
}, xb = new et("Parser"), Dl = function(e) {
  var r = {};
  if (e.aws_mobile_analytics_app_id) {
    var t = {
      AWSPinpoint: {
        appId: e.aws_mobile_analytics_app_id,
        region: e.aws_mobile_analytics_app_region
      }
    };
    r.Analytics = t;
  }
  (e.aws_cognito_identity_pool_id || e.aws_user_pools_id) && (r.Auth = {
    userPoolId: e.aws_user_pools_id,
    userPoolWebClientId: e.aws_user_pools_web_client_id,
    region: e.aws_cognito_region,
    identityPoolId: e.aws_cognito_identity_pool_id,
    identityPoolRegion: e.aws_cognito_region,
    mandatorySignIn: e.aws_mandatory_sign_in === "enable",
    signUpVerificationMethod: e.aws_cognito_sign_up_verification_method || "code"
  });
  var n;
  return e.aws_user_files_s3_bucket ? n = {
    AWSS3: {
      bucket: e.aws_user_files_s3_bucket,
      region: e.aws_user_files_s3_bucket_region,
      dangerouslyConnectToHttpEndpointForTesting: e.aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
    }
  } : n = e ? e.Storage || e : {}, e.Logging && (r.Logging = Ys(Ys({}, e.Logging), { region: e.aws_project_region })), e.geo && (r.Geo = Object.assign({}, e.geo), e.geo.amazon_location_service && (r.Geo = {
    AmazonLocationService: e.geo.amazon_location_service
  })), r.Analytics = Object.assign({}, r.Analytics, e.Analytics), r.Auth = Object.assign({}, r.Auth, e.Auth), r.Storage = Object.assign({}, n), r.Logging = Object.assign({}, r.Logging, e.Logging), xb.debug("parse config", e, "to amplifyconfig", r), r;
}, Tb = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Eb = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, kn = new et("CognitoCredentials"), Ob = new Promise(function(e, r) {
  if (!ho().isBrowser)
    return kn.debug("not in the browser, directly resolved"), e();
  var t = window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null;
  if (t)
    return kn.debug("google api already loaded"), e();
  setTimeout(function() {
    return e();
  }, 2e3);
}), Cb = (
  /** @class */
  function() {
    function e() {
      this.initialized = !1, this.refreshGoogleToken = this.refreshGoogleToken.bind(this), this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    return e.prototype.refreshGoogleToken = function() {
      return Tb(this, void 0, void 0, function() {
        return Eb(this, function(r) {
          switch (r.label) {
            case 0:
              return this.initialized ? [3, 2] : (kn.debug("need to wait for the Google SDK loaded"), [4, Ob]);
            case 1:
              r.sent(), this.initialized = !0, kn.debug("finish waiting"), r.label = 2;
            case 2:
              return [2, this._refreshGoogleTokenImpl()];
          }
        });
      });
    }, e.prototype._refreshGoogleTokenImpl = function() {
      var r = null;
      return ho().isBrowser && (r = window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null), r ? new Promise(function(t, n) {
        r.getAuthInstance().then(function(a) {
          a || (kn.debug("google Auth undefined"), n(new ni("google Auth undefined")));
          var i = a.currentUser.get();
          i.isSignedIn() ? (kn.debug("refreshing the google access token"), i.reloadAuthResponse().then(function(o) {
            var l = o.id_token, h = o.expires_at;
            t({ token: l, expires_at: h });
          }).catch(function(o) {
            o && o.error === "network_error" ? n("Network error reloading google auth response") : n(new ni("Failed to reload google auth response"));
          })) : n(new ni("User is not signed in with Google"));
        }).catch(function(a) {
          kn.debug("Failed to refresh google token", a), n(new ni("Failed to refresh google token"));
        });
      }) : (kn.debug("no gapi auth2 available"), Promise.reject("no gapi auth2 available"));
    }, e;
  }()
), kb = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Db = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ri = new et("CognitoCredentials"), jb = new Promise(function(e, r) {
  if (!ho().isBrowser)
    return ri.debug("not in the browser, directly resolved"), e();
  var t = window.FB;
  if (t)
    return ri.debug("FB SDK already loaded"), e();
  setTimeout(function() {
    return e();
  }, 2e3);
}), Mb = (
  /** @class */
  function() {
    function e() {
      this.initialized = !1, this.refreshFacebookToken = this.refreshFacebookToken.bind(this), this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    return e.prototype.refreshFacebookToken = function() {
      return kb(this, void 0, void 0, function() {
        return Db(this, function(r) {
          switch (r.label) {
            case 0:
              return this.initialized ? [3, 2] : (ri.debug("need to wait for the Facebook SDK loaded"), [4, jb]);
            case 1:
              r.sent(), this.initialized = !0, ri.debug("finish waiting"), r.label = 2;
            case 2:
              return [2, this._refreshFacebookTokenImpl()];
          }
        });
      });
    }, e.prototype._refreshFacebookTokenImpl = function() {
      var r = null;
      if (ho().isBrowser && (r = window.FB), !r) {
        var t = "no fb sdk available";
        return ri.debug(t), Promise.reject(new ni(t));
      }
      return new Promise(function(n, a) {
        r.getLoginStatus(function(i) {
          if (!i || !i.authResponse) {
            var o = "no response from facebook when refreshing the jwt token";
            ri.debug(o), a(new ni(o));
          } else {
            var l = i.authResponse, h = l.accessToken, s = l.expiresIn, f = /* @__PURE__ */ new Date(), p = s * 1e3 + f.getTime();
            if (!h) {
              var o = "the jwtToken is undefined";
              ri.debug(o), a(new ni(o));
            }
            n({
              token: h,
              expires_at: p
            });
          }
        }, { scope: "public_profile,email" });
      });
    }, e;
  }()
), Pb = new Cb(), Ab = new Mb(), Hn = {}, Rb = (
  /** @class */
  function() {
    function e() {
    }
    return e.setItem = function(r, t) {
      return Hn[r] = t, Hn[r];
    }, e.getItem = function(r) {
      return Object.prototype.hasOwnProperty.call(Hn, r) ? Hn[r] : void 0;
    }, e.removeItem = function(r) {
      return delete Hn[r];
    }, e.clear = function() {
      return Hn = {}, Hn;
    }, e;
  }()
), jl = (
  /** @class */
  function() {
    function e() {
      try {
        this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.amplify.test-ls", 1), this.storageWindow.removeItem("aws.amplify.test-ls");
      } catch {
        this.storageWindow = Rb;
      }
    }
    return e.prototype.getStorage = function() {
      return this.storageWindow;
    }, e;
  }()
), Rh = {
  id: "aws",
  outputs: {
    dnsSuffix: "amazonaws.com"
  },
  regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
  regions: ["aws-global"]
}, Ib = {
  partitions: [
    Rh,
    {
      id: "aws-cn",
      outputs: {
        dnsSuffix: "amazonaws.com.cn"
      },
      regionRegex: "^cn\\-\\w+\\-\\d+$",
      regions: ["aws-cn-global"]
    }
  ]
}, Nb = globalThis && globalThis.__values || function(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Bu = function(e) {
  var r, t, n = Ib.partitions;
  try {
    for (var a = Nb(n), i = a.next(); !i.done; i = a.next()) {
      var o = i.value, l = o.regions, h = o.outputs, s = o.regionRegex, f = new RegExp(s);
      if (l.includes(e) || f.test(e))
        return h.dnsSuffix;
    }
  } catch (p) {
    r = { error: p };
  } finally {
    try {
      i && !i.done && (t = a.return) && t.call(a);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return Rh.outputs.dnsSuffix;
};
function Lb(e, r) {
  return r = r || {}, new Promise(function(t, n) {
    var a = new XMLHttpRequest(), i = [], o = [], l = {}, h = function() {
      return { ok: (a.status / 100 | 0) == 2, statusText: a.statusText, status: a.status, url: a.responseURL, text: function() {
        return Promise.resolve(a.responseText);
      }, json: function() {
        return Promise.resolve(a.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([a.response]));
      }, clone: h, headers: { keys: function() {
        return i;
      }, entries: function() {
        return o;
      }, get: function(f) {
        return l[f.toLowerCase()];
      }, has: function(f) {
        return f.toLowerCase() in l;
      } } };
    };
    for (var s in a.open(r.method || "get", e, !0), a.onload = function() {
      a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(f, p, m) {
        i.push(p = p.toLowerCase()), o.push([p, m]), l[p] = l[p] ? l[p] + "," + m : m;
      }), t(h());
    }, a.onerror = n, a.withCredentials = r.credentials == "include", r.headers)
      a.setRequestHeader(s, r.headers[s]);
    a.send(r.body || null);
  });
}
const Fb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lb
}, Symbol.toStringTag, { value: "Module" })), Nf = /* @__PURE__ */ Cl(Fb);
self.fetch || (self.fetch = Nf.default || Nf);
var js = function(e) {
  var r;
  return function() {
    return r || (r = e()), r;
  };
}, Us = globalThis && globalThis.__assign || function() {
  return Us = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Us.apply(this, arguments);
}, $b = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Yb = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ub = function(e) {
  return !["HEAD", "GET", "DELETE"].includes(e.toUpperCase());
}, zb = function(e, r) {
  var t = e.url, n = e.method, a = e.headers, i = e.body, o = r.abortSignal;
  return $b(void 0, void 0, void 0, function() {
    var l, h, s, f, p, m, w;
    return Yb(this, function(S) {
      switch (S.label) {
        case 0:
          return S.trys.push([0, 2, , 3]), [4, fetch(t, {
            method: n,
            headers: a,
            body: Ub(n) ? i : void 0,
            signal: o
          })];
        case 1:
          return l = S.sent(), [3, 3];
        case 2:
          throw h = S.sent(), h instanceof TypeError ? new Error("Network error") : h;
        case 3:
          return s = {}, (m = l.headers) === null || m === void 0 || m.forEach(function(E, x) {
            s[x.toLowerCase()] = E;
          }), f = {
            statusCode: l.status,
            headers: s,
            body: null
          }, p = Object.assign((w = l.body) !== null && w !== void 0 ? w : {}, {
            text: js(function() {
              return l.text();
            }),
            blob: js(function() {
              return l.blob();
            }),
            json: js(function() {
              return l.json();
            })
          }), [2, Us(Us({}, f), { body: p })];
      }
    });
  });
}, zs = globalThis && globalThis.__assign || function() {
  return zs = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, zs.apply(this, arguments);
}, Wb = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Bb = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Hb = 3, Ih = function(e) {
  var r = e.maxAttempts, t = r === void 0 ? Hb : r, n = e.retryDecider, a = e.computeDelay, i = e.abortSignal;
  if (t < 1)
    throw new Error("maxAttempts must be greater than 0");
  return function(o, l) {
    return function(s) {
      var f;
      return Wb(this, void 0, void 0, function() {
        var p, m, w, S, E, x;
        return Bb(this, function(j) {
          switch (j.label) {
            case 0:
              m = (f = l.attemptsCount) !== null && f !== void 0 ? f : 0, S = function() {
                if (w)
                  return Lf(w, m), w;
                throw Lf(p, m), p;
              }, j.label = 1;
            case 1:
              if (!(!(i != null && i.aborted) && m < t))
                return [3, 11];
              j.label = 2;
            case 2:
              return j.trys.push([2, 4, , 5]), [4, o(s)];
            case 3:
              return w = j.sent(), p = void 0, [3, 5];
            case 4:
              return E = j.sent(), p = E, w = void 0, [3, 5];
            case 5:
              return m = l.attemptsCount > m ? l.attemptsCount : m + 1, l.attemptsCount = m, [4, n(w, p)];
            case 6:
              return j.sent() ? !(i != null && i.aborted) && m < t ? (x = a(m), [4, Gb(x, i)]) : [3, 8] : [3, 9];
            case 7:
              j.sent(), j.label = 8;
            case 8:
              return [3, 1];
            case 9:
              return [2, S()];
            case 10:
              return [3, 1];
            case 11:
              if (i != null && i.aborted)
                throw new Error("Request aborted.");
              return [2, S()];
          }
        });
      });
    };
  };
}, Gb = function(e, r) {
  if (r != null && r.aborted)
    return Promise.resolve();
  var t, n, a = new Promise(function(i) {
    n = i, t = setTimeout(i, e);
  });
  return r == null || r.addEventListener("abort", function i(o) {
    clearTimeout(t), r == null || r.removeEventListener("abort", i), n();
  }), a;
}, Lf = function(e, r) {
  var t;
  Object.prototype.toString.call(e) === "[object Object]" && (e.$metadata = zs(zs({}, (t = e.$metadata) !== null && t !== void 0 ? t : {}), { attempts: r }));
}, Ff = 5 * 60 * 1e3, Nh = function(e) {
  var r = bh(Ff), t = r(e);
  return t === !1 ? Ff : t;
}, Vb = [
  "AuthFailure",
  "InvalidSignatureException",
  "RequestExpired",
  "RequestInTheFuture",
  "RequestTimeTooSkewed",
  "SignatureDoesNotMatch",
  "BadRequestException"
  // API Gateway
], Kb = function(e) {
  return Vb.includes(e);
}, qb = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Zb = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Lh = function(e) {
  return function(r, t) {
    return qb(void 0, void 0, void 0, function() {
      var n, a, i, o;
      return Zb(this, function(l) {
        switch (l.label) {
          case 0:
            return t == null ? [3, 1] : (a = t, [3, 3]);
          case 1:
            return [4, e(r)];
          case 2:
            a = l.sent(), l.label = 3;
          case 3:
            return n = ((o = a) !== null && o !== void 0 ? o : {}).name, i = r == null ? void 0 : r.statusCode, [2, e_(t) || Qb(i, n) || Kb(n) || t_(i, n)];
        }
      });
    });
  };
}, Jb = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException"
], Xb = [
  "TimeoutError",
  "RequestTimeout",
  "RequestTimeoutException"
], Qb = function(e, r) {
  return e === 429 || Jb.includes(r);
}, e_ = function(e) {
  return (e == null ? void 0 : e.name) === "Network error";
}, t_ = function(e, r) {
  return [500, 502, 503, 504].includes(e) || Xb.includes(r);
}, r_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, n_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Fh = function(e) {
  var r = e.userAgentHeader, t = r === void 0 ? "x-amz-user-agent" : r, n = e.userAgentValue, a = n === void 0 ? "" : n;
  return function(i) {
    return function(l) {
      return r_(this, void 0, void 0, function() {
        var h, s, f;
        return n_(this, function(p) {
          switch (p.label) {
            case 0:
              return a.trim().length !== 0 ? [3, 2] : [4, i(l)];
            case 1:
              return h = p.sent(), [2, h];
            case 2:
              return s = t.toLowerCase(), l.headers[s] = l.headers[s] ? "".concat(l.headers[s], " ").concat(a) : a, [4, i(l)];
            case 3:
              return f = p.sent(), [2, f];
          }
        });
      });
    };
  };
}, Ml = function(e, r) {
  return function(t, n) {
    for (var a = {}, i = function(s) {
      return e(s, n);
    }, o = r.length - 1; o >= 0; o--) {
      var l = r[o], h = l(n);
      i = h(i, a);
    }
    return i(t);
  };
}, i_ = Ml(zb, [Fh, Ih]), $h = function(e) {
  return new Date(Date.now() + e);
}, a_ = 5 * 60 * 1e3, s_ = function(e, r) {
  return Math.abs($h(r).getTime() - e) >= a_;
}, o_ = function(e, r) {
  return s_(e, r) ? e - Date.now() : r;
}, u_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, l_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, c_ = function(e) {
  var r = e.credentials, t = e.region, n = e.service, a = e.uriEscapePath, i = a === void 0 ? !0 : a, o;
  return function(l) {
    return function(s) {
      return u_(this, void 0, void 0, function() {
        var f, p, m, w, S, E;
        return l_(this, function(x) {
          switch (x.label) {
            case 0:
              return o = o ?? 0, E = {}, typeof r != "function" ? [3, 2] : [4, r()];
            case 1:
              return p = x.sent(), [3, 3];
            case 2:
              p = r, x.label = 3;
            case 3:
              return f = (E.credentials = p, E.signingDate = $h(o), E.signingRegion = t, E.signingService = n, E.uriEscapePath = i, E), [4, bb(s, f)];
            case 4:
              return m = x.sent(), [4, l(m)];
            case 5:
              return w = x.sent(), S = f_(w), S && (o = o_(Date.parse(S), o)), [2, w];
          }
        });
      });
    };
  };
}, f_ = function(e) {
  var r, t, n = e === void 0 ? {} : e, a = n.headers;
  return (t = (r = a == null ? void 0 : a.date) !== null && r !== void 0 ? r : a == null ? void 0 : a.Date) !== null && t !== void 0 ? t : a == null ? void 0 : a["x-amz-date"];
}, d_ = function(e) {
  var r = /[!'()*]/g;
  return encodeURIComponent(e).replace(r, h_);
}, h_ = function(e) {
  return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
}, Ws = globalThis && globalThis.__assign || function() {
  return Ws = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ws.apply(this, arguments);
}, St = function(e) {
  var r, t, n = e.headers, a = e.statusCode;
  return Ws(Ws({}, y_(e) ? e.$metadata : {}), { httpStatusCode: a, requestId: (t = (r = n["x-amzn-requestid"]) !== null && r !== void 0 ? r : n["x-amzn-request-id"]) !== null && t !== void 0 ? t : n["x-amz-request-id"], extendedRequestId: n["x-amz-id-2"], cfId: n["x-amz-cf-id"] });
}, y_ = function(e) {
  return typeof (e == null ? void 0 : e.$metadata) == "object";
}, Yh = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Uh = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, g_ = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, Pl = function(e) {
  return Yh(void 0, void 0, void 0, function() {
    var r, t, n, a, i, o, l, h, s, f;
    return Uh(this, function(p) {
      switch (p.label) {
        case 0:
          return !e || e.statusCode < 300 ? [
            2
            /*return*/
          ] : [4, Al(e)];
        case 1:
          return r = p.sent(), t = function(m) {
            var w = g_(m.toString().split(/[\,\:]+/), 1), S = w[0];
            return S.includes("#") ? S.split("#")[1] : S;
          }, n = t((h = (l = (o = e.headers["x-amzn-errortype"]) !== null && o !== void 0 ? o : r.code) !== null && l !== void 0 ? l : r.__type) !== null && h !== void 0 ? h : "UnknownError"), a = (f = (s = r.message) !== null && s !== void 0 ? s : r.Message) !== null && f !== void 0 ? f : "Unknown error", i = new Error(a), [2, Object.assign(i, {
            name: n,
            $metadata: St(e)
          })];
      }
    });
  });
}, Al = function(e) {
  return Yh(void 0, void 0, void 0, function() {
    var r;
    return Uh(this, function(t) {
      switch (t.label) {
        case 0:
          if (!e.body)
            throw new Error("Missing response payload");
          return [4, e.body.json()];
        case 1:
          return r = t.sent(), [2, Object.assign(r, {
            $metadata: St(e)
          })];
      }
    });
  });
}, p_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, v_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, m_ = "cognito-identity", b_ = function(e) {
  var r = e.region;
  return {
    url: new URL("https://cognito-identity.".concat(r, ".").concat(Bu(r)))
  };
}, __ = function() {
  return function(e, r) {
    return function(n) {
      return p_(this, void 0, void 0, function() {
        return v_(this, function(a) {
          return n.headers["cache-control"] = "no-store", [2, e(n)];
        });
      });
    };
  };
}, zh = Ml(i_, [__]), Rl = {
  service: m_,
  endpointResolver: b_,
  retryDecider: Lh(Pl),
  computeDelay: Nh,
  userAgentValue: fo()
};
ph(function() {
  Rl.userAgentValue = fo();
});
var Wh = function(e) {
  return {
    "content-type": "application/x-amz-json-1.1",
    "x-amz-target": "AWSCognitoIdentityService.".concat(e)
  };
}, Bh = function(e, r, t) {
  var n = e.url;
  return {
    headers: r,
    url: n,
    body: t,
    method: "POST"
  };
}, Oa = globalThis && globalThis.__assign || function() {
  return Oa = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Oa.apply(this, arguments);
}, w_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, S_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Kt = function(e, r, t, n) {
  return function(a, i) {
    return w_(void 0, void 0, void 0, function() {
      var o, l, h, s;
      return S_(this, function(f) {
        switch (f.label) {
          case 0:
            return o = Oa(Oa({}, n), a), [4, o.endpointResolver(o, i)];
          case 1:
            return l = f.sent(), [4, r(i, l)];
          case 2:
            return h = f.sent(), [4, e(h, Oa({}, o))];
          case 3:
            return s = f.sent(), [4, t(s)];
          case 4:
            return [2, f.sent()];
        }
      });
    });
  };
}, x_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, T_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, E_ = function(e, r) {
  var t = Wh("GetId"), n = JSON.stringify(e);
  return Bh(r, t, n);
}, O_ = function(e) {
  return x_(void 0, void 0, void 0, function() {
    var r, t;
    return T_(this, function(n) {
      switch (n.label) {
        case 0:
          return e.statusCode >= 300 ? [4, Pl(e)] : [3, 2];
        case 1:
          throw r = n.sent(), r;
        case 2:
          return [4, Al(e)];
        case 3:
          return t = n.sent(), [2, {
            IdentityId: t.IdentityId,
            $metadata: St(e)
          }];
      }
    });
  });
}, _s = Kt(zh, E_, O_, Rl), C_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, k_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, D_ = function(e, r) {
  var t = Wh("GetCredentialsForIdentity"), n = JSON.stringify(e);
  return Bh(r, t, n);
}, j_ = function(e) {
  return C_(void 0, void 0, void 0, function() {
    var r, t;
    return k_(this, function(n) {
      switch (n.label) {
        case 0:
          return e.statusCode >= 300 ? [4, Pl(e)] : [3, 2];
        case 1:
          throw r = n.sent(), r;
        case 2:
          return [4, Al(e)];
        case 3:
          return t = n.sent(), [2, {
            IdentityId: t.IdentityId,
            Credentials: M_(t.Credentials),
            $metadata: St(e)
          }];
      }
    });
  });
}, M_ = function(e) {
  return e === void 0 && (e = {}), {
    AccessKeyId: e.AccessKeyId,
    SecretKey: e.SecretKey,
    SessionToken: e.SessionToken,
    Expiration: new Date(e.Expiration * 1e3)
  };
}, ws = Kt(zh, D_, j_, Rl), Bs = globalThis && globalThis.__assign || function() {
  return Bs = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Bs.apply(this, arguments);
}, ft = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, dt = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ne = new et("Credentials"), P_ = 50 * 60 * 1e3, A_ = "CognitoIdentityId-", R_ = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default", I_ = function(e, r, t) {
  Na.dispatch("core", { event: e, data: r, message: t }, "Credentials", R_);
}, N_ = (
  /** @class */
  function() {
    function e(r) {
      this._gettingCredPromise = null, this._refreshHandlers = {}, this.Auth = void 0, this.configure(r), this._refreshHandlers.google = Pb.refreshGoogleToken, this._refreshHandlers.facebook = Ab.refreshFacebookToken;
    }
    return e.prototype.getModuleName = function() {
      return "Credentials";
    }, e.prototype.getCredSource = function() {
      return this._credentials_source;
    }, e.prototype.configure = function(r) {
      if (!r)
        return this._config || {};
      this._config = Object.assign({}, this._config, r);
      var t = this._config.refreshHandlers;
      return t && (this._refreshHandlers = Bs(Bs({}, this._refreshHandlers), t)), this._storage = this._config.storage, this._storage || (this._storage = new jl().getStorage()), this._storageSync = Promise.resolve(), typeof this._storage.sync == "function" && (this._storageSync = this._storage.sync()), I_("credentials_configured", null, "Credentials has been configured successfully"), this._config;
    }, e.prototype.get = function() {
      return ne.debug("getting credentials"), this._pickupCredentials();
    }, e.prototype._getCognitoIdentityIdStorageKey = function(r) {
      return "".concat(A_).concat(r);
    }, e.prototype._pickupCredentials = function() {
      return ne.debug("picking up credentials"), !this._gettingCredPromise || !this._gettingCredPromise.isPending() ? (ne.debug("getting new cred promise"), this._gettingCredPromise = s2(this._keepAlive())) : ne.debug("getting old cred promise"), this._gettingCredPromise;
    }, e.prototype._keepAlive = function() {
      return ft(this, void 0, void 0, function() {
        var r, t, n, a, i, o, l, h;
        return dt(this, function(s) {
          switch (s.label) {
            case 0:
              if (ne.debug("checking if credentials exists and not expired"), r = this._credentials, r && !this._isExpired(r) && !this._isPastTTL())
                return ne.debug("credentials not changed and not expired, directly return"), [2, Promise.resolve(r)];
              if (ne.debug("need to get a new credential or refresh the existing one"), t = this.Auth, n = t === void 0 ? Ka.Auth : t, !n || typeof n.currentUserCredentials != "function")
                return [2, this._setCredentialsForGuest()];
              if (!(!this._isExpired(r) && this._isPastTTL()))
                return [3, 6];
              ne.debug("ttl has passed but token is not yet expired"), s.label = 1;
            case 1:
              return s.trys.push([1, 5, , 6]), [4, n.currentUserPoolUser()];
            case 2:
              return a = s.sent(), [4, n.currentSession()];
            case 3:
              return i = s.sent(), o = i.refreshToken, l = new Promise(function(f, p) {
                a.refreshSession(o, function(m, w) {
                  return m ? p(m) : f(w);
                });
              }), [4, l];
            case 4:
              return s.sent(), [3, 6];
            case 5:
              return h = s.sent(), ne.debug("Error attempting to refreshing the session", h), [3, 6];
            case 6:
              return [2, n.currentUserCredentials()];
          }
        });
      });
    }, e.prototype.refreshFederatedToken = function(r) {
      ne.debug("Getting federated credentials");
      var t = r.provider, n = r.user, a = r.token, i = r.identity_id, o = r.expires_at;
      o = new Date(o).getFullYear() === 1970 ? o * 1e3 : o;
      var l = this;
      return ne.debug("checking if federated jwt token expired"), o > (/* @__PURE__ */ new Date()).getTime() ? (ne.debug("token not expired"), this._setCredentialsFromFederation({
        provider: t,
        token: a,
        user: n,
        identity_id: i,
        expires_at: o
      })) : l._refreshHandlers[t] && typeof l._refreshHandlers[t] == "function" ? (ne.debug("getting refreshed jwt token from federation provider"), this._providerRefreshWithRetry({
        refreshHandler: l._refreshHandlers[t],
        provider: t,
        user: n
      })) : (ne.debug("no refresh handler for provider:", t), this.clear(), Promise.reject("no refresh handler for provider"));
    }, e.prototype._providerRefreshWithRetry = function(r) {
      var t = this, n = r.refreshHandler, a = r.provider, i = r.user, o = 10 * 1e3;
      return d2(n, [], o).then(function(l) {
        return ne.debug("refresh federated token sucessfully", l), t._setCredentialsFromFederation({
          provider: a,
          token: l.token,
          user: i,
          identity_id: l.identity_id,
          expires_at: l.expires_at
        });
      }).catch(function(l) {
        var h = typeof l == "string" && l.toLowerCase().lastIndexOf("network error", l.length) === 0;
        return h || t.clear(), ne.debug("refresh federated token failed", l), Promise.reject("refreshing federation token failed: " + l);
      });
    }, e.prototype._isExpired = function(r) {
      if (!r)
        return ne.debug("no credentials for expiration check"), !0;
      ne.debug("are these credentials expired?", r);
      var t = Date.now(), n = r.expiration;
      return n.getTime() <= t;
    }, e.prototype._isPastTTL = function() {
      return this._nextCredentialsRefresh <= Date.now();
    }, e.prototype._setCredentialsForGuest = function() {
      var r;
      return ft(this, void 0, void 0, function() {
        var t, n, a, i, o, l, h, s, f, p, m = this;
        return dt(this, function(w) {
          switch (w.label) {
            case 0:
              return ne.debug("setting credentials for guest"), !((r = this._config) === null || r === void 0) && r.identityPoolId || (this._config = Object.assign({}, this._config, Dl(this._config || {}).Auth)), t = this._config, n = t.identityPoolId, a = t.region, i = t.mandatorySignIn, o = t.identityPoolRegion, i ? [2, Promise.reject("cannot get guest credentials when mandatory signin enabled")] : n ? !o && !a ? (ne.debug("region is not configured for getting the credentials"), [2, Promise.reject("region is not configured for getting the credentials")]) : (h = this, [4, this._getGuestIdentityId()]) : (ne.debug("No Cognito Identity pool provided for unauthenticated access"), [2, Promise.reject("No Cognito Identity pool provided for unauthenticated access")]);
            case 1:
              return l = h._identityId = w.sent(), s = { region: o ?? a }, f = function() {
                return ft(m, void 0, void 0, function() {
                  var S, E;
                  return dt(this, function(x) {
                    switch (x.label) {
                      case 0:
                        return l ? [3, 2] : [4, _s(s, {
                          IdentityPoolId: n
                        })];
                      case 1:
                        S = x.sent().IdentityId, this._identityId = S, x.label = 2;
                      case 2:
                        return [4, ws(s, {
                          IdentityId: this._identityId
                        })];
                      case 3:
                        return E = x.sent().Credentials, [2, {
                          identityId: this._identityId,
                          accessKeyId: E.AccessKeyId,
                          secretAccessKey: E.SecretKey,
                          sessionToken: E.SessionToken,
                          expiration: E.Expiration
                        }];
                    }
                  });
                });
              }, p = f().catch(function(S) {
                return ft(m, void 0, void 0, function() {
                  return dt(this, function(E) {
                    throw S;
                  });
                });
              }), [2, this._loadCredentials(p, "guest", !1, null).then(function(S) {
                return S;
              }).catch(function(S) {
                return ft(m, void 0, void 0, function() {
                  var E, x = this;
                  return dt(this, function(j) {
                    switch (j.label) {
                      case 0:
                        return S.name === "ResourceNotFoundException" && S.message === "Identity '".concat(l, "' not found.") ? (ne.debug("Failed to load guest credentials"), [4, this._removeGuestIdentityId()]) : [3, 2];
                      case 1:
                        return j.sent(), E = function() {
                          return ft(x, void 0, void 0, function() {
                            var O, I;
                            return dt(this, function(M) {
                              switch (M.label) {
                                case 0:
                                  return [4, _s(s, {
                                    IdentityPoolId: n
                                  })];
                                case 1:
                                  return O = M.sent().IdentityId, this._identityId = O, [4, ws(s, {
                                    IdentityId: O
                                  })];
                                case 2:
                                  return I = M.sent().Credentials, [2, {
                                    identityId: O,
                                    accessKeyId: I.AccessKeyId,
                                    secretAccessKey: I.SecretKey,
                                    sessionToken: I.SessionToken,
                                    expiration: I.Expiration
                                  }];
                              }
                            });
                          });
                        }, p = E().catch(function(O) {
                          return ft(x, void 0, void 0, function() {
                            return dt(this, function(I) {
                              throw O;
                            });
                          });
                        }), [2, this._loadCredentials(p, "guest", !1, null)];
                      case 2:
                        return [2, S];
                    }
                  });
                });
              })];
          }
        });
      });
    }, e.prototype._setCredentialsFromFederation = function(r) {
      var t = this, n = r.provider, a = r.token, i = r.identity_id, o = {
        google: "accounts.google.com",
        facebook: "graph.facebook.com",
        amazon: "www.amazon.com",
        developer: "cognito-identity.amazonaws.com"
      }, l = o[n] || n;
      if (!l)
        return Promise.reject("You must specify a federated provider");
      var h = {};
      h[l] = a;
      var s = this._config, f = s.identityPoolId, p = s.region, m = s.identityPoolRegion;
      if (!f)
        return ne.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
      if (!m && !p)
        return ne.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
      var w = { region: m ?? p }, S = function() {
        return ft(t, void 0, void 0, function() {
          var x, j;
          return dt(this, function(O) {
            switch (O.label) {
              case 0:
                return i ? [3, 2] : [4, _s(w, {
                  IdentityPoolId: f,
                  Logins: h
                })];
              case 1:
                x = O.sent().IdentityId, i = x, O.label = 2;
              case 2:
                return [4, ws(w, {
                  IdentityId: i,
                  Logins: h
                })];
              case 3:
                return j = O.sent().Credentials, [2, {
                  identityId: i,
                  accessKeyId: j.AccessKeyId,
                  secretAccessKey: j.SecretKey,
                  sessionToken: j.SessionToken,
                  expiration: j.Expiration
                }];
            }
          });
        });
      }, E = S().catch(function(x) {
        return ft(t, void 0, void 0, function() {
          return dt(this, function(j) {
            throw x;
          });
        });
      });
      return this._loadCredentials(E, "federated", !0, r);
    }, e.prototype._setCredentialsFromSession = function(r) {
      var t = this;
      ne.debug("set credentials from session");
      var n = r.getIdToken().getJwtToken(), a = this._config, i = a.region, o = a.userPoolId, l = a.identityPoolId, h = a.identityPoolRegion;
      if (!l)
        return ne.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
      if (!h && !i)
        return ne.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
      var s = "cognito-idp." + i + ".amazonaws.com/" + o, f = {};
      f[s] = n;
      var p = { region: h ?? i }, m = function() {
        return ft(t, void 0, void 0, function() {
          var S, E, x, j, O, I, M, k, fe, ae;
          return dt(this, function(B) {
            switch (B.label) {
              case 0:
                return [4, this._getGuestIdentityId()];
              case 1:
                return S = B.sent(), S ? [3, 3] : [4, _s(p, {
                  IdentityPoolId: l,
                  Logins: f
                })];
              case 2:
                x = B.sent().IdentityId, E = x, B.label = 3;
              case 3:
                return [4, ws(p, {
                  IdentityId: S || E,
                  Logins: f
                })];
              case 4:
                return j = B.sent(), O = j.Credentials, I = O.AccessKeyId, M = O.Expiration, k = O.SecretKey, fe = O.SessionToken, ae = j.IdentityId, this._identityId = ae, S ? (ne.debug("The guest identity ".concat(S, " has been successfully linked to the logins")), S === ae && ne.debug("The guest identity ".concat(S, " has become the primary identity")), [4, this._removeGuestIdentityId()]) : [3, 6];
              case 5:
                B.sent(), B.label = 6;
              case 6:
                return [2, {
                  accessKeyId: I,
                  secretAccessKey: k,
                  sessionToken: fe,
                  expiration: M,
                  identityId: ae
                }];
            }
          });
        });
      }, w = m().catch(function(S) {
        return ft(t, void 0, void 0, function() {
          return dt(this, function(E) {
            throw S;
          });
        });
      });
      return this._loadCredentials(w, "userPool", !0, null);
    }, e.prototype._loadCredentials = function(r, t, n, a) {
      var i = this, o = this;
      return new Promise(function(l, h) {
        r.then(function(s) {
          return ft(i, void 0, void 0, function() {
            var f, p, m, w, S;
            return dt(this, function(E) {
              switch (E.label) {
                case 0:
                  if (ne.debug("Load credentials successfully", s), this._identityId && !s.identityId && (s.identityId = this._identityId), o._credentials = s, o._credentials.authenticated = n, o._credentials_source = t, o._nextCredentialsRefresh = (/* @__PURE__ */ new Date()).getTime() + P_, t === "federated") {
                    f = Object.assign({ id: this._credentials.identityId }, a.user), p = a.provider, m = a.token, w = a.expires_at, S = a.identity_id;
                    try {
                      this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                        provider: p,
                        token: m,
                        user: f,
                        expires_at: w,
                        identity_id: S
                      }));
                    } catch (x) {
                      ne.debug("Failed to put federated info into auth storage", x);
                    }
                  }
                  return t !== "guest" ? [3, 2] : [4, this._setGuestIdentityId(s.identityId)];
                case 1:
                  E.sent(), E.label = 2;
                case 2:
                  return l(o._credentials), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }).catch(function(s) {
          if (s) {
            ne.debug("Failed to load credentials", r), ne.debug("Error loading credentials", s), h(s);
            return;
          }
        });
      });
    }, e.prototype.set = function(r, t) {
      return t === "session" ? this._setCredentialsFromSession(r) : t === "federation" ? this._setCredentialsFromFederation(r) : t === "guest" ? this._setCredentialsForGuest() : (ne.debug("no source specified for setting credentials"), Promise.reject("invalid source"));
    }, e.prototype.clear = function() {
      return ft(this, void 0, void 0, function() {
        return dt(this, function(r) {
          return this._credentials = null, this._credentials_source = null, ne.debug("removing aws-amplify-federatedInfo from storage"), this._storage.removeItem("aws-amplify-federatedInfo"), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype._getGuestIdentityId = function() {
      return ft(this, void 0, void 0, function() {
        var r, t;
        return dt(this, function(n) {
          switch (n.label) {
            case 0:
              r = this._config.identityPoolId, n.label = 1;
            case 1:
              return n.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return n.sent(), [2, this._storage.getItem(this._getCognitoIdentityIdStorageKey(r))];
            case 3:
              return t = n.sent(), ne.debug("Failed to get the cached guest identityId", t), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._setGuestIdentityId = function(r) {
      return ft(this, void 0, void 0, function() {
        var t, n;
        return dt(this, function(a) {
          switch (a.label) {
            case 0:
              t = this._config.identityPoolId, a.label = 1;
            case 1:
              return a.trys.push([1, 3, , 4]), [4, this._storageSync];
            case 2:
              return a.sent(), this._storage.setItem(this._getCognitoIdentityIdStorageKey(t), r), [3, 4];
            case 3:
              return n = a.sent(), ne.debug("Failed to cache guest identityId", n), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._removeGuestIdentityId = function() {
      return ft(this, void 0, void 0, function() {
        var r;
        return dt(this, function(t) {
          return r = this._config.identityPoolId, ne.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(r), " from storage")), this._storage.removeItem(this._getCognitoIdentityIdStorageKey(r)), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.shear = function(r) {
      return {
        accessKeyId: r.accessKeyId,
        sessionToken: r.sessionToken,
        secretAccessKey: r.secretAccessKey,
        identityId: r.identityId,
        authenticated: r.authenticated
      };
    }, e;
  }()
), ii = new N_(null);
Ka.register(ii);
var L_ = "x-amz-user-agent";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Hu = function(e, r) {
  return Hu = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n)
      n.hasOwnProperty(a) && (t[a] = n[a]);
  }, Hu(e, r);
};
function F_(e, r) {
  Hu(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var hr = {
  keyPrefix: "aws-amplify-cache",
  capacityInBytes: 1048576,
  itemMaxSize: 21e4,
  defaultTTL: 2592e5,
  defaultPriority: 5,
  warningThreshold: 0.8,
  // the storage helper will check if localStorage exists,
  // if not, will use a in-memory object instead
  storage: new jl().getStorage()
};
function $f(e) {
  var r = 0;
  r = e.length;
  for (var t = e.length; t >= 0; t -= 1) {
    var n = e.charCodeAt(t);
    n > 127 && n <= 2047 ? r += 1 : n > 2047 && n <= 65535 && (r += 2), n >= 56320 && n <= 57343 && (t -= 1);
  }
  return r;
}
function zi() {
  var e = /* @__PURE__ */ new Date();
  return e.getTime();
}
function Ss(e) {
  return Number.isInteger ? Number.isInteger(e) : $_(e);
}
function $_(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
var Xr = new et("StorageCache"), Y_ = (
  /** @class */
  function() {
    function e(r) {
      this.config = Object.assign({}, r), this.cacheCurSizeKey = this.config.keyPrefix + "CurSize", this.checkConfig();
    }
    return e.prototype.getModuleName = function() {
      return "Cache";
    }, e.prototype.checkConfig = function() {
      Ss(this.config.capacityInBytes) || (Xr.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default."), this.config.capacityInBytes = hr.capacityInBytes), Ss(this.config.itemMaxSize) || (Xr.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default."), this.config.itemMaxSize = hr.itemMaxSize), Ss(this.config.defaultTTL) || (Xr.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default."), this.config.defaultTTL = hr.defaultTTL), Ss(this.config.defaultPriority) || (Xr.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default."), this.config.defaultPriority = hr.defaultPriority), this.config.itemMaxSize > this.config.capacityInBytes && (Xr.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default."), this.config.itemMaxSize = hr.itemMaxSize), (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) && (Xr.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default."), this.config.defaultPriority = hr.defaultPriority), (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) && (Xr.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default."), this.config.warningThreshold = hr.warningThreshold);
      var r = 5 * 1024 * 1024;
      this.config.capacityInBytes > r && (Xr.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default."), this.config.capacityInBytes = hr.capacityInBytes);
    }, e.prototype.fillCacheItem = function(r, t, n) {
      var a = {
        key: r,
        data: t,
        timestamp: zi(),
        visitedTime: zi(),
        priority: n.priority,
        expires: n.expires,
        type: typeof t,
        byteSize: 0
      };
      return a.byteSize = $f(JSON.stringify(a)), a.byteSize = $f(JSON.stringify(a)), a;
    }, e.prototype.configure = function(r) {
      return r ? (r.keyPrefix && Xr.warn("Don't try to configure keyPrefix!"), this.config = Object.assign({}, this.config, r, r.Cache), this.checkConfig(), this.config) : this.config;
    }, e;
  }()
), Ct = new et("Cache"), U_ = (
  /** @class */
  function(e) {
    F_(r, e);
    function r(t) {
      var n = this, a = t ? Object.assign({}, hr, t) : hr;
      return n = e.call(this, a) || this, n.config.storage = a.storage, n.getItem = n.getItem.bind(n), n.setItem = n.setItem.bind(n), n.removeItem = n.removeItem.bind(n), n;
    }
    return r.prototype._decreaseCurSizeInBytes = function(t) {
      var n = this.getCacheCurSize();
      this.config.storage.setItem(this.cacheCurSizeKey, (n - t).toString());
    }, r.prototype._increaseCurSizeInBytes = function(t) {
      var n = this.getCacheCurSize();
      this.config.storage.setItem(this.cacheCurSizeKey, (n + t).toString());
    }, r.prototype._refreshItem = function(t, n) {
      return t.visitedTime = zi(), this.config.storage.setItem(n, JSON.stringify(t)), t;
    }, r.prototype._isExpired = function(t) {
      var n = this.config.storage.getItem(t), a = JSON.parse(n);
      return zi() >= a.expires;
    }, r.prototype._removeItem = function(t, n) {
      var a = n || JSON.parse(this.config.storage.getItem(t)).byteSize;
      this._decreaseCurSizeInBytes(a), this.config.storage.removeItem(t);
    }, r.prototype._setItem = function(t, n) {
      this._increaseCurSizeInBytes(n.byteSize);
      try {
        this.config.storage.setItem(t, JSON.stringify(n));
      } catch (a) {
        this._decreaseCurSizeInBytes(n.byteSize), Ct.error("Failed to set item " + a);
      }
    }, r.prototype._sizeToPop = function(t) {
      var n = this.getCacheCurSize() + t - this.config.capacityInBytes, a = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
      return n > a ? n : a;
    }, r.prototype._isCacheFull = function(t) {
      return t + this.getCacheCurSize() > this.config.capacityInBytes;
    }, r.prototype._findValidKeys = function() {
      for (var t = [], n = [], a = 0; a < this.config.storage.length; a += 1)
        n.push(this.config.storage.key(a));
      for (var a = 0; a < n.length; a += 1) {
        var i = n[a];
        i.indexOf(this.config.keyPrefix) === 0 && i !== this.cacheCurSizeKey && (this._isExpired(i) ? this._removeItem(i) : t.push(i));
      }
      return t;
    }, r.prototype._popOutItems = function(t, n) {
      for (var a = [], i = n, o = 0; o < t.length; o += 1) {
        var l = this.config.storage.getItem(t[o]);
        if (l != null) {
          var h = JSON.parse(l);
          a.push(h);
        }
      }
      a.sort(function(s, f) {
        return s.priority > f.priority ? -1 : s.priority < f.priority ? 1 : s.visitedTime < f.visitedTime ? -1 : 1;
      });
      for (var o = 0; o < a.length; o += 1)
        if (this._removeItem(a[o].key, a[o].byteSize), i -= a[o].byteSize, i <= 0)
          return;
    }, r.prototype.setItem = function(t, n, a) {
      Ct.log("Set item: key is " + t + ", value is " + n + " with options: " + a);
      var i = this.config.keyPrefix + t;
      if (i === this.config.keyPrefix || i === this.cacheCurSizeKey) {
        Ct.warn("Invalid key: should not be empty or 'CurSize'");
        return;
      }
      if (typeof n > "u") {
        Ct.warn("The value of item should not be undefined!");
        return;
      }
      var o = {
        priority: a && a.priority !== void 0 ? a.priority : this.config.defaultPriority,
        expires: a && a.expires !== void 0 ? a.expires : this.config.defaultTTL + zi()
      };
      if (o.priority < 1 || o.priority > 5) {
        Ct.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
        return;
      }
      var l = this.fillCacheItem(i, n, o);
      if (l.byteSize > this.config.itemMaxSize) {
        Ct.warn("Item with key: " + t + " you are trying to put into is too big!");
        return;
      }
      try {
        var h = this.config.storage.getItem(i);
        if (h && this._removeItem(i, JSON.parse(h).byteSize), this._isCacheFull(l.byteSize)) {
          var s = this._findValidKeys();
          if (this._isCacheFull(l.byteSize)) {
            var f = this._sizeToPop(l.byteSize);
            this._popOutItems(s, f);
          }
        }
        this._setItem(i, l);
      } catch (p) {
        Ct.warn("setItem failed! " + p);
      }
    }, r.prototype.getItem = function(t, n) {
      Ct.log("Get item: key is " + t + " with options " + n);
      var a = null, i = this.config.keyPrefix + t;
      if (i === this.config.keyPrefix || i === this.cacheCurSizeKey)
        return Ct.warn("Invalid key: should not be empty or 'CurSize'"), null;
      try {
        if (a = this.config.storage.getItem(i), a != null)
          if (this._isExpired(i))
            this._removeItem(i, JSON.parse(a).byteSize), a = null;
          else {
            var o = JSON.parse(a);
            return o = this._refreshItem(o, i), o.data;
          }
        if (n && n.callback !== void 0) {
          var l = n.callback();
          return l !== null && this.setItem(t, l, n), l;
        }
        return null;
      } catch (h) {
        return Ct.warn("getItem failed! " + h), null;
      }
    }, r.prototype.removeItem = function(t) {
      Ct.log("Remove item: key is " + t);
      var n = this.config.keyPrefix + t;
      if (!(n === this.config.keyPrefix || n === this.cacheCurSizeKey))
        try {
          var a = this.config.storage.getItem(n);
          a && this._removeItem(n, JSON.parse(a).byteSize);
        } catch (i) {
          Ct.warn("removeItem failed! " + i);
        }
    }, r.prototype.clear = function() {
      Ct.log("Clear Cache");
      for (var t = [], n = 0; n < this.config.storage.length; n += 1) {
        var a = this.config.storage.key(n);
        a.indexOf(this.config.keyPrefix) === 0 && t.push(a);
      }
      try {
        for (var n = 0; n < t.length; n += 1)
          this.config.storage.removeItem(t[n]);
      } catch (i) {
        Ct.warn("clear failed! " + i);
      }
    }, r.prototype.getAllKeys = function() {
      for (var t = [], n = 0; n < this.config.storage.length; n += 1) {
        var a = this.config.storage.key(n);
        a.indexOf(this.config.keyPrefix) === 0 && a !== this.cacheCurSizeKey && t.push(a.substring(this.config.keyPrefix.length));
      }
      return t;
    }, r.prototype.getCacheCurSize = function() {
      var t = this.config.storage.getItem(this.cacheCurSizeKey);
      return t || (this.config.storage.setItem(this.cacheCurSizeKey, "0"), t = "0"), Number(t);
    }, r.prototype.createInstance = function(t) {
      return (!t.keyPrefix || t.keyPrefix === hr.keyPrefix) && (Ct.error("invalid keyPrefix, setting keyPrefix with timeStamp"), t.keyPrefix = zi.toString()), new r(t);
    }, r;
  }(Y_)
), wo = new U_();
Ka.register(wo);
var Ca = "sendUploadProgress", Hs = "sendDownloadProgress", Yf = "Network Error", z_ = "ECONNABORTED", Uf = "Request aborted", W_ = "ERR_ABORTED", Hh = "canceled", B_ = "ERR_CANCELED", Gu = "x-amz-content-sha256", H_ = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, G_ = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, V_ = function(e) {
  return function(r) {
    return function(n) {
      return H_(this, void 0, void 0, function() {
        var a;
        return G_(this, function(i) {
          switch (i.label) {
            case 0:
              return n.headers[Gu] ? [2, r(n)] : [3, 1];
            case 1:
              return [4, Ph(n.body)];
            case 2:
              return a = i.sent(), n.headers[Gu] = a, [2, r(n)];
          }
        });
      });
    };
  };
}, zf = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, xs = new et("xhr-http-handler"), K_ = function(e, r) {
  var t = e.url, n = e.method, a = e.headers, i = e.body, o = r.emitter, l = r.responseType, h = r.abortSignal;
  return new Promise(function(s, f) {
    var p, m = new XMLHttpRequest();
    if (m.open(n.toUpperCase(), t.toString()), Object.entries(a).filter(function(S) {
      var E = zf(S, 1), x = E[0];
      return !X_.includes(x);
    }).forEach(function(S) {
      var E = zf(S, 2), x = E[0], j = E[1];
      m.setRequestHeader(x, j);
    }), m.responseType = l, o && (m.upload.addEventListener("progress", function(S) {
      o.emit(Ca, S), xs.debug(S);
    }), m.addEventListener("progress", function(S) {
      o.emit(Hs, S), xs.debug(S);
    })), m.addEventListener("error", function() {
      var S = Vu(Yf, z_, m, r);
      xs.error(Yf), f(S), m = null;
    }), m.addEventListener("abort", function() {
      if (!(!m || h != null && h.aborted)) {
        var S = Vu(Uf, W_, m, r);
        xs.error(Uf), f(S), m = null;
      }
    }), m.addEventListener("readystatechange", function() {
      if (!(!m || m.readyState !== m.DONE)) {
        var S = function() {
          if (m) {
            var E = Z_(m.getAllResponseHeaders()), x = m.responseType, j = m.response, O = x === "text" ? m.responseText : "", I = {
              blob: function() {
                return Promise.resolve(j);
              },
              text: js(function() {
                return x === "blob" ? J_(j) : Promise.resolve(O);
              }),
              json: function() {
                return Promise.reject(
                  // S3 does not support JSON response. So fail-fast here with nicer error message.
                  new Error("Parsing response to JSON is not implemented. Please use response.text() instead.")
                );
              }
            }, M = {
              statusCode: m.status,
              headers: E,
              // The xhr.responseType is only set to 'blob' for streaming binary S3 object data. The streaming data is
              // exposed via public interface of Storage.get(). So we need to return the response as a Blob object for
              // backward compatibility. In other cases, the response payload is only used internally, we return it is
              // {@link ResponseBodyMixin}
              body: m.responseType === "blob" ? Object.assign(j, I) : I
            };
            s(M), m = null;
          }
        };
        setTimeout(S);
      }
    }), h) {
      var w = function() {
        if (m) {
          var S = q_(Hh, B_, m, r);
          m.abort(), f(S), m = null;
        }
      };
      h.aborted ? w() : h.addEventListener("abort", w);
    }
    if (typeof ReadableStream == "function" && i instanceof ReadableStream)
      throw new Error("ReadableStream request payload is not supported.");
    m.send((p = i) !== null && p !== void 0 ? p : null);
  });
}, Vu = function(e, r, t, n) {
  return Object.assign(new Error(e), {
    code: r,
    config: n,
    request: t
  });
}, q_ = function(e, r, t, n) {
  var a = Vu(e, r, t, n);
  return a.name = "CanceledError", a.__CANCEL__ = !0, a;
}, Ku = function(e) {
  return !!(e != null && e.__CANCEL__);
}, Z_ = function(e) {
  return e ? e.split(`\r
`).reduce(function(r, t) {
    var n = t.split(": "), a = n.shift(), i = n.join(": ");
    return r[a.toLowerCase()] = i, r;
  }, {}) : {};
}, J_ = function(e) {
  var r = new FileReader();
  return new Promise(function(t, n) {
    r.onloadend = function() {
      r.readyState === FileReader.DONE && t(r.result);
    }, r.onerror = function() {
      n(r.error);
    }, r.readAsText(e);
  });
}, X_ = ["host"], br = Ml(K_, [
  V_,
  Fh,
  Ih,
  c_
]), Q_ = {
  parse: function(e) {
    var r = new DOMParser(), t = r.parseFromString(e, "text/xml"), n = qu(t), a = Object.keys(n)[0];
    return n[a];
  }
}, qu = function(e) {
  var r, t, n;
  if (tw(e))
    return r = {}, r[e.documentElement.nodeName] = qu(e.documentElement), r;
  if (e.nodeType === Node.TEXT_NODE)
    return (t = e.nodeValue) === null || t === void 0 ? void 0 : t.trim();
  if (ew(e)) {
    if (rw(e))
      return (n = e.childNodes[0]) === null || n === void 0 ? void 0 : n.nodeValue;
    for (var a = {}, i = 0; i < e.attributes.length; i++) {
      var o = e.attributes[i];
      Gh(o.nodeName) || (a[o.nodeName] = o.nodeValue);
    }
    if (e.children.length > 0)
      for (var i = 0; i < e.children.length; i++) {
        var l = e.children[i], h = qu(l);
        if (h !== void 0) {
          var s = l.nodeName;
          a[s] === void 0 ? a[s] = h : Array.isArray(a[s]) ? a[s].push(h) : a[s] = [a[s], h];
        }
      }
    return Object.keys(a).length === 0 ? "" : a;
  }
}, ew = function(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}, tw = function(e) {
  return e.nodeType === Node.DOCUMENT_NODE;
}, rw = function(e) {
  var r;
  return nw(e) && e.children.length === 0 && ((r = e.firstChild) === null || r === void 0 ? void 0 : r.nodeType) === Node.TEXT_NODE;
}, nw = function(e) {
  for (var r = 0; r < e.attributes.length; r++) {
    var t = e.attributes[r];
    if (!Gh(t.nodeName))
      return !1;
  }
  return !0;
}, Gh = function(e) {
  return e === "xmlns" || e.startsWith("xmlns:");
};
function Wf(e) {
  var r = Array.from(e, function(t) {
    return String.fromCodePoint(t);
  }).join("");
  return btoa(r);
}
function Vh(e) {
  return new TextEncoder().encode(e);
}
function Zu(e) {
  return Wf(typeof e == "string" ? Vh(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength));
}
var Kh = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, qh = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, qt = function(e) {
  return Kh(void 0, void 0, void 0, function() {
    var r, t, n, a, i, o, l;
    return qh(this, function(h) {
      switch (h.label) {
        case 0:
          return !e || e.statusCode < 300 ? [
            2
            /*return*/
          ] : (r = e.statusCode, [4, yi(e)]);
        case 1:
          return t = h.sent(), n = t != null && t.Code ? t.Code : r === 404 ? "NotFound" : r.toString(), a = (l = (o = t == null ? void 0 : t.message) !== null && o !== void 0 ? o : t == null ? void 0 : t.Message) !== null && l !== void 0 ? l : n, i = new Error(a), [2, Object.assign(i, {
            name: n,
            $metadata: St(e)
          })];
      }
    });
  });
}, yi = function(e) {
  return Kh(void 0, void 0, void 0, function() {
    var r;
    return qh(this, function(t) {
      switch (t.label) {
        case 0:
          if (!e.body)
            throw new Error("S3 aborted request.");
          return [4, e.body.text()];
        case 1:
          if (r = t.sent(), (r == null ? void 0 : r.length) > 0)
            try {
              return [2, Q_.parse(r)];
            } catch {
              throw new Error("Failed to parse XML response.");
            }
          return [2, {}];
      }
    });
  });
}, iw = globalThis && globalThis.__values || function(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Bf = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, Ft = function(e, r) {
  var t, n, a = {};
  try {
    for (var i = iw(Object.entries(r)), o = i.next(); !o.done; o = i.next()) {
      var l = Bf(o.value, 2), h = l[0], s = l[1], f = Bf(Array.isArray(s) ? s : [s], 2), p = f[0], m = f[1];
      e.hasOwnProperty(p) && (a[h] = m ? m(e[p]) : String(e[p]));
    }
  } catch (w) {
    t = { error: w };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return a;
}, jr = function(e) {
  return e ? Number(e) : void 0;
}, Gs = function(e) {
  return e ? e === "true" : void 0;
}, ka = function(e) {
  return e ? new Date(e) : void 0;
}, Vs = function(e, r) {
  if (e === "")
    return [];
  var t = (Array.isArray(e) ? e : [e]).filter(function(n) {
    return n != null;
  });
  return r(t);
}, Zh = function(e) {
  var r = "x-amz-meta-", t = Object.keys(e).filter(function(n) {
    return n.startsWith(r);
  }).reduce(function(n, a) {
    return n[a.replace(r, "")] = e[a], n;
  }, {});
  return Object.keys(t).length > 0 ? t : void 0;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function aw(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}
function sw(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var On = 64, ow = 16, uw = [1732584193, 4023233417, 2562383102, 271733878], Jh = (
  /** @class */
  function() {
    function e() {
      this.state = Uint32Array.from(uw), this.buffer = new DataView(new ArrayBuffer(On)), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return e.prototype.update = function(r) {
      if (!lw(r)) {
        if (this.finished)
          throw new Error("Attempted to update an already finished hash.");
        var t = cw(r), n = 0, a = t.byteLength;
        for (this.bytesHashed += a; a > 0; )
          this.buffer.setUint8(this.bufferLength++, t[n++]), a--, this.bufferLength === On && (this.hashBuffer(), this.bufferLength = 0);
      }
    }, e.prototype.digest = function() {
      return aw(this, void 0, void 0, function() {
        var r, t, n, a, i, l, l, o, l;
        return sw(this, function(h) {
          if (!this.finished) {
            if (r = this, t = r.buffer, n = r.bufferLength, a = r.bytesHashed, i = a * 8, t.setUint8(this.bufferLength++, 128), n % On >= On - 8) {
              for (l = this.bufferLength; l < On; l++)
                t.setUint8(l, 0);
              this.hashBuffer(), this.bufferLength = 0;
            }
            for (l = this.bufferLength; l < On - 8; l++)
              t.setUint8(l, 0);
            t.setUint32(On - 8, i >>> 0, !0), t.setUint32(On - 4, Math.floor(i / 4294967296), !0), this.hashBuffer(), this.finished = !0;
          }
          for (o = new DataView(new ArrayBuffer(ow)), l = 0; l < 4; l++)
            o.setUint32(l * 4, this.state[l], !0);
          return [2, new Uint8Array(o.buffer, o.byteOffset, o.byteLength)];
        });
      });
    }, e.prototype.hashBuffer = function() {
      var r = this, t = r.buffer, n = r.state, a = n[0], i = n[1], o = n[2], l = n[3];
      a = ht(a, i, o, l, t.getUint32(0, !0), 7, 3614090360), l = ht(l, a, i, o, t.getUint32(4, !0), 12, 3905402710), o = ht(o, l, a, i, t.getUint32(8, !0), 17, 606105819), i = ht(i, o, l, a, t.getUint32(12, !0), 22, 3250441966), a = ht(a, i, o, l, t.getUint32(16, !0), 7, 4118548399), l = ht(l, a, i, o, t.getUint32(20, !0), 12, 1200080426), o = ht(o, l, a, i, t.getUint32(24, !0), 17, 2821735955), i = ht(i, o, l, a, t.getUint32(28, !0), 22, 4249261313), a = ht(a, i, o, l, t.getUint32(32, !0), 7, 1770035416), l = ht(l, a, i, o, t.getUint32(36, !0), 12, 2336552879), o = ht(o, l, a, i, t.getUint32(40, !0), 17, 4294925233), i = ht(i, o, l, a, t.getUint32(44, !0), 22, 2304563134), a = ht(a, i, o, l, t.getUint32(48, !0), 7, 1804603682), l = ht(l, a, i, o, t.getUint32(52, !0), 12, 4254626195), o = ht(o, l, a, i, t.getUint32(56, !0), 17, 2792965006), i = ht(i, o, l, a, t.getUint32(60, !0), 22, 1236535329), a = yt(a, i, o, l, t.getUint32(4, !0), 5, 4129170786), l = yt(l, a, i, o, t.getUint32(24, !0), 9, 3225465664), o = yt(o, l, a, i, t.getUint32(44, !0), 14, 643717713), i = yt(i, o, l, a, t.getUint32(0, !0), 20, 3921069994), a = yt(a, i, o, l, t.getUint32(20, !0), 5, 3593408605), l = yt(l, a, i, o, t.getUint32(40, !0), 9, 38016083), o = yt(o, l, a, i, t.getUint32(60, !0), 14, 3634488961), i = yt(i, o, l, a, t.getUint32(16, !0), 20, 3889429448), a = yt(a, i, o, l, t.getUint32(36, !0), 5, 568446438), l = yt(l, a, i, o, t.getUint32(56, !0), 9, 3275163606), o = yt(o, l, a, i, t.getUint32(12, !0), 14, 4107603335), i = yt(i, o, l, a, t.getUint32(32, !0), 20, 1163531501), a = yt(a, i, o, l, t.getUint32(52, !0), 5, 2850285829), l = yt(l, a, i, o, t.getUint32(8, !0), 9, 4243563512), o = yt(o, l, a, i, t.getUint32(28, !0), 14, 1735328473), i = yt(i, o, l, a, t.getUint32(48, !0), 20, 2368359562), a = gt(a, i, o, l, t.getUint32(20, !0), 4, 4294588738), l = gt(l, a, i, o, t.getUint32(32, !0), 11, 2272392833), o = gt(o, l, a, i, t.getUint32(44, !0), 16, 1839030562), i = gt(i, o, l, a, t.getUint32(56, !0), 23, 4259657740), a = gt(a, i, o, l, t.getUint32(4, !0), 4, 2763975236), l = gt(l, a, i, o, t.getUint32(16, !0), 11, 1272893353), o = gt(o, l, a, i, t.getUint32(28, !0), 16, 4139469664), i = gt(i, o, l, a, t.getUint32(40, !0), 23, 3200236656), a = gt(a, i, o, l, t.getUint32(52, !0), 4, 681279174), l = gt(l, a, i, o, t.getUint32(0, !0), 11, 3936430074), o = gt(o, l, a, i, t.getUint32(12, !0), 16, 3572445317), i = gt(i, o, l, a, t.getUint32(24, !0), 23, 76029189), a = gt(a, i, o, l, t.getUint32(36, !0), 4, 3654602809), l = gt(l, a, i, o, t.getUint32(48, !0), 11, 3873151461), o = gt(o, l, a, i, t.getUint32(60, !0), 16, 530742520), i = gt(i, o, l, a, t.getUint32(8, !0), 23, 3299628645), a = pt(a, i, o, l, t.getUint32(0, !0), 6, 4096336452), l = pt(l, a, i, o, t.getUint32(28, !0), 10, 1126891415), o = pt(o, l, a, i, t.getUint32(56, !0), 15, 2878612391), i = pt(i, o, l, a, t.getUint32(20, !0), 21, 4237533241), a = pt(a, i, o, l, t.getUint32(48, !0), 6, 1700485571), l = pt(l, a, i, o, t.getUint32(12, !0), 10, 2399980690), o = pt(o, l, a, i, t.getUint32(40, !0), 15, 4293915773), i = pt(i, o, l, a, t.getUint32(4, !0), 21, 2240044497), a = pt(a, i, o, l, t.getUint32(32, !0), 6, 1873313359), l = pt(l, a, i, o, t.getUint32(60, !0), 10, 4264355552), o = pt(o, l, a, i, t.getUint32(24, !0), 15, 2734768916), i = pt(i, o, l, a, t.getUint32(52, !0), 21, 1309151649), a = pt(a, i, o, l, t.getUint32(16, !0), 6, 4149444226), l = pt(l, a, i, o, t.getUint32(44, !0), 10, 3174756917), o = pt(o, l, a, i, t.getUint32(8, !0), 15, 718787259), i = pt(i, o, l, a, t.getUint32(36, !0), 21, 3951481745), n[0] = a + n[0] & 4294967295, n[1] = i + n[1] & 4294967295, n[2] = o + n[2] & 4294967295, n[3] = l + n[3] & 4294967295;
    }, e;
  }()
);
function So(e, r, t, n, a, i) {
  return r = (r + e & 4294967295) + (n + i & 4294967295) & 4294967295, (r << a | r >>> 32 - a) + t & 4294967295;
}
function ht(e, r, t, n, a, i, o) {
  return So(r & t | ~r & n, e, r, a, i, o);
}
function yt(e, r, t, n, a, i, o) {
  return So(r & n | t & ~n, e, r, a, i, o);
}
function gt(e, r, t, n, a, i, o) {
  return So(r ^ t ^ n, e, r, a, i, o);
}
function pt(e, r, t, n, a, i, o) {
  return So(t ^ (r | ~n), e, r, a, i, o);
}
function lw(e) {
  return typeof e == "string" ? e.length === 0 : e.byteLength === 0;
}
function cw(e) {
  return typeof e == "string" ? jh(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e);
}
var Da = globalThis && globalThis.__assign || function() {
  return Da = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Da.apply(this, arguments);
}, Ju = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Xu = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, fw = globalThis && globalThis.__values || function(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, dw = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, fi = function(e) {
  var r, t, n = {};
  try {
    for (var a = fw(Object.entries(e)), i = a.next(); !i.done; i = a.next()) {
      var o = dw(i.value, 2), l = o[0], h = o[1];
      h != null && (n[l] = h.toString());
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      i && !i.done && (t = a.return) && t.call(a);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return n;
}, ra = function(e) {
  return Ju(void 0, void 0, void 0, function() {
    var r, t, n, a, i, o;
    return Xu(this, function(l) {
      switch (l.label) {
        case 0:
          return r = function(h) {
            return Ju(void 0, void 0, void 0, function() {
              var s;
              return Xu(this, function(f) {
                return s = new Jh(), s.update(Vh(h)), [2, s.digest()];
              });
            });
          }, t = fi, o = {
            "x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm,
            // base64 encoded is need
            // see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html#specifying-s3-c-encryption
            "x-amz-server-side-encryption-customer-key": e.SSECustomerKey && Zu(e.SSECustomerKey)
          }, n = "x-amz-server-side-encryption-customer-key-md5", a = e.SSECustomerKey, a ? (i = Zu, [4, r(e.SSECustomerKey)]) : [3, 2];
        case 1:
          a = i.apply(void 0, [l.sent()]), l.label = 2;
        case 2:
          return [2, t.apply(void 0, [
            // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
            // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
            (o[n] = a, o)
          ])];
      }
    });
  });
}, Il = function(e) {
  return Ju(void 0, void 0, void 0, function() {
    var r, t;
    return Xu(this, function(n) {
      switch (n.label) {
        case 0:
          return r = [{}], [4, ra(e)];
        case 1:
          return [2, Da.apply(void 0, [Da.apply(void 0, r.concat([n.sent()])), fi(Da({ "x-amz-server-side-encryption": e.ServerSideEncryption, "x-amz-server-side-encryption-aws-kms-key-id": e.SSEKMSKeyId, "x-amz-acl": e.ACL, "cache-control": e.CacheControl, "content-disposition": e.ContentDisposition, "content-language": e.ContentLanguage, "content-encoding": e.ContentEncoding, "content-type": e.ContentType, expires: (t = e.Expires) === null || t === void 0 ? void 0 : t.toUTCString(), "x-amz-tagging": e.Tagging }, hw(e.Metadata)))])];
      }
    });
  });
}, hw = function(e) {
  return e === void 0 && (e = {}), Object.keys(e).reduce(function(r, t) {
    return r["x-amz-meta-".concat(t.toLowerCase())] = e[t], r;
  }, {});
}, Nr = function(e, r) {
  return e.pathname.replace(/\/$/, "") + "/".concat(r.split("/").map(d_).join("/"));
}, yw = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/, gw = /(\d+\.){3}\d+/, pw = /\.\./, Xh = "s3", vw = function(e, r) {
  var t = e.region, n = e.useAccelerateEndpoint, a = e.customEndpoint, i = e.forcePathStyle, o;
  if (a)
    o = new URL(a);
  else if (n) {
    if (i)
      throw new Error("Path style URLs are not supported with S3 Transfer Acceleration.");
    o = new URL("https://s3-accelerate.".concat(Bu(t)));
  } else
    o = new URL("https://s3.".concat(t, ".").concat(Bu(t)));
  if (r != null && r.Bucket) {
    if (!mw(r.Bucket))
      throw new Error('Invalid bucket name: "'.concat(r.Bucket, '".'));
    i || r.Bucket.includes(".") ? o.pathname = "/".concat(r.Bucket) : o.host = "".concat(r.Bucket, ".").concat(o.host);
  }
  return { url: o };
}, mw = function(e) {
  return yw.test(e) && !gw.test(e) && !pw.test(e);
}, Lt = {
  service: Xh,
  endpointResolver: vw,
  retryDecider: Lh(qt),
  computeDelay: Nh,
  userAgentValue: fo(),
  useAccelerateEndpoint: !1,
  uriEscapePath: !1
  // Required by S3. See https://github.com/aws/aws-sdk-js-v3/blob/9ba012dfa3a3429aa2db0f90b3b0b3a7a31f9bc3/packages/signature-v4/src/SignatureV4.ts#L76-L83
}, Nn = globalThis && globalThis.__assign || function() {
  return Nn = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Nn.apply(this, arguments);
}, Nl = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Ll = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, bu = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, bw = globalThis && globalThis.__values || function(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qh = function(e, r) {
  return Nl(void 0, void 0, void 0, function() {
    var t, n, a;
    return Ll(this, function(i) {
      switch (i.label) {
        case 0:
          return [4, ra(e)];
        case 1:
          return t = i.sent(), n = Ft(e, {
            "response-cache-control": "ResponseCacheControl",
            "response-content-disposition": "ResponseContentDisposition",
            "response-content-encoding": "ResponseContentEncoding",
            "response-content-language": "ResponseContentLanguage",
            "response-content-type": "ResponseContentType"
          }), a = new URL(r.url.toString()), a.pathname = Nr(a, e.Key), a.search = new URLSearchParams(n).toString(), [2, {
            method: "GET",
            headers: t,
            url: a
          }];
      }
    });
  });
}, _w = function(e) {
  return Nl(void 0, void 0, void 0, function() {
    var r;
    return Ll(this, function(t) {
      switch (t.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = t.sent(), r;
        case 2:
          if (e.body)
            return [2, Nn(Nn({}, Ft(e.headers, {
              DeleteMarker: ["x-amz-delete-marker", Gs],
              AcceptRanges: "accept-ranges",
              Expiration: "x-amz-expiration",
              Restore: "x-amz-restore",
              LastModified: ["last-modified", ka],
              ContentLength: ["content-length", jr],
              ETag: "etag",
              ChecksumCRC32: "x-amz-checksum-crc32",
              ChecksumCRC32C: "x-amz-checksum-crc32c",
              ChecksumSHA1: "x-amz-checksum-sha1",
              ChecksumSHA256: "x-amz-checksum-sha256",
              MissingMeta: ["x-amz-missing-meta", jr],
              VersionId: "x-amz-version-id",
              CacheControl: "cache-control",
              ContentDisposition: "content-disposition",
              ContentEncoding: "content-encoding",
              ContentLanguage: "content-language",
              ContentRange: "content-range",
              ContentType: "content-type",
              Expires: ["expires", ka],
              WebsiteRedirectLocation: "x-amz-website-redirect-location",
              ServerSideEncryption: "x-amz-server-side-encryption",
              SSECustomerAlgorithm: "x-amz-server-side-encryption-customer-algorithm",
              SSECustomerKeyMD5: "x-amz-server-side-encryption-customer-key-md5",
              SSEKMSKeyId: "x-amz-server-side-encryption-aws-kms-key-id",
              BucketKeyEnabled: [
                "x-amz-server-side-encryption-bucket-key-enabled",
                Gs
              ],
              StorageClass: "x-amz-storage-class",
              RequestCharged: "x-amz-request-charged",
              ReplicationStatus: "x-amz-replication-status",
              PartsCount: ["x-amz-mp-parts-count", jr],
              TagCount: ["x-amz-tagging-count", jr],
              ObjectLockMode: "x-amz-object-lock-mode",
              ObjectLockRetainUntilDate: [
                "x-amz-object-lock-retain-until-date",
                ka
              ],
              ObjectLockLegalHoldStatus: "x-amz-object-lock-legal-hold"
            })), { Metadata: Zh(e.headers), $metadata: St(e), Body: e.body })];
          throw new Error("Got empty response body.");
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, ww = Kt(br, Qh, _w, Nn(Nn({}, Lt), { responseType: "blob" })), Sw = function(e, r) {
  return Nl(void 0, void 0, void 0, function() {
    var t, n, a, i, o, l, h, s, f, p, m, w, S;
    return Ll(this, function(E) {
      switch (E.label) {
        case 0:
          return t = Lt.endpointResolver(e, r), [4, Qh(r, t)];
        case 1:
          n = E.sent(), a = n.url, i = n.headers, o = n.method, a.searchParams.append(Gu, Th), a.searchParams.append((S = e.userAgentHeader) !== null && S !== void 0 ? S : L_, e.userAgentValue);
          try {
            for (l = bw(Object.entries(i).sort(function(x, j) {
              var O = bu(x, 1), I = O[0], M = bu(j, 1), k = M[0];
              return I.localeCompare(k);
            })), h = l.next(); !h.done; h = l.next())
              s = bu(h.value, 2), f = s[0], p = s[1], a.searchParams.append(f, p);
          } catch (x) {
            m = { error: x };
          } finally {
            try {
              h && !h.done && (w = l.return) && w.call(l);
            } finally {
              if (m)
                throw m.error;
            }
          }
          return [2, Sb({ method: o, url: a, body: null }, Nn(Nn({}, Lt), e)).toString()];
      }
    });
  });
}, Fa = globalThis && globalThis.__assign || function() {
  return Fa = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Fa.apply(this, arguments);
}, xw = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Tw = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ew = function(e, r) {
  var t = fi({
    "x-amz-request-payer": e.RequestPayer,
    "x-amz-expected-bucket-owner": e.ExpectedBucketOwner
  }), n = fi({
    "list-type": "2",
    "continuation-token": e.ContinuationToken,
    delimiter: e.Delimiter,
    "encoding-type": e.EncodingType,
    "fetch-owner": e.FetchOwner,
    "max-keys": e.MaxKeys,
    prefix: e.Prefix,
    "start-after": e.StartAfter
  }), a = new URL(r.url.toString());
  return a.search = new URLSearchParams(n).toString(), {
    method: "GET",
    headers: t,
    url: a
  };
}, Ow = function(e) {
  return xw(void 0, void 0, void 0, function() {
    var r, t, n;
    return Tw(this, function(a) {
      switch (a.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = a.sent(), r;
        case 2:
          return [4, yi(e)];
        case 3:
          return t = a.sent(), n = Ft(t, {
            CommonPrefixes: [
              "CommonPrefixes",
              function(i) {
                return Vs(i, Cw);
              }
            ],
            Contents: [
              "Contents",
              function(i) {
                return Vs(i, Dw);
              }
            ],
            ContinuationToken: "ContinuationToken",
            Delimiter: "Delimiter",
            EncodingType: "EncodingType",
            IsTruncated: ["IsTruncated", Gs],
            KeyCount: ["KeyCount", jr],
            MaxKeys: ["MaxKeys", jr],
            Name: "Name",
            NextContinuationToken: "NextContinuationToken",
            Prefix: "Prefix",
            StartAfter: "StartAfter"
          }), [2, Fa({ $metadata: St(e) }, n)];
      }
    });
  });
}, Cw = function(e) {
  return e.map(kw);
}, kw = function(e) {
  return Ft(e, {
    Prefix: "Prefix"
  });
}, Dw = function(e) {
  return e.map(jw);
}, jw = function(e) {
  return Ft(e, {
    Key: "Key",
    LastModified: ["LastModified", ka],
    ETag: "ETag",
    ChecksumAlgorithm: [
      "ChecksumAlgorithm",
      function(r) {
        return Vs(r, Mw);
      }
    ],
    Size: ["Size", jr],
    StorageClass: "StorageClass",
    Owner: ["Owner", Pw]
  });
}, Mw = function(e) {
  return e.map(function(r) {
    return String(r);
  });
}, Pw = function(e) {
  return Ft(e, { DisplayName: "DisplayName", ID: "ID" });
}, e0 = Kt(br, Ew, Ow, Fa(Fa({}, Lt), { responseType: "text" })), Mr = globalThis && globalThis.__assign || function() {
  return Mr = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Mr.apply(this, arguments);
}, t0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, r0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Aw = function(e, r) {
  return t0(void 0, void 0, void 0, function() {
    var t, n, a, i;
    return r0(this, function(o) {
      switch (o.label) {
        case 0:
          return n = [{}], [4, Il(Mr(Mr({}, e), { ContentType: (i = e.ContentType) !== null && i !== void 0 ? i : "application/octet-stream" }))];
        case 1:
          return t = Mr.apply(void 0, [Mr.apply(void 0, n.concat([o.sent()])), fi({ "content-md5": e.ContentMD5 })]), a = new URL(r.url.toString()), a.pathname = Nr(a, e.Key), [2, {
            method: "PUT",
            headers: t,
            url: a,
            body: e.Body
          }];
      }
    });
  });
}, Rw = function(e) {
  return t0(void 0, void 0, void 0, function() {
    var r;
    return r0(this, function(t) {
      switch (t.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = t.sent(), r;
        case 2:
          return [2, Mr(Mr({}, Ft(e.headers, {
            ETag: "etag",
            VersionId: "x-amz-version-id"
          })), { $metadata: St(e) })];
      }
    });
  });
}, Iw = Kt(br, Aw, Rw, Mr(Mr({}, Lt), { responseType: "text" })), $a = globalThis && globalThis.__assign || function() {
  return $a = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, $a.apply(this, arguments);
}, n0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, i0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Nw = function(e, r) {
  return n0(void 0, void 0, void 0, function() {
    var t, n;
    return i0(this, function(a) {
      switch (a.label) {
        case 0:
          return [4, Il(e)];
        case 1:
          return t = a.sent(), n = new URL(r.url.toString()), n.pathname = Nr(n, e.Key), n.search = "uploads", [2, {
            method: "POST",
            headers: t,
            url: n
          }];
      }
    });
  });
}, Lw = function(e) {
  return n0(void 0, void 0, void 0, function() {
    var r, t, n;
    return i0(this, function(a) {
      switch (a.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = a.sent(), r;
        case 2:
          return [4, yi(e)];
        case 3:
          return t = a.sent(), n = Ft(t, {
            UploadId: "UploadId"
          }), [2, $a({ $metadata: St(e) }, n)];
      }
    });
  });
}, a0 = Kt(br, Nw, Lw, $a($a({}, Lt), { responseType: "text" })), Ln = globalThis && globalThis.__assign || function() {
  return Ln = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ln.apply(this, arguments);
}, s0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, o0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Fw = function(e, r) {
  return s0(void 0, void 0, void 0, function() {
    var t, n, a;
    return o0(this, function(i) {
      switch (i.label) {
        case 0:
          return n = [{}], [4, ra(e)];
        case 1:
          return t = Ln.apply(void 0, [Ln.apply(void 0, n.concat([i.sent()])), fi({ "content-md5": e.ContentMD5 })]), t["content-type"] = "application/octet-stream", a = new URL(r.url.toString()), a.pathname = Nr(a, e.Key), a.search = new URLSearchParams({
            partNumber: e.PartNumber + "",
            uploadId: e.UploadId
          }).toString(), [2, {
            method: "PUT",
            headers: t,
            url: a,
            body: e.Body
          }];
      }
    });
  });
}, $w = function(e) {
  return s0(void 0, void 0, void 0, function() {
    var r;
    return o0(this, function(t) {
      switch (t.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = t.sent(), r;
        case 2:
          return [2, Ln(Ln({}, Ft(e.headers, {
            ETag: "etag"
          })), { $metadata: St(e) })];
      }
    });
  });
}, u0 = Kt(br, Fw, $w, Ln(Ln({}, Lt), { responseType: "text" })), di = globalThis && globalThis.__assign || function() {
  return di = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, di.apply(this, arguments);
}, xo = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, To = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, l0 = "Invalid parameter for ComplteMultipartUpload API", Yw = function(e, r) {
  return xo(void 0, void 0, void 0, function() {
    var t, n;
    return To(this, function(a) {
      switch (a.label) {
        case 0:
          return [4, ra(e)];
        case 1:
          return t = a.sent(), t["content-type"] = "application/xml", n = new URL(r.url.toString()), n.pathname = Nr(n, e.Key), n.search = new URLSearchParams({ uploadId: e.UploadId }).toString(), [2, {
            method: "POST",
            headers: t,
            url: n,
            body: '<?xml version="1.0" encoding="UTF-8"?>' + Uw(e.MultipartUpload)
          }];
      }
    });
  });
}, Uw = function(e) {
  var r;
  if (!(!((r = e.Parts) === null || r === void 0) && r.length))
    throw new Error("".concat(l0, ": ").concat(e));
  return '<CompleteMultipartUpload xmlns="http://s3.amazonaws.com/doc/2006-03-01/">'.concat(e.Parts.map(zw).join(""), "</CompleteMultipartUpload>");
}, zw = function(e) {
  if (!e.ETag || e.PartNumber == null)
    throw new Error("".concat(l0, ": ").concat(e));
  return "<Part><ETag>".concat(e.ETag, "</ETag><PartNumber>").concat(e.PartNumber, "</PartNumber></Part>");
}, Ww = function(e) {
  return xo(void 0, void 0, void 0, function() {
    var r, t;
    return To(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, yi(e)];
        case 1:
          return r = n.sent(), r.Code !== void 0 && r.Message !== void 0 ? [4, qt(di(di({}, e), { statusCode: 500 }))] : [3, 3];
        case 2:
          throw t = n.sent(), t.$metadata.httpStatusCode = e.statusCode, t;
        case 3:
          return [2, r];
      }
    });
  });
}, Bw = function(e) {
  return xo(void 0, void 0, void 0, function() {
    var r, t, n;
    return To(this, function(a) {
      switch (a.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = a.sent(), r;
        case 2:
          return [4, Ww(e)];
        case 3:
          return t = a.sent(), n = Ft(t, {
            ETag: "ETag",
            Key: "Key",
            Location: "Location"
          }), [2, di({ $metadata: St(e) }, n)];
      }
    });
  });
}, Hw = function(e, r) {
  return xo(void 0, void 0, void 0, function() {
    var t, n;
    return To(this, function(a) {
      switch (a.label) {
        case 0:
          return e.statusCode !== 200 ? [3, 2] : e.body ? [4, yi(e)] : [2, !0];
        case 1:
          return t = a.sent(), t.Code !== void 0 && t.Message !== void 0 ? [2, !0] : [2, !1];
        case 2:
          return n = Lt.retryDecider, [2, n(e, r)];
      }
    });
  });
}, c0 = Kt(br, Yw, Bw, di(di({}, Lt), { responseType: "text", retryDecider: Hw })), Ya = globalThis && globalThis.__assign || function() {
  return Ya = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ya.apply(this, arguments);
}, f0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, d0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Gw = function(e, r) {
  return f0(void 0, void 0, void 0, function() {
    var t, n;
    return d0(this, function(a) {
      switch (a.label) {
        case 0:
          return [4, ra(e)];
        case 1:
          return t = a.sent(), n = new URL(r.url.toString()), n.pathname = Nr(n, e.Key), n.search = new URLSearchParams({
            uploadId: e.UploadId
          }).toString(), [2, {
            method: "GET",
            headers: t,
            url: n
          }];
      }
    });
  });
}, Vw = function(e) {
  return f0(void 0, void 0, void 0, function() {
    var r, t, n;
    return d0(this, function(a) {
      switch (a.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = a.sent(), r;
        case 2:
          return [4, yi(e)];
        case 3:
          return t = a.sent(), n = Ft(t, {
            UploadId: "UploadId",
            Parts: [
              "Part",
              function(i) {
                return Vs(i, Kw);
              }
            ]
          }), [2, Ya({ $metadata: St(e) }, n)];
      }
    });
  });
}, Kw = function(e) {
  return e.map(function(r) {
    return Ft(r, {
      PartNumber: ["PartNumber", jr],
      ETag: "ETag",
      Size: ["Size", jr]
    });
  });
}, h0 = Kt(br, Gw, Vw, Ya(Ya({}, Lt), { responseType: "text" })), Ks = globalThis && globalThis.__assign || function() {
  return Ks = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ks.apply(this, arguments);
}, qw = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Zw = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Jw = function(e, r) {
  var t = new URL(r.url.toString());
  return t.pathname = Nr(t, e.Key), t.search = new URLSearchParams({
    uploadId: e.UploadId
  }).toString(), {
    method: "DELETE",
    headers: {},
    url: t
  };
}, Xw = function(e) {
  return qw(void 0, void 0, void 0, function() {
    var r;
    return Zw(this, function(t) {
      switch (t.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = t.sent(), r;
        case 2:
          return [2, {
            $metadata: St(e)
          }];
      }
    });
  });
}, y0 = Kt(br, Jw, Xw, Ks(Ks({}, Lt), { responseType: "text" })), Ji = globalThis && globalThis.__assign || function() {
  return Ji = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ji.apply(this, arguments);
}, g0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, p0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Qw = function(e, r) {
  return g0(void 0, void 0, void 0, function() {
    var t, n, a;
    return p0(this, function(i) {
      switch (i.label) {
        case 0:
          return n = [{}], [4, Il(e)];
        case 1:
          return t = Ji.apply(void 0, [Ji.apply(void 0, n.concat([i.sent()])), fi({
            "x-amz-copy-source": e.CopySource,
            "x-amz-metadata-directive": e.MetadataDirective
          })]), a = new URL(r.url.toString()), a.pathname = Nr(a, e.Key), [2, {
            method: "PUT",
            headers: t,
            url: a
          }];
      }
    });
  });
}, e3 = function(e) {
  return g0(void 0, void 0, void 0, function() {
    var r;
    return p0(this, function(t) {
      switch (t.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = t.sent(), r;
        case 2:
          return [4, yi(e)];
        case 3:
          return t.sent(), [2, {
            $metadata: St(e)
          }];
      }
    });
  });
}, t3 = Kt(br, Qw, e3, Ji(Ji({}, Lt), { responseType: "text" })), ui = globalThis && globalThis.__assign || function() {
  return ui = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ui.apply(this, arguments);
}, v0 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, m0 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, r3 = function(e, r) {
  return v0(void 0, void 0, void 0, function() {
    var t, n;
    return m0(this, function(a) {
      switch (a.label) {
        case 0:
          return [4, ra(e)];
        case 1:
          return t = a.sent(), n = new URL(r.url.toString()), n.pathname = Nr(n, e.Key), [2, {
            method: "HEAD",
            headers: t,
            url: n
          }];
      }
    });
  });
}, n3 = function(e) {
  return v0(void 0, void 0, void 0, function() {
    var r, t;
    return m0(this, function(n) {
      switch (n.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = n.sent(), r;
        case 2:
          return t = ui(ui({}, Ft(e.headers, {
            ContentLength: ["content-length", jr],
            ContentType: "content-type",
            ETag: "etag",
            LastModified: ["last-modified", ka],
            VersionId: "x-amz-version-id"
          })), { Metadata: Zh(e.headers) }), [2, ui({ $metadata: St(e) }, t)];
      }
    });
  });
}, Hf = Kt(br, r3, n3, ui(ui({}, Lt), { responseType: "text" })), Xi = globalThis && globalThis.__assign || function() {
  return Xi = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Xi.apply(this, arguments);
}, i3 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, a3 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, s3 = function(e, r) {
  var t = new URL(r.url.toString());
  return t.pathname = Nr(t, e.Key), {
    method: "DELETE",
    headers: {},
    url: t
  };
}, o3 = function(e) {
  return i3(void 0, void 0, void 0, function() {
    var r, t;
    return a3(this, function(n) {
      switch (n.label) {
        case 0:
          return e.statusCode >= 300 ? [4, qt(e)] : [3, 2];
        case 1:
          throw r = n.sent(), r;
        case 2:
          return t = Ft(e.headers, {
            DeleteMarker: ["x-amz-delete-marker", Gs],
            VersionId: "x-amz-version-id",
            RequestCharged: "x-amz-request-charged"
          }), [2, Xi(Xi({}, t), { $metadata: St(e) })];
      }
    });
  });
}, u3 = Kt(br, s3, o3, Xi(Xi({}, Lt), { responseType: "text" })), Cr;
(function(e) {
  e.NO_CREDENTIALS = "No credentials", e.NO_SRC_KEY = 'source param should be an object with the property "key" with value of type string', e.NO_DEST_KEY = 'destination param should be an object with the property "key" with value of type string', e.INVALID_BLOB = "Object must be an instance of Blob";
})(Cr || (Cr = {}));
var Gf;
(function(e) {
  e.CLEANUP_FAILED = "Multipart copy clean up failed", e.NO_OBJECT_FOUND = "Object does not exist", e.INVALID_QUEUESIZE = "Queue size must be a positive number", e.NO_COPYSOURCE = "You must specify a copy source", e.MAX_NUM_PARTS_EXCEEDED = "Only a maximum of 10000 parts are allowed";
})(Gf || (Gf = {}));
var Vf;
(function(e) {
  e.UPLOAD_PAUSED_MESSAGE = "paused";
})(Vf || (Vf = {}));
var l3 = typeof Symbol < "u" && typeof Symbol.for == "function" ? Symbol.for("amplify_default") : "@@amplify_default", c3 = "http://localhost:20005", Sa = "__uploadInProgress", f3 = function(e) {
  if (typeof e == "string")
    return e.length;
  if (y3(e))
    return e.byteLength;
  if (h3(e))
    return e.size;
  throw new Error("Cannot determine byte length of " + e);
}, vt = function(e, r, t, n, a) {
  if (e) {
    var i = { attrs: t };
    n && (i.metrics = n), Na.dispatch("storage", {
      event: r,
      data: i,
      message: a
    }, "Storage", l3);
  }
}, d3 = function(e) {
  return typeof e < "u" && e instanceof File;
}, h3 = function(e) {
  return typeof e < "u" && e instanceof Blob;
}, y3 = function(e) {
  return typeof e < "u" && e instanceof ArrayBuffer;
}, ja = globalThis && globalThis.__assign || function() {
  return ja = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ja.apply(this, arguments);
}, g3 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, p3 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Kf = new et("S3ClientUtils"), qf = { accessKeyId: "", secretAccessKey: "" }, b0 = function(e) {
  var r = e.credentials, t = e.level, n = e.customPrefix, a = e.identityId, i = n || {}, o = a || r.identityId, l = (i.private !== void 0 ? i.private : "private/") + o + "/", h = (i.protected !== void 0 ? i.protected : "protected/") + o + "/", s = i.public !== void 0 ? i.public : "public/";
  switch (t) {
    case "private":
      return l;
    case "protected":
      return h;
    default:
      return s;
  }
}, _0 = function() {
  return g3(void 0, void 0, void 0, function() {
    var e, r, t;
    return p3(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, ii.get()];
        case 1:
          return e = n.sent(), e ? (r = ii.shear(e), Kf.debug("credentials provider get credentials", r), [2, r]) : [2, qf];
        case 2:
          return t = n.sent(), Kf.warn("credentials provider error", t), [2, qf];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Qn = function(e) {
  if (!e.region)
    throw new Error("Region is missing.");
  return ja(ja(ja({}, e), { region: e.region, credentials: e.credentials ? function() {
    return Promise.resolve(e.credentials);
  } : _0, userAgentValue: fo({
    category: Nu.Storage,
    action: e.storageAction
  }) }), e.dangerouslyConnectToHttpEndpointForTesting ? {
    customEndpoint: c3,
    forcePathStyle: !0
  } : {});
}, w0 = 1024 * 1024, v3 = 1024 * w0, m3 = 1024 * v3, qs = 5 * w0, S0 = 5 * m3, b3 = 1e4, Qu = 4, x0 = function(e) {
  for (var r = qs, t = Math.ceil(e / r); t > b3; )
    r *= 2, t = Math.ceil(e / r);
  return r;
}, Fl = { exports: {} }, Hi = typeof Reflect == "object" ? Reflect : null, Zf = Hi && typeof Hi.apply == "function" ? Hi.apply : function(r, t, n) {
  return Function.prototype.apply.call(r, t, n);
}, Ms;
Hi && typeof Hi.ownKeys == "function" ? Ms = Hi.ownKeys : Object.getOwnPropertySymbols ? Ms = function(r) {
  return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
} : Ms = function(r) {
  return Object.getOwnPropertyNames(r);
};
function _3(e) {
  console && console.warn && console.warn(e);
}
var T0 = Number.isNaN || function(r) {
  return r !== r;
};
function Te() {
  Te.init.call(this);
}
Fl.exports = Te;
Fl.exports.once = T3;
Te.EventEmitter = Te;
Te.prototype._events = void 0;
Te.prototype._eventsCount = 0;
Te.prototype._maxListeners = void 0;
var Jf = 10;
function Eo(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(Te, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Jf;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || T0(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    Jf = e;
  }
});
Te.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Te.prototype.setMaxListeners = function(r) {
  if (typeof r != "number" || r < 0 || T0(r))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + r + ".");
  return this._maxListeners = r, this;
};
function E0(e) {
  return e._maxListeners === void 0 ? Te.defaultMaxListeners : e._maxListeners;
}
Te.prototype.getMaxListeners = function() {
  return E0(this);
};
Te.prototype.emit = function(r) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t.push(arguments[n]);
  var a = r === "error", i = this._events;
  if (i !== void 0)
    a = a && i.error === void 0;
  else if (!a)
    return !1;
  if (a) {
    var o;
    if (t.length > 0 && (o = t[0]), o instanceof Error)
      throw o;
    var l = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw l.context = o, l;
  }
  var h = i[r];
  if (h === void 0)
    return !1;
  if (typeof h == "function")
    Zf(h, this, t);
  else
    for (var s = h.length, f = j0(h, s), n = 0; n < s; ++n)
      Zf(f[n], this, t);
  return !0;
};
function O0(e, r, t, n) {
  var a, i, o;
  if (Eo(t), i = e._events, i === void 0 ? (i = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (i.newListener !== void 0 && (e.emit(
    "newListener",
    r,
    t.listener ? t.listener : t
  ), i = e._events), o = i[r]), o === void 0)
    o = i[r] = t, ++e._eventsCount;
  else if (typeof o == "function" ? o = i[r] = n ? [t, o] : [o, t] : n ? o.unshift(t) : o.push(t), a = E0(e), a > 0 && o.length > a && !o.warned) {
    o.warned = !0;
    var l = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(r) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = r, l.count = o.length, _3(l);
  }
  return e;
}
Te.prototype.addListener = function(r, t) {
  return O0(this, r, t, !1);
};
Te.prototype.on = Te.prototype.addListener;
Te.prototype.prependListener = function(r, t) {
  return O0(this, r, t, !0);
};
function w3() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function C0(e, r, t) {
  var n = { fired: !1, wrapFn: void 0, target: e, type: r, listener: t }, a = w3.bind(n);
  return a.listener = t, n.wrapFn = a, a;
}
Te.prototype.once = function(r, t) {
  return Eo(t), this.on(r, C0(this, r, t)), this;
};
Te.prototype.prependOnceListener = function(r, t) {
  return Eo(t), this.prependListener(r, C0(this, r, t)), this;
};
Te.prototype.removeListener = function(r, t) {
  var n, a, i, o, l;
  if (Eo(t), a = this._events, a === void 0)
    return this;
  if (n = a[r], n === void 0)
    return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete a[r], a.removeListener && this.emit("removeListener", r, n.listener || t));
  else if (typeof n != "function") {
    for (i = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === t || n[o].listener === t) {
        l = n[o].listener, i = o;
        break;
      }
    if (i < 0)
      return this;
    i === 0 ? n.shift() : S3(n, i), n.length === 1 && (a[r] = n[0]), a.removeListener !== void 0 && this.emit("removeListener", r, l || t);
  }
  return this;
};
Te.prototype.off = Te.prototype.removeListener;
Te.prototype.removeAllListeners = function(r) {
  var t, n, a;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[r] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[r]), this;
  if (arguments.length === 0) {
    var i = Object.keys(n), o;
    for (a = 0; a < i.length; ++a)
      o = i[a], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[r], typeof t == "function")
    this.removeListener(r, t);
  else if (t !== void 0)
    for (a = t.length - 1; a >= 0; a--)
      this.removeListener(r, t[a]);
  return this;
};
function k0(e, r, t) {
  var n = e._events;
  if (n === void 0)
    return [];
  var a = n[r];
  return a === void 0 ? [] : typeof a == "function" ? t ? [a.listener || a] : [a] : t ? x3(a) : j0(a, a.length);
}
Te.prototype.listeners = function(r) {
  return k0(this, r, !0);
};
Te.prototype.rawListeners = function(r) {
  return k0(this, r, !1);
};
Te.listenerCount = function(e, r) {
  return typeof e.listenerCount == "function" ? e.listenerCount(r) : D0.call(e, r);
};
Te.prototype.listenerCount = D0;
function D0(e) {
  var r = this._events;
  if (r !== void 0) {
    var t = r[e];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Te.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Ms(this._events) : [];
};
function j0(e, r) {
  for (var t = new Array(r), n = 0; n < r; ++n)
    t[n] = e[n];
  return t;
}
function S3(e, r) {
  for (; r + 1 < e.length; r++)
    e[r] = e[r + 1];
  e.pop();
}
function x3(e) {
  for (var r = new Array(e.length), t = 0; t < r.length; ++t)
    r[t] = e[t].listener || e[t];
  return r;
}
function T3(e, r) {
  return new Promise(function(t, n) {
    function a(o) {
      e.removeListener(r, i), n(o);
    }
    function i() {
      typeof e.removeListener == "function" && e.removeListener("error", a), t([].slice.call(arguments));
    }
    M0(e, r, i, { once: !0 }), r !== "error" && E3(e, a, { once: !0 });
  });
}
function E3(e, r, t) {
  typeof e.on == "function" && M0(e, "error", r, t);
}
function M0(e, r, t, n) {
  if (typeof e.on == "function")
    n.once ? e.once(r, t) : e.on(r, t);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(r, function a(i) {
      n.once && e.removeEventListener(r, a), t(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var el = Fl.exports, O3 = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, C3 = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Xf = function(e) {
  return O3(void 0, void 0, void 0, function() {
    var r, t, n;
    return C3(this, function(a) {
      switch (a.label) {
        case 0:
          return r = new Jh(), typeof e != "string" ? [3, 1] : (r.update(e), [3, 3]);
        case 1:
          return [4, k3(e)];
        case 2:
          t = a.sent(), r.update(t), a.label = 3;
        case 3:
          return [4, r.digest()];
        case 4:
          return n = a.sent(), [2, Zu(n)];
      }
    });
  });
}, k3 = function(e) {
  return new Promise(function(r, t) {
    var n = new FileReader();
    n.onloadend = function() {
      n.result && r(n.result), n.onabort = function() {
        return t(new Error("Read aborted"));
      }, n.onerror = function() {
        return t(n.error);
      };
    }, e !== void 0 && n.readAsArrayBuffer(e);
  });
}, Dt = globalThis && globalThis.__assign || function() {
  return Dt = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Dt.apply(this, arguments);
}, Gn = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Vn = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ni = new et("AWSS3ProviderManagedUpload"), D3 = (
  /** @class */
  function() {
    function e(r, t, n) {
      this.opts = null, this.completedParts = [], this.partSize = qs, this.bytesUploaded = 0, this.totalBytesToUpload = 0, this.emitter = null, this.params = r, this.opts = Dt({ isObjectLockEnabled: !1 }, t), this.emitter = n, this.s3Config = Qn(Dt(Dt({}, t), { emitter: n, storageAction: an.Put }));
    }
    return e.prototype.upload = function() {
      return Gn(this, void 0, void 0, function() {
        var r, t, n, a, i, o, l, h, s, f, p, m = this;
        return Vn(this, function(w) {
          switch (w.label) {
            case 0:
              return w.trys.push([0, 12, , 14]), r = this.opts.isObjectLockEnabled, r !== !0 ? [3, 2] : (t = this.params, [4, Xf(
                // @ts-expect-error currently ReadableStream<any> is not being supported in put api
                this.params.Body
              )]);
            case 1:
              t.ContentMD5 = w.sent(), w.label = 2;
            case 2:
              return this.body = this.validateAndSanitizeBody(this.params.Body), this.totalBytesToUpload = this.byteLength(this.body), this.totalBytesToUpload <= qs ? (this.params.Body = this.body, n = Iw, a = [this.s3Config], i = [Dt({}, this.params)], p = {}, [4, this.getObjectKeyWithPrefix(this.params.Key)]) : [3, 4];
            case 3:
              return [2, n.apply(void 0, a.concat([Dt.apply(void 0, i.concat([(p.Key = w.sent(), p)]))]))];
            case 4:
              return this.partSize = x0(this.totalBytesToUpload), o = this, [4, this.createMultiPartUpload()];
            case 5:
              o.uploadId = w.sent(), l = Math.ceil(this.totalBytesToUpload / this.partSize), h = this.createParts(), s = 0, w.label = 6;
            case 6:
              return s < l ? [4, this.uploadParts(this.uploadId, h.slice(s, s + Qu))] : [3, 9];
            case 7:
              w.sent(), w.label = 8;
            case 8:
              return s += Qu, [3, 6];
            case 9:
              return h.map(function(S) {
                m.removeEventListener(S);
              }), [4, this.finishMultiPartUpload(this.uploadId)];
            case 10:
              return [2, w.sent()];
            case 11:
              return [3, 14];
            case 12:
              return f = w.sent(), [4, this.cleanup(this.uploadId)];
            case 13:
              throw w.sent(), Ni.error("Error. Cancelling the multipart upload."), f;
            case 14:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.createParts = function() {
      try {
        for (var r = [], t = 0; t < this.totalBytesToUpload; ) {
          var n = Math.min(t + this.partSize, this.totalBytesToUpload);
          r.push({
            bodyPart: this.body.slice(t, n),
            partNumber: r.length + 1,
            emitter: new el.EventEmitter(),
            _lastUploadedBytes: 0
          }), t += this.partSize;
        }
        return r;
      } catch (a) {
        throw Ni.error(a), a;
      }
    }, e.prototype.createMultiPartUpload = function() {
      return Gn(this, void 0, void 0, function() {
        var r, t, n, a, i, o;
        return Vn(this, function(l) {
          switch (l.label) {
            case 0:
              return l.trys.push([0, 3, , 4]), t = a0, n = [this.s3Config], a = [Dt({}, this.params)], o = {}, [4, this.getObjectKeyWithPrefix(this.params.Key)];
            case 1:
              return [4, t.apply(void 0, n.concat([Dt.apply(void 0, a.concat([(o.Key = l.sent(), o)]))]))];
            case 2:
              return r = l.sent(), Ni.debug(r.UploadId), [2, r.UploadId];
            case 3:
              throw i = l.sent(), Ni.error(i), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.uploadParts = function(r, t) {
      return Gn(this, void 0, void 0, function() {
        var n, a, i, o = this;
        return Vn(this, function(l) {
          switch (l.label) {
            case 0:
              return l.trys.push([0, 2, , 3]), [4, Promise.all(t.map(function(h) {
                return Gn(o, void 0, void 0, function() {
                  var s, f, p, m, w, S, E, x, j, O, I, M;
                  return Vn(this, function(k) {
                    switch (k.label) {
                      case 0:
                        return this.setupEventListener(h), s = this.opts.isObjectLockEnabled, s ? (f = this.params, [4, Xf(h.bodyPart)]) : [3, 2];
                      case 1:
                        f.ContentMD5 = k.sent(), k.label = 2;
                      case 2:
                        return p = this.params, p.Key, m = p.Bucket, w = p.SSECustomerAlgorithm, S = p.SSECustomerKey, E = p.SSECustomerKeyMD5, x = p.ContentMD5, O = u0, I = [Dt(Dt({}, this.s3Config), { emitter: h.emitter })], M = {
                          PartNumber: h.partNumber,
                          Body: h.bodyPart,
                          UploadId: r
                        }, [4, this.getObjectKeyWithPrefix(this.params.Key)];
                      case 3:
                        return [4, O.apply(void 0, I.concat([(M.Key = k.sent(), M.Bucket = m, M.SSECustomerAlgorithm = w, M.SSECustomerKey = S, M.SSECustomerKeyMD5 = E, M.ContentMD5 = x, M)]))];
                      case 4:
                        return j = k.sent(), [2, j];
                    }
                  });
                });
              }))];
            case 1:
              for (n = l.sent(), a = 0; a < n.length; a++)
                this.completedParts.push({
                  PartNumber: t[a].partNumber,
                  ETag: n[a].ETag
                });
              return [3, 3];
            case 2:
              throw i = l.sent(), Ni.error("Error happened while uploading a part. Cancelling the multipart upload"), i;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.finishMultiPartUpload = function(r) {
      return Gn(this, void 0, void 0, function() {
        var t, n, a, i;
        return Vn(this, function(o) {
          switch (o.label) {
            case 0:
              return i = {
                Bucket: this.params.Bucket
              }, [4, this.getObjectKeyWithPrefix(this.params.Key)];
            case 1:
              t = (i.Key = o.sent(), i.UploadId = r, i.MultipartUpload = { Parts: this.completedParts }, i), o.label = 2;
            case 2:
              return o.trys.push([2, 4, , 5]), [4, c0(Dt(Dt({}, this.s3Config), { emitter: void 0 }), t)];
            case 3:
              return n = o.sent().Key, [2, n];
            case 4:
              throw a = o.sent(), Ni.error("Error happened while finishing the upload."), a;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.cleanup = function(r) {
      return Gn(this, void 0, void 0, function() {
        var t, n, a;
        return Vn(this, function(i) {
          switch (i.label) {
            case 0:
              return this.body = null, this.completedParts = [], this.bytesUploaded = 0, this.totalBytesToUpload = 0, r ? (a = {
                Bucket: this.params.Bucket
              }, [4, this.getObjectKeyWithPrefix(this.params.Key)]) : [
                2
                /*return*/
              ];
            case 1:
              return t = (a.Key = i.sent(), a.UploadId = r, a), [4, y0(this.s3Config, t)];
            case 2:
              return i.sent(), [4, h0(this.s3Config, t)];
            case 3:
              if (n = i.sent(), n && n.Parts && n.Parts.length > 0)
                throw new Error("Multipart upload clean up failed.");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.removeEventListener = function(r) {
      r.emitter.removeAllListeners(Ca), r.emitter.removeAllListeners(Hs);
    }, e.prototype.setupEventListener = function(r) {
      var t = this;
      r.emitter.on(Ca, function(n) {
        t.progressChanged(r.partNumber, n.loaded - r._lastUploadedBytes), r._lastUploadedBytes = n.loaded;
      });
    }, e.prototype.progressChanged = function(r, t) {
      this.bytesUploaded += t, this.emitter.emit(Ca, {
        loaded: this.bytesUploaded,
        total: this.totalBytesToUpload,
        part: r,
        key: this.params.Key
      });
    }, e.prototype.byteLength = function(r) {
      if (r == null)
        return 0;
      if (typeof r.byteLength == "number")
        return r.byteLength;
      if (typeof r.length == "number")
        return r.length;
      if (typeof r.size == "number")
        return r.size;
      if (typeof r.path != "string")
        throw new Error("Cannot determine length of " + r);
    }, e.prototype.validateAndSanitizeBody = function(r) {
      var t = this.isGenericObject(r) ? JSON.stringify(r) : r;
      if (this.byteLength(t) > S0)
        throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytesToUpload, " Bytes"));
      return t;
    }, e.prototype.isGenericObject = function(r) {
      if (r !== null && typeof r == "object")
        try {
          return !(this.byteLength(r) >= 0);
        } catch {
          return !0;
        }
      return !1;
    }, e.prototype.getObjectKeyWithPrefix = function(r) {
      return Gn(this, void 0, void 0, function() {
        var t, n, a;
        return Vn(this, function(i) {
          switch (i.label) {
            case 0:
              return t = b0, n = [Dt({}, this.opts)], a = {}, [4, _0()];
            case 1:
              return [4, t.apply(void 0, [Dt.apply(void 0, n.concat([(a.credentials = i.sent(), a)]))])];
            case 2:
              return [2, i.sent() + r];
          }
        });
      });
    }, e;
  }()
), Dn = globalThis && globalThis.__assign || function() {
  return Dn = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Dn.apply(this, arguments);
}, zt = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, Wt = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Qf = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, ed = globalThis && globalThis.__spreadArray || function(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}, kt = new et("AWSS3UploadTask"), Be;
(function(e) {
  e[e.INIT = 0] = "INIT", e[e.IN_PROGRESS = 1] = "IN_PROGRESS", e[e.PAUSED = 2] = "PAUSED", e[e.CANCELLED = 3] = "CANCELLED", e[e.COMPLETED = 4] = "COMPLETED";
})(Be || (Be = {}));
var rr;
(function(e) {
  e.CANCEL = "cancel", e.UPLOAD_COMPLETE = "uploadComplete", e.UPLOAD_PROGRESS = "uploadPartProgress", e.ERROR = "error";
})(rr || (rr = {}));
function j3(e, r) {
  return e.PartNumber - r.PartNumber;
}
var P0 = (
  /** @class */
  function() {
    function e(r) {
      var t = r.s3Config, n = r.file, a = r.emitter, i = r.storage, o = r.params, l = r.level, h = r.prefixPromise;
      this.queueSize = Qu, this.partSize = qs, this.inProgress = [], this.completedParts = [], this.queued = [], this.bytesUploaded = 0, this.totalBytes = 0, this.state = Be.INIT, this.prefixPromise = h, this.s3Config = t, this.storage = i, this.storageSync = Promise.resolve(), typeof this.storage.sync == "function" && (this.storageSync = this.storage.sync()), this.params = o, this.file = n, this.totalBytes = this.file.size, this.bytesUploaded = 0, this.emitter = a, this.queued = [], this.fileId = this._getFileId(l), this._validateParams(), this.emitter.on(rr.ERROR, function() {
      });
    }
    return Object.defineProperty(e.prototype, "percent", {
      get: function() {
        return this.bytesUploaded / this.totalBytes * 100;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isInProgress", {
      get: function() {
        return this.state === Be.IN_PROGRESS;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._listSingleFile = function(r) {
      var t = r.key, n = r.bucket;
      return zt(this, void 0, void 0, function() {
        var a, i, o, l;
        return Wt(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this.prefixPromise];
            case 1:
              return a = h.sent(), [4, e0(this.s3Config, {
                Bucket: n,
                Prefix: a + t
              })];
            case 2:
              return i = h.sent().Contents, o = i === void 0 ? [] : i, l = o.find(function(s) {
                return s.Key === "".concat(a).concat(t);
              }), [2, l];
          }
        });
      });
    }, e.prototype._getFileId = function(r) {
      return d3(this.file) ? [
        this.file.name,
        this.file.lastModified,
        this.file.size,
        this.file.type,
        this.params.Bucket,
        r,
        this.params.Key
      ].join("-") : [
        this.file.size,
        this.file.type,
        this.params.Bucket,
        r,
        this.params.Key
      ].join("-");
    }, e.prototype._findCachedUploadParts = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n, a, i, o, l;
        return Wt(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              return r = h.sent(), Object.keys(r).length === 0 || !Object.prototype.hasOwnProperty.call(r, this.fileId) ? [2, { parts: [], uploadId: null }] : (t = r[this.fileId], t.lastTouched = Date.now(), this.storage.setItem(Sa, JSON.stringify(r)), i = h0, o = [this.s3Config], l = {
                Bucket: this.params.Bucket
              }, [4, this.prefixPromise]);
            case 2:
              return [4, i.apply(void 0, o.concat([(l.Key = h.sent() + this.params.Key, l.UploadId = t.uploadId, l)]))];
            case 3:
              return n = h.sent().Parts, a = n === void 0 ? [] : n, [2, {
                parts: a,
                uploadId: t.uploadId
              }];
          }
        });
      });
    }, e.prototype._emitEvent = function(r, t) {
      this.emitter.emit(r, t);
    }, e.prototype._validateParams = function() {
      if (this.totalBytes > S0)
        throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytes, " Bytes"));
    }, e.prototype._listCachedUploadTasks = function() {
      return zt(this, void 0, void 0, function() {
        var r;
        return Wt(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.storageSync];
            case 1:
              return t.sent(), r = this.storage.getItem(Sa) || "{}", [2, JSON.parse(r)];
          }
        });
      });
    }, e.prototype._cache = function(r) {
      return zt(this, void 0, void 0, function() {
        var t;
        return Wt(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              return t = n.sent(), t[this.fileId] = r, this.storage.setItem(Sa, JSON.stringify(t)), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._isCached = function() {
      return zt(this, void 0, void 0, function() {
        var r, t;
        return Wt(this, function(n) {
          switch (n.label) {
            case 0:
              return t = (r = Object.prototype.hasOwnProperty).call, [4, this._listCachedUploadTasks()];
            case 1:
              return [2, t.apply(r, [n.sent(), this.fileId])];
          }
        });
      });
    }, e.prototype._removeFromCache = function() {
      return zt(this, void 0, void 0, function() {
        var r;
        return Wt(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._listCachedUploadTasks()];
            case 1:
              return r = t.sent(), delete r[this.fileId], this.storage.setItem(Sa, JSON.stringify(r)), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._onPartUploadCompletion = function(r) {
      var t = r.eTag, n = r.partNumber, a = r.chunk;
      return zt(this, void 0, void 0, function() {
        return Wt(this, function(i) {
          return this.completedParts.push({
            ETag: t,
            PartNumber: n
          }), this.bytesUploaded += f3(a), this._emitEvent(rr.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
          }), this.inProgress = this.inProgress.filter(function(o) {
            return o.uploadPartInput.PartNumber !== n;
          }), this.queued.length && this.state !== Be.PAUSED && this._startNextPart(), this._isDone() && this._completeUpload(), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype._completeUpload = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n, a;
        return Wt(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 4, , 5]), r = c0, t = [this.s3Config], a = {
                Bucket: this.params.Bucket
              }, [4, this.prefixPromise];
            case 1:
              return [4, r.apply(void 0, t.concat([(a.Key = i.sent() + this.params.Key, a.UploadId = this.uploadId, a.MultipartUpload = {
                // Parts are not always completed in order, we need to manually sort them
                Parts: ed([], Qf(this.completedParts), !1).sort(j3)
              }, a)]))];
            case 2:
              return i.sent(), [4, this._verifyFileSize()];
            case 3:
              return i.sent(), this._emitEvent(rr.UPLOAD_COMPLETE, {
                key: this.params.Key
              }), this._removeFromCache(), this.state = Be.COMPLETED, [3, 5];
            case 4:
              return n = i.sent(), kt.error("error completing upload", n), this._emitEvent(rr.ERROR, n), [3, 5];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._makeUploadPartRequest = function(r, t) {
      return zt(this, void 0, void 0, function() {
        var n, a, i, o, l, h;
        return Wt(this, function(s) {
          switch (s.label) {
            case 0:
              return s.trys.push([0, 4, , 5]), a = u0, i = [Dn(Dn({}, this.s3Config), { abortSignal: t })], o = [Dn({}, r)], h = {}, [4, this.prefixPromise];
            case 1:
              return [4, a.apply(void 0, i.concat([Dn.apply(void 0, o.concat([(h.Key = s.sent() + this.params.Key, h)]))]))];
            case 2:
              return n = s.sent(), [4, this._onPartUploadCompletion({
                eTag: n.ETag,
                partNumber: r.PartNumber,
                chunk: r.Body
              })];
            case 3:
              return s.sent(), [3, 5];
            case 4:
              return l = s.sent(), this.state === Be.PAUSED ? kt.log("upload paused") : this.state === Be.CANCELLED ? kt.log("upload aborted") : kt.error("error starting next part of upload: ", l), !Ku(l) && l.message !== Hh && (this._emitEvent(rr.ERROR, l), this.pause()), [3, 5];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._startNextPart = function() {
      if (this.queued.length > 0 && this.state !== Be.PAUSED) {
        var r = new AbortController(), t = this.queued.shift();
        this.inProgress.push({
          uploadPartInput: t,
          s3Request: this._makeUploadPartRequest(t, r.signal),
          abortController: r
        });
      }
    }, e.prototype._verifyFileSize = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n;
        return Wt(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 2, , 3]), [4, this._listSingleFile({
                key: this.params.Key,
                bucket: this.params.Bucket
              })];
            case 1:
              return t = a.sent(), r = !!(t && t.Size === this.file.size), [3, 3];
            case 2:
              return n = a.sent(), kt.log("Could not get file on s3 for size matching: ", n), [
                2
                /*return*/
              ];
            case 3:
              if (!r)
                throw new Error("File size does not match between local file and file on s3");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._isDone = function() {
      return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    }, e.prototype._createParts = function() {
      for (var r = this.file.size, t = [], n = 0; n < r; ) {
        var a = Math.min(n + this.partSize, r);
        t.push({
          Body: this.file.slice(n, a),
          Key: this.params.Key,
          Bucket: this.params.Bucket,
          PartNumber: t.length + 1,
          UploadId: this.uploadId
        }), n += this.partSize;
      }
      return t;
    }, e.prototype._initCachedUploadParts = function(r) {
      this.bytesUploaded += r.reduce(function(n, a) {
        return n + a.Size;
      }, 0);
      var t = new Set(r.map(function(n) {
        return n.PartNumber;
      }));
      this.queued = this.queued.filter(function(n) {
        return !t.has(n.PartNumber);
      }), this.completedParts = r.map(function(n) {
        return {
          PartNumber: n.PartNumber,
          ETag: n.ETag
        };
      }), this._emitEvent(rr.UPLOAD_PROGRESS, {
        loaded: this.bytesUploaded,
        total: this.totalBytes
      });
    }, e.prototype._initMultipartUpload = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n, a, i;
        return Wt(this, function(o) {
          switch (o.label) {
            case 0:
              return t = a0, n = [this.s3Config], a = [Dn({}, this.params)], i = {}, [4, this.prefixPromise];
            case 1:
              return [4, t.apply(void 0, n.concat([Dn.apply(void 0, a.concat([(i.Key = o.sent() + this.params.Key, i)]))]))];
            case 2:
              return r = o.sent(), this._cache({
                uploadId: r.UploadId,
                lastTouched: Date.now(),
                bucket: this.params.Bucket,
                key: this.params.Key,
                fileName: this.file instanceof File ? this.file.name : ""
              }), [2, r.UploadId];
          }
        });
      });
    }, e.prototype._initializeUploadTask = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n, n, a;
        return Wt(this, function(i) {
          switch (i.label) {
            case 0:
              this.state = Be.IN_PROGRESS, this.partSize = x0(this.totalBytes), i.label = 1;
            case 1:
              return i.trys.push([1, 7, , 8]), [4, this._isCached()];
            case 2:
              return i.sent() ? [4, this._findCachedUploadParts()] : [3, 4];
            case 3:
              return r = i.sent(), t = r.parts, n = r.uploadId, this.uploadId = n, this.queued = this._createParts(), this._initCachedUploadParts(t), this._isDone() ? this._completeUpload() : this._startUpload(), [3, 6];
            case 4:
              return this.uploadId ? [3, 6] : [4, this._initMultipartUpload()];
            case 5:
              n = i.sent(), this.uploadId = n, this.queued = this._createParts(), this._startUpload(), i.label = 6;
            case 6:
              return [3, 8];
            case 7:
              return a = i.sent(), Ku(a) || (kt.error("Error initializing the upload task", a), this._emitEvent(rr.ERROR, a)), [3, 8];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.resume = function() {
      this.state === Be.CANCELLED ? kt.warn("This task has already been cancelled") : this.state === Be.COMPLETED ? kt.warn("This task has already been completed") : this.state === Be.IN_PROGRESS ? kt.warn("Upload task already in progress") : this.uploadId ? this._startUpload() : this._initializeUploadTask();
    }, e.prototype._startUpload = function() {
      this.state = Be.IN_PROGRESS;
      for (var r = 0; r < this.queueSize; r++)
        this._startNextPart();
    }, e.prototype._cancel = function() {
      return zt(this, void 0, void 0, function() {
        var r, t, n, a;
        return Wt(this, function(i) {
          switch (i.label) {
            case 0:
              return this.state !== Be.CANCELLED ? [3, 1] : (kt.warn("This task has already been cancelled"), [2, !1]);
            case 1:
              return this.state !== Be.COMPLETED ? [3, 2] : (kt.warn("This task has already been completed"), [2, !1]);
            case 2:
              this.pause(), this.queued = [], this.completedParts = [], this.bytesUploaded = 0, this.state = Be.CANCELLED, i.label = 3;
            case 3:
              return i.trys.push([3, 7, , 8]), r = y0, t = [this.s3Config], a = {
                Bucket: this.params.Bucket
              }, [4, this.prefixPromise];
            case 4:
              return [4, r.apply(void 0, t.concat([(a.Key = i.sent() + this.params.Key, a.UploadId = this.uploadId, a)]))];
            case 5:
              return i.sent(), [4, this._removeFromCache()];
            case 6:
              return i.sent(), [2, !0];
            case 7:
              return n = i.sent(), kt.error("Error cancelling upload task", n), [2, !1];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.pause = function() {
      var r;
      this.state === Be.CANCELLED ? kt.warn("This task has already been cancelled") : this.state === Be.COMPLETED ? kt.warn("This task has already been completed") : this.state === Be.PAUSED && kt.warn("This task is already paused"), this.state = Be.PAUSED;
      var t = this.inProgress.splice(0, this.inProgress.length);
      t.forEach(function(n) {
        n.abortController.abort();
      }), (r = this.queued).unshift.apply(r, ed([], Qf(t.map(function(n) {
        return n.uploadPartInput;
      })), !1));
    }, e;
  }()
), Ne = globalThis && globalThis.__assign || function() {
  return Ne = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ne.apply(this, arguments);
}, Kn = globalThis && globalThis.__awaiter || function(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function l(f) {
      try {
        s(n.next(f));
      } catch (p) {
        o(p);
      }
    }
    function h(f) {
      try {
        s(n.throw(f));
      } catch (p) {
        o(p);
      }
    }
    function s(f) {
      f.done ? i(f.value) : a(f.value).then(l, h);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, qn = globalThis && globalThis.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(s) {
    return function(f) {
      return h([s, f]);
    };
  }
  function h(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = s[0] & 2 ? a.return : s[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, s[1])).done)
          return i;
        switch (a = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, a = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], a = 0;
      } finally {
        n = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, td = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, rd = globalThis && globalThis.__spreadArray || function(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}, ze = new et("AWSS3Provider"), nd = "public", M3 = 900, P3 = (
  /** @class */
  function() {
    function e(r) {
      var t = this;
      this._config = r || {}, this._storage = new jl().getStorage(), Na.listen("auth", function(n) {
        var a = n.payload;
        (a.event === "signOut" || a.event === "signIn") && t._storage.removeItem(Sa);
      }), ze.debug("Storage Options", this._config);
    }
    return e.prototype.getCategory = function() {
      return e.CATEGORY;
    }, e.prototype.getProviderName = function() {
      return e.PROVIDER_NAME;
    }, e.prototype.configure = function(r) {
      if (ze.debug("configure Storage", r), !r)
        return this._config;
      var t = Dl(r);
      return this._config = Object.assign({}, this._config, t.Storage), this._config.bucket || ze.debug("Do not have bucket yet"), this._config;
    }, e.prototype.startResumableUpload = function(r, t) {
      var n, a = r.s3Config, i = r.emitter, o = r.key, l = r.file, h = r.params, s = t.progressCallback, f = t.completeCallback, p = t.errorCallback, m = (n = t.track, n === void 0 ? !1 : n);
      if (!(l instanceof Blob))
        throw new Error(Cr.INVALID_BLOB);
      i.on(rr.UPLOAD_PROGRESS, function(E) {
        s && (typeof s == "function" ? s(E) : ze.warn("progressCallback should be a function, not a " + typeof s));
      }), i.on(rr.UPLOAD_COMPLETE, function(E) {
        f && (typeof f == "function" ? f(E) : ze.warn("completeCallback should be a function, not a " + typeof f));
      }), i.on(rr.ERROR, function(E) {
        p && (typeof p == "function" ? p(E) : ze.warn("errorCallback should be a function, not a " + typeof p));
      });
      var w = ii.get().then(function(E) {
        var x = ii.shear(E);
        return b0(Ne(Ne({}, t), { level: r.accessLevel, credentials: x }));
      }), S = new P0({
        s3Config: a,
        file: l,
        emitter: i,
        level: r.accessLevel,
        storage: this._storage,
        params: h,
        prefixPromise: w
      });
      return vt(m, "upload", { method: "put", result: "success" }, null, "Upload Task created successfully for ".concat(o)), S.resume(), S;
    }, e.prototype.copy = function(r, t, n) {
      return Kn(this, void 0, void 0, function() {
        var a, i, o, l, h, s, f, p, m, w, S, E, x, j, O, I, M, k, fe, ae, B, ue, be, K, ve;
        return qn(this, function(q) {
          switch (q.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              if (a = q.sent(), !a || !this._isWithCredentials(this._config))
                throw new Error(Cr.NO_CREDENTIALS);
              if (i = Object.assign({}, this._config, n), o = i.acl, l = i.bucket, h = i.cacheControl, s = i.expires, f = i.track, p = i.serverSideEncryption, m = i.SSECustomerAlgorithm, w = i.SSECustomerKey, S = i.SSECustomerKeyMD5, E = i.SSEKMSKeyId, x = (K = r.level, K === void 0 ? nd : K), j = r.identityId, O = r.key, I = (ve = t.level, ve === void 0 ? nd : ve), M = t.key, !O || typeof O != "string")
                throw new Error(Cr.NO_SRC_KEY);
              if (!M || typeof M != "string")
                throw new Error(Cr.NO_DEST_KEY);
              x !== "protected" && j && ze.warn(`You may copy files from another user if the source level is "protected", currently it's `.concat(x)), k = this._prefix(Ne(Ne(Ne({}, i), { level: x }), j && { identityId: j })), fe = this._prefix(Ne(Ne({}, i), { level: I })), ae = "".concat(l, "/").concat(k).concat(O), B = "".concat(fe).concat(M), ze.debug("copying ".concat(ae, " to ").concat(B)), ue = {
                Bucket: l,
                CopySource: ae,
                Key: B,
                // Copies over metadata like contentType as well
                MetadataDirective: "COPY"
              }, h && (ue.CacheControl = h), s && (ue.Expires = s), p && (ue.ServerSideEncryption = p), m && (ue.SSECustomerAlgorithm = m), w && (ue.SSECustomerKey = w), S && (ue.SSECustomerKeyMD5 = S), E && (ue.SSEKMSKeyId = E), o && (ue.ACL = o), q.label = 2;
            case 2:
              return q.trys.push([2, 4, , 5]), [4, t3(Qn(Ne(Ne({}, i), { storageAction: an.Copy })), ue)];
            case 3:
              return q.sent(), vt(f, "copy", {
                method: "copy",
                result: "success"
              }, null, "Copy success from ".concat(O, " to ").concat(M)), [2, {
                key: M
              }];
            case 4:
              throw be = q.sent(), vt(f, "copy", {
                method: "copy",
                result: "failed"
              }, null, "Copy failed from ".concat(O, " to ").concat(M)), be;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(r, t) {
      var n;
      return Kn(this, void 0, void 0, function() {
        var a, i, o, l, h, s, f, p, m, w, S, E, x, j, O, I, M, k, fe, ae, B, ue, be, K, ve, q, qe, at, xt, st;
        return qn(this, function(je) {
          switch (je.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              if (a = je.sent(), !a || !this._isWithCredentials(this._config))
                throw new Error(Cr.NO_CREDENTIALS);
              if (i = Object.assign({}, this._config, t), o = i.bucket, l = i.download, h = i.cacheControl, s = i.contentDisposition, f = i.contentEncoding, p = i.contentLanguage, m = i.contentType, w = i.expires, S = i.track, E = i.SSECustomerAlgorithm, x = i.SSECustomerKey, j = i.SSECustomerKeyMD5, O = i.progressCallback, I = (xt = i.validateObjectExistence, xt === void 0 ? !1 : xt), M = this._prefix(i), k = M + r, fe = new el.EventEmitter(), ae = Qn(Ne(Ne({}, i), { emitter: fe, storageAction: an.Get })), ze.debug("get " + r + " from " + k), B = {
                Bucket: o,
                Key: k
              }, h && (B.ResponseCacheControl = h), s && (B.ResponseContentDisposition = s), f && (B.ResponseContentEncoding = f), p && (B.ResponseContentLanguage = p), m && (B.ResponseContentType = m), E && (B.SSECustomerAlgorithm = E), x && (B.SSECustomerKey = x), j && (B.SSECustomerKeyMD5 = j), l !== !0)
                return [3, 5];
              je.label = 2;
            case 2:
              return je.trys.push([2, 4, , 5]), O && (typeof O == "function" ? fe.on(Hs, function($t) {
                O($t);
              }) : ze.warn("progressCallback should be a function, not a " + typeof O)), [4, ww(ae, B)];
            case 3:
              return ue = je.sent(), fe.removeAllListeners(Hs), vt(S, "download", { method: "get", result: "success" }, {
                fileSize: Number(ue.Body.size || ue.Body.length)
              }, "Download success for ".concat(r)), [2, ue];
            case 4:
              throw be = je.sent(), vt(S, "download", {
                method: "get",
                result: "failed"
              }, null, "Download failed with ".concat(be.message)), be;
            case 5:
              if (!I)
                return [3, 9];
              je.label = 6;
            case 6:
              return je.trys.push([6, 8, , 9]), [4, Hf(ae, B)];
            case 7:
              return je.sent(), [3, 9];
            case 8:
              throw K = je.sent(), ((n = K.$metadata) === null || n === void 0 ? void 0 : n.httpStatusCode) === 404 && vt(S, "getSignedUrl", {
                method: "get",
                result: "failed"
              }, null, "".concat(r, " not found")), K;
            case 9:
              return je.trys.push([9, 12, , 13]), q = Sw, qe = [Ne({}, ae)], st = { expiration: w || M3 }, [4, ae.credentials()];
            case 10:
              return [4, q.apply(void 0, [Ne.apply(void 0, qe.concat([(st.credentials = je.sent(), st.signingRegion = ae.region, st.signingService = Xh, st)])), B])];
            case 11:
              return ve = je.sent(), vt(S, "getSignedUrl", { method: "get", result: "success" }, null, "Signed URL: ".concat(ve)), [2, ve];
            case 12:
              throw at = je.sent(), ze.warn("get signed url error", at), vt(S, "getSignedUrl", { method: "get", result: "failed" }, null, "Could not get a signed URL for ".concat(r)), at;
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getProperties = function(r, t) {
      var n;
      return Kn(this, void 0, void 0, function() {
        var a, i, o, l, h, s, f, p, m, w, S, E, x, j, O;
        return qn(this, function(I) {
          switch (I.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              if (a = I.sent(), !a || !this._isWithCredentials(this._config))
                throw new Error(Cr.NO_CREDENTIALS);
              i = Object.assign({}, this._config, t), o = i.bucket, l = (O = i.track, O === void 0 ? !1 : O), h = i.SSECustomerAlgorithm, s = i.SSECustomerKey, f = i.SSECustomerKeyMD5, p = this._prefix(i), m = p + r, ze.debug("getProperties ".concat(r, " from ").concat(m)), w = Qn(Ne(Ne({}, i), { storageAction: an.GetProperties })), S = {
                Bucket: o,
                Key: m
              }, h && (S.SSECustomerAlgorithm = h), s && (S.SSECustomerKey = s), f && (S.SSECustomerKeyMD5 = f), I.label = 2;
            case 2:
              return I.trys.push([2, 4, , 5]), [4, Hf(w, S)];
            case 3:
              return E = I.sent(), x = {
                contentLength: E.ContentLength,
                contentType: E.ContentType,
                eTag: E.ETag,
                lastModified: E.LastModified,
                metadata: E.Metadata
              }, vt(l, "getProperties", { method: "getProperties", result: "success" }, null, "getProperties successful for ".concat(r)), [2, x];
            case 4:
              throw j = I.sent(), ((n = j.$metadata) === null || n === void 0 ? void 0 : n.httpStatusCode) === 404 && vt(l, "getProperties", {
                method: "getProperties",
                result: "failed"
              }, null, "".concat(r, " not found")), j;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.put = function(r, t, n) {
      var a = Object.assign({}, this._config, n), i = a.bucket, o = a.track, l = a.progressCallback, h = a.level, s = a.resumable, f = a.contentType, p = a.contentDisposition, m = a.contentEncoding, w = a.cacheControl, S = a.expires, E = a.metadata, x = a.tagging, j = a.acl, O = a.serverSideEncryption, I = a.SSECustomerAlgorithm, M = a.SSECustomerKey, k = a.SSECustomerKeyMD5, fe = a.SSEKMSKeyId, ae = f || "binary/octet-stream", B = {
        Bucket: i,
        Key: r,
        Body: t,
        ContentType: ae
      };
      w && (B.CacheControl = w), p && (B.ContentDisposition = p), m && (B.ContentEncoding = m), S && (B.Expires = S), E && (B.Metadata = E), x && (B.Tagging = x), O && (B.ServerSideEncryption = O), I && (B.SSECustomerAlgorithm = I), M && (B.SSECustomerKey = M), k && (B.SSECustomerKeyMD5 = k), fe && (B.SSEKMSKeyId = fe);
      var ue = new el.EventEmitter(), be = new D3(B, a, ue);
      if (j && (B.ACL = j), s === !0) {
        var K = Qn(Ne(Ne({}, a), { storageAction: an.Put })), ve = {
          bucket: i,
          key: r,
          s3Config: K,
          file: t,
          emitter: ue,
          accessLevel: h,
          params: B
        };
        return this.startResumableUpload(ve, n);
      }
      try {
        return l && (typeof l == "function" ? ue.on(Ca, function(q) {
          l(q);
        }) : ze.warn("progressCallback should be a function, not a " + typeof l)), be.upload().then(function(q) {
          return ze.debug("upload result", q), vt(o, "upload", { method: "put", result: "success" }, null, "Upload success for ".concat(r)), { key: r };
        });
      } catch (q) {
        throw ze.warn("error uploading", q), vt(o, "upload", { method: "put", result: "failed" }, null, "Error uploading ".concat(r)), q;
      }
    }, e.prototype.remove = function(r, t) {
      return Kn(this, void 0, void 0, function() {
        var n, a, i, o, l, h, s, f, p, m;
        return qn(this, function(w) {
          switch (w.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              if (n = w.sent(), !n || !this._isWithCredentials(this._config))
                throw new Error(Cr.NO_CREDENTIALS);
              a = Object.assign({}, this._config, t), i = a.bucket, o = a.track, l = this._prefix(a), h = l + r, ze.debug("remove " + r + " from " + h), s = {
                Bucket: i,
                Key: h
              }, f = Qn(Ne(Ne({}, a), { storageAction: an.Remove })), w.label = 2;
            case 2:
              return w.trys.push([2, 4, , 5]), [4, u3(f, s)];
            case 3:
              return p = w.sent(), vt(o, "delete", { method: "remove", result: "success" }, null, "Deleted ".concat(r, " successfully")), [2, p];
            case 4:
              throw m = w.sent(), vt(o, "delete", { method: "remove", result: "failed" }, null, "Deletion of ".concat(r, " failed with ").concat(m)), m;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._list = function(r, t, n) {
      return Kn(this, void 0, void 0, function() {
        var a, i;
        return qn(this, function(o) {
          switch (o.label) {
            case 0:
              return a = {
                results: [],
                hasNextToken: !1
              }, [4, e0(Qn(Ne(Ne({}, t), { storageAction: an.List })), Ne({}, r))];
            case 1:
              return i = o.sent(), i && i.Contents && (a.results = i.Contents.map(function(l) {
                return {
                  key: l.Key.substr(n.length),
                  eTag: l.ETag,
                  lastModified: l.LastModified,
                  size: l.Size
                };
              }), a.nextToken = i.NextContinuationToken, a.hasNextToken = i.IsTruncated), [2, a];
          }
        });
      });
    }, e.prototype.list = function(r, t) {
      return Kn(this, void 0, void 0, function() {
        var n, a, i, o, l, h, s, f, p, m, w, S, E, x, j;
        return qn(this, function(O) {
          switch (O.label) {
            case 0:
              return [4, this._ensureCredentials()];
            case 1:
              if (n = O.sent(), !n || !this._isWithCredentials(this._config))
                throw new Error(Cr.NO_CREDENTIALS);
              a = Object.assign({}, this._config, t), i = a.bucket, o = a.track, l = a.pageSize, h = a.nextToken, s = this._prefix(a), f = s + r, ze.debug("list " + r + " from " + f), O.label = 2;
            case 2:
              if (O.trys.push([2, 10, , 11]), p = {
                results: [],
                hasNextToken: !1
              }, m = 1e3, w = void 0, S = {
                Bucket: i,
                Prefix: f,
                MaxKeys: m,
                ContinuationToken: h
              }, S.ContinuationToken = h, l !== "ALL")
                return [3, 7];
              O.label = 3;
            case 3:
              return [4, this._list(S, a, s)];
            case 4:
              w = O.sent(), (x = p.results).push.apply(x, rd([], td(w.results), !1)), w.nextToken && (S.ContinuationToken = w.nextToken), O.label = 5;
            case 5:
              if (w.nextToken)
                return [3, 3];
              O.label = 6;
            case 6:
              return [3, 9];
            case 7:
              return l && l <= m && typeof l == "number" ? S.MaxKeys = l : ze.warn("pageSize should be from 0 - ".concat(m, ".")), [4, this._list(S, a, s)];
            case 8:
              w = O.sent(), (j = p.results).push.apply(j, rd([], td(w.results), !1)), p.hasNextToken = w.hasNextToken, p.nextToken = w.nextToken, O.label = 9;
            case 9:
              return vt(o, "list", { method: "list", result: "success" }, null, "".concat(p.results.length, " items returned from list operation")), ze.debug("list", p), [2, p];
            case 10:
              throw E = O.sent(), ze.error("list InvalidArgument", E), vt(o, "list", { method: "list", result: "failed" }, null, "Listing items failed: ".concat(E.message)), E;
            case 11:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._ensureCredentials = function() {
      return Kn(this, void 0, void 0, function() {
        var r, t, n;
        return qn(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 2, , 3]), [4, ii.get()];
            case 1:
              return r = a.sent(), r ? (t = ii.shear(r), ze.debug("set credentials for storage", t), this._config.credentials = t, [2, !0]) : [2, !1];
            case 2:
              return n = a.sent(), ze.warn("ensure credentials error", n), [2, !1];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._isWithCredentials = function(r) {
      return typeof r == "object" && r.hasOwnProperty("credentials");
    }, e.prototype._prefix = function(r) {
      var t = r.credentials, n = r.level, a = r.customPrefix || {}, i = r.identityId || t.identityId, o = (a.private !== void 0 ? a.private : "private/") + i + "/", l = (a.protected !== void 0 ? a.protected : "protected/") + i + "/", h = a.public !== void 0 ? a.public : "public/";
      switch (n) {
        case "private":
          return o;
        case "protected":
          return l;
        default:
          return h;
      }
    }, e.CATEGORY = "Storage", e.PROVIDER_NAME = "AWSS3", e;
  }()
), It = globalThis && globalThis.__assign || function() {
  return It = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, It.apply(this, arguments);
}, A3 = globalThis && globalThis.__read || function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], o;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (l) {
    o = { error: l };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}, Or = new et("StorageClass"), _u = new et("Storage"), Qr = "AWSS3", id = (
  /** @class */
  function() {
    function e() {
      this._config = {}, this._pluggables = [], this._abortControllerMap = /* @__PURE__ */ new WeakMap(), Or.debug("Storage Options", this._config), this.get = this.get.bind(this), this.put = this.put.bind(this), this.remove = this.remove.bind(this), this.list = this.list.bind(this);
    }
    return e.prototype.getModuleName = function() {
      return "Storage";
    }, e.prototype.addPluggable = function(r) {
      if (r && r.getCategory() === "Storage") {
        this._pluggables.push(r);
        var t = {};
        return t = r.configure(this._config[r.getProviderName()]), t;
      }
    }, e.prototype.getPluggable = function(r) {
      var t = this._pluggables.find(function(n) {
        return n.getProviderName() === r;
      });
      return t === void 0 ? (Or.debug("No plugin found with providerName", r), null) : t;
    }, e.prototype.removePluggable = function(r) {
      this._pluggables = this._pluggables.filter(function(t) {
        return t.getProviderName() !== r;
      });
    }, e.prototype.configure = function(r) {
      var t = this, n;
      if (Or.debug("configure Storage"), !r)
        return this._config;
      var a = Dl(r), i = (n = a.Storage) !== null && n !== void 0 ? n : {}, o = [
        "bucket",
        "region",
        "level",
        "track",
        "customPrefix",
        "ContentMD5",
        "serverSideEncryption",
        "SSECustomerAlgorithm",
        "SSECustomerKey",
        // TODO(AllanZhengYP): remove in V6.
        "SSECustomerKeyMD5",
        "SSEKMSKeyId"
      ], l = function(h) {
        return Object.keys(h).find(function(s) {
          return o.includes(s);
        });
      };
      return l(i) && !i[Qr] && (i[Qr] = {}), Object.entries(i).forEach(function(h) {
        var s = A3(h, 2), f = s[0], p = s[1];
        f && o.includes(f) && p !== void 0 && (i[Qr][f] = p, delete i[f]);
      }), Object.keys(i).forEach(function(h) {
        typeof i[h] != "string" && (t._config[h] = It(It({}, t._config[h]), i[h]));
      }), this._pluggables.forEach(function(h) {
        h.configure(t._config[h.getProviderName()]);
      }), this._pluggables.length === 0 && this.addPluggable(new P3()), this._config;
    }, e.prototype.getAbortController = function() {
      return new AbortController();
    }, e.prototype.updateRequestToBeCancellable = function(r, t) {
      this._abortControllerMap.set(r, t);
    }, e.prototype.isUploadTask = function(r) {
      return typeof r < "u" && typeof r.pause == "function" && typeof r.resume == "function";
    }, e.prototype.cancel = function(r, t) {
      if (r instanceof P0)
        return r._cancel();
      var n = this._abortControllerMap.get(r);
      n ? n.abort(t) : Or.debug("The request does not map to any cancel token");
    }, e.prototype.copy = function(r, t, n) {
      var a = (n == null ? void 0 : n.provider) || Qr, i = this._pluggables.find(function(h) {
        return h.getProviderName() === a;
      });
      if (i === void 0)
        return Or.debug("No plugin found with providerName", a), Promise.reject("No plugin found in Storage for the provider");
      var o = this.getAbortController();
      if (typeof i.copy != "function")
        return Promise.reject(".copy is not implemented on provider ".concat(i.getProviderName()));
      var l = i.copy(r, t, It(It({}, n), { abortSignal: o.signal }));
      return this.updateRequestToBeCancellable(l, o), l;
    }, e.prototype.get = function(r, t) {
      var n = (t == null ? void 0 : t.provider) || Qr, a = this._pluggables.find(function(l) {
        return l.getProviderName() === n;
      });
      if (a === void 0)
        return Or.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider");
      var i = this.getAbortController(), o = a.get(r, It(It({}, t), { abortSignal: i.signal }));
      return this.updateRequestToBeCancellable(o, i), o;
    }, e.prototype.isCancelError = function(r) {
      return Ku(r);
    }, e.prototype.getProperties = function(r, t) {
      var n = (t == null ? void 0 : t.provider) || Qr, a = this._pluggables.find(function(l) {
        return l.getProviderName() === n;
      });
      if (a === void 0)
        throw Or.debug("No plugin found with providerName", n), new Error("No plugin found with providerName");
      var i = this.getAbortController();
      if (typeof a.getProperties != "function")
        return Promise.reject(".getProperties is not implemented on provider ".concat(a.getProviderName()));
      var o = a == null ? void 0 : a.getProperties(r, It({}, t));
      return this.updateRequestToBeCancellable(o, i), o;
    }, e.prototype.put = function(r, t, n) {
      var a = (n == null ? void 0 : n.provider) || Qr, i = this._pluggables.find(function(h) {
        return h.getProviderName() === a;
      });
      if (i === void 0)
        return Or.debug("No plugin found with providerName", a), Promise.reject("No plugin found in Storage for the provider");
      var o = this.getAbortController(), l = i.put(r, t, It(It({}, n), { abortSignal: o.signal }));
      return this.isUploadTask(l) || this.updateRequestToBeCancellable(l, o), l;
    }, e.prototype.remove = function(r, t) {
      var n = (t == null ? void 0 : t.provider) || Qr, a = this._pluggables.find(function(i) {
        return i.getProviderName() === n;
      });
      return a === void 0 ? (Or.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider")) : a.remove(r, t);
    }, e.prototype.list = function(r, t) {
      var n = (t == null ? void 0 : t.provider) || Qr, a = this._pluggables.find(function(i) {
        return i.getProviderName() === n;
      });
      return a === void 0 ? (Or.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider")) : a.list(r, t);
    }, e;
  }()
), en = null, R3 = function() {
  if (en)
    return en;
  _u.debug("Create Storage Instance, debug"), en = new id(), en.vault = new id();
  var e = en.configure;
  return en.configure = function(r) {
    _u.debug("storage configure called");
    var t = It({}, e.call(en, r));
    Object.keys(t).forEach(function(n) {
      typeof t[n] != "string" && (t[n] = It(It({}, t[n]), { level: "private" }));
    }), _u.debug("storage vault configure called"), en.vault.configure(t);
  }, en;
}, A0 = R3();
Ka.register(A0);
const gi = () => wo.getItem(Tl, {
  callback: () => Om
}), I3 = (e) => {
  wo.setItem(Tl, e);
}, K9 = (e) => {
  N3();
  const r = gi();
  let t = r.permissions;
  e.forEach((n) => {
    t = t.concat(n);
  }), r.permissions = t, I3(r);
}, N3 = () => {
  wo.removeItem(Tl);
}, L3 = (e, r, t = "*") => {
  if (e === null)
    throw new Error("User Roles is null");
  if (e.length === 0)
    throw new Error("User Roles is empty and is required parameter");
  const n = U3(e);
  let a = !1;
  const i = [];
  return n.forEach((o) => {
    const l = Cm(o, r, t);
    i.push(l);
  }), a = i.includes(!0), a;
}, q9 = (e, r, t = "*") => {
  const n = $3();
  let a = null;
  Object.prototype.hasOwnProperty.call(n, r.path) && (a = n[r.path]);
  let i = "";
  return a !== null && (i = a.actionName), L3(e, i, t);
}, Z9 = () => {
  const { roles: e } = gi();
  return e;
}, J9 = () => {
  const { policies: e } = gi();
  return e;
}, X9 = () => {
  const { statements: e } = gi();
  return e;
}, F3 = () => {
  const { permissions: e } = gi();
  return e;
}, $3 = () => {
  const { routes: e } = gi();
  return e;
}, Y3 = (e) => {
  let r = [];
  const t = F3();
  if (Array.isArray(t)) {
    const n = t.find(
      (a) => a.roleName === e
    );
    n && (r = n.permissionStatements);
  }
  return r;
}, Q9 = (e) => {
  const r = [], { roles: t } = gi();
  return Array.isArray(t) ? (t.forEach((n) => {
    const a = Tm[n.name], i = new RegExp(a);
    e.forEach((o) => {
      i.test(o) === !0 && r.push(n.name);
    });
  }), [...new Set(r)]) : r;
}, U3 = (e) => {
  const r = [];
  return e.forEach((t) => {
    const n = Y3(t);
    Array.isArray(n) && n.forEach((a) => {
      r.push(a);
    });
  }), r;
};
var tl = { exports: {} }, pa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ad;
function z3() {
  if (ad)
    return pa;
  ad = 1;
  var e = pr, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(l, h, s) {
    var f, p = {}, m = null, w = null;
    s !== void 0 && (m = "" + s), h.key !== void 0 && (m = "" + h.key), h.ref !== void 0 && (w = h.ref);
    for (f in h)
      n.call(h, f) && !i.hasOwnProperty(f) && (p[f] = h[f]);
    if (l && l.defaultProps)
      for (f in h = l.defaultProps, h)
        p[f] === void 0 && (p[f] = h[f]);
    return { $$typeof: r, type: l, key: m, ref: w, props: p, _owner: a.current };
  }
  return pa.Fragment = t, pa.jsx = o, pa.jsxs = o, pa;
}
var va = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sd;
function W3() {
  return sd || (sd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = pr, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), S = Symbol.iterator, E = "@@iterator";
    function x(b) {
      if (b === null || typeof b != "object")
        return null;
      var D = S && b[S] || b[E];
      return typeof D == "function" ? D : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(b) {
      {
        for (var D = arguments.length, R = new Array(D > 1 ? D - 1 : 0), H = 1; H < D; H++)
          R[H - 1] = arguments[H];
        I("error", b, R);
      }
    }
    function I(b, D, R) {
      {
        var H = j.ReactDebugCurrentFrame, te = H.getStackAddendum();
        te !== "" && (D += "%s", R = R.concat([te]));
        var xe = R.map(function(se) {
          return String(se);
        });
        xe.unshift("Warning: " + D), Function.prototype.apply.call(console[b], console, xe);
      }
    }
    var M = !1, k = !1, fe = !1, ae = !1, B = !1, ue;
    ue = Symbol.for("react.module.reference");
    function be(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === n || b === i || B || b === a || b === s || b === f || ae || b === w || M || k || fe || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === p || b.$$typeof === o || b.$$typeof === l || b.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === ue || b.getModuleId !== void 0));
    }
    function K(b, D, R) {
      var H = b.displayName;
      if (H)
        return H;
      var te = D.displayName || D.name || "";
      return te !== "" ? R + "(" + te + ")" : R;
    }
    function ve(b) {
      return b.displayName || "Context";
    }
    function q(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case s:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case l:
            var D = b;
            return ve(D) + ".Consumer";
          case o:
            var R = b;
            return ve(R._context) + ".Provider";
          case h:
            return K(b, b.render, "ForwardRef");
          case p:
            var H = b.displayName || null;
            return H !== null ? H : q(b.type) || "Memo";
          case m: {
            var te = b, xe = te._payload, se = te._init;
            try {
              return q(se(xe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var qe = Object.assign, at = 0, xt, st, je, $t, Fe, or, Yt;
    function Tt() {
    }
    Tt.__reactDisabledLog = !0;
    function Ut() {
      {
        if (at === 0) {
          xt = console.log, st = console.info, je = console.warn, $t = console.error, Fe = console.group, or = console.groupCollapsed, Yt = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: Tt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        at++;
      }
    }
    function z() {
      {
        if (at--, at === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: qe({}, b, {
              value: xt
            }),
            info: qe({}, b, {
              value: st
            }),
            warn: qe({}, b, {
              value: je
            }),
            error: qe({}, b, {
              value: $t
            }),
            group: qe({}, b, {
              value: Fe
            }),
            groupCollapsed: qe({}, b, {
              value: or
            }),
            groupEnd: qe({}, b, {
              value: Yt
            })
          });
        }
        at < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var wr = j.ReactCurrentDispatcher, Sr;
    function Pt(b, D, R) {
      {
        if (Sr === void 0)
          try {
            throw Error();
          } catch (te) {
            var H = te.stack.trim().match(/\n( *(at )?)/);
            Sr = H && H[1] || "";
          }
        return `
` + Sr + b;
      }
    }
    var Jt = !1, xr;
    {
      var yn = typeof WeakMap == "function" ? WeakMap : Map;
      xr = new yn();
    }
    function W(b, D) {
      if (!b || Jt)
        return "";
      {
        var R = xr.get(b);
        if (R !== void 0)
          return R;
      }
      var H;
      Jt = !0;
      var te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var xe;
      xe = wr.current, wr.current = null, Ut();
      try {
        if (D) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (ct) {
              H = ct;
            }
            Reflect.construct(b, [], se);
          } else {
            try {
              se.call();
            } catch (ct) {
              H = ct;
            }
            b.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ct) {
            H = ct;
          }
          b();
        }
      } catch (ct) {
        if (ct && H && typeof ct.stack == "string") {
          for (var X = ct.stack.split(`
`), rt = H.stack.split(`
`), $e = X.length - 1, Oe = rt.length - 1; $e >= 1 && Oe >= 0 && X[$e] !== rt[Oe]; )
            Oe--;
          for (; $e >= 1 && Oe >= 0; $e--, Oe--)
            if (X[$e] !== rt[Oe]) {
              if ($e !== 1 || Oe !== 1)
                do
                  if ($e--, Oe--, Oe < 0 || X[$e] !== rt[Oe]) {
                    var nt = `
` + X[$e].replace(" at new ", " at ");
                    return b.displayName && nt.includes("<anonymous>") && (nt = nt.replace("<anonymous>", b.displayName)), typeof b == "function" && xr.set(b, nt), nt;
                  }
                while ($e >= 1 && Oe >= 0);
              break;
            }
        }
      } finally {
        Jt = !1, wr.current = xe, z(), Error.prepareStackTrace = te;
      }
      var Wr = b ? b.displayName || b.name : "", Br = Wr ? Pt(Wr) : "";
      return typeof b == "function" && xr.set(b, Br), Br;
    }
    function Yr(b, D, R) {
      return W(b, !1);
    }
    function Tr(b) {
      var D = b.prototype;
      return !!(D && D.isReactComponent);
    }
    function ur(b, D, R) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return W(b, Tr(b));
      if (typeof b == "string")
        return Pt(b);
      switch (b) {
        case s:
          return Pt("Suspense");
        case f:
          return Pt("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case h:
            return Yr(b.render);
          case p:
            return ur(b.type, D, R);
          case m: {
            var H = b, te = H._payload, xe = H._init;
            try {
              return ur(xe(te), D, R);
            } catch {
            }
          }
        }
      return "";
    }
    var Ur = Object.prototype.hasOwnProperty, gn = {}, Ti = j.ReactDebugCurrentFrame;
    function pn(b) {
      if (b) {
        var D = b._owner, R = ur(b.type, b._source, D ? D.type : null);
        Ti.setExtraStackFrame(R);
      } else
        Ti.setExtraStackFrame(null);
    }
    function T(b, D, R, H, te) {
      {
        var xe = Function.call.bind(Ur);
        for (var se in b)
          if (xe(b, se)) {
            var X = void 0;
            try {
              if (typeof b[se] != "function") {
                var rt = Error((H || "React class") + ": " + R + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw rt.name = "Invariant Violation", rt;
              }
              X = b[se](D, se, H, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($e) {
              X = $e;
            }
            X && !(X instanceof Error) && (pn(te), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", R, se, typeof X), pn(null)), X instanceof Error && !(X.message in gn) && (gn[X.message] = !0, pn(te), O("Failed %s type: %s", R, X.message), pn(null));
          }
      }
    }
    var N = Array.isArray;
    function U(b) {
      return N(b);
    }
    function G(b) {
      {
        var D = typeof Symbol == "function" && Symbol.toStringTag, R = D && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return R;
      }
    }
    function J(b) {
      try {
        return ie(b), !1;
      } catch {
        return !0;
      }
    }
    function ie(b) {
      return "" + b;
    }
    function le(b) {
      if (J(b))
        return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", G(b)), ie(b);
    }
    var Ze = j.ReactCurrentOwner, zr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, lr, _e, vn;
    vn = {};
    function Yn(b) {
      if (Ur.call(b, "ref")) {
        var D = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (D && D.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function mn(b) {
      if (Ur.call(b, "key")) {
        var D = Object.getOwnPropertyDescriptor(b, "key").get;
        if (D && D.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function oa(b, D) {
      if (typeof b.ref == "string" && Ze.current && D && Ze.current.stateNode !== D) {
        var R = q(Ze.current.type);
        vn[R] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(Ze.current.type), b.ref), vn[R] = !0);
      }
    }
    function Ei(b, D) {
      {
        var R = function() {
          lr || (lr = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
        };
        R.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function bn(b, D) {
      {
        var R = function() {
          _e || (_e = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
        };
        R.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var Oi = function(b, D, R, H, te, xe, se) {
      var X = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: b,
        key: D,
        ref: R,
        props: se,
        // Record the component responsible for creating this element.
        _owner: xe
      };
      return X._store = {}, Object.defineProperty(X._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(X, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.defineProperty(X, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: te
      }), Object.freeze && (Object.freeze(X.props), Object.freeze(X)), X;
    };
    function Vo(b, D, R, H, te) {
      {
        var xe, se = {}, X = null, rt = null;
        R !== void 0 && (le(R), X = "" + R), mn(D) && (le(D.key), X = "" + D.key), Yn(D) && (rt = D.ref, oa(D, te));
        for (xe in D)
          Ur.call(D, xe) && !zr.hasOwnProperty(xe) && (se[xe] = D[xe]);
        if (b && b.defaultProps) {
          var $e = b.defaultProps;
          for (xe in $e)
            se[xe] === void 0 && (se[xe] = $e[xe]);
        }
        if (X || rt) {
          var Oe = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          X && Ei(se, Oe), rt && bn(se, Oe);
        }
        return Oi(b, X, rt, te, H, Ze.current, se);
      }
    }
    var _n = j.ReactCurrentOwner, rs = j.ReactDebugCurrentFrame;
    function Xt(b) {
      if (b) {
        var D = b._owner, R = ur(b.type, b._source, D ? D.type : null);
        rs.setExtraStackFrame(R);
      } else
        rs.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function Un(b) {
      return typeof b == "object" && b !== null && b.$$typeof === r;
    }
    function zn() {
      {
        if (_n.current) {
          var b = q(_n.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function F(b) {
      {
        if (b !== void 0) {
          var D = b.fileName.replace(/^.*[\\\/]/, ""), R = b.lineNumber;
          return `

Check your code at ` + D + ":" + R + ".";
        }
        return "";
      }
    }
    var ns = {};
    function Ko(b) {
      {
        var D = zn();
        if (!D) {
          var R = typeof b == "string" ? b : b.displayName || b.name;
          R && (D = `

Check the top-level render call using <` + R + ">.");
        }
        return D;
      }
    }
    function Qt(b, D) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var R = Ko(D);
        if (ns[R])
          return;
        ns[R] = !0;
        var H = "";
        b && b._owner && b._owner !== _n.current && (H = " It was passed a child from " + q(b._owner.type) + "."), Xt(b), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, H), Xt(null);
      }
    }
    function Et(b, D) {
      {
        if (typeof b != "object")
          return;
        if (U(b))
          for (var R = 0; R < b.length; R++) {
            var H = b[R];
            Un(H) && Qt(H, D);
          }
        else if (Un(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var te = x(b);
          if (typeof te == "function" && te !== b.entries)
            for (var xe = te.call(b), se; !(se = xe.next()).done; )
              Un(se.value) && Qt(se.value, D);
        }
      }
    }
    function re(b) {
      {
        var D = b.type;
        if (D == null || typeof D == "string")
          return;
        var R;
        if (typeof D == "function")
          R = D.propTypes;
        else if (typeof D == "object" && (D.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        D.$$typeof === p))
          R = D.propTypes;
        else
          return;
        if (R) {
          var H = q(D);
          T(R, b.props, "prop", H, b);
        } else if (D.PropTypes !== void 0 && !Er) {
          Er = !0;
          var te = q(D);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", te || "Unknown");
        }
        typeof D.getDefaultProps == "function" && !D.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ua(b) {
      {
        for (var D = Object.keys(b.props), R = 0; R < D.length; R++) {
          var H = D[R];
          if (H !== "children" && H !== "key") {
            Xt(b), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), Xt(null);
            break;
          }
        }
        b.ref !== null && (Xt(b), O("Invalid attribute `ref` supplied to `React.Fragment`."), Xt(null));
      }
    }
    var me = {};
    function wn(b, D, R, H, te, xe) {
      {
        var se = be(b);
        if (!se) {
          var X = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (X += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var rt = F(te);
          rt ? X += rt : X += zn();
          var $e;
          b === null ? $e = "null" : U(b) ? $e = "array" : b !== void 0 && b.$$typeof === r ? ($e = "<" + (q(b.type) || "Unknown") + " />", X = " Did you accidentally export a JSX literal instead of a component?") : $e = typeof b, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $e, X);
        }
        var Oe = Vo(b, D, R, te, xe);
        if (Oe == null)
          return Oe;
        if (se) {
          var nt = D.children;
          if (nt !== void 0)
            if (H)
              if (U(nt)) {
                for (var Wr = 0; Wr < nt.length; Wr++)
                  Et(nt[Wr], b);
                Object.freeze && Object.freeze(nt);
              } else
                O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Et(nt, b);
        }
        if (Ur.call(D, "key")) {
          var Br = q(b), ct = Object.keys(D).filter(function(ca) {
            return ca !== "key";
          }), la = ct.length > 0 ? "{key: someKey, " + ct.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!me[Br + la]) {
            var Ye = ct.length > 0 ? "{" + ct.join(": ..., ") + ": ...}" : "{}";
            O(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, la, Br, Ye, Br), me[Br + la] = !0;
          }
        }
        return b === n ? ua(Oe) : re(Oe), Oe;
      }
    }
    function qo(b, D, R) {
      return wn(b, D, R, !0);
    }
    function Ci(b, D, R) {
      return wn(b, D, R, !1);
    }
    var tt = Ci, cr = qo;
    va.Fragment = n, va.jsx = tt, va.jsxs = cr;
  }()), va;
}
process.env.NODE_ENV === "production" ? tl.exports = z3() : tl.exports = W3();
var y = tl.exports, R0 = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Zs = pr.createContext && /* @__PURE__ */ pr.createContext(R0), B3 = ["attr", "size", "title"];
function H3(e, r) {
  if (e == null)
    return {};
  var t = G3(e, r), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function G3(e, r) {
  if (e == null)
    return {};
  var t = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (r.indexOf(n) >= 0)
        continue;
      t[n] = e[n];
    }
  return t;
}
function Js() {
  return Js = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Js.apply(this, arguments);
}
function od(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Xs(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? od(Object(t), !0).forEach(function(n) {
      V3(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : od(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function V3(e, r, t) {
  return r = K3(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function K3(e) {
  var r = q3(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function q3(e, r) {
  if (typeof e != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function I0(e) {
  return e && e.map((r, t) => /* @__PURE__ */ pr.createElement(r.tag, Xs({
    key: t
  }, r.attr), I0(r.child)));
}
function Ke(e) {
  return (r) => /* @__PURE__ */ pr.createElement(Z3, Js({
    attr: Xs({}, e.attr)
  }, r), I0(e.child));
}
function Z3(e) {
  var r = (t) => {
    var {
      attr: n,
      size: a,
      title: i
    } = e, o = H3(e, B3), l = a || t.size || "1em", h;
    return t.className && (h = t.className), e.className && (h = (h ? h + " " : "") + e.className), /* @__PURE__ */ pr.createElement("svg", Js({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, n, o, {
      className: h,
      style: Xs(Xs({
        color: e.color || t.color
      }, t.style), e.style),
      height: l,
      width: l,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && /* @__PURE__ */ pr.createElement("title", null, i), e.children);
  };
  return Zs !== void 0 ? /* @__PURE__ */ pr.createElement(Zs.Consumer, null, (t) => r(t)) : r(R0);
}
const J3 = "_root_18xmn_5", X3 = {
  root: J3
}, Mt = ({
  size: e = "sm",
  variant: r = "filled",
  radius: t = "sm",
  leftSection: n,
  ...a
}) => /* @__PURE__ */ y.jsx(
  oo,
  {
    size: e,
    variant: r,
    radius: t,
    leftSection: n ? /* @__PURE__ */ y.jsx(Zs.Provider, { value: { size: "1.5em" }, children: n }) : null,
    className: X3.root,
    ...a
  }
);
function Q3(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" }, child: [] }] })(e);
}
function N0(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z" }, child: [] }] })(e);
}
function e4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" }, child: [] }] })(e);
}
function t4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z" }, child: [] }] })(e);
}
function r4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" }, child: [] }] })(e);
}
function L0(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" }, child: [] }] })(e);
}
function pi(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024", fill: "currentColor", fillRule: "evenodd" }, child: [{ tag: "path", attr: { d: "M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z" }, child: [] }] })(e);
}
function F0(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" }, child: [] }] })(e);
}
function n4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" }, child: [] }] })(e);
}
function qa(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" }, child: [] }] })(e);
}
function i4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z" }, child: [] }] })(e);
}
function a4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" }, child: [] }] })(e);
}
function s4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" }, child: [] }] })(e);
}
function $0(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
function o4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" }, child: [] }] })(e);
}
function u4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" }, child: [] }] })(e);
}
function Oo(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z" }, child: [] }] })(e);
}
function l4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" }, child: [] }] })(e);
}
function ud(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" }, child: [] }] })(e);
}
const c4 = ({
  children: e = "Add Record",
  leftSection: r = /* @__PURE__ */ y.jsx($0, {}),
  ...t
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: r, children: e, ...t }), $l = ({
  variant: e = "outline",
  children: r = "Close",
  leftSection: t = /* @__PURE__ */ y.jsx(pi, {}),
  ...n
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: t, children: r, variant: e, ...n }), Yl = ({
  children: e = "Cancel",
  leftSection: r = /* @__PURE__ */ y.jsx(pi, {}),
  ...t
}) => /* @__PURE__ */ y.jsx($l, { leftSection: r, children: e, ...t }), ek = ({
  onClick: e,
  ...r
}) => /* @__PURE__ */ y.jsx(ir, { ...r, children: /* @__PURE__ */ y.jsx(pi, { onClick: e }) }), f4 = ({ value: e }) => /* @__PURE__ */ y.jsx(om, { timeout: 2e3, value: e, children: ({
  copied: r,
  copy: t
}) => /* @__PURE__ */ y.jsx(um, { label: r ? "Copied" : "Copy", withArrow: !0, position: "right", children: /* @__PURE__ */ y.jsx(ir, { color: r ? "teal" : "gray", onClick: t, variant: "subtle", children: r ? /* @__PURE__ */ y.jsx(L0, { size: "1.4rem" }) : /* @__PURE__ */ y.jsx(F0, { size: "1.4rem" }) }) }) }), d4 = ({
  variant: e = "outline",
  children: r = "Delete",
  leftSection: t = /* @__PURE__ */ y.jsx(n4, {}),
  ...n
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: t, children: r, variant: e, ...n }), tk = ({
  variant: e = "outline",
  children: r = "Edit",
  leftSection: t = /* @__PURE__ */ y.jsx(qa, {}),
  ...n
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: t, children: r, variant: e, ...n }), h4 = ({
  size: e = "lg",
  variant: r = "subtle",
  ...t
}) => /* @__PURE__ */ y.jsx(
  ir,
  {
    size: e,
    variant: r,
    ...t,
    children: /* @__PURE__ */ y.jsx(i4, {})
  }
), rk = ({
  variant: e = "outline",
  children: r = "Reload",
  leftSection: t = /* @__PURE__ */ y.jsx(o4, {}),
  ...n
}) => /* @__PURE__ */ y.jsx(Mt, { variant: e, leftSection: t, children: r, ...n }), Y0 = ({
  children: e = "Save",
  leftSection: r = /* @__PURE__ */ y.jsx(u4, {}),
  ...t
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: r, children: e, ...t }), nk = ({
  variant: e = "subtle",
  size: r = "xl",
  ...t
}) => /* @__PURE__ */ y.jsxs(Xe, { shadow: "md", width: 200, children: [
  /* @__PURE__ */ y.jsx(Xe.Target, { children: /* @__PURE__ */ y.jsx(ir, { variant: e, size: r, ...t, children: /* @__PURE__ */ y.jsx(Oo, { size: "1.6rem" }) }) }),
  /* @__PURE__ */ y.jsx(Xe.Dropdown, { children: Array.isArray(t.settings) && t.settings.length > 0 ? t.settings.map((n, a) => /* @__PURE__ */ y.jsx(Xe.Item, { onClick: n.onClick, children: n.label }, a)) : null })
] }), y4 = ({
  children: e = "Submit",
  leftSection: r = /* @__PURE__ */ y.jsx(L0, {}),
  ...t
}) => /* @__PURE__ */ y.jsx(Mt, { leftSection: r, children: e, type: "submit", ...t }), U0 = () => /* @__PURE__ */ y.jsxs(Gt, { children: [
  /* @__PURE__ */ y.jsxs(ee, { justify: "space-aprart", children: [
    /* @__PURE__ */ y.jsx(Ge, { width: "88%", height: 20 }),
    /* @__PURE__ */ y.jsx(Ge, { width: "10%", height: 20 })
  ] }),
  /* @__PURE__ */ y.jsx(yf, {}),
  /* @__PURE__ */ y.jsxs(uo, { cols: 2, my: "lg", children: [
    /* @__PURE__ */ y.jsxs(Ue, { gap: "lg", m: "lg", children: [
      /* @__PURE__ */ y.jsx(Ge, { height: 10, mt: 6, width: "100%", radius: "xl" }),
      /* @__PURE__ */ y.jsx(Ge, { height: 10, mt: 6, width: "100%", radius: "xl" }),
      /* @__PURE__ */ y.jsx(Ge, { height: 10, mt: 6, width: "100%", radius: "xl" })
    ] }),
    /* @__PURE__ */ y.jsx(Ge, { height: 100, mt: 6, width: "100%", radius: "xl" })
  ] }),
  /* @__PURE__ */ y.jsx(yf, {}),
  /* @__PURE__ */ y.jsxs(ee, { children: [
    /* @__PURE__ */ y.jsx(Ge, { height: 30, mt: 6, width: "100%", radius: "xl" }),
    /* @__PURE__ */ y.jsx(Ge, { height: 30, mt: 6, width: "100%", radius: "xl" })
  ] })
] }), g4 = "_header_1esal_5", p4 = {
  header: g4
}, v4 = ({ actionItems: e }) => {
  if (typeof e > "u")
    return null;
  const r = e.filter((t) => t.visible === !0);
  return /* @__PURE__ */ y.jsx(uo, { cols: 2, children: r.map(
    (t, n) => /* @__PURE__ */ y.jsx(
      Cn,
      {
        label: t.label,
        description: t.description,
        leftSection: t.icon,
        rightSection: /* @__PURE__ */ y.jsx(N0, { size: 12, stroke: "1.5" }),
        component: Ra,
        to: typeof t.to < "u" ? t.to : ""
      },
      n
    )
  ) });
}, m4 = ({ item: e }) => /* @__PURE__ */ y.jsx(_t, { order: 6, children: /* @__PURE__ */ y.jsxs(ee, { children: [
  e.value !== null ? /* @__PURE__ */ y.jsx(lm, { color: e.color, size: "lg", radius: "xl", children: parseInt(e.value) }) : null,
  /* @__PURE__ */ y.jsx(Ve, { tt: "uppercase", children: e.label })
] }) }), ld = ({ dataPoints: e }) => typeof e > "u" ? null : /* @__PURE__ */ y.jsx(Ue, { gap: "lg", m: "lg", children: e.map((r, t) => /* @__PURE__ */ y.jsx(m4, { item: r }, t)) });
function b4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }, child: [] }, { tag: "path", attr: { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, child: [] }, { tag: "path", attr: { d: "M13.41 10.59l2.59 -2.59" }, child: [] }, { tag: "path", attr: { d: "M7 12a5 5 0 0 1 5 -5" }, child: [] }] })(e);
}
const _4 = ({ metric: e }) => {
  var r, t;
  return console.debug(e), typeof e.visible < "u" && e.visible === !1 ? null : /* @__PURE__ */ y.jsxs(
    cm,
    {
      shadow: "lg",
      radius: "lg",
      p: "md",
      m: "xl",
      withBorder: !0,
      children: [
        /* @__PURE__ */ y.jsx(b4, { size: 24 }),
        /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsxs(_t, { order: 3, children: [
          e.value,
          " ",
          e.unit
        ] }) }),
        /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(_t, { order: 4, children: e.label }) }),
        /* @__PURE__ */ y.jsxs(jt, { my: "lg", children: [
          (r = e.insight) == null ? void 0 : r.icon,
          /* @__PURE__ */ y.jsx(_t, { order: 6, children: (t = e.insight) == null ? void 0 : t.label })
        ] })
      ]
    }
  );
}, cd = ({ metrics: e }) => typeof e > "u" ? null : /* @__PURE__ */ y.jsx(jt, { children: e.map((r, t) => /* @__PURE__ */ y.jsx(_4, { metric: r }, t)) }), w4 = ({
  content: e,
  dataPoints: r,
  metrics: t
}) => typeof e < "u" && pr.isValidElement(e) ? e : r && r.length > 0 && t && t.length > 0 ? /* @__PURE__ */ y.jsx(fm, { my: "lg", children: /* @__PURE__ */ y.jsxs(Vt, { children: [
  r && r.length > 0 ? /* @__PURE__ */ y.jsx(Vt.Col, { span: {
    base: 7,
    lg: 6,
    xs: 12
  }, children: /* @__PURE__ */ y.jsx(ld, { dataPoints: r }) }) : null,
  t && t.length > 0 ? /* @__PURE__ */ y.jsx(Vt.Col, { span: {
    base: 5,
    lg: 6,
    xs: 12
  }, children: /* @__PURE__ */ y.jsx(cd, { metrics: t }) }) : null
] }) }) : r && r.length > 0 && (typeof t > "u" || typeof t < "u" && t.length === 0) ? /* @__PURE__ */ y.jsxs(jt, { my: "lg", children: [
  " ",
  /* @__PURE__ */ y.jsx(ld, { dataPoints: r }),
  " "
] }) : t && t.length > 0 && (typeof r > "u" || typeof r < "u" && r.length === 0) ? /* @__PURE__ */ y.jsxs(jt, { my: "lg", children: [
  " ",
  /* @__PURE__ */ y.jsx(cd, { metrics: t }),
  " "
] }) : /* @__PURE__ */ y.jsx("div", {}), S4 = ({
  content: e,
  actionItems: r
}) => /* @__PURE__ */ y.jsx(y.Fragment, { children: e || /* @__PURE__ */ y.jsx(y.Fragment, { children: r ? /* @__PURE__ */ y.jsx(v4, { actionItems: r }) : null }) });
function x4(e) {
  return Ke({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M32 384h272v32H32zM400 384h80v32h-80zM384 447.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z" }, child: [] }, { tag: "g", attr: {}, child: [{ tag: "path", attr: { d: "M32 240h80v32H32zM208 240h272v32H208zM192 303.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z" }, child: [] }] }, { tag: "g", attr: {}, child: [{ tag: "path", attr: { d: "M32 96h272v32H32zM400 96h80v32h-80zM384 159.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z" }, child: [] }] }] })(e);
}
const T4 = ({
  content: e,
  title: r = "Dashboard Widget",
  options: t = {
    showOptionsButton: !1
  }
}) => /* @__PURE__ */ y.jsx(y.Fragment, { children: e || /* @__PURE__ */ y.jsxs(ee, { justify: "apart", p: "sm", children: [
  /* @__PURE__ */ y.jsx(_t, { order: 3, children: r }),
  t && t.showOptionsButton ? /* @__PURE__ */ y.jsx(oo, { variant: "subtle", children: /* @__PURE__ */ y.jsx(x4, { size: 14 }) }) : null
] }) }), ik = ({
  header: e,
  body: r,
  footer: t
}) => {
  const [n, a] = Pr(!0);
  return bt(() => {
    setTimeout(() => {
      a(!1);
    }, 1e3);
  }, []), n ? /* @__PURE__ */ y.jsx(U0, {}) : /* @__PURE__ */ y.jsxs(Gt, { shadow: "sm", mb: "sm", children: [
    /* @__PURE__ */ y.jsx(Gt.Section, { className: p4.header, children: e || null }),
    /* @__PURE__ */ y.jsx(Gt.Section, { children: r || null }),
    /* @__PURE__ */ y.jsx(Gt.Section, { withBorder: !0, children: t || null })
  ] });
}, E4 = "_header_1esal_5", O4 = {
  header: E4
}, ak = ({ widget: e }) => {
  const [r, t] = Pr(!0);
  return bt(() => {
    setTimeout(() => {
      t(!1);
    }, 1e3);
  }, []), r ? /* @__PURE__ */ y.jsx(U0, {}) : /* @__PURE__ */ y.jsxs(Gt, { shadow: "sm", mb: "sm", children: [
    /* @__PURE__ */ y.jsx(Gt.Section, { className: O4.header, children: /* @__PURE__ */ y.jsx(T4, { ...e.header }) }),
    /* @__PURE__ */ y.jsx(Gt.Section, { children: /* @__PURE__ */ y.jsx(w4, { ...e.body }) }),
    /* @__PURE__ */ y.jsx(Gt.Section, { withBorder: !0, children: /* @__PURE__ */ y.jsx(S4, { ...e.footer }) })
  ] });
};
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var z0;
function L() {
  return z0.apply(null, arguments);
}
function C4(e) {
  z0 = e;
}
function vr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function li(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ge(e, r) {
  return Object.prototype.hasOwnProperty.call(e, r);
}
function Ul(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var r;
  for (r in e)
    if (ge(e, r))
      return !1;
  return !0;
}
function Rt(e) {
  return e === void 0;
}
function cn(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Za(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function W0(e, r) {
  var t = [], n, a = e.length;
  for (n = 0; n < a; ++n)
    t.push(r(e[n], n));
  return t;
}
function Mn(e, r) {
  for (var t in r)
    ge(r, t) && (e[t] = r[t]);
  return ge(r, "toString") && (e.toString = r.toString), ge(r, "valueOf") && (e.valueOf = r.valueOf), e;
}
function Lr(e, r, t, n) {
  return dy(e, r, t, n, !0).utc();
}
function k4() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Q(e) {
  return e._pf == null && (e._pf = k4()), e._pf;
}
var rl;
Array.prototype.some ? rl = Array.prototype.some : rl = function(e) {
  var r = Object(this), t = r.length >>> 0, n;
  for (n = 0; n < t; n++)
    if (n in r && e.call(this, r[n], n, r))
      return !0;
  return !1;
};
function zl(e) {
  var r = null, t = !1, n = e._d && !isNaN(e._d.getTime());
  if (n && (r = Q(e), t = rl.call(r.parsedDateParts, function(a) {
    return a != null;
  }), n = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && t), e._strict && (n = n && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = n;
  else
    return n;
  return e._isValid;
}
function Co(e) {
  var r = Lr(NaN);
  return e != null ? Mn(Q(r), e) : Q(r).userInvalidated = !0, r;
}
var fd = L.momentProperties = [], wu = !1;
function Wl(e, r) {
  var t, n, a, i = fd.length;
  if (Rt(r._isAMomentObject) || (e._isAMomentObject = r._isAMomentObject), Rt(r._i) || (e._i = r._i), Rt(r._f) || (e._f = r._f), Rt(r._l) || (e._l = r._l), Rt(r._strict) || (e._strict = r._strict), Rt(r._tzm) || (e._tzm = r._tzm), Rt(r._isUTC) || (e._isUTC = r._isUTC), Rt(r._offset) || (e._offset = r._offset), Rt(r._pf) || (e._pf = Q(r)), Rt(r._locale) || (e._locale = r._locale), i > 0)
    for (t = 0; t < i; t++)
      n = fd[t], a = r[n], Rt(a) || (e[n] = a);
  return e;
}
function Ja(e) {
  Wl(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), wu === !1 && (wu = !0, L.updateOffset(this), wu = !1);
}
function mr(e) {
  return e instanceof Ja || e != null && e._isAMomentObject != null;
}
function B0(e) {
  L.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ar(e, r) {
  var t = !0;
  return Mn(function() {
    if (L.deprecationHandler != null && L.deprecationHandler(null, e), t) {
      var n = [], a, i, o, l = arguments.length;
      for (i = 0; i < l; i++) {
        if (a = "", typeof arguments[i] == "object") {
          a += `
[` + i + "] ";
          for (o in arguments[0])
            ge(arguments[0], o) && (a += o + ": " + arguments[0][o] + ", ");
          a = a.slice(0, -2);
        } else
          a = arguments[i];
        n.push(a);
      }
      B0(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), t = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var dd = {};
function H0(e, r) {
  L.deprecationHandler != null && L.deprecationHandler(e, r), dd[e] || (B0(r), dd[e] = !0);
}
L.suppressDeprecationWarnings = !1;
L.deprecationHandler = null;
function Fr(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function D4(e) {
  var r, t;
  for (t in e)
    ge(e, t) && (r = e[t], Fr(r) ? this[t] = r : this["_" + t] = r);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function nl(e, r) {
  var t = Mn({}, e), n;
  for (n in r)
    ge(r, n) && (li(e[n]) && li(r[n]) ? (t[n] = {}, Mn(t[n], e[n]), Mn(t[n], r[n])) : r[n] != null ? t[n] = r[n] : delete t[n]);
  for (n in e)
    ge(e, n) && !ge(r, n) && li(e[n]) && (t[n] = Mn({}, t[n]));
  return t;
}
function Bl(e) {
  e != null && this.set(e);
}
var il;
Object.keys ? il = Object.keys : il = function(e) {
  var r, t = [];
  for (r in e)
    ge(e, r) && t.push(r);
  return t;
};
var j4 = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function M4(e, r, t) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return Fr(n) ? n.call(r, t) : n;
}
function Rr(e, r, t) {
  var n = "" + Math.abs(e), a = r - n.length, i = e >= 0;
  return (i ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + n;
}
var Hl = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Ts = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Su = {}, Gi = {};
function V(e, r, t, n) {
  var a = n;
  typeof n == "string" && (a = function() {
    return this[n]();
  }), e && (Gi[e] = a), r && (Gi[r[0]] = function() {
    return Rr(a.apply(this, arguments), r[1], r[2]);
  }), t && (Gi[t] = function() {
    return this.localeData().ordinal(
      a.apply(this, arguments),
      e
    );
  });
}
function P4(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function A4(e) {
  var r = e.match(Hl), t, n;
  for (t = 0, n = r.length; t < n; t++)
    Gi[r[t]] ? r[t] = Gi[r[t]] : r[t] = P4(r[t]);
  return function(a) {
    var i = "", o;
    for (o = 0; o < n; o++)
      i += Fr(r[o]) ? r[o].call(a, e) : r[o];
    return i;
  };
}
function Ps(e, r) {
  return e.isValid() ? (r = G0(r, e.localeData()), Su[r] = Su[r] || A4(r), Su[r](e)) : e.localeData().invalidDate();
}
function G0(e, r) {
  var t = 5;
  function n(a) {
    return r.longDateFormat(a) || a;
  }
  for (Ts.lastIndex = 0; t >= 0 && Ts.test(e); )
    e = e.replace(
      Ts,
      n
    ), Ts.lastIndex = 0, t -= 1;
  return e;
}
var R4 = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function I4(e) {
  var r = this._longDateFormat[e], t = this._longDateFormat[e.toUpperCase()];
  return r || !t ? r : (this._longDateFormat[e] = t.match(Hl).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[e]);
}
var N4 = "Invalid date";
function L4() {
  return this._invalidDate;
}
var F4 = "%d", $4 = /\d{1,2}/;
function Y4(e) {
  return this._ordinal.replace("%d", e);
}
var U4 = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function z4(e, r, t, n) {
  var a = this._relativeTime[t];
  return Fr(a) ? a(e, r, t, n) : a.replace(/%d/i, e);
}
function W4(e, r) {
  var t = this._relativeTime[e > 0 ? "future" : "past"];
  return Fr(t) ? t(r) : t.replace(/%s/i, r);
}
var hd = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function sr(e) {
  return typeof e == "string" ? hd[e] || hd[e.toLowerCase()] : void 0;
}
function Gl(e) {
  var r = {}, t, n;
  for (n in e)
    ge(e, n) && (t = sr(n), t && (r[t] = e[n]));
  return r;
}
var B4 = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function H4(e) {
  var r = [], t;
  for (t in e)
    ge(e, t) && r.push({ unit: t, priority: B4[t] });
  return r.sort(function(n, a) {
    return n.priority - a.priority;
  }), r;
}
var V0 = /\d/, Zt = /\d\d/, K0 = /\d{3}/, Vl = /\d{4}/, ko = /[+-]?\d{6}/, Re = /\d\d?/, q0 = /\d\d\d\d?/, Z0 = /\d\d\d\d\d\d?/, Do = /\d{1,3}/, Kl = /\d{1,4}/, jo = /[+-]?\d{1,6}/, na = /\d+/, Mo = /[+-]?\d+/, G4 = /Z|[+-]\d\d:?\d\d/gi, Po = /Z|[+-]\d\d(?::?\d\d)?/gi, V4 = /[+-]?\d+(\.\d{1,3})?/, Xa = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, ia = /^[1-9]\d?/, ql = /^([1-9]\d|\d)/, Qs;
Qs = {};
function Y(e, r, t) {
  Qs[e] = Fr(r) ? r : function(n, a) {
    return n && t ? t : r;
  };
}
function K4(e, r) {
  return ge(Qs, e) ? Qs[e](r._strict, r._locale) : new RegExp(q4(e));
}
function q4(e) {
  return un(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, t, n, a, i) {
        return t || n || a || i;
      }
    )
  );
}
function un(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function nr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function oe(e) {
  var r = +e, t = 0;
  return r !== 0 && isFinite(r) && (t = nr(r)), t;
}
var al = {};
function Ee(e, r) {
  var t, n = r, a;
  for (typeof e == "string" && (e = [e]), cn(r) && (n = function(i, o) {
    o[r] = oe(i);
  }), a = e.length, t = 0; t < a; t++)
    al[e[t]] = n;
}
function Qa(e, r) {
  Ee(e, function(t, n, a, i) {
    a._w = a._w || {}, r(t, a._w, a, i);
  });
}
function Z4(e, r, t) {
  r != null && ge(al, e) && al[e](r, t._a, t, e);
}
function Ao(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var wt = 0, sn = 1, Dr = 2, Qe = 3, gr = 4, on = 5, ai = 6, J4 = 7, X4 = 8;
V("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Rr(e, 4) : "+" + e;
});
V(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
V(0, ["YYYY", 4], 0, "year");
V(0, ["YYYYY", 5], 0, "year");
V(0, ["YYYYYY", 6, !0], 0, "year");
Y("Y", Mo);
Y("YY", Re, Zt);
Y("YYYY", Kl, Vl);
Y("YYYYY", jo, ko);
Y("YYYYYY", jo, ko);
Ee(["YYYYY", "YYYYYY"], wt);
Ee("YYYY", function(e, r) {
  r[wt] = e.length === 2 ? L.parseTwoDigitYear(e) : oe(e);
});
Ee("YY", function(e, r) {
  r[wt] = L.parseTwoDigitYear(e);
});
Ee("Y", function(e, r) {
  r[wt] = parseInt(e, 10);
});
function Ma(e) {
  return Ao(e) ? 366 : 365;
}
L.parseTwoDigitYear = function(e) {
  return oe(e) + (oe(e) > 68 ? 1900 : 2e3);
};
var J0 = aa("FullYear", !0);
function Q4() {
  return Ao(this.year());
}
function aa(e, r) {
  return function(t) {
    return t != null ? (X0(this, e, t), L.updateOffset(this, r), this) : Ua(this, e);
  };
}
function Ua(e, r) {
  if (!e.isValid())
    return NaN;
  var t = e._d, n = e._isUTC;
  switch (r) {
    case "Milliseconds":
      return n ? t.getUTCMilliseconds() : t.getMilliseconds();
    case "Seconds":
      return n ? t.getUTCSeconds() : t.getSeconds();
    case "Minutes":
      return n ? t.getUTCMinutes() : t.getMinutes();
    case "Hours":
      return n ? t.getUTCHours() : t.getHours();
    case "Date":
      return n ? t.getUTCDate() : t.getDate();
    case "Day":
      return n ? t.getUTCDay() : t.getDay();
    case "Month":
      return n ? t.getUTCMonth() : t.getMonth();
    case "FullYear":
      return n ? t.getUTCFullYear() : t.getFullYear();
    default:
      return NaN;
  }
}
function X0(e, r, t) {
  var n, a, i, o, l;
  if (!(!e.isValid() || isNaN(t))) {
    switch (n = e._d, a = e._isUTC, r) {
      case "Milliseconds":
        return void (a ? n.setUTCMilliseconds(t) : n.setMilliseconds(t));
      case "Seconds":
        return void (a ? n.setUTCSeconds(t) : n.setSeconds(t));
      case "Minutes":
        return void (a ? n.setUTCMinutes(t) : n.setMinutes(t));
      case "Hours":
        return void (a ? n.setUTCHours(t) : n.setHours(t));
      case "Date":
        return void (a ? n.setUTCDate(t) : n.setDate(t));
      case "FullYear":
        break;
      default:
        return;
    }
    i = t, o = e.month(), l = e.date(), l = l === 29 && o === 1 && !Ao(i) ? 28 : l, a ? n.setUTCFullYear(i, o, l) : n.setFullYear(i, o, l);
  }
}
function eS(e) {
  return e = sr(e), Fr(this[e]) ? this[e]() : this;
}
function tS(e, r) {
  if (typeof e == "object") {
    e = Gl(e);
    var t = H4(e), n, a = t.length;
    for (n = 0; n < a; n++)
      this[t[n].unit](e[t[n].unit]);
  } else if (e = sr(e), Fr(this[e]))
    return this[e](r);
  return this;
}
function rS(e, r) {
  return (e % r + r) % r;
}
var He;
Array.prototype.indexOf ? He = Array.prototype.indexOf : He = function(e) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === e)
      return r;
  return -1;
};
function Zl(e, r) {
  if (isNaN(e) || isNaN(r))
    return NaN;
  var t = rS(r, 12);
  return e += (r - t) / 12, t === 1 ? Ao(e) ? 29 : 28 : 31 - t % 7 % 2;
}
V("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
V("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
V("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Y("M", Re, ia);
Y("MM", Re, Zt);
Y("MMM", function(e, r) {
  return r.monthsShortRegex(e);
});
Y("MMMM", function(e, r) {
  return r.monthsRegex(e);
});
Ee(["M", "MM"], function(e, r) {
  r[sn] = oe(e) - 1;
});
Ee(["MMM", "MMMM"], function(e, r, t, n) {
  var a = t._locale.monthsParse(e, n, t._strict);
  a != null ? r[sn] = a : Q(t).invalidMonth = e;
});
var nS = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Q0 = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), ey = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, iS = Xa, aS = Xa;
function sS(e, r) {
  return e ? vr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || ey).test(r) ? "format" : "standalone"][e.month()] : vr(this._months) ? this._months : this._months.standalone;
}
function oS(e, r) {
  return e ? vr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[ey.test(r) ? "format" : "standalone"][e.month()] : vr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function uS(e, r, t) {
  var n, a, i, o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      i = Lr([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(i, "").toLocaleLowerCase();
  return t ? r === "MMM" ? (a = He.call(this._shortMonthsParse, o), a !== -1 ? a : null) : (a = He.call(this._longMonthsParse, o), a !== -1 ? a : null) : r === "MMM" ? (a = He.call(this._shortMonthsParse, o), a !== -1 ? a : (a = He.call(this._longMonthsParse, o), a !== -1 ? a : null)) : (a = He.call(this._longMonthsParse, o), a !== -1 ? a : (a = He.call(this._shortMonthsParse, o), a !== -1 ? a : null));
}
function lS(e, r, t) {
  var n, a, i;
  if (this._monthsParseExact)
    return uS.call(this, e, r, t);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (a = Lr([2e3, n]), t && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(a, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(a, "").replace(".", "") + "$",
      "i"
    )), !t && !this._monthsParse[n] && (i = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""), this._monthsParse[n] = new RegExp(i.replace(".", ""), "i")), t && r === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (t && r === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!t && this._monthsParse[n].test(e))
      return n;
  }
}
function ty(e, r) {
  if (!e.isValid())
    return e;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = oe(r);
    else if (r = e.localeData().monthsParse(r), !cn(r))
      return e;
  }
  var t = r, n = e.date();
  return n = n < 29 ? n : Math.min(n, Zl(e.year(), t)), e._isUTC ? e._d.setUTCMonth(t, n) : e._d.setMonth(t, n), e;
}
function ry(e) {
  return e != null ? (ty(this, e), L.updateOffset(this, !0), this) : Ua(this, "Month");
}
function cS() {
  return Zl(this.year(), this.month());
}
function fS(e) {
  return this._monthsParseExact ? (ge(this, "_monthsRegex") || ny.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ge(this, "_monthsShortRegex") || (this._monthsShortRegex = iS), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function dS(e) {
  return this._monthsParseExact ? (ge(this, "_monthsRegex") || ny.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ge(this, "_monthsRegex") || (this._monthsRegex = aS), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function ny() {
  function e(h, s) {
    return s.length - h.length;
  }
  var r = [], t = [], n = [], a, i, o, l;
  for (a = 0; a < 12; a++)
    i = Lr([2e3, a]), o = un(this.monthsShort(i, "")), l = un(this.months(i, "")), r.push(o), t.push(l), n.push(l), n.push(o);
  r.sort(e), t.sort(e), n.sort(e), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function hS(e, r, t, n, a, i, o) {
  var l;
  return e < 100 && e >= 0 ? (l = new Date(e + 400, r, t, n, a, i, o), isFinite(l.getFullYear()) && l.setFullYear(e)) : l = new Date(e, r, t, n, a, i, o), l;
}
function za(e) {
  var r, t;
  return e < 100 && e >= 0 ? (t = Array.prototype.slice.call(arguments), t[0] = e + 400, r = new Date(Date.UTC.apply(null, t)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(e)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function eo(e, r, t) {
  var n = 7 + r - t, a = (7 + za(e, 0, n).getUTCDay() - r) % 7;
  return -a + n - 1;
}
function iy(e, r, t, n, a) {
  var i = (7 + t - n) % 7, o = eo(e, n, a), l = 1 + 7 * (r - 1) + i + o, h, s;
  return l <= 0 ? (h = e - 1, s = Ma(h) + l) : l > Ma(e) ? (h = e + 1, s = l - Ma(e)) : (h = e, s = l), {
    year: h,
    dayOfYear: s
  };
}
function Wa(e, r, t) {
  var n = eo(e.year(), r, t), a = Math.floor((e.dayOfYear() - n - 1) / 7) + 1, i, o;
  return a < 1 ? (o = e.year() - 1, i = a + ln(o, r, t)) : a > ln(e.year(), r, t) ? (i = a - ln(e.year(), r, t), o = e.year() + 1) : (o = e.year(), i = a), {
    week: i,
    year: o
  };
}
function ln(e, r, t) {
  var n = eo(e, r, t), a = eo(e + 1, r, t);
  return (Ma(e) - n + a) / 7;
}
V("w", ["ww", 2], "wo", "week");
V("W", ["WW", 2], "Wo", "isoWeek");
Y("w", Re, ia);
Y("ww", Re, Zt);
Y("W", Re, ia);
Y("WW", Re, Zt);
Qa(
  ["w", "ww", "W", "WW"],
  function(e, r, t, n) {
    r[n.substr(0, 1)] = oe(e);
  }
);
function yS(e) {
  return Wa(e, this._week.dow, this._week.doy).week;
}
var gS = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function pS() {
  return this._week.dow;
}
function vS() {
  return this._week.doy;
}
function mS(e) {
  var r = this.localeData().week(this);
  return e == null ? r : this.add((e - r) * 7, "d");
}
function bS(e) {
  var r = Wa(this, 1, 4).week;
  return e == null ? r : this.add((e - r) * 7, "d");
}
V("d", 0, "do", "day");
V("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
V("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
V("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
V("e", 0, 0, "weekday");
V("E", 0, 0, "isoWeekday");
Y("d", Re);
Y("e", Re);
Y("E", Re);
Y("dd", function(e, r) {
  return r.weekdaysMinRegex(e);
});
Y("ddd", function(e, r) {
  return r.weekdaysShortRegex(e);
});
Y("dddd", function(e, r) {
  return r.weekdaysRegex(e);
});
Qa(["dd", "ddd", "dddd"], function(e, r, t, n) {
  var a = t._locale.weekdaysParse(e, n, t._strict);
  a != null ? r.d = a : Q(t).invalidWeekday = e;
});
Qa(["d", "e", "E"], function(e, r, t, n) {
  r[n] = oe(e);
});
function _S(e, r) {
  return typeof e != "string" ? e : isNaN(e) ? (e = r.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function wS(e, r) {
  return typeof e == "string" ? r.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Jl(e, r) {
  return e.slice(r, 7).concat(e.slice(0, r));
}
var SS = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ay = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), xS = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), TS = Xa, ES = Xa, OS = Xa;
function CS(e, r) {
  var t = vr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return e === !0 ? Jl(t, this._week.dow) : e ? t[e.day()] : t;
}
function kS(e) {
  return e === !0 ? Jl(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function DS(e) {
  return e === !0 ? Jl(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function jS(e, r, t) {
  var n, a, i, o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      i = Lr([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(i, "").toLocaleLowerCase();
  return t ? r === "dddd" ? (a = He.call(this._weekdaysParse, o), a !== -1 ? a : null) : r === "ddd" ? (a = He.call(this._shortWeekdaysParse, o), a !== -1 ? a : null) : (a = He.call(this._minWeekdaysParse, o), a !== -1 ? a : null) : r === "dddd" ? (a = He.call(this._weekdaysParse, o), a !== -1 || (a = He.call(this._shortWeekdaysParse, o), a !== -1) ? a : (a = He.call(this._minWeekdaysParse, o), a !== -1 ? a : null)) : r === "ddd" ? (a = He.call(this._shortWeekdaysParse, o), a !== -1 || (a = He.call(this._weekdaysParse, o), a !== -1) ? a : (a = He.call(this._minWeekdaysParse, o), a !== -1 ? a : null)) : (a = He.call(this._minWeekdaysParse, o), a !== -1 || (a = He.call(this._weekdaysParse, o), a !== -1) ? a : (a = He.call(this._shortWeekdaysParse, o), a !== -1 ? a : null));
}
function MS(e, r, t) {
  var n, a, i;
  if (this._weekdaysParseExact)
    return jS.call(this, e, r, t);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (a = Lr([2e3, 1]).day(n), t && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (i = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""), this._weekdaysParse[n] = new RegExp(i.replace(".", ""), "i")), t && r === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (t && r === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (t && r === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!t && this._weekdaysParse[n].test(e))
      return n;
  }
}
function PS(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = Ua(this, "Day");
  return e != null ? (e = _S(e, this.localeData()), this.add(e - r, "d")) : r;
}
function AS(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? r : this.add(e - r, "d");
}
function RS(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var r = wS(e, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function IS(e) {
  return this._weekdaysParseExact ? (ge(this, "_weekdaysRegex") || Xl.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ge(this, "_weekdaysRegex") || (this._weekdaysRegex = TS), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function NS(e) {
  return this._weekdaysParseExact ? (ge(this, "_weekdaysRegex") || Xl.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ge(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = ES), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function LS(e) {
  return this._weekdaysParseExact ? (ge(this, "_weekdaysRegex") || Xl.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ge(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = OS), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Xl() {
  function e(f, p) {
    return p.length - f.length;
  }
  var r = [], t = [], n = [], a = [], i, o, l, h, s;
  for (i = 0; i < 7; i++)
    o = Lr([2e3, 1]).day(i), l = un(this.weekdaysMin(o, "")), h = un(this.weekdaysShort(o, "")), s = un(this.weekdays(o, "")), r.push(l), t.push(h), n.push(s), a.push(l), a.push(h), a.push(s);
  r.sort(e), t.sort(e), n.sort(e), a.sort(e), this._weekdaysRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function Ql() {
  return this.hours() % 12 || 12;
}
function FS() {
  return this.hours() || 24;
}
V("H", ["HH", 2], 0, "hour");
V("h", ["hh", 2], 0, Ql);
V("k", ["kk", 2], 0, FS);
V("hmm", 0, 0, function() {
  return "" + Ql.apply(this) + Rr(this.minutes(), 2);
});
V("hmmss", 0, 0, function() {
  return "" + Ql.apply(this) + Rr(this.minutes(), 2) + Rr(this.seconds(), 2);
});
V("Hmm", 0, 0, function() {
  return "" + this.hours() + Rr(this.minutes(), 2);
});
V("Hmmss", 0, 0, function() {
  return "" + this.hours() + Rr(this.minutes(), 2) + Rr(this.seconds(), 2);
});
function sy(e, r) {
  V(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
sy("a", !0);
sy("A", !1);
function oy(e, r) {
  return r._meridiemParse;
}
Y("a", oy);
Y("A", oy);
Y("H", Re, ql);
Y("h", Re, ia);
Y("k", Re, ia);
Y("HH", Re, Zt);
Y("hh", Re, Zt);
Y("kk", Re, Zt);
Y("hmm", q0);
Y("hmmss", Z0);
Y("Hmm", q0);
Y("Hmmss", Z0);
Ee(["H", "HH"], Qe);
Ee(["k", "kk"], function(e, r, t) {
  var n = oe(e);
  r[Qe] = n === 24 ? 0 : n;
});
Ee(["a", "A"], function(e, r, t) {
  t._isPm = t._locale.isPM(e), t._meridiem = e;
});
Ee(["h", "hh"], function(e, r, t) {
  r[Qe] = oe(e), Q(t).bigHour = !0;
});
Ee("hmm", function(e, r, t) {
  var n = e.length - 2;
  r[Qe] = oe(e.substr(0, n)), r[gr] = oe(e.substr(n)), Q(t).bigHour = !0;
});
Ee("hmmss", function(e, r, t) {
  var n = e.length - 4, a = e.length - 2;
  r[Qe] = oe(e.substr(0, n)), r[gr] = oe(e.substr(n, 2)), r[on] = oe(e.substr(a)), Q(t).bigHour = !0;
});
Ee("Hmm", function(e, r, t) {
  var n = e.length - 2;
  r[Qe] = oe(e.substr(0, n)), r[gr] = oe(e.substr(n));
});
Ee("Hmmss", function(e, r, t) {
  var n = e.length - 4, a = e.length - 2;
  r[Qe] = oe(e.substr(0, n)), r[gr] = oe(e.substr(n, 2)), r[on] = oe(e.substr(a));
});
function $S(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var YS = /[ap]\.?m?\.?/i, US = aa("Hours", !0);
function zS(e, r, t) {
  return e > 11 ? t ? "pm" : "PM" : t ? "am" : "AM";
}
var uy = {
  calendar: j4,
  longDateFormat: R4,
  invalidDate: N4,
  ordinal: F4,
  dayOfMonthOrdinalParse: $4,
  relativeTime: U4,
  months: nS,
  monthsShort: Q0,
  week: gS,
  weekdays: SS,
  weekdaysMin: xS,
  weekdaysShort: ay,
  meridiemParse: YS
}, Le = {}, ma = {}, Ba;
function WS(e, r) {
  var t, n = Math.min(e.length, r.length);
  for (t = 0; t < n; t += 1)
    if (e[t] !== r[t])
      return t;
  return n;
}
function yd(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function BS(e) {
  for (var r = 0, t, n, a, i; r < e.length; ) {
    for (i = yd(e[r]).split("-"), t = i.length, n = yd(e[r + 1]), n = n ? n.split("-") : null; t > 0; ) {
      if (a = Ro(i.slice(0, t).join("-")), a)
        return a;
      if (n && n.length >= t && WS(i, n) >= t - 1)
        break;
      t--;
    }
    r++;
  }
  return Ba;
}
function HS(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function Ro(e) {
  var r = null, t;
  if (Le[e] === void 0 && typeof module < "u" && module && module.exports && HS(e))
    try {
      r = Ba._abbr, t = require, t("./locale/" + e), Rn(r);
    } catch {
      Le[e] = null;
    }
  return Le[e];
}
function Rn(e, r) {
  var t;
  return e && (Rt(r) ? t = fn(e) : t = ec(e, r), t ? Ba = t : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Ba._abbr;
}
function ec(e, r) {
  if (r !== null) {
    var t, n = uy;
    if (r.abbr = e, Le[e] != null)
      H0(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = Le[e]._config;
    else if (r.parentLocale != null)
      if (Le[r.parentLocale] != null)
        n = Le[r.parentLocale]._config;
      else if (t = Ro(r.parentLocale), t != null)
        n = t._config;
      else
        return ma[r.parentLocale] || (ma[r.parentLocale] = []), ma[r.parentLocale].push({
          name: e,
          config: r
        }), null;
    return Le[e] = new Bl(nl(n, r)), ma[e] && ma[e].forEach(function(a) {
      ec(a.name, a.config);
    }), Rn(e), Le[e];
  } else
    return delete Le[e], null;
}
function GS(e, r) {
  if (r != null) {
    var t, n, a = uy;
    Le[e] != null && Le[e].parentLocale != null ? Le[e].set(nl(Le[e]._config, r)) : (n = Ro(e), n != null && (a = n._config), r = nl(a, r), n == null && (r.abbr = e), t = new Bl(r), t.parentLocale = Le[e], Le[e] = t), Rn(e);
  } else
    Le[e] != null && (Le[e].parentLocale != null ? (Le[e] = Le[e].parentLocale, e === Rn() && Rn(e)) : Le[e] != null && delete Le[e]);
  return Le[e];
}
function fn(e) {
  var r;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Ba;
  if (!vr(e)) {
    if (r = Ro(e), r)
      return r;
    e = [e];
  }
  return BS(e);
}
function VS() {
  return il(Le);
}
function tc(e) {
  var r, t = e._a;
  return t && Q(e).overflow === -2 && (r = t[sn] < 0 || t[sn] > 11 ? sn : t[Dr] < 1 || t[Dr] > Zl(t[wt], t[sn]) ? Dr : t[Qe] < 0 || t[Qe] > 24 || t[Qe] === 24 && (t[gr] !== 0 || t[on] !== 0 || t[ai] !== 0) ? Qe : t[gr] < 0 || t[gr] > 59 ? gr : t[on] < 0 || t[on] > 59 ? on : t[ai] < 0 || t[ai] > 999 ? ai : -1, Q(e)._overflowDayOfYear && (r < wt || r > Dr) && (r = Dr), Q(e)._overflowWeeks && r === -1 && (r = J4), Q(e)._overflowWeekday && r === -1 && (r = X4), Q(e).overflow = r), e;
}
var KS = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, qS = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ZS = /Z|[+-]\d\d(?::?\d\d)?/, Es = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], xu = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], JS = /^\/?Date\((-?\d+)/i, XS = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, QS = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ly(e) {
  var r, t, n = e._i, a = KS.exec(n) || qS.exec(n), i, o, l, h, s = Es.length, f = xu.length;
  if (a) {
    for (Q(e).iso = !0, r = 0, t = s; r < t; r++)
      if (Es[r][1].exec(a[1])) {
        o = Es[r][0], i = Es[r][2] !== !1;
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (a[3]) {
      for (r = 0, t = f; r < t; r++)
        if (xu[r][1].exec(a[3])) {
          l = (a[2] || " ") + xu[r][0];
          break;
        }
      if (l == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!i && l != null) {
      e._isValid = !1;
      return;
    }
    if (a[4])
      if (ZS.exec(a[4]))
        h = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = o + (l || "") + (h || ""), nc(e);
  } else
    e._isValid = !1;
}
function ex(e, r, t, n, a, i) {
  var o = [
    tx(e),
    Q0.indexOf(r),
    parseInt(t, 10),
    parseInt(n, 10),
    parseInt(a, 10)
  ];
  return i && o.push(parseInt(i, 10)), o;
}
function tx(e) {
  var r = parseInt(e, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function rx(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function nx(e, r, t) {
  if (e) {
    var n = ay.indexOf(e), a = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (n !== a)
      return Q(t).weekdayMismatch = !0, t._isValid = !1, !1;
  }
  return !0;
}
function ix(e, r, t) {
  if (e)
    return QS[e];
  if (r)
    return 0;
  var n = parseInt(t, 10), a = n % 100, i = (n - a) / 100;
  return i * 60 + a;
}
function cy(e) {
  var r = XS.exec(rx(e._i)), t;
  if (r) {
    if (t = ex(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !nx(r[1], t, e))
      return;
    e._a = t, e._tzm = ix(r[8], r[9], r[10]), e._d = za.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Q(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function ax(e) {
  var r = JS.exec(e._i);
  if (r !== null) {
    e._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (ly(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (cy(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : L.createFromInputFallback(e);
}
L.createFromInputFallback = ar(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Ui(e, r, t) {
  return e ?? r ?? t;
}
function sx(e) {
  var r = new Date(L.now());
  return e._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function rc(e) {
  var r, t, n = [], a, i, o;
  if (!e._d) {
    for (a = sx(e), e._w && e._a[Dr] == null && e._a[sn] == null && ox(e), e._dayOfYear != null && (o = Ui(e._a[wt], a[wt]), (e._dayOfYear > Ma(o) || e._dayOfYear === 0) && (Q(e)._overflowDayOfYear = !0), t = za(o, 0, e._dayOfYear), e._a[sn] = t.getUTCMonth(), e._a[Dr] = t.getUTCDate()), r = 0; r < 3 && e._a[r] == null; ++r)
      e._a[r] = n[r] = a[r];
    for (; r < 7; r++)
      e._a[r] = n[r] = e._a[r] == null ? r === 2 ? 1 : 0 : e._a[r];
    e._a[Qe] === 24 && e._a[gr] === 0 && e._a[on] === 0 && e._a[ai] === 0 && (e._nextDay = !0, e._a[Qe] = 0), e._d = (e._useUTC ? za : hS).apply(
      null,
      n
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Qe] = 24), e._w && typeof e._w.d < "u" && e._w.d !== i && (Q(e).weekdayMismatch = !0);
  }
}
function ox(e) {
  var r, t, n, a, i, o, l, h, s;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (i = 1, o = 4, t = Ui(
    r.GG,
    e._a[wt],
    Wa(Ae(), 1, 4).year
  ), n = Ui(r.W, 1), a = Ui(r.E, 1), (a < 1 || a > 7) && (h = !0)) : (i = e._locale._week.dow, o = e._locale._week.doy, s = Wa(Ae(), i, o), t = Ui(r.gg, e._a[wt], s.year), n = Ui(r.w, s.week), r.d != null ? (a = r.d, (a < 0 || a > 6) && (h = !0)) : r.e != null ? (a = r.e + i, (r.e < 0 || r.e > 6) && (h = !0)) : a = i), n < 1 || n > ln(t, i, o) ? Q(e)._overflowWeeks = !0 : h != null ? Q(e)._overflowWeekday = !0 : (l = iy(t, n, a, i, o), e._a[wt] = l.year, e._dayOfYear = l.dayOfYear);
}
L.ISO_8601 = function() {
};
L.RFC_2822 = function() {
};
function nc(e) {
  if (e._f === L.ISO_8601) {
    ly(e);
    return;
  }
  if (e._f === L.RFC_2822) {
    cy(e);
    return;
  }
  e._a = [], Q(e).empty = !0;
  var r = "" + e._i, t, n, a, i, o, l = r.length, h = 0, s, f;
  for (a = G0(e._f, e._locale).match(Hl) || [], f = a.length, t = 0; t < f; t++)
    i = a[t], n = (r.match(K4(i, e)) || [])[0], n && (o = r.substr(0, r.indexOf(n)), o.length > 0 && Q(e).unusedInput.push(o), r = r.slice(
      r.indexOf(n) + n.length
    ), h += n.length), Gi[i] ? (n ? Q(e).empty = !1 : Q(e).unusedTokens.push(i), Z4(i, n, e)) : e._strict && !n && Q(e).unusedTokens.push(i);
  Q(e).charsLeftOver = l - h, r.length > 0 && Q(e).unusedInput.push(r), e._a[Qe] <= 12 && Q(e).bigHour === !0 && e._a[Qe] > 0 && (Q(e).bigHour = void 0), Q(e).parsedDateParts = e._a.slice(0), Q(e).meridiem = e._meridiem, e._a[Qe] = ux(
    e._locale,
    e._a[Qe],
    e._meridiem
  ), s = Q(e).era, s !== null && (e._a[wt] = e._locale.erasConvertYear(s, e._a[wt])), rc(e), tc(e);
}
function ux(e, r, t) {
  var n;
  return t == null ? r : e.meridiemHour != null ? e.meridiemHour(r, t) : (e.isPM != null && (n = e.isPM(t), n && r < 12 && (r += 12), !n && r === 12 && (r = 0)), r);
}
function lx(e) {
  var r, t, n, a, i, o, l = !1, h = e._f.length;
  if (h === 0) {
    Q(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (a = 0; a < h; a++)
    i = 0, o = !1, r = Wl({}, e), e._useUTC != null && (r._useUTC = e._useUTC), r._f = e._f[a], nc(r), zl(r) && (o = !0), i += Q(r).charsLeftOver, i += Q(r).unusedTokens.length * 10, Q(r).score = i, l ? i < n && (n = i, t = r) : (n == null || i < n || o) && (n = i, t = r, o && (l = !0));
  Mn(e, t || r);
}
function cx(e) {
  if (!e._d) {
    var r = Gl(e._i), t = r.day === void 0 ? r.date : r.day;
    e._a = W0(
      [r.year, r.month, t, r.hour, r.minute, r.second, r.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), rc(e);
  }
}
function fx(e) {
  var r = new Ja(tc(fy(e)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function fy(e) {
  var r = e._i, t = e._f;
  return e._locale = e._locale || fn(e._l), r === null || t === void 0 && r === "" ? Co({ nullInput: !0 }) : (typeof r == "string" && (e._i = r = e._locale.preparse(r)), mr(r) ? new Ja(tc(r)) : (Za(r) ? e._d = r : vr(t) ? lx(e) : t ? nc(e) : dx(e), zl(e) || (e._d = null), e));
}
function dx(e) {
  var r = e._i;
  Rt(r) ? e._d = new Date(L.now()) : Za(r) ? e._d = new Date(r.valueOf()) : typeof r == "string" ? ax(e) : vr(r) ? (e._a = W0(r.slice(0), function(t) {
    return parseInt(t, 10);
  }), rc(e)) : li(r) ? cx(e) : cn(r) ? e._d = new Date(r) : L.createFromInputFallback(e);
}
function dy(e, r, t, n, a) {
  var i = {};
  return (r === !0 || r === !1) && (n = r, r = void 0), (t === !0 || t === !1) && (n = t, t = void 0), (li(e) && Ul(e) || vr(e) && e.length === 0) && (e = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = a, i._l = t, i._i = e, i._f = r, i._strict = n, fx(i);
}
function Ae(e, r, t, n) {
  return dy(e, r, t, n, !1);
}
var hx = ar(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ae.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Co();
  }
), yx = ar(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ae.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Co();
  }
);
function hy(e, r) {
  var t, n;
  if (r.length === 1 && vr(r[0]) && (r = r[0]), !r.length)
    return Ae();
  for (t = r[0], n = 1; n < r.length; ++n)
    (!r[n].isValid() || r[n][e](t)) && (t = r[n]);
  return t;
}
function gx() {
  var e = [].slice.call(arguments, 0);
  return hy("isBefore", e);
}
function px() {
  var e = [].slice.call(arguments, 0);
  return hy("isAfter", e);
}
var vx = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, ba = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function mx(e) {
  var r, t = !1, n, a = ba.length;
  for (r in e)
    if (ge(e, r) && !(He.call(ba, r) !== -1 && (e[r] == null || !isNaN(e[r]))))
      return !1;
  for (n = 0; n < a; ++n)
    if (e[ba[n]]) {
      if (t)
        return !1;
      parseFloat(e[ba[n]]) !== oe(e[ba[n]]) && (t = !0);
    }
  return !0;
}
function bx() {
  return this._isValid;
}
function _x() {
  return _r(NaN);
}
function Io(e) {
  var r = Gl(e), t = r.year || 0, n = r.quarter || 0, a = r.month || 0, i = r.week || r.isoWeek || 0, o = r.day || 0, l = r.hour || 0, h = r.minute || 0, s = r.second || 0, f = r.millisecond || 0;
  this._isValid = mx(r), this._milliseconds = +f + s * 1e3 + // 1000
  h * 6e4 + // 1000 * 60
  l * 1e3 * 60 * 60, this._days = +o + i * 7, this._months = +a + n * 3 + t * 12, this._data = {}, this._locale = fn(), this._bubble();
}
function As(e) {
  return e instanceof Io;
}
function sl(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function wx(e, r, t) {
  var n = Math.min(e.length, r.length), a = Math.abs(e.length - r.length), i = 0, o;
  for (o = 0; o < n; o++)
    (t && e[o] !== r[o] || !t && oe(e[o]) !== oe(r[o])) && i++;
  return i + a;
}
function yy(e, r) {
  V(e, 0, 0, function() {
    var t = this.utcOffset(), n = "+";
    return t < 0 && (t = -t, n = "-"), n + Rr(~~(t / 60), 2) + r + Rr(~~t % 60, 2);
  });
}
yy("Z", ":");
yy("ZZ", "");
Y("Z", Po);
Y("ZZ", Po);
Ee(["Z", "ZZ"], function(e, r, t) {
  t._useUTC = !0, t._tzm = ic(Po, e);
});
var Sx = /([\+\-]|\d\d)/gi;
function ic(e, r) {
  var t = (r || "").match(e), n, a, i;
  return t === null ? null : (n = t[t.length - 1] || [], a = (n + "").match(Sx) || ["-", 0, 0], i = +(a[1] * 60) + oe(a[2]), i === 0 ? 0 : a[0] === "+" ? i : -i);
}
function ac(e, r) {
  var t, n;
  return r._isUTC ? (t = r.clone(), n = (mr(e) || Za(e) ? e.valueOf() : Ae(e).valueOf()) - t.valueOf(), t._d.setTime(t._d.valueOf() + n), L.updateOffset(t, !1), t) : Ae(e).local();
}
function ol(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
L.updateOffset = function() {
};
function xx(e, r, t) {
  var n = this._offset || 0, a;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = ic(Po, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !t && (e = e * 60);
    return !this._isUTC && r && (a = ol(this)), this._offset = e, this._isUTC = !0, a != null && this.add(a, "m"), n !== e && (!r || this._changeInProgress ? vy(
      this,
      _r(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, L.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : ol(this);
}
function Tx(e, r) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, r), this) : -this.utcOffset();
}
function Ex(e) {
  return this.utcOffset(0, e);
}
function Ox(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(ol(this), "m")), this;
}
function Cx() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = ic(G4, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function kx(e) {
  return this.isValid() ? (e = e ? Ae(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Dx() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function jx() {
  if (!Rt(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, r;
  return Wl(e, this), e = fy(e), e._a ? (r = e._isUTC ? Lr(e._a) : Ae(e._a), this._isDSTShifted = this.isValid() && wx(e._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Mx() {
  return this.isValid() ? !this._isUTC : !1;
}
function Px() {
  return this.isValid() ? this._isUTC : !1;
}
function gy() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Ax = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Rx = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function _r(e, r) {
  var t = e, n = null, a, i, o;
  return As(e) ? t = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : cn(e) || !isNaN(+e) ? (t = {}, r ? t[r] = +e : t.milliseconds = +e) : (n = Ax.exec(e)) ? (a = n[1] === "-" ? -1 : 1, t = {
    y: 0,
    d: oe(n[Dr]) * a,
    h: oe(n[Qe]) * a,
    m: oe(n[gr]) * a,
    s: oe(n[on]) * a,
    ms: oe(sl(n[ai] * 1e3)) * a
    // the millisecond decimal point is included in the match
  }) : (n = Rx.exec(e)) ? (a = n[1] === "-" ? -1 : 1, t = {
    y: Zn(n[2], a),
    M: Zn(n[3], a),
    w: Zn(n[4], a),
    d: Zn(n[5], a),
    h: Zn(n[6], a),
    m: Zn(n[7], a),
    s: Zn(n[8], a)
  }) : t == null ? t = {} : typeof t == "object" && ("from" in t || "to" in t) && (o = Ix(
    Ae(t.from),
    Ae(t.to)
  ), t = {}, t.ms = o.milliseconds, t.M = o.months), i = new Io(t), As(e) && ge(e, "_locale") && (i._locale = e._locale), As(e) && ge(e, "_isValid") && (i._isValid = e._isValid), i;
}
_r.fn = Io.prototype;
_r.invalid = _x;
function Zn(e, r) {
  var t = e && parseFloat(e.replace(",", "."));
  return (isNaN(t) ? 0 : t) * r;
}
function gd(e, r) {
  var t = {};
  return t.months = r.month() - e.month() + (r.year() - e.year()) * 12, e.clone().add(t.months, "M").isAfter(r) && --t.months, t.milliseconds = +r - +e.clone().add(t.months, "M"), t;
}
function Ix(e, r) {
  var t;
  return e.isValid() && r.isValid() ? (r = ac(r, e), e.isBefore(r) ? t = gd(e, r) : (t = gd(r, e), t.milliseconds = -t.milliseconds, t.months = -t.months), t) : { milliseconds: 0, months: 0 };
}
function py(e, r) {
  return function(t, n) {
    var a, i;
    return n !== null && !isNaN(+n) && (H0(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = t, t = n, n = i), a = _r(t, n), vy(this, a, e), this;
  };
}
function vy(e, r, t, n) {
  var a = r._milliseconds, i = sl(r._days), o = sl(r._months);
  e.isValid() && (n = n ?? !0, o && ty(e, Ua(e, "Month") + o * t), i && X0(e, "Date", Ua(e, "Date") + i * t), a && e._d.setTime(e._d.valueOf() + a * t), n && L.updateOffset(e, i || o));
}
var Nx = py(1, "add"), Lx = py(-1, "subtract");
function my(e) {
  return typeof e == "string" || e instanceof String;
}
function Fx(e) {
  return mr(e) || Za(e) || my(e) || cn(e) || Yx(e) || $x(e) || e === null || e === void 0;
}
function $x(e) {
  var r = li(e) && !Ul(e), t = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], a, i, o = n.length;
  for (a = 0; a < o; a += 1)
    i = n[a], t = t || ge(e, i);
  return r && t;
}
function Yx(e) {
  var r = vr(e), t = !1;
  return r && (t = e.filter(function(n) {
    return !cn(n) && my(e);
  }).length === 0), r && t;
}
function Ux(e) {
  var r = li(e) && !Ul(e), t = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], a, i;
  for (a = 0; a < n.length; a += 1)
    i = n[a], t = t || ge(e, i);
  return r && t;
}
function zx(e, r) {
  var t = e.diff(r, "days", !0);
  return t < -6 ? "sameElse" : t < -1 ? "lastWeek" : t < 0 ? "lastDay" : t < 1 ? "sameDay" : t < 2 ? "nextDay" : t < 7 ? "nextWeek" : "sameElse";
}
function Wx(e, r) {
  arguments.length === 1 && (arguments[0] ? Fx(arguments[0]) ? (e = arguments[0], r = void 0) : Ux(arguments[0]) && (r = arguments[0], e = void 0) : (e = void 0, r = void 0));
  var t = e || Ae(), n = ac(t, this).startOf("day"), a = L.calendarFormat(this, n) || "sameElse", i = r && (Fr(r[a]) ? r[a].call(this, t) : r[a]);
  return this.format(
    i || this.localeData().calendar(a, this, Ae(t))
  );
}
function Bx() {
  return new Ja(this);
}
function Hx(e, r) {
  var t = mr(e) ? e : Ae(e);
  return this.isValid() && t.isValid() ? (r = sr(r) || "millisecond", r === "millisecond" ? this.valueOf() > t.valueOf() : t.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function Gx(e, r) {
  var t = mr(e) ? e : Ae(e);
  return this.isValid() && t.isValid() ? (r = sr(r) || "millisecond", r === "millisecond" ? this.valueOf() < t.valueOf() : this.clone().endOf(r).valueOf() < t.valueOf()) : !1;
}
function Vx(e, r, t, n) {
  var a = mr(e) ? e : Ae(e), i = mr(r) ? r : Ae(r);
  return this.isValid() && a.isValid() && i.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(a, t) : !this.isBefore(a, t)) && (n[1] === ")" ? this.isBefore(i, t) : !this.isAfter(i, t))) : !1;
}
function Kx(e, r) {
  var t = mr(e) ? e : Ae(e), n;
  return this.isValid() && t.isValid() ? (r = sr(r) || "millisecond", r === "millisecond" ? this.valueOf() === t.valueOf() : (n = t.valueOf(), this.clone().startOf(r).valueOf() <= n && n <= this.clone().endOf(r).valueOf())) : !1;
}
function qx(e, r) {
  return this.isSame(e, r) || this.isAfter(e, r);
}
function Zx(e, r) {
  return this.isSame(e, r) || this.isBefore(e, r);
}
function Jx(e, r, t) {
  var n, a, i;
  if (!this.isValid())
    return NaN;
  if (n = ac(e, this), !n.isValid())
    return NaN;
  switch (a = (n.utcOffset() - this.utcOffset()) * 6e4, r = sr(r), r) {
    case "year":
      i = Rs(this, n) / 12;
      break;
    case "month":
      i = Rs(this, n);
      break;
    case "quarter":
      i = Rs(this, n) / 3;
      break;
    case "second":
      i = (this - n) / 1e3;
      break;
    case "minute":
      i = (this - n) / 6e4;
      break;
    case "hour":
      i = (this - n) / 36e5;
      break;
    case "day":
      i = (this - n - a) / 864e5;
      break;
    case "week":
      i = (this - n - a) / 6048e5;
      break;
    default:
      i = this - n;
  }
  return t ? i : nr(i);
}
function Rs(e, r) {
  if (e.date() < r.date())
    return -Rs(r, e);
  var t = (r.year() - e.year()) * 12 + (r.month() - e.month()), n = e.clone().add(t, "months"), a, i;
  return r - n < 0 ? (a = e.clone().add(t - 1, "months"), i = (r - n) / (n - a)) : (a = e.clone().add(t + 1, "months"), i = (r - n) / (a - n)), -(t + i) || 0;
}
L.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
L.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Xx() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Qx(e) {
  if (!this.isValid())
    return null;
  var r = e !== !0, t = r ? this.clone().utc() : this;
  return t.year() < 0 || t.year() > 9999 ? Ps(
    t,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Fr(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Ps(t, "Z")) : Ps(
    t,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function e6() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", r = "", t, n, a, i;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), t = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", a = "-MM-DD[T]HH:mm:ss.SSS", i = r + '[")]', this.format(t + n + a + i);
}
function t6(e) {
  e || (e = this.isUtc() ? L.defaultFormatUtc : L.defaultFormat);
  var r = Ps(this, e);
  return this.localeData().postformat(r);
}
function r6(e, r) {
  return this.isValid() && (mr(e) && e.isValid() || Ae(e).isValid()) ? _r({ to: this, from: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function n6(e) {
  return this.from(Ae(), e);
}
function i6(e, r) {
  return this.isValid() && (mr(e) && e.isValid() || Ae(e).isValid()) ? _r({ from: this, to: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function a6(e) {
  return this.to(Ae(), e);
}
function by(e) {
  var r;
  return e === void 0 ? this._locale._abbr : (r = fn(e), r != null && (this._locale = r), this);
}
var _y = ar(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function wy() {
  return this._locale;
}
var to = 1e3, Vi = 60 * to, ro = 60 * Vi, Sy = (365 * 400 + 97) * 24 * ro;
function Ki(e, r) {
  return (e % r + r) % r;
}
function xy(e, r, t) {
  return e < 100 && e >= 0 ? new Date(e + 400, r, t) - Sy : new Date(e, r, t).valueOf();
}
function Ty(e, r, t) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, r, t) - Sy : Date.UTC(e, r, t);
}
function s6(e) {
  var r, t;
  if (e = sr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Ty : xy, e) {
    case "year":
      r = t(this.year(), 0, 1);
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = t(this.year(), this.month(), 1);
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= Ki(
        r + (this._isUTC ? 0 : this.utcOffset() * Vi),
        ro
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= Ki(r, Vi);
      break;
    case "second":
      r = this._d.valueOf(), r -= Ki(r, to);
      break;
  }
  return this._d.setTime(r), L.updateOffset(this, !0), this;
}
function o6(e) {
  var r, t;
  if (e = sr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Ty : xy, e) {
    case "year":
      r = t(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = t(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += ro - Ki(
        r + (this._isUTC ? 0 : this.utcOffset() * Vi),
        ro
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += Vi - Ki(r, Vi) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += to - Ki(r, to) - 1;
      break;
  }
  return this._d.setTime(r), L.updateOffset(this, !0), this;
}
function u6() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function l6() {
  return Math.floor(this.valueOf() / 1e3);
}
function c6() {
  return new Date(this.valueOf());
}
function f6() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function d6() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function h6() {
  return this.isValid() ? this.toISOString() : null;
}
function y6() {
  return zl(this);
}
function g6() {
  return Mn({}, Q(this));
}
function p6() {
  return Q(this).overflow;
}
function v6() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
V("N", 0, 0, "eraAbbr");
V("NN", 0, 0, "eraAbbr");
V("NNN", 0, 0, "eraAbbr");
V("NNNN", 0, 0, "eraName");
V("NNNNN", 0, 0, "eraNarrow");
V("y", ["y", 1], "yo", "eraYear");
V("y", ["yy", 2], 0, "eraYear");
V("y", ["yyy", 3], 0, "eraYear");
V("y", ["yyyy", 4], 0, "eraYear");
Y("N", sc);
Y("NN", sc);
Y("NNN", sc);
Y("NNNN", k6);
Y("NNNNN", D6);
Ee(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, r, t, n) {
    var a = t._locale.erasParse(e, n, t._strict);
    a ? Q(t).era = a : Q(t).invalidEra = e;
  }
);
Y("y", na);
Y("yy", na);
Y("yyy", na);
Y("yyyy", na);
Y("yo", j6);
Ee(["y", "yy", "yyy", "yyyy"], wt);
Ee(["yo"], function(e, r, t, n) {
  var a;
  t._locale._eraYearOrdinalRegex && (a = e.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? r[wt] = t._locale.eraYearOrdinalParse(e, a) : r[wt] = parseInt(e, 10);
});
function m6(e, r) {
  var t, n, a, i = this._eras || fn("en")._eras;
  for (t = 0, n = i.length; t < n; ++t) {
    switch (typeof i[t].since) {
      case "string":
        a = L(i[t].since).startOf("day"), i[t].since = a.valueOf();
        break;
    }
    switch (typeof i[t].until) {
      case "undefined":
        i[t].until = 1 / 0;
        break;
      case "string":
        a = L(i[t].until).startOf("day").valueOf(), i[t].until = a.valueOf();
        break;
    }
  }
  return i;
}
function b6(e, r, t) {
  var n, a, i = this.eras(), o, l, h;
  for (e = e.toUpperCase(), n = 0, a = i.length; n < a; ++n)
    if (o = i[n].name.toUpperCase(), l = i[n].abbr.toUpperCase(), h = i[n].narrow.toUpperCase(), t)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (l === e)
            return i[n];
          break;
        case "NNNN":
          if (o === e)
            return i[n];
          break;
        case "NNNNN":
          if (h === e)
            return i[n];
          break;
      }
    else if ([o, l, h].indexOf(e) >= 0)
      return i[n];
}
function _6(e, r) {
  var t = e.since <= e.until ? 1 : -1;
  return r === void 0 ? L(e.since).year() : L(e.since).year() + (r - e.offset) * t;
}
function w6() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].name;
  return "";
}
function S6() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].narrow;
  return "";
}
function x6() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].abbr;
  return "";
}
function T6() {
  var e, r, t, n, a = this.localeData().eras();
  for (e = 0, r = a.length; e < r; ++e)
    if (t = a[e].since <= a[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return (this.year() - L(a[e].since).year()) * t + a[e].offset;
  return this.year();
}
function E6(e) {
  return ge(this, "_erasNameRegex") || oc.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function O6(e) {
  return ge(this, "_erasAbbrRegex") || oc.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function C6(e) {
  return ge(this, "_erasNarrowRegex") || oc.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function sc(e, r) {
  return r.erasAbbrRegex(e);
}
function k6(e, r) {
  return r.erasNameRegex(e);
}
function D6(e, r) {
  return r.erasNarrowRegex(e);
}
function j6(e, r) {
  return r._eraYearOrdinalRegex || na;
}
function oc() {
  var e = [], r = [], t = [], n = [], a, i, o, l, h, s = this.eras();
  for (a = 0, i = s.length; a < i; ++a)
    o = un(s[a].name), l = un(s[a].abbr), h = un(s[a].narrow), r.push(o), e.push(l), t.push(h), n.push(o), n.push(l), n.push(h);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
V(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
V(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function No(e, r) {
  V(0, [e, e.length], 0, r);
}
No("gggg", "weekYear");
No("ggggg", "weekYear");
No("GGGG", "isoWeekYear");
No("GGGGG", "isoWeekYear");
Y("G", Mo);
Y("g", Mo);
Y("GG", Re, Zt);
Y("gg", Re, Zt);
Y("GGGG", Kl, Vl);
Y("gggg", Kl, Vl);
Y("GGGGG", jo, ko);
Y("ggggg", jo, ko);
Qa(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, r, t, n) {
    r[n.substr(0, 2)] = oe(e);
  }
);
Qa(["gg", "GG"], function(e, r, t, n) {
  r[n] = L.parseTwoDigitYear(e);
});
function M6(e) {
  return Ey.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function P6(e) {
  return Ey.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function A6() {
  return ln(this.year(), 1, 4);
}
function R6() {
  return ln(this.isoWeekYear(), 1, 4);
}
function I6() {
  var e = this.localeData()._week;
  return ln(this.year(), e.dow, e.doy);
}
function N6() {
  var e = this.localeData()._week;
  return ln(this.weekYear(), e.dow, e.doy);
}
function Ey(e, r, t, n, a) {
  var i;
  return e == null ? Wa(this, n, a).year : (i = ln(e, n, a), r > i && (r = i), L6.call(this, e, r, t, n, a));
}
function L6(e, r, t, n, a) {
  var i = iy(e, r, t, n, a), o = za(i.year, 0, i.dayOfYear);
  return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
}
V("Q", 0, "Qo", "quarter");
Y("Q", V0);
Ee("Q", function(e, r) {
  r[sn] = (oe(e) - 1) * 3;
});
function F6(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
V("D", ["DD", 2], "Do", "date");
Y("D", Re, ia);
Y("DD", Re, Zt);
Y("Do", function(e, r) {
  return e ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
Ee(["D", "DD"], Dr);
Ee("Do", function(e, r) {
  r[Dr] = oe(e.match(Re)[0]);
});
var Oy = aa("Date", !0);
V("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Y("DDD", Do);
Y("DDDD", K0);
Ee(["DDD", "DDDD"], function(e, r, t) {
  t._dayOfYear = oe(e);
});
function $6(e) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? r : this.add(e - r, "d");
}
V("m", ["mm", 2], 0, "minute");
Y("m", Re, ql);
Y("mm", Re, Zt);
Ee(["m", "mm"], gr);
var Y6 = aa("Minutes", !1);
V("s", ["ss", 2], 0, "second");
Y("s", Re, ql);
Y("ss", Re, Zt);
Ee(["s", "ss"], on);
var U6 = aa("Seconds", !1);
V("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
V(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
V(0, ["SSS", 3], 0, "millisecond");
V(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
V(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
V(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
V(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
V(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
V(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Y("S", Do, V0);
Y("SS", Do, Zt);
Y("SSS", Do, K0);
var Pn, Cy;
for (Pn = "SSSS"; Pn.length <= 9; Pn += "S")
  Y(Pn, na);
function z6(e, r) {
  r[ai] = oe(("0." + e) * 1e3);
}
for (Pn = "S"; Pn.length <= 9; Pn += "S")
  Ee(Pn, z6);
Cy = aa("Milliseconds", !1);
V("z", 0, 0, "zoneAbbr");
V("zz", 0, 0, "zoneName");
function W6() {
  return this._isUTC ? "UTC" : "";
}
function B6() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var A = Ja.prototype;
A.add = Nx;
A.calendar = Wx;
A.clone = Bx;
A.diff = Jx;
A.endOf = o6;
A.format = t6;
A.from = r6;
A.fromNow = n6;
A.to = i6;
A.toNow = a6;
A.get = eS;
A.invalidAt = p6;
A.isAfter = Hx;
A.isBefore = Gx;
A.isBetween = Vx;
A.isSame = Kx;
A.isSameOrAfter = qx;
A.isSameOrBefore = Zx;
A.isValid = y6;
A.lang = _y;
A.locale = by;
A.localeData = wy;
A.max = yx;
A.min = hx;
A.parsingFlags = g6;
A.set = tS;
A.startOf = s6;
A.subtract = Lx;
A.toArray = f6;
A.toObject = d6;
A.toDate = c6;
A.toISOString = Qx;
A.inspect = e6;
typeof Symbol < "u" && Symbol.for != null && (A[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
A.toJSON = h6;
A.toString = Xx;
A.unix = l6;
A.valueOf = u6;
A.creationData = v6;
A.eraName = w6;
A.eraNarrow = S6;
A.eraAbbr = x6;
A.eraYear = T6;
A.year = J0;
A.isLeapYear = Q4;
A.weekYear = M6;
A.isoWeekYear = P6;
A.quarter = A.quarters = F6;
A.month = ry;
A.daysInMonth = cS;
A.week = A.weeks = mS;
A.isoWeek = A.isoWeeks = bS;
A.weeksInYear = I6;
A.weeksInWeekYear = N6;
A.isoWeeksInYear = A6;
A.isoWeeksInISOWeekYear = R6;
A.date = Oy;
A.day = A.days = PS;
A.weekday = AS;
A.isoWeekday = RS;
A.dayOfYear = $6;
A.hour = A.hours = US;
A.minute = A.minutes = Y6;
A.second = A.seconds = U6;
A.millisecond = A.milliseconds = Cy;
A.utcOffset = xx;
A.utc = Ex;
A.local = Ox;
A.parseZone = Cx;
A.hasAlignedHourOffset = kx;
A.isDST = Dx;
A.isLocal = Mx;
A.isUtcOffset = Px;
A.isUtc = gy;
A.isUTC = gy;
A.zoneAbbr = W6;
A.zoneName = B6;
A.dates = ar(
  "dates accessor is deprecated. Use date instead.",
  Oy
);
A.months = ar(
  "months accessor is deprecated. Use month instead",
  ry
);
A.years = ar(
  "years accessor is deprecated. Use year instead",
  J0
);
A.zone = ar(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Tx
);
A.isDSTShifted = ar(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  jx
);
function H6(e) {
  return Ae(e * 1e3);
}
function G6() {
  return Ae.apply(null, arguments).parseZone();
}
function ky(e) {
  return e;
}
var pe = Bl.prototype;
pe.calendar = M4;
pe.longDateFormat = I4;
pe.invalidDate = L4;
pe.ordinal = Y4;
pe.preparse = ky;
pe.postformat = ky;
pe.relativeTime = z4;
pe.pastFuture = W4;
pe.set = D4;
pe.eras = m6;
pe.erasParse = b6;
pe.erasConvertYear = _6;
pe.erasAbbrRegex = O6;
pe.erasNameRegex = E6;
pe.erasNarrowRegex = C6;
pe.months = sS;
pe.monthsShort = oS;
pe.monthsParse = lS;
pe.monthsRegex = dS;
pe.monthsShortRegex = fS;
pe.week = yS;
pe.firstDayOfYear = vS;
pe.firstDayOfWeek = pS;
pe.weekdays = CS;
pe.weekdaysMin = DS;
pe.weekdaysShort = kS;
pe.weekdaysParse = MS;
pe.weekdaysRegex = IS;
pe.weekdaysShortRegex = NS;
pe.weekdaysMinRegex = LS;
pe.isPM = $S;
pe.meridiem = zS;
function no(e, r, t, n) {
  var a = fn(), i = Lr().set(n, r);
  return a[t](i, e);
}
function Dy(e, r, t) {
  if (cn(e) && (r = e, e = void 0), e = e || "", r != null)
    return no(e, r, t, "month");
  var n, a = [];
  for (n = 0; n < 12; n++)
    a[n] = no(e, n, t, "month");
  return a;
}
function uc(e, r, t, n) {
  typeof e == "boolean" ? (cn(r) && (t = r, r = void 0), r = r || "") : (r = e, t = r, e = !1, cn(r) && (t = r, r = void 0), r = r || "");
  var a = fn(), i = e ? a._week.dow : 0, o, l = [];
  if (t != null)
    return no(r, (t + i) % 7, n, "day");
  for (o = 0; o < 7; o++)
    l[o] = no(r, (o + i) % 7, n, "day");
  return l;
}
function V6(e, r) {
  return Dy(e, r, "months");
}
function K6(e, r) {
  return Dy(e, r, "monthsShort");
}
function q6(e, r, t) {
  return uc(e, r, t, "weekdays");
}
function Z6(e, r, t) {
  return uc(e, r, t, "weekdaysShort");
}
function J6(e, r, t) {
  return uc(e, r, t, "weekdaysMin");
}
Rn("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var r = e % 10, t = oe(e % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return e + t;
  }
});
L.lang = ar(
  "moment.lang is deprecated. Use moment.locale instead.",
  Rn
);
L.langData = ar(
  "moment.langData is deprecated. Use moment.localeData instead.",
  fn
);
var tn = Math.abs;
function X6() {
  var e = this._data;
  return this._milliseconds = tn(this._milliseconds), this._days = tn(this._days), this._months = tn(this._months), e.milliseconds = tn(e.milliseconds), e.seconds = tn(e.seconds), e.minutes = tn(e.minutes), e.hours = tn(e.hours), e.months = tn(e.months), e.years = tn(e.years), this;
}
function jy(e, r, t, n) {
  var a = _r(r, t);
  return e._milliseconds += n * a._milliseconds, e._days += n * a._days, e._months += n * a._months, e._bubble();
}
function Q6(e, r) {
  return jy(this, e, r, 1);
}
function e5(e, r) {
  return jy(this, e, r, -1);
}
function pd(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function t5() {
  var e = this._milliseconds, r = this._days, t = this._months, n = this._data, a, i, o, l, h;
  return e >= 0 && r >= 0 && t >= 0 || e <= 0 && r <= 0 && t <= 0 || (e += pd(ul(t) + r) * 864e5, r = 0, t = 0), n.milliseconds = e % 1e3, a = nr(e / 1e3), n.seconds = a % 60, i = nr(a / 60), n.minutes = i % 60, o = nr(i / 60), n.hours = o % 24, r += nr(o / 24), h = nr(My(r)), t += h, r -= pd(ul(h)), l = nr(t / 12), t %= 12, n.days = r, n.months = t, n.years = l, this;
}
function My(e) {
  return e * 4800 / 146097;
}
function ul(e) {
  return e * 146097 / 4800;
}
function r5(e) {
  if (!this.isValid())
    return NaN;
  var r, t, n = this._milliseconds;
  if (e = sr(e), e === "month" || e === "quarter" || e === "year")
    switch (r = this._days + n / 864e5, t = this._months + My(r), e) {
      case "month":
        return t;
      case "quarter":
        return t / 3;
      case "year":
        return t / 12;
    }
  else
    switch (r = this._days + Math.round(ul(this._months)), e) {
      case "week":
        return r / 7 + n / 6048e5;
      case "day":
        return r + n / 864e5;
      case "hour":
        return r * 24 + n / 36e5;
      case "minute":
        return r * 1440 + n / 6e4;
      case "second":
        return r * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function dn(e) {
  return function() {
    return this.as(e);
  };
}
var Py = dn("ms"), n5 = dn("s"), i5 = dn("m"), a5 = dn("h"), s5 = dn("d"), o5 = dn("w"), u5 = dn("M"), l5 = dn("Q"), c5 = dn("y"), f5 = Py;
function d5() {
  return _r(this);
}
function h5(e) {
  return e = sr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function vi(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var y5 = vi("milliseconds"), g5 = vi("seconds"), p5 = vi("minutes"), v5 = vi("hours"), m5 = vi("days"), b5 = vi("months"), _5 = vi("years");
function w5() {
  return nr(this.days() / 7);
}
var nn = Math.round, Wi = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function S5(e, r, t, n, a) {
  return a.relativeTime(r || 1, !!t, e, n);
}
function x5(e, r, t, n) {
  var a = _r(e).abs(), i = nn(a.as("s")), o = nn(a.as("m")), l = nn(a.as("h")), h = nn(a.as("d")), s = nn(a.as("M")), f = nn(a.as("w")), p = nn(a.as("y")), m = i <= t.ss && ["s", i] || i < t.s && ["ss", i] || o <= 1 && ["m"] || o < t.m && ["mm", o] || l <= 1 && ["h"] || l < t.h && ["hh", l] || h <= 1 && ["d"] || h < t.d && ["dd", h];
  return t.w != null && (m = m || f <= 1 && ["w"] || f < t.w && ["ww", f]), m = m || s <= 1 && ["M"] || s < t.M && ["MM", s] || p <= 1 && ["y"] || ["yy", p], m[2] = r, m[3] = +e > 0, m[4] = n, S5.apply(null, m);
}
function T5(e) {
  return e === void 0 ? nn : typeof e == "function" ? (nn = e, !0) : !1;
}
function E5(e, r) {
  return Wi[e] === void 0 ? !1 : r === void 0 ? Wi[e] : (Wi[e] = r, e === "s" && (Wi.ss = r - 1), !0);
}
function O5(e, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = !1, n = Wi, a, i;
  return typeof e == "object" && (r = e, e = !1), typeof e == "boolean" && (t = e), typeof r == "object" && (n = Object.assign({}, Wi, r), r.s != null && r.ss == null && (n.ss = r.s - 1)), a = this.localeData(), i = x5(this, !t, n, a), t && (i = a.pastFuture(+this, i)), a.postformat(i);
}
var Tu = Math.abs;
function Li(e) {
  return (e > 0) - (e < 0) || +e;
}
function Lo() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Tu(this._milliseconds) / 1e3, r = Tu(this._days), t = Tu(this._months), n, a, i, o, l = this.asSeconds(), h, s, f, p;
  return l ? (n = nr(e / 60), a = nr(n / 60), e %= 60, n %= 60, i = nr(t / 12), t %= 12, o = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", h = l < 0 ? "-" : "", s = Li(this._months) !== Li(l) ? "-" : "", f = Li(this._days) !== Li(l) ? "-" : "", p = Li(this._milliseconds) !== Li(l) ? "-" : "", h + "P" + (i ? s + i + "Y" : "") + (t ? s + t + "M" : "") + (r ? f + r + "D" : "") + (a || n || e ? "T" : "") + (a ? p + a + "H" : "") + (n ? p + n + "M" : "") + (e ? p + o + "S" : "")) : "P0D";
}
var he = Io.prototype;
he.isValid = bx;
he.abs = X6;
he.add = Q6;
he.subtract = e5;
he.as = r5;
he.asMilliseconds = Py;
he.asSeconds = n5;
he.asMinutes = i5;
he.asHours = a5;
he.asDays = s5;
he.asWeeks = o5;
he.asMonths = u5;
he.asQuarters = l5;
he.asYears = c5;
he.valueOf = f5;
he._bubble = t5;
he.clone = d5;
he.get = h5;
he.milliseconds = y5;
he.seconds = g5;
he.minutes = p5;
he.hours = v5;
he.days = m5;
he.weeks = w5;
he.months = b5;
he.years = _5;
he.humanize = O5;
he.toISOString = Lo;
he.toString = Lo;
he.toJSON = Lo;
he.locale = by;
he.localeData = wy;
he.toIsoString = ar(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Lo
);
he.lang = _y;
V("X", 0, 0, "unix");
V("x", 0, 0, "valueOf");
Y("x", Mo);
Y("X", V4);
Ee("X", function(e, r, t) {
  t._d = new Date(parseFloat(e) * 1e3);
});
Ee("x", function(e, r, t) {
  t._d = new Date(oe(e));
});
//! moment.js
L.version = "2.30.1";
C4(Ae);
L.fn = A;
L.min = gx;
L.max = px;
L.now = vx;
L.utc = Lr;
L.unix = H6;
L.months = V6;
L.isDate = Za;
L.locale = Rn;
L.invalid = Co;
L.duration = _r;
L.isMoment = mr;
L.weekdays = q6;
L.parseZone = G6;
L.localeData = fn;
L.isDuration = As;
L.monthsShort = K6;
L.weekdaysMin = J6;
L.defineLocale = ec;
L.updateLocale = GS;
L.locales = VS;
L.weekdaysShort = Z6;
L.normalizeUnits = sr;
L.relativeTimeRounding = T5;
L.relativeTimeThreshold = E5;
L.calendarFormat = zx;
L.prototype = A;
L.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const sk = () => {
  const e = L().format("HH"), r = parseInt(e);
  return r >= 3 && r < 12 ? "Good Morning" : r >= 12 && r < 15 ? "Good Afternoon" : r >= 15 && r < 20 ? "Good Evening" : r >= 20 || r < 3 ? "Good Night" : "Hello";
}, C5 = ({
  handleChange: e
}) => /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(
  qi,
  {
    onChange: () => {
      e();
    }
  }
) }), ok = ({
  record: e,
  path: r,
  handleDeleteLinkClick: t,
  idProperty: n = "id"
}) => /* @__PURE__ */ y.jsxs(Xe, { shadow: "md", width: 200, children: [
  /* @__PURE__ */ y.jsx(Xe.Target, { children: /* @__PURE__ */ y.jsx(h4, { size: "xl" }) }),
  /* @__PURE__ */ y.jsxs(Xe.Dropdown, { children: [
    /* @__PURE__ */ y.jsx(Xe.Item, { children: /* @__PURE__ */ y.jsx(Ra, { to: { pathname: `${r}/${e[n]}` }, children: "Edit" }) }),
    /* @__PURE__ */ y.jsx(Xe.Item, { onClick: t, children: "Delete" })
  ] })
] }), uk = ({
  item: e,
  handleChange: r
}) => {
  let t = !1;
  return typeof e < "u" && e.selected === !0 && (t = !0), /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(
    qi,
    {
      checked: t,
      onChange: () => {
        r(e);
      }
    }
  ) });
}, k5 = ({
  item: e,
  column: r
}) => /* @__PURE__ */ y.jsx(
  ut.Td,
  {
    style: () => ({
      width: r.width ?? r.width
    }),
    children: /* @__PURE__ */ y.jsx(Ve, { children: e[r.dataKey] })
  }
), D5 = ({
  item: e,
  column: r
}) => {
  if (typeof r.render > "u")
    throw new Error("render function is required");
  return /* @__PURE__ */ y.jsx(ut.Td, { children: r.render(e) });
}, j5 = ({
  item: e,
  column: r
}) => {
  if (typeof r.dataKey < "u" && typeof r.render > "u")
    return /* @__PURE__ */ y.jsx(k5, { item: e, column: r });
  if (r.render)
    return /* @__PURE__ */ y.jsx(D5, { item: e, column: r });
  throw new Error("Either dataKey or render function is required");
}, M5 = ({
  item: e,
  columns: r
}) => /* @__PURE__ */ y.jsx(ut.Tr, { children: r.map((t, n) => /* @__PURE__ */ y.jsx(j5, { item: e, column: t }, n)) }), Os = ({
  height: e = 40,
  radius: r = "sm"
}) => /* @__PURE__ */ y.jsxs(ee, { grow: !0, children: [
  /* @__PURE__ */ y.jsx(Ge, { height: e, mt: 6, radius: r }),
  /* @__PURE__ */ y.jsx(Ge, { height: e, mt: 6, radius: r }),
  /* @__PURE__ */ y.jsx(Ge, { height: e, mt: 6, radius: r }),
  /* @__PURE__ */ y.jsx(Ge, { height: e, mt: 6, radius: r }),
  /* @__PURE__ */ y.jsx(Ge, { height: e, mt: 6, radius: r })
] }), lk = ({
  items: e,
  loading: r,
  selection: t,
  columns: n
}) => {
  if (typeof e > "u")
    return null;
  if (r) {
    const a = Array.isArray(n) ? n.length : 1;
    return /* @__PURE__ */ y.jsx(ut.Tbody, { children: /* @__PURE__ */ y.jsx(ut.Tr, { children: /* @__PURE__ */ y.jsxs(ut.Td, { colSpan: a, children: [
      /* @__PURE__ */ y.jsx(Os, {}),
      /* @__PURE__ */ y.jsx(Os, {}),
      /* @__PURE__ */ y.jsx(Os, {}),
      /* @__PURE__ */ y.jsx(Os, {})
    ] }) }) });
  }
  if (e.length === 0) {
    const a = Array.isArray(n) ? n.length : 1;
    return /* @__PURE__ */ y.jsx(ut.Tbody, { children: /* @__PURE__ */ y.jsx(ut.Tr, { children: /* @__PURE__ */ y.jsx(ut.Td, { colSpan: a, children: /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(Sl, { variant: "outline", size: "sm", radius: "sm", children: /* @__PURE__ */ y.jsx(Ve, { children: De.get("No Records Found") }) }) }) }) }) });
  }
  return /* @__PURE__ */ y.jsx(ut.Tbody, { children: e.map((a) => {
    if (typeof a > "u")
      return /* @__PURE__ */ y.jsx(ut.Tr, { children: /* @__PURE__ */ y.jsx(ut.Td, { children: "undefined item" }) }, 1);
    let i = Object.assign({}, a, { selected: !1 });
    return typeof t < "u" && typeof t[a.id] < "u" && (i = Object.assign({}, a, { selected: !0 })), /* @__PURE__ */ y.jsx(
      M5,
      {
        item: i,
        columns: n
      },
      a.id
    );
  }) });
}, ck = ({
  columns: e,
  handleSelectAllRows: r
}) => /* @__PURE__ */ y.jsx(ut.Thead, { children: /* @__PURE__ */ y.jsx(ut.Tr, { children: e.map((t, n) => t.id === "select" && typeof r < "u" ? /* @__PURE__ */ y.jsx(ut.Th, { children: /* @__PURE__ */ y.jsx(C5, { handleChange: r }) }, n) : typeof t.sortable < "u" && t.sortable === !0 ? /* @__PURE__ */ y.jsx(ut.Th, { children: /* @__PURE__ */ y.jsxs(ee, { children: [
  t.title,
  /* @__PURE__ */ y.jsx(ir, { onClick: t.onClick, children: t.sortDirection === "desc" ? /* @__PURE__ */ y.jsx(Q3, {}) : /* @__PURE__ */ y.jsx(e4, {}) })
] }) }, n) : /* @__PURE__ */ y.jsx(ut.Th, { children: t.title }, n)) }) });
var vd = Array.isArray, md = Object.keys, P5 = Object.prototype.hasOwnProperty, A5 = typeof Element < "u";
function ll(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    var t = vd(e), n = vd(r), a, i, o;
    if (t && n) {
      if (i = e.length, i != r.length)
        return !1;
      for (a = i; a-- !== 0; )
        if (!ll(e[a], r[a]))
          return !1;
      return !0;
    }
    if (t != n)
      return !1;
    var l = e instanceof Date, h = r instanceof Date;
    if (l != h)
      return !1;
    if (l && h)
      return e.getTime() == r.getTime();
    var s = e instanceof RegExp, f = r instanceof RegExp;
    if (s != f)
      return !1;
    if (s && f)
      return e.toString() == r.toString();
    var p = md(e);
    if (i = p.length, i !== md(r).length)
      return !1;
    for (a = i; a-- !== 0; )
      if (!P5.call(r, p[a]))
        return !1;
    if (A5 && e instanceof Element && r instanceof Element)
      return e === r;
    for (a = i; a-- !== 0; )
      if (o = p[a], !(o === "_owner" && e.$$typeof) && !ll(e[o], r[o]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var R5 = function(r, t) {
  try {
    return ll(r, t);
  } catch (n) {
    if (n.message && n.message.match(/stack|recursion/i) || n.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", n.name, n.message), !1;
    throw n;
  }
};
const jn = /* @__PURE__ */ yo(R5);
var I5 = function(r) {
  return N5(r) && !L5(r);
};
function N5(e) {
  return !!e && typeof e == "object";
}
function L5(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || Y5(e);
}
var F5 = typeof Symbol == "function" && Symbol.for, $5 = F5 ? Symbol.for("react.element") : 60103;
function Y5(e) {
  return e.$$typeof === $5;
}
function U5(e) {
  return Array.isArray(e) ? [] : {};
}
function io(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? Ha(U5(e), e, r) : e;
}
function z5(e, r, t) {
  return e.concat(r).map(function(n) {
    return io(n, t);
  });
}
function W5(e, r, t) {
  var n = {};
  return t.isMergeableObject(e) && Object.keys(e).forEach(function(a) {
    n[a] = io(e[a], t);
  }), Object.keys(r).forEach(function(a) {
    !t.isMergeableObject(r[a]) || !e[a] ? n[a] = io(r[a], t) : n[a] = Ha(e[a], r[a], t);
  }), n;
}
function Ha(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || z5, t.isMergeableObject = t.isMergeableObject || I5;
  var n = Array.isArray(r), a = Array.isArray(e), i = n === a;
  return i ? n ? t.arrayMerge(e, r, t) : W5(e, r, t) : io(r, t);
}
Ha.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(n, a) {
    return Ha(n, a, t);
  }, {});
};
var cl = Ha, B5 = typeof global == "object" && global && global.Object === Object && global;
const Ay = B5;
var H5 = typeof self == "object" && self && self.Object === Object && self, G5 = Ay || H5 || Function("return this")();
const $r = G5;
var V5 = $r.Symbol;
const Fn = V5;
var Ry = Object.prototype, K5 = Ry.hasOwnProperty, q5 = Ry.toString, _a = Fn ? Fn.toStringTag : void 0;
function Z5(e) {
  var r = K5.call(e, _a), t = e[_a];
  try {
    e[_a] = void 0;
    var n = !0;
  } catch {
  }
  var a = q5.call(e);
  return n && (r ? e[_a] = t : delete e[_a]), a;
}
var J5 = Object.prototype, X5 = J5.toString;
function Q5(e) {
  return X5.call(e);
}
var e8 = "[object Null]", t8 = "[object Undefined]", bd = Fn ? Fn.toStringTag : void 0;
function mi(e) {
  return e == null ? e === void 0 ? t8 : e8 : bd && bd in Object(e) ? Z5(e) : Q5(e);
}
function Iy(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var r8 = Iy(Object.getPrototypeOf, Object);
const lc = r8;
function bi(e) {
  return e != null && typeof e == "object";
}
var n8 = "[object Object]", i8 = Function.prototype, a8 = Object.prototype, Ny = i8.toString, s8 = a8.hasOwnProperty, o8 = Ny.call(Object);
function _d(e) {
  if (!bi(e) || mi(e) != n8)
    return !1;
  var r = lc(e);
  if (r === null)
    return !0;
  var t = s8.call(r, "constructor") && r.constructor;
  return typeof t == "function" && t instanceof t && Ny.call(t) == o8;
}
function u8() {
  this.__data__ = [], this.size = 0;
}
function Ly(e, r) {
  return e === r || e !== e && r !== r;
}
function Fo(e, r) {
  for (var t = e.length; t--; )
    if (Ly(e[t][0], r))
      return t;
  return -1;
}
var l8 = Array.prototype, c8 = l8.splice;
function f8(e) {
  var r = this.__data__, t = Fo(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : c8.call(r, t, 1), --this.size, !0;
}
function d8(e) {
  var r = this.__data__, t = Fo(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function h8(e) {
  return Fo(this.__data__, e) > -1;
}
function y8(e, r) {
  var t = this.__data__, n = Fo(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
function hn(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
hn.prototype.clear = u8;
hn.prototype.delete = f8;
hn.prototype.get = d8;
hn.prototype.has = h8;
hn.prototype.set = y8;
function g8() {
  this.__data__ = new hn(), this.size = 0;
}
function p8(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function v8(e) {
  return this.__data__.get(e);
}
function m8(e) {
  return this.__data__.has(e);
}
function es(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var b8 = "[object AsyncFunction]", _8 = "[object Function]", w8 = "[object GeneratorFunction]", S8 = "[object Proxy]";
function Fy(e) {
  if (!es(e))
    return !1;
  var r = mi(e);
  return r == _8 || r == w8 || r == b8 || r == S8;
}
var x8 = $r["__core-js_shared__"];
const Eu = x8;
var wd = function() {
  var e = /[^.]+$/.exec(Eu && Eu.keys && Eu.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function T8(e) {
  return !!wd && wd in e;
}
var E8 = Function.prototype, O8 = E8.toString;
function _i(e) {
  if (e != null) {
    try {
      return O8.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var C8 = /[\\^$.*+?()[\]{}|]/g, k8 = /^\[object .+?Constructor\]$/, D8 = Function.prototype, j8 = Object.prototype, M8 = D8.toString, P8 = j8.hasOwnProperty, A8 = RegExp(
  "^" + M8.call(P8).replace(C8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function R8(e) {
  if (!es(e) || T8(e))
    return !1;
  var r = Fy(e) ? A8 : k8;
  return r.test(_i(e));
}
function I8(e, r) {
  return e == null ? void 0 : e[r];
}
function wi(e, r) {
  var t = I8(e, r);
  return R8(t) ? t : void 0;
}
var N8 = wi($r, "Map");
const Ga = N8;
var L8 = wi(Object, "create");
const Va = L8;
function F8() {
  this.__data__ = Va ? Va(null) : {}, this.size = 0;
}
function $8(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var Y8 = "__lodash_hash_undefined__", U8 = Object.prototype, z8 = U8.hasOwnProperty;
function W8(e) {
  var r = this.__data__;
  if (Va) {
    var t = r[e];
    return t === Y8 ? void 0 : t;
  }
  return z8.call(r, e) ? r[e] : void 0;
}
var B8 = Object.prototype, H8 = B8.hasOwnProperty;
function G8(e) {
  var r = this.__data__;
  return Va ? r[e] !== void 0 : H8.call(r, e);
}
var V8 = "__lodash_hash_undefined__";
function K8(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Va && r === void 0 ? V8 : r, this;
}
function hi(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
hi.prototype.clear = F8;
hi.prototype.delete = $8;
hi.prototype.get = W8;
hi.prototype.has = G8;
hi.prototype.set = K8;
function q8() {
  this.size = 0, this.__data__ = {
    hash: new hi(),
    map: new (Ga || hn)(),
    string: new hi()
  };
}
function Z8(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function $o(e, r) {
  var t = e.__data__;
  return Z8(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function J8(e) {
  var r = $o(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function X8(e) {
  return $o(this, e).get(e);
}
function Q8(e) {
  return $o(this, e).has(e);
}
function eT(e, r) {
  var t = $o(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
function $n(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
$n.prototype.clear = q8;
$n.prototype.delete = J8;
$n.prototype.get = X8;
$n.prototype.has = Q8;
$n.prototype.set = eT;
var tT = 200;
function rT(e, r) {
  var t = this.__data__;
  if (t instanceof hn) {
    var n = t.__data__;
    if (!Ga || n.length < tT - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new $n(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
function sa(e) {
  var r = this.__data__ = new hn(e);
  this.size = r.size;
}
sa.prototype.clear = g8;
sa.prototype.delete = p8;
sa.prototype.get = v8;
sa.prototype.has = m8;
sa.prototype.set = rT;
function nT(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n && r(e[t], t, e) !== !1; )
    ;
  return e;
}
var iT = function() {
  try {
    var e = wi(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Sd = iT;
function $y(e, r, t) {
  r == "__proto__" && Sd ? Sd(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
var aT = Object.prototype, sT = aT.hasOwnProperty;
function Yy(e, r, t) {
  var n = e[r];
  (!(sT.call(e, r) && Ly(n, t)) || t === void 0 && !(r in e)) && $y(e, r, t);
}
function Yo(e, r, t, n) {
  var a = !t;
  t || (t = {});
  for (var i = -1, o = r.length; ++i < o; ) {
    var l = r[i], h = n ? n(t[l], e[l], l, t, e) : void 0;
    h === void 0 && (h = e[l]), a ? $y(t, l, h) : Yy(t, l, h);
  }
  return t;
}
function oT(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var uT = "[object Arguments]";
function xd(e) {
  return bi(e) && mi(e) == uT;
}
var Uy = Object.prototype, lT = Uy.hasOwnProperty, cT = Uy.propertyIsEnumerable, fT = xd(function() {
  return arguments;
}()) ? xd : function(e) {
  return bi(e) && lT.call(e, "callee") && !cT.call(e, "callee");
};
const dT = fT;
var hT = Array.isArray;
const ts = hT;
function yT() {
  return !1;
}
var zy = typeof exports == "object" && exports && !exports.nodeType && exports, Td = zy && typeof module == "object" && module && !module.nodeType && module, gT = Td && Td.exports === zy, Ed = gT ? $r.Buffer : void 0, pT = Ed ? Ed.isBuffer : void 0, vT = pT || yT;
const Wy = vT;
var mT = 9007199254740991, bT = /^(?:0|[1-9]\d*)$/;
function _T(e, r) {
  var t = typeof e;
  return r = r ?? mT, !!r && (t == "number" || t != "symbol" && bT.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var wT = 9007199254740991;
function By(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= wT;
}
var ST = "[object Arguments]", xT = "[object Array]", TT = "[object Boolean]", ET = "[object Date]", OT = "[object Error]", CT = "[object Function]", kT = "[object Map]", DT = "[object Number]", jT = "[object Object]", MT = "[object RegExp]", PT = "[object Set]", AT = "[object String]", RT = "[object WeakMap]", IT = "[object ArrayBuffer]", NT = "[object DataView]", LT = "[object Float32Array]", FT = "[object Float64Array]", $T = "[object Int8Array]", YT = "[object Int16Array]", UT = "[object Int32Array]", zT = "[object Uint8Array]", WT = "[object Uint8ClampedArray]", BT = "[object Uint16Array]", HT = "[object Uint32Array]", Pe = {};
Pe[LT] = Pe[FT] = Pe[$T] = Pe[YT] = Pe[UT] = Pe[zT] = Pe[WT] = Pe[BT] = Pe[HT] = !0;
Pe[ST] = Pe[xT] = Pe[IT] = Pe[TT] = Pe[NT] = Pe[ET] = Pe[OT] = Pe[CT] = Pe[kT] = Pe[DT] = Pe[jT] = Pe[MT] = Pe[PT] = Pe[AT] = Pe[RT] = !1;
function GT(e) {
  return bi(e) && By(e.length) && !!Pe[mi(e)];
}
function cc(e) {
  return function(r) {
    return e(r);
  };
}
var Hy = typeof exports == "object" && exports && !exports.nodeType && exports, Pa = Hy && typeof module == "object" && module && !module.nodeType && module, VT = Pa && Pa.exports === Hy, Ou = VT && Ay.process, KT = function() {
  try {
    var e = Pa && Pa.require && Pa.require("util").types;
    return e || Ou && Ou.binding && Ou.binding("util");
  } catch {
  }
}();
const Qi = KT;
var Od = Qi && Qi.isTypedArray, qT = Od ? cc(Od) : GT;
const ZT = qT;
var JT = Object.prototype, XT = JT.hasOwnProperty;
function Gy(e, r) {
  var t = ts(e), n = !t && dT(e), a = !t && !n && Wy(e), i = !t && !n && !a && ZT(e), o = t || n || a || i, l = o ? oT(e.length, String) : [], h = l.length;
  for (var s in e)
    (r || XT.call(e, s)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    _T(s, h))) && l.push(s);
  return l;
}
var QT = Object.prototype;
function fc(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || QT;
  return e === t;
}
var eE = Iy(Object.keys, Object);
const tE = eE;
var rE = Object.prototype, nE = rE.hasOwnProperty;
function iE(e) {
  if (!fc(e))
    return tE(e);
  var r = [];
  for (var t in Object(e))
    nE.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
function Vy(e) {
  return e != null && By(e.length) && !Fy(e);
}
function dc(e) {
  return Vy(e) ? Gy(e) : iE(e);
}
function aE(e, r) {
  return e && Yo(r, dc(r), e);
}
function sE(e) {
  var r = [];
  if (e != null)
    for (var t in Object(e))
      r.push(t);
  return r;
}
var oE = Object.prototype, uE = oE.hasOwnProperty;
function lE(e) {
  if (!es(e))
    return sE(e);
  var r = fc(e), t = [];
  for (var n in e)
    n == "constructor" && (r || !uE.call(e, n)) || t.push(n);
  return t;
}
function hc(e) {
  return Vy(e) ? Gy(e, !0) : lE(e);
}
function cE(e, r) {
  return e && Yo(r, hc(r), e);
}
var Ky = typeof exports == "object" && exports && !exports.nodeType && exports, Cd = Ky && typeof module == "object" && module && !module.nodeType && module, fE = Cd && Cd.exports === Ky, kd = fE ? $r.Buffer : void 0, Dd = kd ? kd.allocUnsafe : void 0;
function dE(e, r) {
  if (r)
    return e.slice();
  var t = e.length, n = Dd ? Dd(t) : new e.constructor(t);
  return e.copy(n), n;
}
function qy(e, r) {
  var t = -1, n = e.length;
  for (r || (r = Array(n)); ++t < n; )
    r[t] = e[t];
  return r;
}
function hE(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++t < n; ) {
    var o = e[t];
    r(o, t, e) && (i[a++] = o);
  }
  return i;
}
function Zy() {
  return [];
}
var yE = Object.prototype, gE = yE.propertyIsEnumerable, jd = Object.getOwnPropertySymbols, pE = jd ? function(e) {
  return e == null ? [] : (e = Object(e), hE(jd(e), function(r) {
    return gE.call(e, r);
  }));
} : Zy;
const yc = pE;
function vE(e, r) {
  return Yo(e, yc(e), r);
}
function Jy(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var mE = Object.getOwnPropertySymbols, bE = mE ? function(e) {
  for (var r = []; e; )
    Jy(r, yc(e)), e = lc(e);
  return r;
} : Zy;
const Xy = bE;
function _E(e, r) {
  return Yo(e, Xy(e), r);
}
function Qy(e, r, t) {
  var n = r(e);
  return ts(e) ? n : Jy(n, t(e));
}
function wE(e) {
  return Qy(e, dc, yc);
}
function SE(e) {
  return Qy(e, hc, Xy);
}
var xE = wi($r, "DataView");
const fl = xE;
var TE = wi($r, "Promise");
const dl = TE;
var EE = wi($r, "Set");
const hl = EE;
var OE = wi($r, "WeakMap");
const yl = OE;
var Md = "[object Map]", CE = "[object Object]", Pd = "[object Promise]", Ad = "[object Set]", Rd = "[object WeakMap]", Id = "[object DataView]", kE = _i(fl), DE = _i(Ga), jE = _i(dl), ME = _i(hl), PE = _i(yl), ei = mi;
(fl && ei(new fl(new ArrayBuffer(1))) != Id || Ga && ei(new Ga()) != Md || dl && ei(dl.resolve()) != Pd || hl && ei(new hl()) != Ad || yl && ei(new yl()) != Rd) && (ei = function(e) {
  var r = mi(e), t = r == CE ? e.constructor : void 0, n = t ? _i(t) : "";
  if (n)
    switch (n) {
      case kE:
        return Id;
      case DE:
        return Md;
      case jE:
        return Pd;
      case ME:
        return Ad;
      case PE:
        return Rd;
    }
  return r;
});
const gc = ei;
var AE = Object.prototype, RE = AE.hasOwnProperty;
function IE(e) {
  var r = e.length, t = new e.constructor(r);
  return r && typeof e[0] == "string" && RE.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var NE = $r.Uint8Array;
const Nd = NE;
function pc(e) {
  var r = new e.constructor(e.byteLength);
  return new Nd(r).set(new Nd(e)), r;
}
function LE(e, r) {
  var t = r ? pc(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var FE = /\w*$/;
function $E(e) {
  var r = new e.constructor(e.source, FE.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var Ld = Fn ? Fn.prototype : void 0, Fd = Ld ? Ld.valueOf : void 0;
function YE(e) {
  return Fd ? Object(Fd.call(e)) : {};
}
function UE(e, r) {
  var t = r ? pc(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var zE = "[object Boolean]", WE = "[object Date]", BE = "[object Map]", HE = "[object Number]", GE = "[object RegExp]", VE = "[object Set]", KE = "[object String]", qE = "[object Symbol]", ZE = "[object ArrayBuffer]", JE = "[object DataView]", XE = "[object Float32Array]", QE = "[object Float64Array]", eO = "[object Int8Array]", tO = "[object Int16Array]", rO = "[object Int32Array]", nO = "[object Uint8Array]", iO = "[object Uint8ClampedArray]", aO = "[object Uint16Array]", sO = "[object Uint32Array]";
function oO(e, r, t) {
  var n = e.constructor;
  switch (r) {
    case ZE:
      return pc(e);
    case zE:
    case WE:
      return new n(+e);
    case JE:
      return LE(e, t);
    case XE:
    case QE:
    case eO:
    case tO:
    case rO:
    case nO:
    case iO:
    case aO:
    case sO:
      return UE(e, t);
    case BE:
      return new n();
    case HE:
    case KE:
      return new n(e);
    case GE:
      return $E(e);
    case VE:
      return new n();
    case qE:
      return YE(e);
  }
}
var $d = Object.create, uO = function() {
  function e() {
  }
  return function(r) {
    if (!es(r))
      return {};
    if ($d)
      return $d(r);
    e.prototype = r;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
const lO = uO;
function cO(e) {
  return typeof e.constructor == "function" && !fc(e) ? lO(lc(e)) : {};
}
var fO = "[object Map]";
function dO(e) {
  return bi(e) && gc(e) == fO;
}
var Yd = Qi && Qi.isMap, hO = Yd ? cc(Yd) : dO;
const yO = hO;
var gO = "[object Set]";
function pO(e) {
  return bi(e) && gc(e) == gO;
}
var Ud = Qi && Qi.isSet, vO = Ud ? cc(Ud) : pO;
const mO = vO;
var bO = 1, _O = 2, wO = 4, eg = "[object Arguments]", SO = "[object Array]", xO = "[object Boolean]", TO = "[object Date]", EO = "[object Error]", tg = "[object Function]", OO = "[object GeneratorFunction]", CO = "[object Map]", kO = "[object Number]", rg = "[object Object]", DO = "[object RegExp]", jO = "[object Set]", MO = "[object String]", PO = "[object Symbol]", AO = "[object WeakMap]", RO = "[object ArrayBuffer]", IO = "[object DataView]", NO = "[object Float32Array]", LO = "[object Float64Array]", FO = "[object Int8Array]", $O = "[object Int16Array]", YO = "[object Int32Array]", UO = "[object Uint8Array]", zO = "[object Uint8ClampedArray]", WO = "[object Uint16Array]", BO = "[object Uint32Array]", ke = {};
ke[eg] = ke[SO] = ke[RO] = ke[IO] = ke[xO] = ke[TO] = ke[NO] = ke[LO] = ke[FO] = ke[$O] = ke[YO] = ke[CO] = ke[kO] = ke[rg] = ke[DO] = ke[jO] = ke[MO] = ke[PO] = ke[UO] = ke[zO] = ke[WO] = ke[BO] = !0;
ke[EO] = ke[tg] = ke[AO] = !1;
function Aa(e, r, t, n, a, i) {
  var o, l = r & bO, h = r & _O, s = r & wO;
  if (t && (o = a ? t(e, n, a, i) : t(e)), o !== void 0)
    return o;
  if (!es(e))
    return e;
  var f = ts(e);
  if (f) {
    if (o = IE(e), !l)
      return qy(e, o);
  } else {
    var p = gc(e), m = p == tg || p == OO;
    if (Wy(e))
      return dE(e, l);
    if (p == rg || p == eg || m && !a) {
      if (o = h || m ? {} : cO(e), !l)
        return h ? _E(e, cE(o, e)) : vE(e, aE(o, e));
    } else {
      if (!ke[p])
        return a ? e : {};
      o = oO(e, p, l);
    }
  }
  i || (i = new sa());
  var w = i.get(e);
  if (w)
    return w;
  i.set(e, o), mO(e) ? e.forEach(function(x) {
    o.add(Aa(x, r, t, x, e, i));
  }) : yO(e) && e.forEach(function(x, j) {
    o.set(j, Aa(x, r, t, j, e, i));
  });
  var S = s ? h ? SE : wE : h ? hc : dc, E = f ? void 0 : S(e);
  return nT(E || e, function(x, j) {
    E && (j = x, x = e[j]), Yy(o, j, Aa(x, r, t, j, e, i));
  }), o;
}
var HO = 4;
function zd(e) {
  return Aa(e, HO);
}
function ng(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var GO = "[object Symbol]";
function vc(e) {
  return typeof e == "symbol" || bi(e) && mi(e) == GO;
}
var VO = "Expected a function";
function mc(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(VO);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return t.cache = i.set(a, o) || i, o;
  };
  return t.cache = new (mc.Cache || $n)(), t;
}
mc.Cache = $n;
var KO = 500;
function qO(e) {
  var r = mc(e, function(n) {
    return t.size === KO && t.clear(), n;
  }), t = r.cache;
  return r;
}
var ZO = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, JO = /\\(\\)?/g, XO = qO(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(ZO, function(t, n, a, i) {
    r.push(a ? i.replace(JO, "$1") : n || t);
  }), r;
});
const QO = XO;
var e7 = 1 / 0;
function t7(e) {
  if (typeof e == "string" || vc(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -e7 ? "-0" : r;
}
var r7 = 1 / 0, Wd = Fn ? Fn.prototype : void 0, Bd = Wd ? Wd.toString : void 0;
function ig(e) {
  if (typeof e == "string")
    return e;
  if (ts(e))
    return ng(e, ig) + "";
  if (vc(e))
    return Bd ? Bd.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -r7 ? "-0" : r;
}
function n7(e) {
  return e == null ? "" : ig(e);
}
function ag(e) {
  return ts(e) ? ng(e, t7) : vc(e) ? [e] : qy(QO(n7(e)));
}
var i7 = process.env.NODE_ENV === "production";
function it(e, r) {
  if (!i7) {
    if (e)
      return;
    var t = "Warning: " + r;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
var gl = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hd;
function a7() {
  if (Hd)
    return we;
  Hd = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
  function I(k) {
    if (typeof k == "object" && k !== null) {
      var fe = k.$$typeof;
      switch (fe) {
        case r:
          switch (k = k.type, k) {
            case h:
            case s:
            case n:
            case i:
            case a:
            case p:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case l:
                case f:
                case S:
                case w:
                case o:
                  return k;
                default:
                  return fe;
              }
          }
        case t:
          return fe;
      }
    }
  }
  function M(k) {
    return I(k) === s;
  }
  return we.AsyncMode = h, we.ConcurrentMode = s, we.ContextConsumer = l, we.ContextProvider = o, we.Element = r, we.ForwardRef = f, we.Fragment = n, we.Lazy = S, we.Memo = w, we.Portal = t, we.Profiler = i, we.StrictMode = a, we.Suspense = p, we.isAsyncMode = function(k) {
    return M(k) || I(k) === h;
  }, we.isConcurrentMode = M, we.isContextConsumer = function(k) {
    return I(k) === l;
  }, we.isContextProvider = function(k) {
    return I(k) === o;
  }, we.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === r;
  }, we.isForwardRef = function(k) {
    return I(k) === f;
  }, we.isFragment = function(k) {
    return I(k) === n;
  }, we.isLazy = function(k) {
    return I(k) === S;
  }, we.isMemo = function(k) {
    return I(k) === w;
  }, we.isPortal = function(k) {
    return I(k) === t;
  }, we.isProfiler = function(k) {
    return I(k) === i;
  }, we.isStrictMode = function(k) {
    return I(k) === a;
  }, we.isSuspense = function(k) {
    return I(k) === p;
  }, we.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === s || k === i || k === a || k === p || k === m || typeof k == "object" && k !== null && (k.$$typeof === S || k.$$typeof === w || k.$$typeof === o || k.$$typeof === l || k.$$typeof === f || k.$$typeof === x || k.$$typeof === j || k.$$typeof === O || k.$$typeof === E);
  }, we.typeOf = I, we;
}
var Se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gd;
function s7() {
  return Gd || (Gd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, O = e ? Symbol.for("react.scope") : 60119;
    function I(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === n || W === s || W === i || W === a || W === p || W === m || typeof W == "object" && W !== null && (W.$$typeof === S || W.$$typeof === w || W.$$typeof === o || W.$$typeof === l || W.$$typeof === f || W.$$typeof === x || W.$$typeof === j || W.$$typeof === O || W.$$typeof === E);
    }
    function M(W) {
      if (typeof W == "object" && W !== null) {
        var Yr = W.$$typeof;
        switch (Yr) {
          case r:
            var Tr = W.type;
            switch (Tr) {
              case h:
              case s:
              case n:
              case i:
              case a:
              case p:
                return Tr;
              default:
                var ur = Tr && Tr.$$typeof;
                switch (ur) {
                  case l:
                  case f:
                  case S:
                  case w:
                  case o:
                    return ur;
                  default:
                    return Yr;
                }
            }
          case t:
            return Yr;
        }
      }
    }
    var k = h, fe = s, ae = l, B = o, ue = r, be = f, K = n, ve = S, q = w, qe = t, at = i, xt = a, st = p, je = !1;
    function $t(W) {
      return je || (je = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Fe(W) || M(W) === h;
    }
    function Fe(W) {
      return M(W) === s;
    }
    function or(W) {
      return M(W) === l;
    }
    function Yt(W) {
      return M(W) === o;
    }
    function Tt(W) {
      return typeof W == "object" && W !== null && W.$$typeof === r;
    }
    function Ut(W) {
      return M(W) === f;
    }
    function z(W) {
      return M(W) === n;
    }
    function wr(W) {
      return M(W) === S;
    }
    function Sr(W) {
      return M(W) === w;
    }
    function Pt(W) {
      return M(W) === t;
    }
    function Jt(W) {
      return M(W) === i;
    }
    function xr(W) {
      return M(W) === a;
    }
    function yn(W) {
      return M(W) === p;
    }
    Se.AsyncMode = k, Se.ConcurrentMode = fe, Se.ContextConsumer = ae, Se.ContextProvider = B, Se.Element = ue, Se.ForwardRef = be, Se.Fragment = K, Se.Lazy = ve, Se.Memo = q, Se.Portal = qe, Se.Profiler = at, Se.StrictMode = xt, Se.Suspense = st, Se.isAsyncMode = $t, Se.isConcurrentMode = Fe, Se.isContextConsumer = or, Se.isContextProvider = Yt, Se.isElement = Tt, Se.isForwardRef = Ut, Se.isFragment = z, Se.isLazy = wr, Se.isMemo = Sr, Se.isPortal = Pt, Se.isProfiler = Jt, Se.isStrictMode = xr, Se.isSuspense = yn, Se.isValidElementType = I, Se.typeOf = M;
  }()), Se;
}
process.env.NODE_ENV === "production" ? gl.exports = a7() : gl.exports = s7();
var o7 = gl.exports, bc = o7, u7 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, l7 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, c7 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, sg = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, _c = {};
_c[bc.ForwardRef] = c7;
_c[bc.Memo] = sg;
function Vd(e) {
  return bc.isMemo(e) ? sg : _c[e.$$typeof] || u7;
}
var f7 = Object.defineProperty, d7 = Object.getOwnPropertyNames, Kd = Object.getOwnPropertySymbols, h7 = Object.getOwnPropertyDescriptor, y7 = Object.getPrototypeOf, qd = Object.prototype;
function og(e, r, t) {
  if (typeof r != "string") {
    if (qd) {
      var n = y7(r);
      n && n !== qd && og(e, n, t);
    }
    var a = d7(r);
    Kd && (a = a.concat(Kd(r)));
    for (var i = Vd(e), o = Vd(r), l = 0; l < a.length; ++l) {
      var h = a[l];
      if (!l7[h] && !(t && t[h]) && !(o && o[h]) && !(i && i[h])) {
        var s = h7(r, h);
        try {
          f7(e, h, s);
        } catch {
        }
      }
    }
  }
  return e;
}
var g7 = og;
const p7 = /* @__PURE__ */ yo(g7);
var v7 = 1, m7 = 4;
function b7(e) {
  return Aa(e, v7 | m7);
}
function Ce() {
  return Ce = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ce.apply(this, arguments);
}
function _7(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
}
function si(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Zd(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var Jd = function(r) {
  return Array.isArray(r) && r.length === 0;
}, mt = function(r) {
  return typeof r == "function";
}, Uo = function(r) {
  return r !== null && typeof r == "object";
}, w7 = function(r) {
  return String(Math.floor(Number(r))) === r;
}, Cu = function(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}, wc = function(r) {
  return wl.count(r) === 0;
}, ku = function(r) {
  return Uo(r) && mt(r.then);
};
function S7(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function ot(e, r, t, n) {
  n === void 0 && (n = 0);
  for (var a = ag(r); e && n < a.length; )
    e = e[a[n++]];
  return e === void 0 ? t : e;
}
function Ar(e, r, t) {
  for (var n = zd(e), a = n, i = 0, o = ag(r); i < o.length - 1; i++) {
    var l = o[i], h = ot(e, o.slice(0, i + 1));
    if (h && (Uo(h) || Array.isArray(h)))
      a = a[l] = zd(h);
    else {
      var s = o[i + 1];
      a = a[l] = w7(s) && Number(s) >= 0 ? [] : {};
    }
  }
  return (i === 0 ? e : a)[o[i]] === t ? e : (t === void 0 ? delete a[o[i]] : a[o[i]] = t, i === 0 && t === void 0 && delete n[o[i]], n);
}
function ug(e, r, t, n) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), n === void 0 && (n = {});
  for (var a = 0, i = Object.keys(e); a < i.length; a++) {
    var o = i[a], l = e[o];
    Uo(l) ? t.get(l) || (t.set(l, !0), n[o] = Array.isArray(l) ? [] : {}, ug(l, r, t, n[o])) : n[o] = r;
  }
  return n;
}
var zo = /* @__PURE__ */ Qv(void 0);
zo.displayName = "FormikContext";
var x7 = zo.Provider, T7 = zo.Consumer;
function lg() {
  var e = tm(zo);
  return e || (process.env.NODE_ENV !== "production" ? it(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : it(!1)), e;
}
function E7(e, r) {
  switch (r.type) {
    case "SET_VALUES":
      return Ce({}, e, {
        values: r.payload
      });
    case "SET_TOUCHED":
      return Ce({}, e, {
        touched: r.payload
      });
    case "SET_ERRORS":
      return jn(e.errors, r.payload) ? e : Ce({}, e, {
        errors: r.payload
      });
    case "SET_STATUS":
      return Ce({}, e, {
        status: r.payload
      });
    case "SET_ISSUBMITTING":
      return Ce({}, e, {
        isSubmitting: r.payload
      });
    case "SET_ISVALIDATING":
      return Ce({}, e, {
        isValidating: r.payload
      });
    case "SET_FIELD_VALUE":
      return Ce({}, e, {
        values: Ar(e.values, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return Ce({}, e, {
        touched: Ar(e.touched, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_ERROR":
      return Ce({}, e, {
        errors: Ar(e.errors, r.payload.field, r.payload.value)
      });
    case "RESET_FORM":
      return Ce({}, e, r.payload);
    case "SET_FORMIK_STATE":
      return r.payload(e);
    case "SUBMIT_ATTEMPT":
      return Ce({}, e, {
        touched: ug(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return Ce({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return Ce({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var Jn = {}, Cs = {};
function O7(e) {
  var r = e.validateOnChange, t = r === void 0 ? !0 : r, n = e.validateOnBlur, a = n === void 0 ? !0 : n, i = e.validateOnMount, o = i === void 0 ? !1 : i, l = e.isInitialValid, h = e.enableReinitialize, s = h === void 0 ? !1 : h, f = e.onSubmit, p = si(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), m = Ce({
    validateOnChange: t,
    validateOnBlur: a,
    validateOnMount: o,
    onSubmit: f
  }, p), w = Xn(m.initialValues), S = Xn(m.initialErrors || Jn), E = Xn(m.initialTouched || Cs), x = Xn(m.initialStatus), j = Xn(!1), O = Xn({});
  process.env.NODE_ENV !== "production" && bt(function() {
    typeof l > "u" || (process.env.NODE_ENV !== "production" ? it(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : it(!1));
  }, []), bt(function() {
    return j.current = !0, function() {
      j.current = !1;
    };
  }, []);
  var I = nm(E7, {
    values: m.initialValues,
    errors: m.initialErrors || Jn,
    touched: m.initialTouched || Cs,
    status: m.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), M = I[0], k = I[1], fe = Je(function(T, N) {
    return new Promise(function(U, G) {
      var J = m.validate(T, N);
      J == null ? U(Jn) : ku(J) ? J.then(function(ie) {
        U(ie || Jn);
      }, function(ie) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", ie), G(ie);
      }) : U(J);
    });
  }, [m.validate]), ae = Je(function(T, N) {
    var U = m.validationSchema, G = mt(U) ? U(N) : U, J = N && G.validateAt ? G.validateAt(N, T) : k7(T, G);
    return new Promise(function(ie, le) {
      J.then(function() {
        ie(Jn);
      }, function(Ze) {
        Ze.name === "ValidationError" ? ie(C7(Ze)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", Ze), le(Ze));
      });
    });
  }, [m.validationSchema]), B = Je(function(T, N) {
    return new Promise(function(U) {
      return U(O.current[T].validate(N));
    });
  }, []), ue = Je(function(T) {
    var N = Object.keys(O.current).filter(function(G) {
      return mt(O.current[G].validate);
    }), U = N.length > 0 ? N.map(function(G) {
      return B(G, ot(T, G));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(U).then(function(G) {
      return G.reduce(function(J, ie, le) {
        return ie === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || ie && (J = Ar(J, N[le], ie)), J;
      }, {});
    });
  }, [B]), be = Je(function(T) {
    return Promise.all([ue(T), m.validationSchema ? ae(T) : {}, m.validate ? fe(T) : {}]).then(function(N) {
      var U = N[0], G = N[1], J = N[2], ie = cl.all([U, G, J], {
        arrayMerge: D7
      });
      return ie;
    });
  }, [m.validate, m.validationSchema, ue, fe, ae]), K = tr(function(T) {
    return T === void 0 && (T = M.values), k({
      type: "SET_ISVALIDATING",
      payload: !0
    }), be(T).then(function(N) {
      return j.current && (k({
        type: "SET_ISVALIDATING",
        payload: !1
      }), k({
        type: "SET_ERRORS",
        payload: N
      })), N;
    });
  });
  bt(function() {
    o && j.current === !0 && jn(w.current, m.initialValues) && K(w.current);
  }, [o, K]);
  var ve = Je(function(T) {
    var N = T && T.values ? T.values : w.current, U = T && T.errors ? T.errors : S.current ? S.current : m.initialErrors || {}, G = T && T.touched ? T.touched : E.current ? E.current : m.initialTouched || {}, J = T && T.status ? T.status : x.current ? x.current : m.initialStatus;
    w.current = N, S.current = U, E.current = G, x.current = J;
    var ie = function() {
      k({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!T && !!T.isSubmitting,
          errors: U,
          touched: G,
          status: J,
          values: N,
          isValidating: !!T && !!T.isValidating,
          submitCount: T && T.submitCount && typeof T.submitCount == "number" ? T.submitCount : 0
        }
      });
    };
    if (m.onReset) {
      var le = m.onReset(M.values, yn);
      ku(le) ? le.then(ie) : ie();
    } else
      ie();
  }, [m.initialErrors, m.initialStatus, m.initialTouched]);
  bt(function() {
    j.current === !0 && !jn(w.current, m.initialValues) && (s && (w.current = m.initialValues, ve()), o && K(w.current));
  }, [s, m.initialValues, ve, o, K]), bt(function() {
    s && j.current === !0 && !jn(S.current, m.initialErrors) && (S.current = m.initialErrors || Jn, k({
      type: "SET_ERRORS",
      payload: m.initialErrors || Jn
    }));
  }, [s, m.initialErrors]), bt(function() {
    s && j.current === !0 && !jn(E.current, m.initialTouched) && (E.current = m.initialTouched || Cs, k({
      type: "SET_TOUCHED",
      payload: m.initialTouched || Cs
    }));
  }, [s, m.initialTouched]), bt(function() {
    s && j.current === !0 && !jn(x.current, m.initialStatus) && (x.current = m.initialStatus, k({
      type: "SET_STATUS",
      payload: m.initialStatus
    }));
  }, [s, m.initialStatus, m.initialTouched]);
  var q = tr(function(T) {
    if (O.current[T] && mt(O.current[T].validate)) {
      var N = ot(M.values, T), U = O.current[T].validate(N);
      return ku(U) ? (k({
        type: "SET_ISVALIDATING",
        payload: !0
      }), U.then(function(G) {
        return G;
      }).then(function(G) {
        k({
          type: "SET_FIELD_ERROR",
          payload: {
            field: T,
            value: G
          }
        }), k({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (k({
        type: "SET_FIELD_ERROR",
        payload: {
          field: T,
          value: U
        }
      }), Promise.resolve(U));
    } else if (m.validationSchema)
      return k({
        type: "SET_ISVALIDATING",
        payload: !0
      }), ae(M.values, T).then(function(G) {
        return G;
      }).then(function(G) {
        k({
          type: "SET_FIELD_ERROR",
          payload: {
            field: T,
            value: G[T]
          }
        }), k({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), qe = Je(function(T, N) {
    var U = N.validate;
    O.current[T] = {
      validate: U
    };
  }, []), at = Je(function(T) {
    delete O.current[T];
  }, []), xt = tr(function(T, N) {
    k({
      type: "SET_TOUCHED",
      payload: T
    });
    var U = N === void 0 ? a : N;
    return U ? K(M.values) : Promise.resolve();
  }), st = Je(function(T) {
    k({
      type: "SET_ERRORS",
      payload: T
    });
  }, []), je = tr(function(T, N) {
    var U = mt(T) ? T(M.values) : T;
    k({
      type: "SET_VALUES",
      payload: U
    });
    var G = N === void 0 ? t : N;
    return G ? K(U) : Promise.resolve();
  }), $t = Je(function(T, N) {
    k({
      type: "SET_FIELD_ERROR",
      payload: {
        field: T,
        value: N
      }
    });
  }, []), Fe = tr(function(T, N, U) {
    k({
      type: "SET_FIELD_VALUE",
      payload: {
        field: T,
        value: N
      }
    });
    var G = U === void 0 ? t : U;
    return G ? K(Ar(M.values, T, N)) : Promise.resolve();
  }), or = Je(function(T, N) {
    var U = N, G = T, J;
    if (!Cu(T)) {
      T.persist && T.persist();
      var ie = T.target ? T.target : T.currentTarget, le = ie.type, Ze = ie.name, zr = ie.id, lr = ie.value, _e = ie.checked, vn = ie.outerHTML, Yn = ie.options, mn = ie.multiple;
      U = N || Ze || zr, !U && process.env.NODE_ENV !== "production" && Xd({
        htmlContent: vn,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), G = /number|range/.test(le) ? (J = parseFloat(lr), isNaN(J) ? "" : J) : /checkbox/.test(le) ? M7(ot(M.values, U), _e, lr) : Yn && mn ? j7(Yn) : lr;
    }
    U && Fe(U, G);
  }, [Fe, M.values]), Yt = tr(function(T) {
    if (Cu(T))
      return function(N) {
        return or(N, T);
      };
    or(T);
  }), Tt = tr(function(T, N, U) {
    N === void 0 && (N = !0), k({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: T,
        value: N
      }
    });
    var G = U === void 0 ? a : U;
    return G ? K(M.values) : Promise.resolve();
  }), Ut = Je(function(T, N) {
    T.persist && T.persist();
    var U = T.target, G = U.name, J = U.id, ie = U.outerHTML, le = N || G || J;
    !le && process.env.NODE_ENV !== "production" && Xd({
      htmlContent: ie,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), Tt(le, !0);
  }, [Tt]), z = tr(function(T) {
    if (Cu(T))
      return function(N) {
        return Ut(N, T);
      };
    Ut(T);
  }), wr = Je(function(T) {
    mt(T) ? k({
      type: "SET_FORMIK_STATE",
      payload: T
    }) : k({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return T;
      }
    });
  }, []), Sr = Je(function(T) {
    k({
      type: "SET_STATUS",
      payload: T
    });
  }, []), Pt = Je(function(T) {
    k({
      type: "SET_ISSUBMITTING",
      payload: T
    });
  }, []), Jt = tr(function() {
    return k({
      type: "SUBMIT_ATTEMPT"
    }), K().then(function(T) {
      var N = T instanceof Error, U = !N && Object.keys(T).length === 0;
      if (U) {
        var G;
        try {
          if (G = W(), G === void 0)
            return;
        } catch (J) {
          throw J;
        }
        return Promise.resolve(G).then(function(J) {
          return j.current && k({
            type: "SUBMIT_SUCCESS"
          }), J;
        }).catch(function(J) {
          if (j.current)
            throw k({
              type: "SUBMIT_FAILURE"
            }), J;
        });
      } else if (j.current && (k({
        type: "SUBMIT_FAILURE"
      }), N))
        throw T;
    });
  }), xr = tr(function(T) {
    if (T && T.preventDefault && mt(T.preventDefault) && T.preventDefault(), T && T.stopPropagation && mt(T.stopPropagation) && T.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var N = S7();
      N !== null && N instanceof HTMLButtonElement && (N.attributes && N.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? it(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : it(!1)));
    }
    Jt().catch(function(U) {
      console.warn("Warning: An unhandled error was caught from submitForm()", U);
    });
  }), yn = {
    resetForm: ve,
    validateForm: K,
    validateField: q,
    setErrors: st,
    setFieldError: $t,
    setFieldTouched: Tt,
    setFieldValue: Fe,
    setStatus: Sr,
    setSubmitting: Pt,
    setTouched: xt,
    setValues: je,
    setFormikState: wr,
    submitForm: Jt
  }, W = tr(function() {
    return f(M.values, yn);
  }), Yr = tr(function(T) {
    T && T.preventDefault && mt(T.preventDefault) && T.preventDefault(), T && T.stopPropagation && mt(T.stopPropagation) && T.stopPropagation(), ve();
  }), Tr = Je(function(T) {
    return {
      value: ot(M.values, T),
      error: ot(M.errors, T),
      touched: !!ot(M.touched, T),
      initialValue: ot(w.current, T),
      initialTouched: !!ot(E.current, T),
      initialError: ot(S.current, T)
    };
  }, [M.errors, M.touched, M.values]), ur = Je(function(T) {
    return {
      setValue: function(U, G) {
        return Fe(T, U, G);
      },
      setTouched: function(U, G) {
        return Tt(T, U, G);
      },
      setError: function(U) {
        return $t(T, U);
      }
    };
  }, [Fe, Tt, $t]), Ur = Je(function(T) {
    var N = Uo(T), U = N ? T.name : T, G = ot(M.values, U), J = {
      name: U,
      value: G,
      onChange: Yt,
      onBlur: z
    };
    if (N) {
      var ie = T.type, le = T.value, Ze = T.as, zr = T.multiple;
      ie === "checkbox" ? le === void 0 ? J.checked = !!G : (J.checked = !!(Array.isArray(G) && ~G.indexOf(le)), J.value = le) : ie === "radio" ? (J.checked = G === le, J.value = le) : Ze === "select" && zr && (J.value = J.value || [], J.multiple = !0);
    }
    return J;
  }, [z, Yt, M.values]), gn = hf(function() {
    return !jn(w.current, M.values);
  }, [w.current, M.values]), Ti = hf(function() {
    return typeof l < "u" ? gn ? M.errors && Object.keys(M.errors).length === 0 : l !== !1 && mt(l) ? l(m) : l : M.errors && Object.keys(M.errors).length === 0;
  }, [l, gn, M.errors, m]), pn = Ce({}, M, {
    initialValues: w.current,
    initialErrors: S.current,
    initialTouched: E.current,
    initialStatus: x.current,
    handleBlur: z,
    handleChange: Yt,
    handleReset: Yr,
    handleSubmit: xr,
    resetForm: ve,
    setErrors: st,
    setFormikState: wr,
    setFieldTouched: Tt,
    setFieldValue: Fe,
    setFieldError: $t,
    setStatus: Sr,
    setSubmitting: Pt,
    setTouched: xt,
    setValues: je,
    submitForm: Jt,
    validateForm: K,
    validateField: q,
    isValid: Ti,
    dirty: gn,
    unregisterField: at,
    registerField: qe,
    getFieldProps: Ur,
    getFieldMeta: Tr,
    getFieldHelpers: ur,
    validateOnBlur: a,
    validateOnChange: t,
    validateOnMount: o
  });
  return pn;
}
function cg(e) {
  var r = O7(e), t = e.component, n = e.children, a = e.render, i = e.innerRef;
  return rm(i, function() {
    return r;
  }), process.env.NODE_ENV !== "production" && bt(function() {
    e.render && (process.env.NODE_ENV !== "production" ? it(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : it(!1));
  }, []), yr(x7, {
    value: r
  }, t ? yr(t, r) : a ? a(r) : n ? mt(n) ? n(r) : wc(n) ? null : wl.only(n) : null);
}
function Xd(e) {
  var r = e.htmlContent, t = e.documentationAnchorLink, n = e.handlerName;
  console.warn("Warning: Formik called `" + n + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + r + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + t + `
  `);
}
function C7(e) {
  var r = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return Ar(r, e.path, e.message);
    for (var a = e.inner, t = Array.isArray(a), n = 0, a = t ? a : a[Symbol.iterator](); ; ) {
      var i;
      if (t) {
        if (n >= a.length)
          break;
        i = a[n++];
      } else {
        if (n = a.next(), n.done)
          break;
        i = n.value;
      }
      var o = i;
      ot(r, o.path) || (r = Ar(r, o.path, o.message));
    }
  }
  return r;
}
function k7(e, r, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = {});
  var a = pl(e);
  return r[t ? "validateSync" : "validate"](a, {
    abortEarly: !1,
    context: n
  });
}
function pl(e) {
  var r = Array.isArray(e) ? [] : {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var n = String(t);
      Array.isArray(e[n]) === !0 ? r[n] = e[n].map(function(a) {
        return Array.isArray(a) === !0 || _d(a) ? pl(a) : a !== "" ? a : void 0;
      }) : _d(e[n]) ? r[n] = pl(e[n]) : r[n] = e[n] !== "" ? e[n] : void 0;
    }
  return r;
}
function D7(e, r, t) {
  var n = e.slice();
  return r.forEach(function(i, o) {
    if (typeof n[o] > "u") {
      var l = t.clone !== !1, h = l && t.isMergeableObject(i);
      n[o] = h ? cl(Array.isArray(i) ? [] : {}, i, t) : i;
    } else
      t.isMergeableObject(i) ? n[o] = cl(e[o], i, t) : e.indexOf(i) === -1 && n.push(i);
  }), n;
}
function j7(e) {
  return Array.from(e).filter(function(r) {
    return r.selected;
  }).map(function(r) {
    return r.value;
  });
}
function M7(e, r, t) {
  if (typeof e == "boolean")
    return !!r;
  var n = [], a = !1, i = -1;
  if (Array.isArray(e))
    n = e, i = e.indexOf(t), a = i >= 0;
  else if (!t || t == "true" || t == "false")
    return !!r;
  return r && t && !a ? n.concat(t) : a ? n.slice(0, i).concat(n.slice(i + 1)) : n;
}
var P7 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? im : bt;
function tr(e) {
  var r = Xn(e);
  return P7(function() {
    r.current = e;
  }), Je(function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return r.current.apply(void 0, n);
  }, []);
}
function Sc(e) {
  var r = e.validate, t = e.name, n = e.render, a = e.children, i = e.as, o = e.component, l = si(e, ["validate", "name", "render", "children", "as", "component"]), h = lg(), s = si(h, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && bt(function() {
    n && (process.env.NODE_ENV !== "production" ? it(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + t + '" render={({field, form}) => ...} /> with <Field name="' + t + '">{({field, form, meta}) => ...}</Field>') : it(!1)), i && a && mt(a) && (process.env.NODE_ENV !== "production" ? it(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : it(!1)), o && a && mt(a) && (process.env.NODE_ENV !== "production" ? it(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : it(!1)), n && a && !wc(a) && (process.env.NODE_ENV !== "production" ? it(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : it(!1));
  }, []);
  var f = s.registerField, p = s.unregisterField;
  bt(function() {
    return f(t, {
      validate: r
    }), function() {
      p(t);
    };
  }, [f, p, t, r]);
  var m = s.getFieldProps(Ce({
    name: t
  }, l)), w = s.getFieldMeta(t), S = {
    field: m,
    form: s
  };
  if (n)
    return n(Ce({}, S, {
      meta: w
    }));
  if (mt(a))
    return a(Ce({}, S, {
      meta: w
    }));
  if (o) {
    if (typeof o == "string") {
      var E = l.innerRef, x = si(l, ["innerRef"]);
      return yr(o, Ce({
        ref: E
      }, m, x), a);
    }
    return yr(o, Ce({
      field: m,
      form: s
    }, l), a);
  }
  var j = i || "input";
  if (typeof j == "string") {
    var O = l.innerRef, I = si(l, ["innerRef"]);
    return yr(j, Ce({
      ref: O
    }, m, I), a);
  }
  return yr(j, Ce({}, m, l), a);
}
var fg = /* @__PURE__ */ em(function(e, r) {
  var t = e.action, n = si(e, ["action"]), a = t ?? "#", i = lg(), o = i.handleReset, l = i.handleSubmit;
  return yr("form", Object.assign({
    onSubmit: l,
    ref: r,
    onReset: o,
    action: a
  }, n));
});
fg.displayName = "Form";
function A7(e) {
  var r = function(a) {
    return yr(T7, null, function(i) {
      return i || (process.env.NODE_ENV !== "production" ? it(!1, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + e.name) : it(!1)), yr(e, Object.assign({}, a, {
        formik: i
      }));
    });
  }, t = e.displayName || e.name || e.constructor && e.constructor.name || "Component";
  return r.WrappedComponent = e, r.displayName = "FormikConnect(" + t + ")", p7(
    r,
    e
    // cast type to ComponentClass (even if SFC)
  );
}
var R7 = function(r, t, n) {
  var a = ea(r), i = a[t];
  return a.splice(t, 1), a.splice(n, 0, i), a;
}, I7 = function(r, t, n) {
  var a = ea(r), i = a[t];
  return a[t] = a[n], a[n] = i, a;
}, Du = function(r, t, n) {
  var a = ea(r);
  return a.splice(t, 0, n), a;
}, N7 = function(r, t, n) {
  var a = ea(r);
  return a[t] = n, a;
}, ea = function(r) {
  if (r) {
    if (Array.isArray(r))
      return [].concat(r);
    var t = Object.keys(r).map(function(n) {
      return parseInt(n);
    }).reduce(function(n, a) {
      return a > n ? a : n;
    }, 0);
    return Array.from(Ce({}, r, {
      length: t + 1
    }));
  } else
    return [];
}, dg = /* @__PURE__ */ function(e) {
  _7(r, e);
  function r(n) {
    var a;
    return a = e.call(this, n) || this, a.updateArrayField = function(i, o, l) {
      var h = a.props, s = h.name, f = h.formik.setFormikState;
      f(function(p) {
        var m = typeof l == "function" ? l : i, w = typeof o == "function" ? o : i, S = Ar(p.values, s, i(ot(p.values, s))), E = l ? m(ot(p.errors, s)) : void 0, x = o ? w(ot(p.touched, s)) : void 0;
        return Jd(E) && (E = void 0), Jd(x) && (x = void 0), Ce({}, p, {
          values: S,
          errors: l ? Ar(p.errors, s, E) : p.errors,
          touched: o ? Ar(p.touched, s, x) : p.touched
        });
      });
    }, a.push = function(i) {
      return a.updateArrayField(function(o) {
        return [].concat(ea(o), [b7(i)]);
      }, !1, !1);
    }, a.handlePush = function(i) {
      return function() {
        return a.push(i);
      };
    }, a.swap = function(i, o) {
      return a.updateArrayField(function(l) {
        return I7(l, i, o);
      }, !0, !0);
    }, a.handleSwap = function(i, o) {
      return function() {
        return a.swap(i, o);
      };
    }, a.move = function(i, o) {
      return a.updateArrayField(function(l) {
        return R7(l, i, o);
      }, !0, !0);
    }, a.handleMove = function(i, o) {
      return function() {
        return a.move(i, o);
      };
    }, a.insert = function(i, o) {
      return a.updateArrayField(function(l) {
        return Du(l, i, o);
      }, function(l) {
        return Du(l, i, null);
      }, function(l) {
        return Du(l, i, null);
      });
    }, a.handleInsert = function(i, o) {
      return function() {
        return a.insert(i, o);
      };
    }, a.replace = function(i, o) {
      return a.updateArrayField(function(l) {
        return N7(l, i, o);
      }, !1, !1);
    }, a.handleReplace = function(i, o) {
      return function() {
        return a.replace(i, o);
      };
    }, a.unshift = function(i) {
      var o = -1;
      return a.updateArrayField(function(l) {
        var h = l ? [i].concat(l) : [i];
        return o < 0 && (o = h.length), h;
      }, function(l) {
        var h = l ? [null].concat(l) : [null];
        return o < 0 && (o = h.length), h;
      }, function(l) {
        var h = l ? [null].concat(l) : [null];
        return o < 0 && (o = h.length), h;
      }), o;
    }, a.handleUnshift = function(i) {
      return function() {
        return a.unshift(i);
      };
    }, a.handleRemove = function(i) {
      return function() {
        return a.remove(i);
      };
    }, a.handlePop = function() {
      return function() {
        return a.pop();
      };
    }, a.remove = a.remove.bind(Zd(a)), a.pop = a.pop.bind(Zd(a)), a;
  }
  var t = r.prototype;
  return t.componentDidUpdate = function(a) {
    this.props.validateOnChange && this.props.formik.validateOnChange && !jn(ot(a.formik.values, a.name), ot(this.props.formik.values, this.props.name)) && this.props.formik.validateForm(this.props.formik.values);
  }, t.remove = function(a) {
    var i;
    return this.updateArrayField(
      // so this gets call 3 times
      function(o) {
        var l = o ? ea(o) : [];
        return i || (i = l[a]), mt(l.splice) && l.splice(a, 1), l;
      },
      !0,
      !0
    ), i;
  }, t.pop = function() {
    var a;
    return this.updateArrayField(
      // so this gets call 3 times
      function(i) {
        var o = i;
        return a || (a = o && o.pop && o.pop()), o;
      },
      !0,
      !0
    ), a;
  }, t.render = function() {
    var a = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    }, i = this.props, o = i.component, l = i.render, h = i.children, s = i.name, f = i.formik, p = si(f, ["validate", "validationSchema"]), m = Ce({}, a, {
      form: p,
      name: s
    });
    return o ? yr(o, m) : l ? l(m) : h ? typeof h == "function" ? h(m) : wc(h) ? null : wl.only(h) : null;
  }, r;
}(am);
dg.defaultProps = {
  validateOnChange: !0
};
var L7 = /* @__PURE__ */ A7(dg);
const fk = ({
  columns: e,
  handleSubmit: r
}) => {
  const t = {}, [n, {
    open: a,
    close: i
  }] = hh(!1), o = (l) => {
    r(l);
  };
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(uh, { opened: n, title: De.get("Table Options"), onClose: i, children: /* @__PURE__ */ y.jsx(cg, { initialValues: t, onSubmit: o, children: /* @__PURE__ */ y.jsx(qi.Group, { mt: "sm", children: e.map((l, h) => /* @__PURE__ */ y.jsx(
      qi,
      {
        m: "sm",
        label: l.title,
        value: l.title
      },
      h
    )) }) }) }),
    /* @__PURE__ */ y.jsx(Mt, { leftSection: /* @__PURE__ */ y.jsx(qa, {}), onClick: a, children: "Open" })
  ] });
}, dk = ({
  items: e,
  variant: r = "subtle"
}) => (typeof e > "u" && (e = []), /* @__PURE__ */ y.jsxs(Xe, { shadow: "md", width: 200, children: [
  /* @__PURE__ */ y.jsx(Xe.Target, { children: /* @__PURE__ */ y.jsx(Mt, { variant: r, children: /* @__PURE__ */ y.jsx(s4, {}) }) }),
  /* @__PURE__ */ y.jsx(Xe.Dropdown, { children: e.map((t) => /* @__PURE__ */ y.jsx(
    Xe.Item,
    {
      leftSection: t.iconName === "edit" ? /* @__PURE__ */ y.jsx(qa, {}) : /* @__PURE__ */ y.jsx(F0, {}),
      children: t.text
    },
    t.id
  )) })
] })), hk = ({
  tools: e,
  justify: r = "flex-end",
  gap: t = "md",
  grow: n = !1
}) => /* @__PURE__ */ y.jsx(ee, { justify: r, gap: t, grow: n, children: e.map((a, i) => /* @__PURE__ */ y.jsx("div", { children: a }, i)) }), F7 = (e) => /* @__PURE__ */ y.jsx(
  y4,
  {
    onClick: () => {
    },
    ...e
  }
), hg = ({
  children: e,
  ...r
}) => {
  const t = lo();
  return typeof r.onClick > "u" && (r.onClick = (n) => {
    n.preventDefault(), t(-1);
  }), /* @__PURE__ */ y.jsx(
    Yl,
    {
      ...r,
      children: e
    }
  );
}, $7 = ({
  primaryAction: e,
  secondaryAction: r
}) => /* @__PURE__ */ y.jsxs(ee, { justify: "right", gap: "xs", children: [
  r || /* @__PURE__ */ y.jsx(hg, {}),
  e || /* @__PURE__ */ y.jsx(F7, {})
] }), yk = Object.freeze({
  edit: "edit",
  view: "view"
}), gk = ({
  handleSubmit: e,
  handleCancel: r,
  actionBar: t,
  children: n
}) => {
  const a = lo();
  let i = null;
  return r ? i = r : i = (o) => {
    o.preventDefault(), a(-1);
  }, /* @__PURE__ */ y.jsx("form", { onSubmit: e, children: /* @__PURE__ */ y.jsxs(Ue, { children: [
    n,
    t || /* @__PURE__ */ y.jsx($7, { secondaryAction: /* @__PURE__ */ y.jsx(hg, { onClick: i }) })
  ] }) });
}, Y7 = (e) => /* @__PURE__ */ y.jsx("div", { style: { margin: "1rem 0" }, children: /* @__PURE__ */ y.jsxs(
  "pre",
  {
    style: {
      background: "#f6f8fa",
      padding: ".5rem"
    },
    children: [
      /* @__PURE__ */ y.jsx("strong", { children: "props" }),
      " = ",
      JSON.stringify(e, null, 2)
    ]
  }
) }), pk = ({
  handleSubmit: e,
  isSubmitting: r,
  handleCancel: t,
  children: n,
  cancelLabel: a = "Cancel",
  submitLabel: i = "Save",
  debug: o = !1,
  ...l
}) => /* @__PURE__ */ y.jsxs("form", { onSubmit: e, children: [
  n,
  o && /* @__PURE__ */ y.jsx(Y7, { ...l }),
  /* @__PURE__ */ y.jsxs(ee, { my: "sm", justify: "right", gap: "xs", children: [
    /* @__PURE__ */ y.jsx(Yl, { onClick: t, children: De.get(a) }),
    /* @__PURE__ */ y.jsx(Y0, { type: "submit", disabled: r, children: De.get(i) })
  ] })
] }), vk = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t
  },
  ...n
}) => {
  const [a, i] = Pr(e.value);
  let o = "";
  return typeof r < "u" && r[e.name] && (o = r[e.name]), /* @__PURE__ */ y.jsx(
    qi,
    {
      ...e,
      ...n,
      error: o,
      checked: a,
      onChange: (l) => {
        i(l.currentTarget.checked), t(e.name, l.currentTarget.checked);
      }
    }
  );
}, mk = ({
  enabled: e,
  ...r
}) => e ? /* @__PURE__ */ y.jsx(
  lh,
  {
    value: JSON.stringify(r, null, 2),
    readOnly: !0,
    autosize: !0
  }
) : null, bk = (e) => {
  const {
    field: r,
    form: t,
    ...n
  } = e, a = n.data, i = ch({
    onDropdownClose: () => i.resetSelectedOption(),
    onDropdownOpen: () => i.updateSelectedOptionIndex("active")
  }), o = t.errors[r.name] && t.errors[r.name], [l, h] = Pr(""), [s, f] = Pr(a || []), [p, m] = Pr(r.value ? r.value : []);
  bt(() => {
    t.setFieldValue(r.name, p);
  }, [p]);
  const w = s.some((O) => O === l), S = (O) => {
    h(""), O === "$create" ? (f((I) => [...I, l]), m((I) => [...I, l])) : m(
      (I) => I.includes(O) ? I.filter((M) => M !== O) : [...I, O]
    );
  }, E = (O) => {
    m((I) => I.filter((M) => M !== O));
  }, x = p.map((O) => /* @__PURE__ */ y.jsx(gf, { withRemoveButton: !0, onRemove: () => E(O), children: O }, O)), j = s.filter((O) => O.toLowerCase().includes(l.trim().toLowerCase())).map((O) => /* @__PURE__ */ y.jsx(Bt.Option, { value: O, active: p.includes(O), children: /* @__PURE__ */ y.jsxs(ee, { gap: "sm", children: [
    p.includes(O) ? /* @__PURE__ */ y.jsx(dm, { size: 12 }) : null,
    /* @__PURE__ */ y.jsx("span", { children: O })
  ] }) }, O));
  return /* @__PURE__ */ y.jsxs(Bt, { store: i, onOptionSubmit: S, withinPortal: !1, children: [
    /* @__PURE__ */ y.jsx(Bt.DropdownTarget, { children: /* @__PURE__ */ y.jsx(
      pf,
      {
        onClick: () => i.openDropdown(),
        onBlur: () => {
          r.onBlur;
        },
        label: n.label,
        description: n.description,
        error: o,
        withAsterisk: n.withAsterisk,
        children: /* @__PURE__ */ y.jsxs(gf.Group, { children: [
          x,
          /* @__PURE__ */ y.jsx(Bt.EventsTarget, { children: /* @__PURE__ */ y.jsx(
            pf.Field,
            {
              onFocus: () => i.openDropdown(),
              onBlur: () => i.closeDropdown(),
              value: l,
              placeholder: n.placeholder,
              onChange: (O) => {
                i.updateSelectedOptionIndex(), h(O.currentTarget.value);
              },
              onKeyDown: (O) => {
                O.key === "Backspace" && l.length === 0 && (O.preventDefault(), E(p[p.length - 1]));
              }
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ y.jsx(Bt.Dropdown, { children: /* @__PURE__ */ y.jsxs(Bt.Options, { children: [
      j,
      !w && l.trim().length > 0 && /* @__PURE__ */ y.jsxs(Bt.Option, { value: "$create", children: [
        "+ Create ",
        l
      ] }),
      w && l.trim().length > 0 && j.length === 0 && /* @__PURE__ */ y.jsx(Bt.Empty, { children: "Nothing found" })
    ] }) })
  ] });
}, _k = ({
  field: e,
  form: r,
  ...t
}) => /* @__PURE__ */ y.jsx(
  xl,
  {
    ...e,
    error: r.errors[e.name],
    ...t,
    onChange: (n) => r.setFieldValue(e.name, n)
  }
), wk = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t,
    values: n
  },
  ...a
}) => {
  const i = (h) => {
    h.preventDefault(), t(e.name, "{}");
  }, o = (h) => {
    h.preventDefault(), t(e.name, "");
  }, l = (h) => {
    t(e.name, h);
  };
  return n[e.name] ? /* @__PURE__ */ y.jsxs(ee, { justify: "space-between", grow: !0, children: [
    /* @__PURE__ */ y.jsx(
      lh,
      {
        ...e,
        error: r[e.name],
        formatOnBlur: !0,
        autosize: !0,
        onChange: l,
        ...a
      }
    ),
    /* @__PURE__ */ y.jsx(lt, { children: /* @__PURE__ */ y.jsx(
      Mt,
      {
        mt: "2.7em",
        variant: "subtle",
        onClick: o,
        leftSection: /* @__PURE__ */ y.jsx(pi, {}),
        children: De.get("Clear")
      }
    ) })
  ] }) : /* @__PURE__ */ y.jsx(
    Zi.Wrapper,
    {
      label: a.label,
      description: a.description,
      withAsterisk: a.withAsterisk,
      children: /* @__PURE__ */ y.jsx(
        Mt,
        {
          mt: "xs",
          variant: "subtle",
          onClick: i,
          leftSection: /* @__PURE__ */ y.jsx(qa, {}),
          children: De.get("Edit")
        }
      )
    }
  );
}, Sk = ({
  field: e,
  form: r,
  ...t
}) => {
  const n = (i) => {
    i.preventDefault(), r.setFieldValue(e.name, " ");
  }, a = (i) => {
    i.preventDefault(), r.setFieldValue(e.name, "");
  };
  return r.values[e.name] ? /* @__PURE__ */ y.jsxs(ee, { justify: "space-between", grow: !0, children: [
    /* @__PURE__ */ y.jsx(
      fh,
      {
        ...e,
        ...t,
        error: r.errors[e.name],
        autosize: !0,
        minRows: 3
      }
    ),
    /* @__PURE__ */ y.jsx(lt, { children: /* @__PURE__ */ y.jsx(
      Mt,
      {
        mt: "0em",
        variant: "subtle",
        onClick: a,
        leftSection: /* @__PURE__ */ y.jsx(pi, {}),
        children: De.get("Clear")
      }
    ) })
  ] }) : /* @__PURE__ */ y.jsx(
    Zi.Wrapper,
    {
      label: t.label,
      description: t.description,
      withAsterisk: t.withAsterisk,
      children: /* @__PURE__ */ y.jsx(
        Mt,
        {
          mt: "xs",
          variant: "subtle",
          onClick: n,
          leftSection: /* @__PURE__ */ y.jsx(qa, {}),
          children: De.get("Edit")
        }
      )
    }
  );
}, U7 = (e, r, t, n, a) => {
  const i = {
    bucket: r,
    key: "images/" + t,
    edits: {
      resize: {
        width: n,
        height: a,
        fit: "cover"
      }
    }
  }, o = JSON.stringify(i), l = window.btoa(o);
  return [e, l].join("/");
}, xk = ({
  field: e,
  // name, value
  form: {
    isSubmitting: r,
    setFieldValue: t,
    values: n
  },
  imagesDistributionUrl: a,
  imagesBucket: i,
  ...o
}) => {
  if (typeof i > "u")
    throw new Error("imagesBucket is required parameter");
  if (typeof a > "u")
    throw new Error("imagesDistributionUrl is required parameter");
  const [l, h] = Pr(n[e.name]);
  bt(() => (Na.listen("storage", ({ payload: p }) => {
    if (p.event === "upload" && p.message) {
      const m = p.message.replace("Upload success for ", "");
      p.data.attrs.result === "success" ? (t(e.name, m), h(m)) : (A0.remove(m), console.debug("PAC FORMIK IMAGE removed image with key: ", m));
    }
  }), () => {
    Na.remove("storage", () => {
    });
  }), []);
  const s = () => {
    t(e.name, ""), h("");
  };
  console.debug(l);
  const f = U7(
    a,
    i,
    l,
    50,
    50
  );
  return console.debug(f), /* @__PURE__ */ y.jsxs(Ue, { gap: "xl", children: [
    /* @__PURE__ */ y.jsx(
      hm,
      {
        name: e.name,
        value: e.value,
        ...o
      }
    ),
    l && /* @__PURE__ */ y.jsxs(Gt, { shadow: "sm", p: "lg", radius: "md", withBorder: !0, children: [
      /* @__PURE__ */ y.jsx(Gt.Section, {}),
      /* @__PURE__ */ y.jsx(jt, { p: "xl", children: r ? /* @__PURE__ */ y.jsx("div", { children: "Working..." }) : /* @__PURE__ */ y.jsx(
        dh,
        {
          alt: l,
          w: 100,
          h: 100,
          fit: "contain",
          src: e.value
        }
      ) }),
      /* @__PURE__ */ y.jsxs(ee, { justify: "space-between", children: [
        /* @__PURE__ */ y.jsx(Ve, { fw: 500, children: "Preview" }),
        /* @__PURE__ */ y.jsx(lt, { children: /* @__PURE__ */ y.jsx($l, { variant: "subtle", onClick: s, children: "Clear" }) })
      ] })
    ] })
  ] });
}, z7 = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t
  },
  meta: n,
  ...a
}) => typeof r < "u" && typeof r[e.name] < "u" ? /* @__PURE__ */ y.jsx(
  Ru,
  {
    ...e,
    ...a,
    onChange: (i) => t(e.name, i.currentTarget.value),
    error: r[e.name]
  }
) : /* @__PURE__ */ y.jsx(Ru, { ...e, ...a, onChange: (i) => t(e.name, i.currentTarget.value) }), Tk = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t
  },
  ...n
}) => typeof r < "u" && typeof r[e.name] < "u" ? /* @__PURE__ */ y.jsx(
  vf,
  {
    ...e,
    ...n,
    onChange: (a) => t(e.name, a),
    error: r[e.name]
  }
) : /* @__PURE__ */ y.jsx(vf, { ...e, ...n, onChange: (a) => t(e.name, a) }), W7 = ({
  row: e,
  push: r
}) => /* @__PURE__ */ y.jsx(ee, { children: /* @__PURE__ */ y.jsx(
  Mt,
  {
    leftSection: /* @__PURE__ */ y.jsx($0, {}),
    size: "sm",
    onClick: (t) => {
      t.preventDefault(), r(e);
    },
    children: De.get("Add")
  }
) }), B7 = ({
  remove: e,
  rowIndex: r
}) => /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(
  ym,
  {
    size: "lg",
    title: De.get("Remove"),
    onClick: (t) => {
      t.preventDefault(), e(r);
    }
  }
) }), H7 = ({
  element: e,
  fieldName: r
}) => /* @__PURE__ */ y.jsxs(Vt, { children: [
  /* @__PURE__ */ y.jsx(Vt.Col, { span: 4, children: /* @__PURE__ */ y.jsx(Sc, { ...e, name: r }) }),
  /* @__PURE__ */ y.jsx(Vt.Col, { span: 8, children: e.label && /* @__PURE__ */ y.jsx(_t, { order: 4, children: e.label }) })
] }, e.name), G7 = ({
  field: e,
  rowIndex: r,
  rowValues: t,
  getRowElements: n
}) => {
  const a = n(t), i = Math.floor(12 / a.length);
  return /* @__PURE__ */ y.jsx(Vt, { grow: !0, children: a.map((o, l) => {
    const h = `${e.name}.${r}.${o.name}`, s = o.span ? o.span : i, f = typeof o.label < "u" && o.label.length > 0;
    return /* @__PURE__ */ y.jsx(Vt.Col, { span: s, children: f ? /* @__PURE__ */ y.jsx(H7, { element: o, fieldName: h }) : /* @__PURE__ */ yr(Sc, { ...o, key: o.name, name: h }) }, l);
  }) });
}, V7 = ({
  remove: e,
  getRowElements: r,
  ...t
}) => {
  const n = t.field, a = t.form;
  return Array.isArray(a.values[n.name]) && a.values[n.name].length > 0 ? a.values[n.name].map((i, o) => /* @__PURE__ */ y.jsxs(Vt, { children: [
    /* @__PURE__ */ y.jsx(Vt.Col, { span: 11, children: /* @__PURE__ */ y.jsx(
      G7,
      {
        rowIndex: o,
        rowValues: i,
        getRowElements: r,
        ...t
      }
    ) }),
    /* @__PURE__ */ y.jsx(Vt.Col, { span: 1, children: /* @__PURE__ */ y.jsx(B7, { remove: e, rowIndex: o }) })
  ] }, o)) : null;
}, Ek = ({
  field: e,
  form: r,
  getRowElements: t,
  ...n
}) => {
  const a = (l, h) => (l[h.name] = "", l), o = t({}).reduce(a, {});
  return /* @__PURE__ */ y.jsx(
    Zi.Wrapper,
    {
      label: n.label,
      description: n.description,
      withAsterisk: n.withAsterisk,
      children: /* @__PURE__ */ y.jsx(L7, { name: e.name, children: ({
        remove: l,
        push: h
      }) => /* @__PURE__ */ y.jsxs(Ue, { children: [
        /* @__PURE__ */ y.jsx(
          V7,
          {
            field: e,
            form: r,
            remove: l,
            getRowElements: t,
            ...n
          }
        ),
        /* @__PURE__ */ y.jsx(
          W7,
          {
            push: h,
            row: o
          }
        )
      ] }) })
    }
  );
}, Ok = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t
  },
  ...n
}) => {
  let a = "";
  return typeof r < "u" && typeof r[e.name] < "u" && (a = r[e.name]), /* @__PURE__ */ y.jsx(
    gm,
    {
      ...e,
      ...n,
      onChange: (i) => t(e.name, i.currentTarget.value),
      error: a
    }
  );
}, K7 = "_root_19v9f_1", q7 = "_label_19v9f_21", Z7 = "_description_19v9f_29", ju = {
  root: K7,
  label: q7,
  description: Z7
}, Ck = ({
  field: e,
  form: r,
  children: t,
  ...n
}) => /* @__PURE__ */ y.jsx(
  An.Card,
  {
    ...e,
    ...n,
    checked: e.value,
    className: ju.root,
    children: t || /* @__PURE__ */ y.jsxs(ee, { wrap: "nowrap", align: "flex-start", children: [
      /* @__PURE__ */ y.jsx(An.Indicator, {}),
      /* @__PURE__ */ y.jsxs("div", { children: [
        /* @__PURE__ */ y.jsx(Ve, { className: ju.label, children: n.label }),
        /* @__PURE__ */ y.jsx(Ve, { className: ju.description, children: n.description })
      ] })
    ] })
  }
), J7 = "_root_19v9f_1", X7 = "_label_19v9f_21", Q7 = "_description_19v9f_29", Mu = {
  root: J7,
  label: X7,
  description: Q7
}, kk = (e) => {
  const {
    field: r,
    form: t
  } = e, n = t.errors[r.name] && t.touched[r.name] && t.errors[r.name], a = e.data.map((i, o) => /* @__PURE__ */ y.jsx(An.Card, { className: Mu.root, radius: i.radius, value: i.value, children: i.children ? /* @__PURE__ */ y.jsx(lt, { children: "option.children" }, o) : /* @__PURE__ */ y.jsxs(ee, { wrap: "nowrap", align: "flex-start", children: [
    /* @__PURE__ */ y.jsx(An.Indicator, {}),
    /* @__PURE__ */ y.jsxs(Ue, { gap: "sm", children: [
      /* @__PURE__ */ y.jsx(Ve, { className: Mu.label, children: i.label }),
      /* @__PURE__ */ y.jsx(Ve, { className: Mu.description, children: i.description })
    ] })
  ] }) }, i.name));
  return /* @__PURE__ */ y.jsx(
    An.Group,
    {
      value: r.value,
      onChange: (i) => {
        t.setFieldValue(r.name, i);
      },
      error: n,
      children: /* @__PURE__ */ y.jsx(ee, { mt: "xs", grow: !0, children: a.map((i, o) => /* @__PURE__ */ y.jsx(lt, { children: i }, o)) })
    }
  );
}, Dk = ({
  field: e,
  form: {
    errors: r,
    setFieldValue: t
  },
  options: n,
  ...a
}) => /* @__PURE__ */ y.jsx(
  An.Group,
  {
    ...a,
    name: e.name,
    value: e.value,
    onChange: (i) => t(e.name, i),
    error: typeof r < "u" && typeof r[e.name] < "u" ? r[e.name] : "",
    children: /* @__PURE__ */ y.jsx(ee, { my: "xs", children: n.map((i) => /* @__PURE__ */ y.jsx(An, { value: i.value, label: i.label }, i.value)) })
  }
), jk = ({
  field: e,
  form: {
    setFieldValue: r,
    values: t
  },
  ...n
}) => /* @__PURE__ */ y.jsx(
  An,
  {
    ...e,
    ...n,
    type: "radio",
    checked: t[e.name] === e.value,
    onChange: () => r(e.name, e.value)
  }
), Mk = ({
  field: e,
  form: {
    setFieldValue: r,
    errors: t
  },
  ...n
}) => {
  const a = (i) => {
    r(e.name, i);
  };
  return /* @__PURE__ */ y.jsx(
    Sm,
    {
      ...e,
      ...n,
      onChange: a,
      error: e.name in t && t[e.name]
    }
  );
}, Pk = ({
  field: {
    name: e,
    value: r
  },
  form: {
    errors: t,
    setFieldValue: n
  },
  ...a
}) => {
  const i = (o) => {
    n(e, o);
  };
  return /* @__PURE__ */ y.jsx(Zi.Wrapper, { label: a.label, description: a.description, error: t[e], children: /* @__PURE__ */ y.jsx(
    pm,
    {
      ...a,
      py: "sm",
      name: e,
      value: r,
      onChange: i
    }
  ) });
}, Ak = ({
  field: {
    name: e,
    value: r
  },
  form: {
    setFieldValue: t,
    errors: n
  },
  onLabel: a = "ON",
  offLabel: i = "OFF",
  size: o = "md",
  ...l
}) => {
  typeof l.placeholder < "u" && typeof l.label > "u" && (l.label = l.placeholder);
  const h = (s) => {
    t(e, s.currentTarget.checked);
  };
  return /* @__PURE__ */ y.jsx(
    vm,
    {
      name: e,
      checked: r,
      onChange: h,
      onLabel: a,
      offLabel: i,
      size: o,
      error: n[e],
      ...l
    }
  );
}, Rk = ({
  field: e,
  form: r,
  ...t
}) => /* @__PURE__ */ y.jsx(fh, { ...e, ...t, error: r.errors[e.name] }), eC = "_root_1q77q_1", tC = "_controls_1q77q_10", rC = "_list_1q77q_16", nC = "_input_1q77q_26", iC = "_control_1q77q_10", aC = "_icon_1q77q_53", ti = {
  root: eC,
  controls: tC,
  list: rC,
  input: nC,
  control: iC,
  icon: aC
}, Qd = ({
  options: e,
  onTransfer: r,
  type: t
}) => {
  const n = ch(), [a, i] = Pr([]), [o, l] = Pr(""), h = (f) => i(
    (p) => p.includes(f) ? p.filter((m) => m !== f) : [...p, f]
  ), s = e.filter((f) => f.toLowerCase().includes(o.toLowerCase().trim())).map((f) => /* @__PURE__ */ y.jsx(
    Bt.Option,
    {
      value: f,
      active: a.includes(f),
      onMouseOver: () => n.resetSelectedOption(),
      children: /* @__PURE__ */ y.jsxs(ee, { gap: "sm", children: [
        /* @__PURE__ */ y.jsx(
          qi,
          {
            checked: a.includes(f),
            onChange: () => {
            },
            "aria-hidden": !0,
            tabIndex: -1,
            style: { pointerEvents: "none" }
          }
        ),
        /* @__PURE__ */ y.jsx("span", { children: f })
      ] })
    },
    f
  ));
  return /* @__PURE__ */ y.jsx("div", { className: ti.renderList, "data-type": t, children: /* @__PURE__ */ y.jsxs(Bt, { store: n, onOptionSubmit: h, children: [
    /* @__PURE__ */ y.jsx(Bt.EventsTarget, { children: /* @__PURE__ */ y.jsxs(ee, { wrap: "nowrap", gap: 0, className: ti.controls, children: [
      /* @__PURE__ */ y.jsx(
        Ru,
        {
          placeholder: "Search items",
          classNames: { input: ti.input },
          value: o,
          onChange: (f) => {
            l(f.currentTarget.value), n.updateSelectedOptionIndex();
          }
        }
      ),
      /* @__PURE__ */ y.jsx(
        ir,
        {
          radius: 0,
          variant: "default",
          size: 36,
          className: ti.control,
          onClick: () => {
            r(a), i([]);
          },
          children: /* @__PURE__ */ y.jsx(N0, { className: ti.icon })
        }
      )
    ] }) }),
    /* @__PURE__ */ y.jsx("div", { className: ti.list, children: /* @__PURE__ */ y.jsx(Bt.Options, { children: s.length > 0 ? s : /* @__PURE__ */ y.jsx(Bt.Empty, { children: "Nothing found...." }) }) })
  ] }) });
};
function Ik({
  field: {
    name: e
  },
  form: {
    setFieldValue: r,
    errors: t
  },
  ...n
}) {
  const a = n.data[1], [i, o] = Pr(n.data);
  bt(() => {
    r(e, a);
  }, []);
  const l = (s, f) => o((p) => {
    const m = s === 0 ? 1 : 0, w = p[s].filter((x) => !f.includes(x)), S = [...p[m], ...f], E = [];
    return E[s] = w, E[m] = S, r(e, E[1]), E;
  }), h = () => /* @__PURE__ */ y.jsx(Ue, { children: /* @__PURE__ */ y.jsxs(lt, { className: ti.root, children: [
    /* @__PURE__ */ y.jsx(
      Qd,
      {
        type: "forward",
        options: i[0],
        onTransfer: (s) => l(0, s)
      }
    ),
    /* @__PURE__ */ y.jsx(
      Qd,
      {
        type: "backward",
        options: i[1],
        onTransfer: (s) => l(1, s)
      }
    )
  ] }) });
  return /* @__PURE__ */ y.jsx(
    Zi.Wrapper,
    {
      label: n.label,
      description: n.description,
      error: t[e],
      children: /* @__PURE__ */ y.jsx(Zi, { component: h })
    }
  );
}
const Nk = ({
  cancelUrl: e,
  submitButtonLabel: r,
  disabled: t
}) => (typeof r > "u" && (r = De.get("Submit")), /* @__PURE__ */ y.jsxs(ee, { justify: "flex-end", children: [
  e ? /* @__PURE__ */ y.jsx(Ra, { to: e, children: De.get("Cancel") }) : null,
  /* @__PURE__ */ y.jsx(
    Mt,
    {
      size: "md",
      type: "submit",
      disabled: t,
      className: "d-inline-block",
      children: r
    }
  )
] })), Lk = ({ sections: e }) => {
  let r = e.find((t) => t.default === !0);
  if (typeof r > "u" && Array.isArray(e) && e.length > 0 && (r = e[0]), typeof r > "u")
    throw new Error("defaultItem is required parameter");
  return /* @__PURE__ */ y.jsx(gs, { defaultValue: r.title, children: e.map((t, n) => /* @__PURE__ */ y.jsxs(gs.Item, { value: t.title, children: [
    /* @__PURE__ */ y.jsx(gs.Control, { children: t.title }),
    /* @__PURE__ */ y.jsx(gs.Panel, { children: t.component })
  ] }, n)) });
}, yg = ({
  pageNavigation: e,
  pageHeader: r,
  pageFooter: t,
  children: n
}) => /* @__PURE__ */ y.jsxs(Ue, { children: [
  e,
  r,
  n,
  t
] }), sC = "_container_gvh0a_5", oC = "_title_gvh0a_12", eh = {
  container: sC,
  title: oC
}, xc = ({
  title: e,
  icon: r,
  tools: t
}) => /* @__PURE__ */ y.jsxs(ee, { justify: "space-between", className: eh.container, children: [
  /* @__PURE__ */ y.jsx(_t, { order: 2, children: /* @__PURE__ */ y.jsxs(ee, { children: [
    r,
    De.get(e)
  ] }) }),
  /* @__PURE__ */ y.jsx(ee, { justify: "flex-end", gap: "xs", className: eh.tools, children: t ? t.map((n, a) => /* @__PURE__ */ y.jsx(sm, { children: n }, a)) : null })
] }), Fk = ({
  title: e = "",
  icon: r,
  tools: t,
  pageNavigation: n,
  children: a
}) => {
  const i = lo();
  return typeof t > "u" && (t = [/* @__PURE__ */ y.jsx($l, { onClick: () => i(-1) }, "close-page")]), /* @__PURE__ */ y.jsx(
    yg,
    {
      pageNavigation: n,
      pageHeader: /* @__PURE__ */ y.jsx(xc, { title: e, icon: r, tools: t }),
      children: a
    }
  );
}, uC = "_container_g59zk_5", lC = {
  container: uC
}, $k = ({
  children: e
}) => /* @__PURE__ */ y.jsx(lt, { className: lC.container, children: e }), Yk = ({
  title: e,
  icon: r,
  tools: t,
  pageNavigation: n,
  children: a
}) => {
  const i = lo();
  if (t === void 0) {
    const o = () => {
      i("add");
    };
    t = [/* @__PURE__ */ y.jsx(c4, { onClick: o }, "add-record")];
  }
  return /* @__PURE__ */ y.jsx(
    yg,
    {
      pageNavigation: n,
      pageHeader: /* @__PURE__ */ y.jsx(xc, { title: e, icon: r, tools: t }),
      children: a
    }
  );
}, Uk = ({ columns: e = [] }) => {
  if (!Array.isArray(e))
    throw new Error("Invalid columns value");
  return /* @__PURE__ */ y.jsx(ee, { grow: !0, children: e.map((r, t) => /* @__PURE__ */ y.jsxs(Ue, { children: [
    /* @__PURE__ */ y.jsx(xc, { title: r.title }),
    r.component
  ] }, t)) });
}, zk = (e) => typeof e.tools > "u" ? null : /* @__PURE__ */ y.jsx(ee, { gap: "md", grow: !1, children: e.tools.map((r, t) => /* @__PURE__ */ y.jsx(lt, { children: r }, t)) }), Wk = ({
  filter: e,
  removeItemHandler: r
}) => {
  let t = [];
  return typeof e < "u" && e !== null && (t = Object.keys(e).map((n) => ({
    key: n,
    value: e[n]
  }))), /* @__PURE__ */ y.jsx(ee, { children: t.map(
    (n, a) => /* @__PURE__ */ y.jsx(lt, { children: /* @__PURE__ */ y.jsx(Sl, { children: /* @__PURE__ */ y.jsxs(ee, { children: [
      /* @__PURE__ */ y.jsxs(Ve, { children: [
        n.key,
        " : ",
        n.value
      ] }),
      r ? /* @__PURE__ */ y.jsx(ir, { onClick: r, children: /* @__PURE__ */ y.jsx(pi, {}) }) : null
    ] }) }) }, a)
  ) });
}, cC = /* @__PURE__ */ y.jsxs("svg", { height: 24, width: 24, children: [
  /* @__PURE__ */ y.jsx("defs", { children: /* @__PURE__ */ y.jsx(
    "path",
    {
      d: "M22.5 21.442l-5.663-5.692a8.25 8.25 0 10-1.087 1.087l5.692 5.663 1.058-1.058zM3.75 10.5a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z",
      id: "Search24_svg__a"
    }
  ) }),
  /* @__PURE__ */ y.jsx("use", { fill: "currentColor", fillRule: "evenodd", xlinkHref: "#Search24_svg__a" })
] }), fC = ({
  handleFilterByKeyword: e,
  ...r
}) => /* @__PURE__ */ y.jsx(
  Sc,
  {
    name: "search",
    icon: cC,
    placeholder: "Search",
    component: z7,
    rightSection: r.dirty === !0 ? /* @__PURE__ */ y.jsx(
      ir,
      {
        variant: "transparent",
        onClick: () => {
          e(""), r.resetForm();
        },
        children: /* @__PURE__ */ y.jsx(pi, {})
      }
    ) : null
  }
);
function Si(e) {
  this._maxSize = e, this.clear();
}
Si.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Si.prototype.get = function(e) {
  return this._values[e];
};
Si.prototype.set = function(e, r) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = r;
};
var dC = /[^.^\]^[]+|(?=\[\]|\.\.)/g, gg = /^\d+$/, hC = /^\d/, yC = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, gC = /^\s*(['"]?)(.*?)(\1)\s*$/, Tc = 512, th = new Si(Tc), rh = new Si(Tc), nh = new Si(Tc), ci = {
  Cache: Si,
  split: vl,
  normalizePath: Pu,
  setter: function(e) {
    var r = Pu(e);
    return rh.get(e) || rh.set(e, function(n, a) {
      for (var i = 0, o = r.length, l = n; i < o - 1; ) {
        var h = r[i];
        if (h === "__proto__" || h === "constructor" || h === "prototype")
          return n;
        l = l[r[i++]];
      }
      l[r[i]] = a;
    });
  },
  getter: function(e, r) {
    var t = Pu(e);
    return nh.get(e) || nh.set(e, function(a) {
      for (var i = 0, o = t.length; i < o; )
        if (a != null || !r)
          a = a[t[i++]];
        else
          return;
      return a;
    });
  },
  join: function(e) {
    return e.reduce(function(r, t) {
      return r + (Ec(t) || gg.test(t) ? "[" + t + "]" : (r ? "." : "") + t);
    }, "");
  },
  forEach: function(e, r, t) {
    pC(Array.isArray(e) ? e : vl(e), r, t);
  }
};
function Pu(e) {
  return th.get(e) || th.set(
    e,
    vl(e).map(function(r) {
      return r.replace(gC, "$2");
    })
  );
}
function vl(e) {
  return e.match(dC) || [""];
}
function pC(e, r, t) {
  var n = e.length, a, i, o, l;
  for (i = 0; i < n; i++)
    a = e[i], a && (bC(a) && (a = '"' + a + '"'), l = Ec(a), o = !l && /^\d+$/.test(a), r.call(t, a, l, o, i, e));
}
function Ec(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function vC(e) {
  return e.match(hC) && !e.match(gg);
}
function mC(e) {
  return yC.test(e);
}
function bC(e) {
  return !Ec(e) && (vC(e) || mC(e));
}
const _C = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, Wo = (e) => e.match(_C) || [], Bo = (e) => e[0].toUpperCase() + e.slice(1), Oc = (e, r) => Wo(e).join(r).toLowerCase(), pg = (e) => Wo(e).reduce(
  (r, t) => `${r}${r ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`,
  ""
), wC = (e) => Bo(pg(e)), SC = (e) => Oc(e, "_"), xC = (e) => Oc(e, "-"), TC = (e) => Bo(Oc(e, " ")), EC = (e) => Wo(e).map(Bo).join(" ");
var Au = {
  words: Wo,
  upperFirst: Bo,
  camelCase: pg,
  pascalCase: wC,
  snakeCase: SC,
  kebabCase: xC,
  sentenceCase: TC,
  titleCase: EC
}, Cc = { exports: {} };
Cc.exports = function(e) {
  return vg(OC(e), e);
};
Cc.exports.array = vg;
function vg(e, r) {
  var t = e.length, n = new Array(t), a = {}, i = t, o = CC(r), l = kC(e);
  for (r.forEach(function(s) {
    if (!l.has(s[0]) || !l.has(s[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    a[i] || h(e[i], i, /* @__PURE__ */ new Set());
  return n;
  function h(s, f, p) {
    if (p.has(s)) {
      var m;
      try {
        m = ", node was:" + JSON.stringify(s);
      } catch {
        m = "";
      }
      throw new Error("Cyclic dependency" + m);
    }
    if (!l.has(s))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(s));
    if (!a[f]) {
      a[f] = !0;
      var w = o.get(s) || /* @__PURE__ */ new Set();
      if (w = Array.from(w), f = w.length) {
        p.add(s);
        do {
          var S = w[--f];
          h(S, l.get(S), p);
        } while (f);
        p.delete(s);
      }
      n[--t] = s;
    }
  }
}
function OC(e) {
  for (var r = /* @__PURE__ */ new Set(), t = 0, n = e.length; t < n; t++) {
    var a = e[t];
    r.add(a[0]), r.add(a[1]);
  }
  return Array.from(r);
}
function CC(e) {
  for (var r = /* @__PURE__ */ new Map(), t = 0, n = e.length; t < n; t++) {
    var a = e[t];
    r.has(a[0]) || r.set(a[0], /* @__PURE__ */ new Set()), r.has(a[1]) || r.set(a[1], /* @__PURE__ */ new Set()), r.get(a[0]).add(a[1]);
  }
  return r;
}
function kC(e) {
  for (var r = /* @__PURE__ */ new Map(), t = 0, n = e.length; t < n; t++)
    r.set(e[t], t);
  return r;
}
var DC = Cc.exports;
const jC = /* @__PURE__ */ yo(DC), MC = Object.prototype.toString, PC = Error.prototype.toString, AC = RegExp.prototype.toString, RC = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", IC = /^Symbol\((.*)\)(.*)$/;
function NC(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function ih(e, r = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const t = typeof e;
  if (t === "number")
    return NC(e);
  if (t === "string")
    return r ? `"${e}"` : e;
  if (t === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (t === "symbol")
    return RC.call(e).replace(IC, "Symbol($1)");
  const n = MC.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + PC.call(e) + "]" : n === "RegExp" ? AC.call(e) : null;
}
function In(e, r) {
  let t = ih(e, r);
  return t !== null ? t : JSON.stringify(e, function(n, a) {
    let i = ih(this[n], r);
    return i !== null ? i : a;
  }, 2);
}
function mg(e) {
  return e == null ? [] : [].concat(e);
}
let bg, _g, wg, LC = /\$\{\s*(\w+)\s*\}/g;
bg = Symbol.toStringTag;
class ah {
  constructor(r, t, n, a) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[bg] = "Error", this.name = "ValidationError", this.value = t, this.path = n, this.type = a, this.errors = [], this.inner = [], mg(r).forEach((i) => {
      if (Nt.isError(i)) {
        this.errors.push(...i.errors);
        const o = i.inner.length ? i.inner : [i];
        this.inner.push(...o);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_g = Symbol.hasInstance;
wg = Symbol.toStringTag;
class Nt extends Error {
  static formatError(r, t) {
    const n = t.label || t.path || "this";
    return n !== t.path && (t = Object.assign({}, t, {
      path: n
    })), typeof r == "string" ? r.replace(LC, (a, i) => In(t[i])) : typeof r == "function" ? r(t) : r;
  }
  static isError(r) {
    return r && r.name === "ValidationError";
  }
  constructor(r, t, n, a, i) {
    const o = new ah(r, t, n, a);
    if (i)
      return o;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[wg] = "Error", this.name = o.name, this.message = o.message, this.type = o.type, this.value = o.value, this.path = o.path, this.errors = o.errors, this.inner = o.inner, Error.captureStackTrace && Error.captureStackTrace(this, Nt);
  }
  static [_g](r) {
    return ah[Symbol.hasInstance](r) || super[Symbol.hasInstance](r);
  }
}
let kr = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: r,
    value: t,
    originalValue: n
  }) => {
    const a = n != null && n !== t ? ` (cast from the value \`${In(n, !0)}\`).` : ".";
    return r !== "mixed" ? `${e} must be a \`${r}\` type, but the final value was: \`${In(t, !0)}\`` + a : `${e} must match the configured type. The validated value was: \`${In(t, !0)}\`` + a;
  }
}, At = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, FC = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, ml = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, $C = {
  isValue: "${path} field must be ${value}"
}, bl = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, YC = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, UC = {
  notType: (e) => {
    const {
      path: r,
      value: t,
      spec: n
    } = e, a = n.types.length;
    if (Array.isArray(t)) {
      if (t.length < a)
        return `${r} tuple value has too few items, expected a length of ${a} but got ${t.length} for value: \`${In(t, !0)}\``;
      if (t.length > a)
        return `${r} tuple value has too many items, expected a length of ${a} but got ${t.length} for value: \`${In(t, !0)}\``;
    }
    return Nt.formatError(kr.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: kr,
  string: At,
  number: FC,
  date: ml,
  object: bl,
  array: YC,
  boolean: $C,
  tuple: UC
});
const kc = (e) => e && e.__isYupSchema__;
class ao {
  static fromOptions(r, t) {
    if (!t.then && !t.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: a,
      otherwise: i
    } = t, o = typeof n == "function" ? n : (...l) => l.every((h) => h === n);
    return new ao(r, (l, h) => {
      var s;
      let f = o(...l) ? a : i;
      return (s = f == null ? void 0 : f(h)) != null ? s : h;
    });
  }
  constructor(r, t) {
    this.fn = void 0, this.refs = r, this.refs = r, this.fn = t;
  }
  resolve(r, t) {
    let n = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)
    )), a = this.fn(n, r, t);
    if (a === void 0 || // @ts-ignore this can be base
    a === r)
      return r;
    if (!kc(a))
      throw new TypeError("conditions must return a schema object");
    return a.resolve(t);
  }
}
const ks = {
  context: "$",
  value: "."
};
class xi {
  constructor(r, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof r != "string")
      throw new TypeError("ref must be a string, got: " + r);
    if (this.key = r.trim(), r === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === ks.context, this.isValue = this.key[0] === ks.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? ks.context : this.isValue ? ks.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && ci.getter(this.path, !0), this.map = t.map;
  }
  getValue(r, t, n) {
    let a = this.isContext ? n : this.isValue ? r : t;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(r, t) {
    return this.getValue(r, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(r) {
    return r && r.__isYupRef;
  }
}
xi.prototype.__isYupRef = !0;
const oi = (e) => e == null;
function Fi(e) {
  function r({
    value: t,
    path: n = "",
    options: a,
    originalValue: i,
    schema: o
  }, l, h) {
    const {
      name: s,
      test: f,
      params: p,
      message: m,
      skipAbsent: w
    } = e;
    let {
      parent: S,
      context: E,
      abortEarly: x = o.spec.abortEarly,
      disableStackTrace: j = o.spec.disableStackTrace
    } = a;
    function O(K) {
      return xi.isRef(K) ? K.getValue(t, S, E) : K;
    }
    function I(K = {}) {
      const ve = Object.assign({
        value: t,
        originalValue: i,
        label: o.spec.label,
        path: K.path || n,
        spec: o.spec,
        disableStackTrace: K.disableStackTrace || j
      }, p, K.params);
      for (const qe of Object.keys(ve))
        ve[qe] = O(ve[qe]);
      const q = new Nt(Nt.formatError(K.message || m, ve), t, ve.path, K.type || s, ve.disableStackTrace);
      return q.params = ve, q;
    }
    const M = x ? l : h;
    let k = {
      path: n,
      parent: S,
      type: s,
      from: a.from,
      createError: I,
      resolve: O,
      options: a,
      originalValue: i,
      schema: o
    };
    const fe = (K) => {
      Nt.isError(K) ? M(K) : K ? h(null) : M(I());
    }, ae = (K) => {
      Nt.isError(K) ? M(K) : l(K);
    };
    if (w && oi(t))
      return fe(!0);
    let ue;
    try {
      var be;
      if (ue = f.call(k, t, k), typeof ((be = ue) == null ? void 0 : be.then) == "function") {
        if (a.sync)
          throw new Error(`Validation test of type: "${k.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(ue).then(fe, ae);
      }
    } catch (K) {
      ae(K);
      return;
    }
    fe(ue);
  }
  return r.OPTIONS = e, r;
}
function zC(e, r, t, n = t) {
  let a, i, o;
  return r ? (ci.forEach(r, (l, h, s) => {
    let f = h ? l.slice(1, l.length - 1) : l;
    e = e.resolve({
      context: n,
      parent: a,
      value: t
    });
    let p = e.type === "tuple", m = s ? parseInt(f, 10) : 0;
    if (e.innerType || p) {
      if (p && !s)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
      if (t && m >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${l}, in the path: ${r}. because there is no value at that index. `);
      a = t, t = t && t[m], e = p ? e.spec.types[m] : e.innerType;
    }
    if (!s) {
      if (!e.fields || !e.fields[f])
        throw new Error(`The schema does not contain the path: ${r}. (failed at: ${o} which is a type: "${e.type}")`);
      a = t, t = t && t[f], e = e.fields[f];
    }
    i = f, o = h ? "[" + l + "]" : "." + l;
  }), {
    schema: e,
    parent: a,
    parentPath: i
  }) : {
    parent: a,
    parentPath: r,
    schema: e
  };
}
class so extends Set {
  describe() {
    const r = [];
    for (const t of this.values())
      r.push(xi.isRef(t) ? t.describe() : t);
    return r;
  }
  resolveAll(r) {
    let t = [];
    for (const n of this.values())
      t.push(r(n));
    return t;
  }
  clone() {
    return new so(this.values());
  }
  merge(r, t) {
    const n = this.clone();
    return r.forEach((a) => n.add(a)), t.forEach((a) => n.delete(a)), n;
  }
}
function Bi(e, r = /* @__PURE__ */ new Map()) {
  if (kc(e) || !e || typeof e != "object")
    return e;
  if (r.has(e))
    return r.get(e);
  let t;
  if (e instanceof Date)
    t = new Date(e.getTime()), r.set(e, t);
  else if (e instanceof RegExp)
    t = new RegExp(e), r.set(e, t);
  else if (Array.isArray(e)) {
    t = new Array(e.length), r.set(e, t);
    for (let n = 0; n < e.length; n++)
      t[n] = Bi(e[n], r);
  } else if (e instanceof Map) {
    t = /* @__PURE__ */ new Map(), r.set(e, t);
    for (const [n, a] of e.entries())
      t.set(n, Bi(a, r));
  } else if (e instanceof Set) {
    t = /* @__PURE__ */ new Set(), r.set(e, t);
    for (const n of e)
      t.add(Bi(n, r));
  } else if (e instanceof Object) {
    t = {}, r.set(e, t);
    for (const [n, a] of Object.entries(e))
      t[n] = Bi(a, r);
  } else
    throw Error(`Unable to clone ${e}`);
  return t;
}
class Ir {
  constructor(r) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new so(), this._blacklist = new so(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(kr.notType);
    }), this.type = r.type, this._typeCheck = r.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, r == null ? void 0 : r.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(r) {
    if (this._mutate)
      return r && Object.assign(this.spec, r), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = Bi(Object.assign({}, this.spec, r)), t;
  }
  label(r) {
    let t = this.clone();
    return t.spec.label = r, t;
  }
  meta(...r) {
    if (r.length === 0)
      return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, r[0]), t;
  }
  withMutation(r) {
    let t = this._mutate;
    this._mutate = !0;
    let n = r(this);
    return this._mutate = t, n;
  }
  concat(r) {
    if (!r || r === this)
      return this;
    if (r.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${r.type}`);
    let t = this, n = r.clone();
    const a = Object.assign({}, t.spec, n.spec);
    return n.spec = a, n.internalTests = Object.assign({}, t.internalTests, n.internalTests), n._whitelist = t._whitelist.merge(r._whitelist, r._blacklist), n._blacklist = t._blacklist.merge(r._blacklist, r._whitelist), n.tests = t.tests, n.exclusiveTests = t.exclusiveTests, n.withMutation((i) => {
      r.tests.forEach((o) => {
        i.test(o.OPTIONS);
      });
    }), n.transforms = [...t.transforms, ...n.transforms], n;
  }
  isType(r) {
    return r == null ? !!(this.spec.nullable && r === null || this.spec.optional && r === void 0) : this._typeCheck(r);
  }
  resolve(r) {
    let t = this;
    if (t.conditions.length) {
      let n = t.conditions;
      t = t.clone(), t.conditions = [], t = n.reduce((a, i) => i.resolve(a, r), t), t = t.resolve(r);
    }
    return t;
  }
  resolveOptions(r) {
    var t, n, a, i;
    return Object.assign({}, r, {
      from: r.from || [],
      strict: (t = r.strict) != null ? t : this.spec.strict,
      abortEarly: (n = r.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (a = r.recursive) != null ? a : this.spec.recursive,
      disableStackTrace: (i = r.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(r, t = {}) {
    let n = this.resolve(Object.assign({
      value: r
    }, t)), a = t.assert === "ignore-optionality", i = n._cast(r, t);
    if (t.assert !== !1 && !n.isType(i)) {
      if (a && oi(i))
        return i;
      let o = In(r), l = In(i);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${o} 
` + (l !== o ? `result of cast: ${l}` : ""));
    }
    return i;
  }
  _cast(r, t) {
    let n = r === void 0 ? r : this.transforms.reduce((a, i) => i.call(this, a, r, this), r);
    return n === void 0 && (n = this.getDefault(t)), n;
  }
  _validate(r, t = {}, n, a) {
    let {
      path: i,
      originalValue: o = r,
      strict: l = this.spec.strict
    } = t, h = r;
    l || (h = this._cast(h, Object.assign({
      assert: !1
    }, t)));
    let s = [];
    for (let f of Object.values(this.internalTests))
      f && s.push(f);
    this.runTests({
      path: i,
      value: h,
      originalValue: o,
      options: t,
      tests: s
    }, n, (f) => {
      if (f.length)
        return a(f, h);
      this.runTests({
        path: i,
        value: h,
        originalValue: o,
        options: t,
        tests: this.tests
      }, n, a);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(r, t, n) {
    let a = !1, {
      tests: i,
      value: o,
      originalValue: l,
      path: h,
      options: s
    } = r, f = (E) => {
      a || (a = !0, t(E, o));
    }, p = (E) => {
      a || (a = !0, n(E, o));
    }, m = i.length, w = [];
    if (!m)
      return p([]);
    let S = {
      value: o,
      originalValue: l,
      path: h,
      options: s,
      schema: this
    };
    for (let E = 0; E < i.length; E++) {
      const x = i[E];
      x(S, f, function(O) {
        O && (Array.isArray(O) ? w.push(...O) : w.push(O)), --m <= 0 && p(w);
      });
    }
  }
  asNestedTest({
    key: r,
    index: t,
    parent: n,
    parentPath: a,
    originalParent: i,
    options: o
  }) {
    const l = r ?? t;
    if (l == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const h = typeof l == "number";
    let s = n[l];
    const f = Object.assign({}, o, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: s,
      originalValue: i[l],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [h ? "index" : "key"]: l,
      path: h || l.includes(".") ? `${a || ""}[${h ? l : `"${l}"`}]` : (a ? `${a}.` : "") + r
    });
    return (p, m, w) => this.resolve(f)._validate(s, f, m, w);
  }
  validate(r, t) {
    var n;
    let a = this.resolve(Object.assign({}, t, {
      value: r
    })), i = (n = t == null ? void 0 : t.disableStackTrace) != null ? n : a.spec.disableStackTrace;
    return new Promise((o, l) => a._validate(r, t, (h, s) => {
      Nt.isError(h) && (h.value = s), l(h);
    }, (h, s) => {
      h.length ? l(new Nt(h, s, void 0, void 0, i)) : o(s);
    }));
  }
  validateSync(r, t) {
    var n;
    let a = this.resolve(Object.assign({}, t, {
      value: r
    })), i, o = (n = t == null ? void 0 : t.disableStackTrace) != null ? n : a.spec.disableStackTrace;
    return a._validate(r, Object.assign({}, t, {
      sync: !0
    }), (l, h) => {
      throw Nt.isError(l) && (l.value = h), l;
    }, (l, h) => {
      if (l.length)
        throw new Nt(l, r, void 0, void 0, o);
      i = h;
    }), i;
  }
  isValid(r, t) {
    return this.validate(r, t).then(() => !0, (n) => {
      if (Nt.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(r, t) {
    try {
      return this.validateSync(r, t), !0;
    } catch (n) {
      if (Nt.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault(r) {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this, r) : Bi(t);
  }
  getDefault(r) {
    return this.resolve(r || {})._getDefault(r);
  }
  default(r) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: r
    });
  }
  strict(r = !0) {
    return this.clone({
      strict: r
    });
  }
  nullability(r, t) {
    const n = this.clone({
      nullable: r
    });
    return n.internalTests.nullable = Fi({
      message: t,
      name: "nullable",
      test(a) {
        return a === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(r, t) {
    const n = this.clone({
      optional: r
    });
    return n.internalTests.optionality = Fi({
      message: t,
      name: "optionality",
      test(a) {
        return a === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(r = kr.defined) {
    return this.optionality(!1, r);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(r = kr.notNull) {
    return this.nullability(!1, r);
  }
  required(r = kr.required) {
    return this.clone().withMutation((t) => t.nonNullable(r).defined(r));
  }
  notRequired() {
    return this.clone().withMutation((r) => r.nullable().optional());
  }
  transform(r) {
    let t = this.clone();
    return t.transforms.push(r), t;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...r) {
    let t;
    if (r.length === 1 ? typeof r[0] == "function" ? t = {
      test: r[0]
    } : t = r[0] : r.length === 2 ? t = {
      name: r[0],
      test: r[1]
    } : t = {
      name: r[0],
      message: r[1],
      test: r[2]
    }, t.message === void 0 && (t.message = kr.default), typeof t.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), a = Fi(t), i = t.exclusive || t.name && n.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (n.exclusiveTests[t.name] = !!t.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === t.name && (i || o.OPTIONS.test === a.OPTIONS.test))), n.tests.push(a), n;
  }
  when(r, t) {
    !Array.isArray(r) && typeof r != "string" && (t = r, r = ".");
    let n = this.clone(), a = mg(r).map((i) => new xi(i));
    return a.forEach((i) => {
      i.isSibling && n.deps.push(i.key);
    }), n.conditions.push(typeof t == "function" ? new ao(a, t) : ao.fromOptions(a, t)), n;
  }
  typeError(r) {
    let t = this.clone();
    return t.internalTests.typeError = Fi({
      message: r,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), t;
  }
  oneOf(r, t = kr.oneOf) {
    let n = this.clone();
    return r.forEach((a) => {
      n._whitelist.add(a), n._blacklist.delete(a);
    }), n.internalTests.whiteList = Fi({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(a) {
        let i = this.schema._whitelist, o = i.resolveAll(this.resolve);
        return o.includes(a) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(r, t = kr.notOneOf) {
    let n = this.clone();
    return r.forEach((a) => {
      n._blacklist.add(a), n._whitelist.delete(a);
    }), n.internalTests.blacklist = Fi({
      message: t,
      name: "notOneOf",
      test(a) {
        let i = this.schema._blacklist, o = i.resolveAll(this.resolve);
        return o.includes(a) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(r = !0) {
    let t = this.clone();
    return t.spec.strip = r, t;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(r) {
    const t = (r ? this.resolve(r) : this).clone(), {
      label: n,
      meta: a,
      optional: i,
      nullable: o
    } = t.spec;
    return {
      meta: a,
      label: n,
      optional: i,
      nullable: o,
      default: t.getDefault(r),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((h) => ({
        name: h.OPTIONS.name,
        params: h.OPTIONS.params
      })).filter((h, s, f) => f.findIndex((p) => p.name === h.name) === s)
    };
  }
}
Ir.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  Ir.prototype[`${e}At`] = function(r, t, n = {}) {
    const {
      parent: a,
      parentPath: i,
      schema: o
    } = zC(this, r, t, n.context);
    return o[e](a && a[i], Object.assign({}, n, {
      parent: a,
      path: r
    }));
  };
for (const e of ["equals", "is"])
  Ir.prototype[e] = Ir.prototype.oneOf;
for (const e of ["not", "nope"])
  Ir.prototype[e] = Ir.prototype.notOneOf;
const WC = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function BC(e) {
  const r = _l(e);
  if (!r)
    return Date.parse ? Date.parse(e) : Number.NaN;
  if (r.z === void 0 && r.plusMinus === void 0)
    return new Date(r.year, r.month, r.day, r.hour, r.minute, r.second, r.millisecond).valueOf();
  let t = 0;
  return r.z !== "Z" && r.plusMinus !== void 0 && (t = r.hourOffset * 60 + r.minuteOffset, r.plusMinus === "+" && (t = 0 - t)), Date.UTC(r.year, r.month, r.day, r.hour, r.minute + t, r.second, r.millisecond);
}
function _l(e) {
  var r, t;
  const n = WC.exec(e);
  return n ? {
    year: rn(n[1]),
    month: rn(n[2], 1) - 1,
    day: rn(n[3], 1),
    hour: rn(n[4]),
    minute: rn(n[5]),
    second: rn(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      rn(n[7].substring(0, 3))
    ) : 0,
    precision: (r = (t = n[7]) == null ? void 0 : t.length) != null ? r : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: rn(n[10]),
    minuteOffset: rn(n[11])
  } : null;
}
function rn(e, r = 0) {
  return Number(e) || r;
}
let HC = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), GC = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), VC = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, KC = "^\\d{4}-\\d{2}-\\d{2}", qC = "\\d{2}:\\d{2}:\\d{2}", ZC = "(([+-]\\d{2}(:?\\d{2})?)|Z)", JC = new RegExp(`${KC}T${qC}(\\.\\d+)?${ZC}$`), XC = (e) => oi(e) || e === e.trim(), QC = {}.toString();
function Sg() {
  return new xg();
}
class xg extends Ir {
  constructor() {
    super({
      type: "string",
      check(r) {
        return r instanceof String && (r = r.valueOf()), typeof r == "string";
      }
    }), this.withMutation(() => {
      this.transform((r, t, n) => {
        if (!n.spec.coerce || n.isType(r) || Array.isArray(r))
          return r;
        const a = r != null && r.toString ? r.toString() : r;
        return a === QC ? r : a;
      });
    });
  }
  required(r) {
    return super.required(r).withMutation((t) => t.test({
      message: r || kr.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((r) => (r.tests = r.tests.filter((t) => t.OPTIONS.name !== "required"), r));
  }
  length(r, t = At.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: r
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(r);
      }
    });
  }
  min(r, t = At.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: r
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(r);
      }
    });
  }
  max(r, t = At.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: t,
      params: {
        max: r
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(r);
      }
    });
  }
  matches(r, t) {
    let n = !1, a, i;
    return t && (typeof t == "object" ? {
      excludeEmptyString: n = !1,
      message: a,
      name: i
    } = t : a = t), this.test({
      name: i || "matches",
      message: a || At.matches,
      params: {
        regex: r
      },
      skipAbsent: !0,
      test: (o) => o === "" && n || o.search(r) !== -1
    });
  }
  email(r = At.email) {
    return this.matches(HC, {
      name: "email",
      message: r,
      excludeEmptyString: !0
    });
  }
  url(r = At.url) {
    return this.matches(GC, {
      name: "url",
      message: r,
      excludeEmptyString: !0
    });
  }
  uuid(r = At.uuid) {
    return this.matches(VC, {
      name: "uuid",
      message: r,
      excludeEmptyString: !1
    });
  }
  datetime(r) {
    let t = "", n, a;
    return r && (typeof r == "object" ? {
      message: t = "",
      allowOffset: n = !1,
      precision: a = void 0
    } = r : t = r), this.matches(JC, {
      name: "datetime",
      message: t || At.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: t || At.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || n)
          return !0;
        const o = _l(i);
        return o ? !!o.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: t || At.datetime_precision,
      params: {
        precision: a
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || a == null)
          return !0;
        const o = _l(i);
        return o ? o.precision === a : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((r) => r === null ? "" : r);
  }
  trim(r = At.trim) {
    return this.transform((t) => t != null ? t.trim() : t).test({
      message: r,
      name: "trim",
      test: XC
    });
  }
  lowercase(r = At.lowercase) {
    return this.transform((t) => oi(t) ? t : t.toLowerCase()).test({
      message: r,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => oi(t) || t === t.toLowerCase()
    });
  }
  uppercase(r = At.uppercase) {
    return this.transform((t) => oi(t) ? t : t.toUpperCase()).test({
      message: r,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => oi(t) || t === t.toUpperCase()
    });
  }
}
Sg.prototype = xg.prototype;
let e9 = /* @__PURE__ */ new Date(""), t9 = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Ho extends Ir {
  constructor() {
    super({
      type: "date",
      check(r) {
        return t9(r) && !isNaN(r.getTime());
      }
    }), this.withMutation(() => {
      this.transform((r, t, n) => !n.spec.coerce || n.isType(r) || r === null ? r : (r = BC(r), isNaN(r) ? Ho.INVALID_DATE : new Date(r)));
    });
  }
  prepareParam(r, t) {
    let n;
    if (xi.isRef(r))
      n = r;
    else {
      let a = this.cast(r);
      if (!this._typeCheck(a))
        throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = a;
    }
    return n;
  }
  min(r, t = ml.min) {
    let n = this.prepareParam(r, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: r
      },
      skipAbsent: !0,
      test(a) {
        return a >= this.resolve(n);
      }
    });
  }
  max(r, t = ml.max) {
    let n = this.prepareParam(r, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: r
      },
      skipAbsent: !0,
      test(a) {
        return a <= this.resolve(n);
      }
    });
  }
}
Ho.INVALID_DATE = e9;
Ho.prototype;
function r9(e, r = []) {
  let t = [], n = /* @__PURE__ */ new Set(), a = new Set(r.map(([o, l]) => `${o}-${l}`));
  function i(o, l) {
    let h = ci.split(o)[0];
    n.add(h), a.has(`${l}-${h}`) || t.push([l, h]);
  }
  for (const o of Object.keys(e)) {
    let l = e[o];
    n.add(o), xi.isRef(l) && l.isSibling ? i(l.path, o) : kc(l) && "deps" in l && l.deps.forEach((h) => i(h, o));
  }
  return jC.array(Array.from(n), t).reverse();
}
function sh(e, r) {
  let t = 1 / 0;
  return e.some((n, a) => {
    var i;
    if ((i = r.path) != null && i.includes(n))
      return t = a, !0;
  }), t;
}
function Tg(e) {
  return (r, t) => sh(e, r) - sh(e, t);
}
const n9 = (e, r, t) => {
  if (typeof e != "string")
    return e;
  let n = e;
  try {
    n = JSON.parse(e);
  } catch {
  }
  return t.isType(n) ? n : e;
};
function Is(e) {
  if ("fields" in e) {
    const r = {};
    for (const [t, n] of Object.entries(e.fields))
      r[t] = Is(n);
    return e.setFields(r);
  }
  if (e.type === "array") {
    const r = e.optional();
    return r.innerType && (r.innerType = Is(r.innerType)), r;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Is)
  }) : "optional" in e ? e.optional() : e;
}
const i9 = (e, r) => {
  const t = [...ci.normalizePath(r)];
  if (t.length === 1)
    return t[0] in e;
  let n = t.pop(), a = ci.getter(ci.join(t), !0)(e);
  return !!(a && n in a);
};
let oh = (e) => Object.prototype.toString.call(e) === "[object Object]";
function a9(e, r) {
  let t = Object.keys(e.fields);
  return Object.keys(r).filter((n) => t.indexOf(n) === -1);
}
const s9 = Tg([]);
function Eg(e) {
  return new Og(e);
}
class Og extends Ir {
  constructor(r) {
    super({
      type: "object",
      check(t) {
        return oh(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = s9, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      r && this.shape(r);
    });
  }
  _cast(r, t = {}) {
    var n;
    let a = super._cast(r, t);
    if (a === void 0)
      return this.getDefault(t);
    if (!this._typeCheck(a))
      return a;
    let i = this.fields, o = (n = t.stripUnknown) != null ? n : this.spec.noUnknown, l = [].concat(this._nodes, Object.keys(a).filter((p) => !this._nodes.includes(p))), h = {}, s = Object.assign({}, t, {
      parent: h,
      __validating: t.__validating || !1
    }), f = !1;
    for (const p of l) {
      let m = i[p], w = p in a;
      if (m) {
        let S, E = a[p];
        s.path = (t.path ? `${t.path}.` : "") + p, m = m.resolve({
          value: E,
          context: t.context,
          parent: h
        });
        let x = m instanceof Ir ? m.spec : void 0, j = x == null ? void 0 : x.strict;
        if (x != null && x.strip) {
          f = f || p in a;
          continue;
        }
        S = !t.__validating || !j ? (
          // TODO: use _cast, this is double resolving
          m.cast(a[p], s)
        ) : a[p], S !== void 0 && (h[p] = S);
      } else
        w && !o && (h[p] = a[p]);
      (w !== p in h || h[p] !== a[p]) && (f = !0);
    }
    return f ? h : a;
  }
  _validate(r, t = {}, n, a) {
    let {
      from: i = [],
      originalValue: o = r,
      recursive: l = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: o
    }, ...i], t.__validating = !0, t.originalValue = o, super._validate(r, t, n, (h, s) => {
      if (!l || !oh(s)) {
        a(h, s);
        return;
      }
      o = o || s;
      let f = [];
      for (let p of this._nodes) {
        let m = this.fields[p];
        !m || xi.isRef(m) || f.push(m.asNestedTest({
          options: t,
          key: p,
          parent: s,
          parentPath: t.path,
          originalParent: o
        }));
      }
      this.runTests({
        tests: f,
        value: s,
        originalValue: o,
        options: t
      }, n, (p) => {
        a(p.sort(this._sortErrors).concat(h), s);
      });
    });
  }
  clone(r) {
    const t = super.clone(r);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(r) {
    let t = super.concat(r), n = t.fields;
    for (let [a, i] of Object.entries(this.fields)) {
      const o = n[a];
      n[a] = o === void 0 ? i : o;
    }
    return t.withMutation((a) => (
      // XXX: excludes here is wrong
      a.setFields(n, [...this._excludedEdges, ...r._excludedEdges])
    ));
  }
  _getDefault(r) {
    if ("default" in this.spec)
      return super._getDefault(r);
    if (!this._nodes.length)
      return;
    let t = {};
    return this._nodes.forEach((n) => {
      var a;
      const i = this.fields[n];
      let o = r;
      (a = o) != null && a.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[n]
      })), t[n] = i && "getDefault" in i ? i.getDefault(o) : void 0;
    }), t;
  }
  setFields(r, t) {
    let n = this.clone();
    return n.fields = r, n._nodes = r9(r, t), n._sortErrors = Tg(Object.keys(r)), t && (n._excludedEdges = t), n;
  }
  shape(r, t = []) {
    return this.clone().withMutation((n) => {
      let a = n._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), a = [...n._excludedEdges, ...t]), n.setFields(Object.assign(n.fields, r), a);
    });
  }
  partial() {
    const r = {};
    for (const [t, n] of Object.entries(this.fields))
      r[t] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(r);
  }
  deepPartial() {
    return Is(this);
  }
  pick(r) {
    const t = {};
    for (const n of r)
      this.fields[n] && (t[n] = this.fields[n]);
    return this.setFields(t, this._excludedEdges.filter(([n, a]) => r.includes(n) && r.includes(a)));
  }
  omit(r) {
    const t = [];
    for (const n of Object.keys(this.fields))
      r.includes(n) || t.push(n);
    return this.pick(t);
  }
  from(r, t, n) {
    let a = ci.getter(r, !0);
    return this.transform((i) => {
      if (!i)
        return i;
      let o = i;
      return i9(i, r) && (o = Object.assign({}, i), n || delete o[r], o[t] = a(i)), o;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(n9);
  }
  noUnknown(r = !0, t = bl.noUnknown) {
    typeof r != "boolean" && (t = r, r = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(a) {
        if (a == null)
          return !0;
        const i = a9(this.schema, a);
        return !r || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = r, n;
  }
  unknown(r = !0, t = bl.noUnknown) {
    return this.noUnknown(!r, t);
  }
  transformKeys(r) {
    return this.transform((t) => {
      if (!t)
        return t;
      const n = {};
      for (const a of Object.keys(t))
        n[r(a)] = t[a];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(Au.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Au.snakeCase);
  }
  constantCase() {
    return this.transformKeys((r) => Au.snakeCase(r).toUpperCase());
  }
  describe(r) {
    const t = (r ? this.resolve(r) : this).clone(), n = super.describe(r);
    n.fields = {};
    for (const [i, o] of Object.entries(t.fields)) {
      var a;
      let l = r;
      (a = l) != null && a.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[i]
      })), n.fields[i] = o.describe(l);
    }
    return n;
  }
}
Eg.prototype = Og.prototype;
const o9 = Eg().shape({
  search: Sg()
}), Cg = ({
  keyword: e,
  handleFilterByKeyword: r
}) => {
  const t = (i) => {
    const o = i.search;
    r(o);
  }, n = (i) => /* @__PURE__ */ y.jsxs(lt, { children: [
    /* @__PURE__ */ y.jsx(
      fg,
      {
        placeholder: "Search",
        onSubmit: (o) => {
          o.preventDefault(), i.handleSubmit();
        },
        children: /* @__PURE__ */ y.jsx(fC, { ...i, handleFilterByKeyword: r })
      }
    ),
    !1
  ] }), a = { search: "" };
  return e && (a.search = e), /* @__PURE__ */ y.jsx(
    cg,
    {
      initialValues: a,
      validationSchema: o9,
      onSubmit: t,
      children: n
    }
  );
}, u9 = "_container_1vcpm_5", l9 = {
  container: u9
}, Bk = ({
  keyword: e,
  handleFilterByKeyword: r,
  title: t = "Search",
  ...n
}) => /* @__PURE__ */ y.jsxs(Ue, { className: l9.container, ...n, children: [
  /* @__PURE__ */ y.jsx(_t, { order: 6, children: t }),
  /* @__PURE__ */ y.jsx(
    Cg,
    {
      keyword: e,
      handleFilterByKeyword: r
    },
    "search-tool"
  )
] }), c9 = (e, r, t) => [...Array(Math.ceil((r - e) / t) + 1).keys()].map((n) => n === 0 || n === 0 ? e : n * t), f9 = ({
  min: e = 6,
  max: r = 90,
  step: t = 12,
  itemsPerPageSelected: n = 6,
  onChangeItemsPerPage: a = (i) => {
    console.debug(`default pageSize ${i}`);
  }
}) => {
  const o = c9(e, r, t).map((l) => ({
    label: l.toString(),
    value: l.toString()
  }));
  return /* @__PURE__ */ y.jsx(
    xl,
    {
      styles: { input: { maxWidth: "7em" } },
      data: o,
      value: n == null ? void 0 : n.toString(),
      onChange: a
    }
  );
}, Hk = ({
  limit: e,
  handleItemsPerPageChange: r,
  title: t = "Items Per Page",
  ...n
}) => /* @__PURE__ */ y.jsxs(Ue, { ...n, children: [
  /* @__PURE__ */ y.jsx(_t, { order: 6, children: t }),
  /* @__PURE__ */ y.jsx(
    f9,
    {
      itemsPerPageSelected: e,
      onChangeItemsPerPage: r
    }
  )
] }), Gk = ({
  handleConfirm: e,
  recordIdsLength: r = 0,
  disabled: t = !1,
  ...n
}) => {
  const [a, {
    open: i,
    close: o
  }] = hh(!1);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(
      d4,
      {
        disabled: t,
        onClick: i,
        ...n,
        children: r > 0 ? [De.get("Delete"), r, "Selected"].join(" ") : De.get("Delete")
      }
    ),
    /* @__PURE__ */ y.jsx(
      uh,
      {
        title: /* @__PURE__ */ y.jsx(_t, { order: 5, tt: "uppercase", children: /* @__PURE__ */ y.jsx(Ve, { children: De.get("Confirm Operation") }) }),
        withCloseButton: !1,
        onClose: o,
        opened: a,
        size: "lg",
        transitionProps: {
          transition: "fade",
          duration: 200
        },
        children: /* @__PURE__ */ y.jsxs(Ue, { children: [
          /* @__PURE__ */ y.jsxs(ee, { justify: "left", children: [
            /* @__PURE__ */ y.jsx(Zs.Provider, { value: {
              size: "3em",
              color: "orange"
            }, children: /* @__PURE__ */ y.jsx(ud, {}) }),
            /* @__PURE__ */ y.jsx(lt, { children: /* @__PURE__ */ y.jsx(Ve, { children: De.get("Are you sure you want to delete selected item(s)?") }) })
          ] }),
          /* @__PURE__ */ y.jsxs(ee, { justify: "right", children: [
            /* @__PURE__ */ y.jsx(Yl, { onClick: o }),
            /* @__PURE__ */ y.jsx(Y0, { leftSection: /* @__PURE__ */ y.jsx(ud, {}), onClick: (l) => {
              l.preventDefault(), e(), o();
            }, children: De.get("Confirm") })
          ] })
        ] })
      }
    )
  ] });
}, Vk = ({
  legend: e,
  ...r
}) => {
  const t = typeof e == "string" ? /* @__PURE__ */ y.jsx(_t, { order: 4, children: /* @__PURE__ */ y.jsx(Ve, { tt: "uppercase", children: e }) }) : e;
  return /* @__PURE__ */ y.jsx(mm, { legend: t, ...r });
}, $i = {
  termsOfService: {
    title: "Terms Of Service",
    url: "https://www.panasonic.aero/terms-of-use"
  },
  privacyPolicy: {
    title: "Privacy Policy",
    url: "https://www.panasonic.aero/privacy-policy"
  },
  contactUs: {
    title: "Contact Us",
    url: "https://www.panasonic.aero/contact-us"
  }
}, Kk = (e) => {
  let r = "_blank";
  const t = ["_blank", "_self", "_parent", "_top"];
  return typeof e.linksTarget < "u" && t.indexOf(e.linksTarget) !== -1 && (r = e.linksTarget), /* @__PURE__ */ y.jsx("footer", { children: /* @__PURE__ */ y.jsxs(Ue, { children: [
    /* @__PURE__ */ y.jsxs(ee, { justify: "center", children: [
      /* @__PURE__ */ y.jsx(hu, { href: $i.termsOfService.url, target: r, children: De.get($i.termsOfService.title) }),
      /* @__PURE__ */ y.jsx(hu, { href: $i.privacyPolicy.url, target: r, children: De.get($i.privacyPolicy.title) }),
      /* @__PURE__ */ y.jsx(hu, { href: $i.contactUs.url, target: r, children: De.get($i.contactUs.title) })
    ] }),
    /* @__PURE__ */ y.jsxs(ee, { justify: "center", children: [
      /* @__PURE__ */ y.jsxs(Ve, { children: [
        "Copyright ©",
        (/* @__PURE__ */ new Date()).getFullYear()
      ] }),
      /* @__PURE__ */ y.jsx(Ve, { children: "Panasonic Avionics Corporation." }),
      /* @__PURE__ */ y.jsx(Ve, { children: "All rights reserved." })
    ] })
  ] }) });
}, d9 = "_container_1fooh_5", h9 = {
  container: d9
}, y9 = (e) => /* @__PURE__ */ y.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 69",
    version: "1.1",
    ...e,
    children: /* @__PURE__ */ y.jsxs("g", { id: "surface1", children: [
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 32.691406 46.46875 L 20.378906 46.46875 L 20.378906 30.734375 L 28.378906 30.734375 C 29.894531 30.734375 31.183594 30.699219 32.699219 30.613281 C 34.738281 30.539062 36.621094 29.519531 37.808594 27.863281 C 38.457031 27.007812 38.867188 26 39.007812 24.9375 C 39.140625 24.007812 39.15625 23.210938 39.066406 22.265625 C 38.742188 18.78125 35.804688 16.121094 32.300781 16.140625 L 20.378906 16.140625 L 20.378906 67.15625 L 0 67.15625 L 0 0 L 33.300781 0 C 34.628906 0 35.746094 0.0234375 37.074219 0.0976562 C 45.914062 0.570312 53.199219 5.484375 56.941406 13.5 C 58.851562 17.464844 59.582031 21.894531 59.046875 26.265625 C 58.121094 35.761719 51.121094 43.550781 41.773438 45.488281 C 38.796875 46.160156 35.753906 46.488281 32.699219 46.46875 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 108.359375 63.398438 C 108.089844 59.445312 107.941406 56.101562 107.859375 52.132812 C 107.753906 46.921875 107.691406 42.53125 107.65625 37.320312 C 107.65625 34.652344 107.308594 31.992188 106.621094 29.414062 C 105.785156 25.960938 103.523438 23.023438 100.394531 21.335938 C 98.558594 20.296875 96.566406 19.550781 94.5 19.125 C 87.925781 17.648438 81.125 17.511719 74.496094 18.726562 C 72.546875 19.066406 70.921875 19.539062 69.082031 20.300781 C 64.949219 21.933594 61.800781 25.382812 60.546875 29.648438 C 60.035156 31.246094 59.878906 32.933594 60.089844 34.597656 C 60.121094 34.914062 60.203125 35.183594 60.34375 35.476562 L 76.492188 35.871094 C 76.441406 34.898438 76.589844 33.921875 76.925781 33.007812 C 77.417969 31.574219 78.539062 30.449219 79.972656 29.953125 C 82.039062 29.160156 84.320312 29.121094 86.414062 29.84375 C 87.824219 30.277344 88.921875 31.390625 89.339844 32.804688 C 89.609375 33.703125 89.476562 34.605469 88.925781 35.378906 C 88.476562 36.039062 87.832031 36.542969 87.082031 36.816406 C 86.601562 37.003906 86.183594 37.132812 85.695312 37.265625 C 83.570312 37.847656 81.417969 38.316406 79.246094 38.671875 C 77.429688 38.96875 75.898438 39.246094 74.101562 39.613281 C 71.78125 40.070312 69.496094 40.664062 67.253906 41.398438 C 65.179688 42.046875 63.285156 43.15625 61.703125 44.640625 C 59.582031 46.523438 58.21875 49.109375 57.863281 51.921875 C 57.585938 53.878906 57.652344 55.582031 58.085938 57.511719 C 59.113281 62.40625 62.789062 66.316406 67.613281 67.640625 C 72.832031 69.242188 78.449219 68.957031 83.484375 66.839844 C 85.941406 65.882812 88.109375 64.300781 89.765625 62.25 L 88.628906 54 C 87.867188 55.214844 86.75 56.164062 85.433594 56.722656 C 84.15625 57.285156 82.996094 57.585938 81.609375 57.726562 C 80.445312 57.839844 79.441406 57.757812 78.316406 57.441406 C 77.441406 57.214844 76.652344 56.742188 76.042969 56.078125 C 75.507812 55.519531 75.144531 54.820312 74.992188 54.058594 C 74.730469 52.878906 75.15625 51.65625 76.085938 50.886719 C 76.683594 50.367188 77.371094 49.96875 78.113281 49.703125 C 79.886719 49.046875 81.691406 48.460938 83.511719 47.949219 C 85.828125 47.296875 87.742188 46.589844 89.941406 45.578125 C 90.148438 47.332031 90.140625 48.832031 89.894531 50.578125 C 89.722656 51.863281 89.324219 52.921875 88.628906 54 L 89.765625 62.25 C 90.121094 63.421875 90.441406 64.394531 90.847656 65.550781 C 91.074219 66.1875 91.371094 66.683594 91.824219 67.183594 L 109.597656 67.183594 C 108.863281 66.054688 108.433594 64.75 108.359375 63.40625 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 129.621094 24.253906 C 131.847656 22.277344 134.359375 20.648438 137.070312 19.417969 C 141.492188 17.292969 146.554688 16.917969 151.246094 18.367188 C 156.375 19.78125 160.414062 23.730469 161.949219 28.824219 C 162.722656 31.203125 163.109375 33.691406 163.085938 36.195312 L 163.085938 67.15625 L 144.039062 67.15625 L 144.039062 39.316406 C 144.039062 38.386719 143.917969 37.589844 143.648438 36.703125 C 143.195312 35.148438 142.054688 33.882812 140.550781 33.277344 C 137.207031 31.835938 133.3125 33.125 131.488281 36.277344 C 130.734375 37.527344 130.34375 38.964844 130.363281 40.425781 L 130.363281 67.15625 L 111.914062 67.15625 L 111.914062 19.183594 L 129.21875 19.183594 L 129.621094 24.253906 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 216.058594 63.398438 C 215.789062 59.445312 215.640625 56.101562 215.558594 52.132812 C 215.453125 46.921875 215.390625 42.53125 215.355469 37.320312 C 215.355469 34.652344 215.007812 31.992188 214.320312 29.414062 C 213.488281 25.960938 211.222656 23.023438 208.09375 21.335938 C 206.257812 20.296875 204.269531 19.550781 202.199219 19.125 C 195.628906 17.648438 188.824219 17.511719 182.199219 18.726562 C 180.246094 19.066406 178.621094 19.539062 176.78125 20.300781 C 172.648438 21.933594 169.5 25.382812 168.246094 29.648438 C 167.734375 31.246094 167.578125 32.933594 167.789062 34.597656 C 167.820312 34.914062 167.902344 35.183594 168.046875 35.476562 L 184.191406 35.871094 C 184.144531 34.898438 184.289062 33.921875 184.628906 33.007812 C 185.117188 31.574219 186.242188 30.449219 187.671875 29.953125 C 189.738281 29.160156 192.019531 29.121094 194.113281 29.84375 C 195.523438 30.277344 196.621094 31.390625 197.039062 32.804688 C 197.308594 33.703125 197.175781 34.605469 196.628906 35.378906 C 196.175781 36.039062 195.53125 36.542969 194.78125 36.816406 C 194.300781 37.003906 193.882812 37.132812 193.394531 37.265625 C 191.269531 37.847656 189.117188 38.316406 186.945312 38.671875 C 185.128906 38.96875 183.601562 39.246094 181.800781 39.613281 C 179.484375 40.070312 177.195312 40.664062 174.953125 41.398438 C 172.882812 42.046875 170.984375 43.15625 169.402344 44.640625 C 167.28125 46.523438 165.917969 49.109375 165.5625 51.921875 C 165.285156 53.878906 165.351562 55.582031 165.789062 57.511719 C 166.8125 62.40625 170.488281 66.316406 175.3125 67.640625 C 180.535156 69.242188 186.148438 68.957031 191.183594 66.839844 C 193.640625 65.882812 195.808594 64.300781 197.46875 62.25 L 196.328125 54 C 195.566406 55.214844 194.453125 56.164062 193.132812 56.722656 C 191.859375 57.285156 190.695312 57.585938 189.308594 57.726562 C 188.144531 57.839844 187.140625 57.757812 186.015625 57.441406 C 185.140625 57.214844 184.351562 56.742188 183.742188 56.078125 C 183.207031 55.519531 182.84375 54.820312 182.691406 54.058594 C 182.429688 52.878906 182.855469 51.65625 183.789062 50.886719 C 184.382812 50.367188 185.070312 49.96875 185.8125 49.703125 C 187.589844 49.046875 189.390625 48.460938 191.210938 47.949219 C 193.53125 47.296875 195.441406 46.589844 197.640625 45.578125 C 197.851562 47.332031 197.84375 48.832031 197.59375 50.578125 C 197.421875 51.863281 197.023438 52.921875 196.328125 54 L 197.46875 62.25 C 197.820312 63.421875 198.140625 64.394531 198.546875 65.550781 C 198.773438 66.1875 199.074219 66.683594 199.523438 67.183594 L 217.296875 67.183594 C 216.5625 66.054688 216.136719 64.75 216.058594 63.40625 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 242.683594 49.523438 C 244.058594 49.753906 245.203125 50.046875 246.523438 50.484375 C 247.601562 50.820312 248.410156 51.722656 248.625 52.828125 C 248.902344 54.023438 248.535156 55.273438 247.65625 56.128906 C 246.804688 57.011719 245.683594 57.585938 244.46875 57.757812 C 242.773438 58.027344 241.273438 57.890625 239.671875 57.308594 C 238.921875 57.046875 238.226562 56.652344 237.621094 56.144531 C 236.824219 55.492188 236.242188 54.613281 235.949219 53.625 C 235.6875 52.796875 235.566406 51.933594 235.589844 51.066406 L 218.023438 51.066406 L 218.023438 52.085938 C 218.023438 53.738281 218.28125 55.140625 218.859375 56.691406 C 219.742188 59.015625 220.949219 60.816406 222.773438 62.511719 C 225.019531 64.652344 227.765625 66.199219 230.761719 67.011719 C 236.929688 68.84375 243.429688 69.253906 249.78125 68.210938 C 252.761719 67.78125 255.644531 66.84375 258.308594 65.4375 C 259.488281 64.828125 260.597656 64.085938 261.609375 63.226562 C 266.324219 59.382812 268.164062 53.015625 266.226562 47.25 C 265.570312 45.121094 264.316406 43.222656 262.613281 41.78125 C 260.324219 39.757812 257.605469 38.277344 254.664062 37.453125 L 252.742188 36.90625 C 249.175781 35.902344 245.546875 35.132812 241.882812 34.597656 C 240.847656 34.449219 239.976562 34.28125 238.957031 34.042969 C 238.511719 33.9375 238.074219 33.785156 237.660156 33.59375 C 236.578125 33.109375 236.09375 31.839844 236.578125 30.757812 L 236.664062 30.59375 C 237.207031 29.589844 238.136719 28.855469 239.234375 28.550781 C 241.246094 27.976562 243.089844 28.027344 245.0625 28.6875 C 246.929688 29.304688 248.152344 31.097656 248.046875 33.058594 L 264.984375 33.058594 C 264.984375 31.085938 264.632812 29.125 263.949219 27.269531 C 263.289062 25.367188 262.082031 23.695312 260.484375 22.46875 C 259.121094 21.375 257.59375 20.503906 255.960938 19.890625 C 254.375 19.265625 252.734375 18.808594 251.054688 18.523438 C 247.078125 17.8125 243.03125 17.585938 239.003906 17.851562 C 236.574219 17.984375 234.523438 18.285156 232.148438 18.839844 C 228.953125 19.589844 226.371094 20.828125 223.792969 22.851562 C 221.671875 24.472656 220.085938 26.691406 219.238281 29.21875 C 218.214844 32.277344 218.328125 35.597656 219.554688 38.578125 C 220.847656 41.984375 223.539062 44.671875 226.941406 45.96875 C 228.71875 46.671875 230.273438 47.136719 232.148438 47.519531 C 235.84375 48.285156 238.972656 48.878906 242.691406 49.515625 M 300.226562 18.269531 C 298.328125 17.96875 296.707031 17.84375 294.789062 17.84375 C 292.867188 17.84375 291.253906 17.96875 289.351562 18.269531 C 284.066406 19.023438 279.160156 21.457031 275.363281 25.207031 C 271.167969 29.117188 268.597656 34.460938 268.164062 40.175781 C 267.816406 43.644531 268.136719 47.148438 269.101562 50.496094 C 270.601562 55.914062 273.433594 60.097656 277.898438 63.511719 C 280.671875 65.691406 283.914062 67.195312 287.371094 67.90625 C 289.808594 68.453125 292.296875 68.71875 294.796875 68.699219 C 297.421875 68.699219 299.640625 68.476562 302.210938 67.90625 C 305.667969 67.195312 308.910156 65.6875 311.683594 63.511719 L 301.378906 52.273438 C 299.742188 55.914062 295.464844 57.539062 291.824219 55.898438 C 290.199219 55.195312 288.90625 53.898438 288.203125 52.273438 C 287.527344 50.804688 287.070312 49.246094 286.84375 47.648438 C 286.335938 44.273438 286.394531 41.347656 287.046875 38.003906 C 287.386719 36.269531 287.96875 34.851562 288.9375 33.367188 C 290.234375 31.398438 292.429688 30.214844 294.789062 30.214844 C 297.144531 30.214844 299.339844 31.398438 300.636719 33.367188 C 301.578125 34.765625 302.222656 36.34375 302.527344 38.003906 C 303.179688 41.355469 303.246094 44.28125 302.738281 47.648438 C 302.484375 49.335938 302.078125 50.722656 301.378906 52.273438 L 311.683594 63.511719 C 316.007812 60.296875 319.109375 55.707031 320.476562 50.496094 C 321.457031 46.972656 321.742188 43.824219 321.414062 40.175781 C 320.980469 34.460938 318.410156 29.113281 314.210938 25.207031 C 310.414062 21.453125 305.511719 19.023438 300.226562 18.269531 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 341.789062 24.253906 C 344.015625 22.277344 346.527344 20.648438 349.238281 19.417969 C 353.660156 17.292969 358.722656 16.917969 363.414062 18.367188 C 368.539062 19.78125 372.582031 23.730469 374.113281 28.824219 C 374.890625 31.203125 375.277344 33.691406 375.253906 36.195312 L 375.253906 67.15625 L 356.203125 67.15625 L 356.203125 39.316406 C 356.203125 38.386719 356.085938 37.589844 355.816406 36.703125 C 355.363281 35.148438 354.222656 33.882812 352.71875 33.277344 C 349.375 31.835938 345.480469 33.125 343.65625 36.277344 C 342.902344 37.527344 342.511719 38.964844 342.53125 40.425781 L 342.53125 67.15625 L 324.082031 67.15625 L 324.082031 19.183594 L 341.386719 19.183594 L 341.789062 24.253906 "
        }
      ),
      /* @__PURE__ */ y.jsx(
        "path",
        {
          style: {
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,110%,100%)",
            fillOpacity: "1"
          },
          d: "M 378.945312 0 L 378.945312 12.675781 L 396.878906 12.675781 L 396.878906 0 Z M 378.945312 19.191406 L 378.945312 67.164062 L 396.878906 67.164062 L 396.878906 19.191406 Z M 445.050781 60.9375 C 441.632812 64.632812 437.113281 67.128906 432.164062 68.054688 C 428.683594 68.761719 425.640625 68.910156 422.109375 68.542969 C 417.625 68.140625 413.347656 66.472656 409.777344 63.726562 C 406.820312 61.570312 404.355469 58.800781 402.554688 55.613281 C 401.117188 53.171875 400.152344 50.476562 399.71875 47.675781 C 399.046875 43.597656 399.226562 40.011719 400.296875 36.023438 C 402.75 26.949219 409.566406 20.519531 418.769531 18.609375 C 424.019531 17.519531 428.683594 17.632812 433.882812 18.976562 C 437.421875 19.84375 440.671875 21.625 443.308594 24.140625 C 445 25.683594 446.394531 27.515625 447.433594 29.550781 C 448.726562 31.9375 449.316406 34.640625 449.136719 37.351562 L 432.734375 37.351562 C 432.425781 35.230469 431.28125 33.324219 429.554688 32.054688 C 427.328125 30.308594 424.238281 30.160156 421.851562 31.679688 C 420.226562 32.65625 419.023438 34.203125 418.476562 36.023438 C 417.074219 40.289062 417 44.882812 418.265625 49.191406 C 418.753906 51.019531 419.75 52.667969 421.140625 53.949219 C 422.703125 55.484375 424.902344 56.179688 427.066406 55.824219 C 428.410156 55.648438 429.644531 54.988281 430.53125 53.960938 C 431.480469 52.933594 432.105469 51.648438 432.328125 50.265625 C 432.511719 49.253906 432.609375 48.390625 432.667969 47.363281 L 449.953125 47.363281 C 450.371094 52.386719 448.578125 57.339844 445.050781 60.9375 "
        }
      )
    ] })
  }
), g9 = () => /* @__PURE__ */ y.jsx(
  oo,
  {
    variant: "subtle",
    onClick: () => window.location.href = "/",
    title: "Home",
    children: /* @__PURE__ */ y.jsx(y9, { width: "100%", height: "80%" })
  }
), p9 = ({
  tools: e
}) => /* @__PURE__ */ y.jsx(ee, { gap: "xs", mr: "xs", children: typeof e < "u" ? e.map((r, t) => /* @__PURE__ */ y.jsx(lt, { children: r }, t)) : null }), Go = (e) => {
  const r = {
    dev: "https://portal-dev.nextcloud.aero",
    test: "https://portal-test.nextcloud.aero",
    prd: "https://portal.nextcloud.aero"
  };
  return typeof e < "u" && ["dev", "test", "prd"].indexOf(e.toString().toLowerCase()) !== -1 ? r[e] : r.prd;
}, qk = ({
  stage: e = "prd",
  clickHandler: r
}) => (typeof r > "u" && (r = (t) => {
  t.preventDefault();
  const n = [Go(e), "user/notifications"].join("/");
  window.open(n);
}), /* @__PURE__ */ y.jsxs(ir, { onClick: r, children: [
  " ",
  /* @__PURE__ */ y.jsx(t4, { size: "1.4rem" }),
  " "
] })), Zk = ({
  stage: e = "prd",
  clickHandler: r
}) => (typeof r > "u" && (r = (t) => {
  t.preventDefault();
  const n = [Go(e), "user/settings"].join("/");
  window.open(n);
}), /* @__PURE__ */ y.jsx(ir, { onClick: r, children: /* @__PURE__ */ y.jsx(Oo, { size: "1.4rem" }) })), Jk = ({
  logo: e,
  toolbar: r
}) => /* @__PURE__ */ y.jsxs(ee, { justify: "space-between", className: h9.container, children: [
  e || /* @__PURE__ */ y.jsx(g9, {}),
  r || /* @__PURE__ */ y.jsx(p9, {})
] }), v9 = ({ stage: e = "prd" }) => {
  const r = [Go(e), "profile"].join("/");
  return /* @__PURE__ */ y.jsx(
    Xe.Item,
    {
      leftSection: /* @__PURE__ */ y.jsx(l4, { size: "1.3rem", stroke: "1.5" }),
      onClick: () => window.open(r),
      children: De.get("Profile")
    }
  );
}, m9 = ({ stage: e = "prd" }) => {
  const r = [Go(e), "user-settings"].join("/");
  return /* @__PURE__ */ y.jsx(
    Xe.Item,
    {
      leftSection: /* @__PURE__ */ y.jsx(Oo, { size: "1.3rem", stroke: "1.5" }),
      onClick: () => window.open(r),
      children: De.get("Settings")
    }
  );
}, b9 = "_container_13928_1", _9 = "_userAvatar_13928_5", w9 = "_userInfoContainer_13928_9", S9 = "_userName_13928_14", x9 = "_userEmail_13928_19", Yi = {
  container: b9,
  userAvatar: _9,
  userInfoContainer: w9,
  userName: S9,
  userEmail: x9
}, Xk = ({
  user: e = {
    name: "",
    "email-address": ""
  },
  stage: r = "prd",
  showDefaultMenuItems: t = !1,
  additionalMenuItems: n = []
}) => {
  const a = [];
  return t && (a.push(/* @__PURE__ */ y.jsx(v9, { stage: r })), a.push(/* @__PURE__ */ y.jsx(m9, { stage: r }))), Array.isArray(n) && n.forEach((i) => {
    a.push(/* @__PURE__ */ y.jsx(
      Xe.Item,
      {
        leftSection: i.icon,
        onClick: i.onClick,
        children: De.get(i.title)
      }
    ));
  }), /* @__PURE__ */ y.jsx(lt, { className: Yi.container, children: /* @__PURE__ */ y.jsxs(Xe, { position: "bottom-end", width: "14rem", children: [
    /* @__PURE__ */ y.jsx(Xe.Target, { children: /* @__PURE__ */ y.jsx(
      oo,
      {
        size: "lg",
        variant: "subtle",
        radius: "xs",
        leftSection: e.avatar ? /* @__PURE__ */ y.jsx(
          Iu,
          {
            src: e.avatar,
            size: "md",
            radius: "xl",
            className: Yi.userAvatar
          }
        ) : /* @__PURE__ */ y.jsx(
          Iu,
          {
            name: e.name,
            size: "md",
            radius: "xl",
            className: Yi.userAvatar,
            color: "initials"
          }
        ),
        rightSection: /* @__PURE__ */ y.jsx(
          r4,
          {
            size: 16,
            stroke: "1.5",
            color: "#fff"
          }
        ),
        children: /* @__PURE__ */ y.jsxs(Ue, { gap: 0, className: Yi.userInfoContainer, children: [
          /* @__PURE__ */ y.jsx(Ve, { className: Yi.userName, children: e == null ? void 0 : e.name }),
          /* @__PURE__ */ y.jsx(Ve, { className: Yi.userEmail, children: e == null ? void 0 : e["email-address"] })
        ] })
      }
    ) }),
    /* @__PURE__ */ y.jsx(Xe.Dropdown, { children: a.length > 0 ? a.map((i, o) => /* @__PURE__ */ y.jsx(pr.Fragment, { children: i }, o)) : null })
  ] }) });
}, Qk = ({ message: e = "Loading...Please wait!" }) => /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsxs(ee, { mt: 30, children: [
  /* @__PURE__ */ y.jsx(bm, {}),
  " ",
  /* @__PURE__ */ y.jsx(Ve, { children: e })
] }) }), T9 = "_navbarHeader_2tsfz_1", E9 = {
  navbarHeader: T9
}, O9 = ({
  label: e,
  link: r,
  href: t,
  icon: n,
  onClick: a,
  links: i,
  ...o
}) => {
  const l = Array.isArray(i);
  if (l) {
    const h = (l ? i : []).map(({
      id: s,
      label: f,
      link: p,
      href: m,
      icon: w,
      onClick: S,
      ...E
    }) => S ? /* @__PURE__ */ y.jsx(Cn, { label: f, leftSection: w, href: "#", onClick: S, ...E }, s) : m ? /* @__PURE__ */ y.jsx(Cn, { label: f, leftSection: w, href: m, ...E }, s) : /* @__PURE__ */ y.jsx(
      Cn,
      {
        component: Ra,
        to: p,
        label: f,
        leftSection: w,
        ...E
      },
      s
    ));
    return /* @__PURE__ */ y.jsx(
      Cn,
      {
        label: e,
        leftSection: n,
        href: "#required-for-focus",
        onClick: a,
        childrenOffset: 28,
        ...o,
        children: h
      }
    );
  } else
    return a ? /* @__PURE__ */ y.jsx(Cn, { label: e, leftSection: n, href: "#required-for-focus", onClick: a, ...o }) : t ? /* @__PURE__ */ y.jsx(Cn, { label: e, leftSection: n, href: t, ...o }) : /* @__PURE__ */ y.jsx(
      Cn,
      {
        component: Ra,
        to: r,
        label: e,
        leftSection: n,
        ...o
      }
    );
}, eD = ({
  navbarHeader: e = "PAC App",
  navbarFooter: r = "",
  menuItems: t
}) => {
  Array.isArray(t) || (t = []);
  const n = t.map((a) => /* @__PURE__ */ y.jsx(O9, { ...a }, a.id));
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsx(yu.Section, { className: E9.navbarHeader, children: typeof e == "string" ? /* @__PURE__ */ y.jsx(jt, { p: "sm", children: /* @__PURE__ */ y.jsx(_t, { order: 4, children: /* @__PURE__ */ y.jsx(Ve, { tt: "uppercase", children: e }) }) }) : e }),
    /* @__PURE__ */ y.jsx(yu.Section, { grow: !0, my: "md", component: _m, children: /* @__PURE__ */ y.jsx(Ue, { mr: "sm", children: n }) }),
    /* @__PURE__ */ y.jsx(yu.Section, { children: r })
  ] });
}, C9 = "_gridColumn_if83c_1", k9 = {
  gridColumn: C9
}, D9 = ({
  properties: e,
  cols: r,
  ...t
}) => /* @__PURE__ */ y.jsx(Vt, { ...t, children: e.map(
  (n, a) => {
    let i = 12 / r;
    typeof n.span < "u" && n.span !== null && (i = n.span);
    let o = "";
    if (n.value) {
      const l = n.formatter ? n.formatter(n.value) : n.value;
      o = n.decorator ? n.decorator(l) : l;
    }
    return /* @__PURE__ */ y.jsx(Vt.Col, { span: i, className: k9.gridColumn, children: /* @__PURE__ */ y.jsxs(Ue, { py: "sm", children: [
      /* @__PURE__ */ y.jsx(Ve, { fw: 300, children: n.label.toUpperCase() }),
      /* @__PURE__ */ y.jsx(Ve, { fw: 700, children: o })
    ] }) }, a);
  }
) }), tD = ({
  properties: e,
  cols: r = 3,
  ...t
}) => /* @__PURE__ */ y.jsx(Gt, { ...t, children: /* @__PURE__ */ y.jsx(D9, { properties: e, cols: r }) }), rD = ({
  value: e,
  size: r = "lg",
  radius: t = "xl"
}) => /* @__PURE__ */ y.jsx(Iu, { src: e, size: r, radius: t }), nD = ({ value: e }) => {
  if (typeof e > "u" || e === null)
    return e;
  const r = typeof e == "string" ? e : e.props.value;
  return /* @__PURE__ */ y.jsxs(ee, { children: [
    /* @__PURE__ */ y.jsx(lt, { children: e }),
    /* @__PURE__ */ y.jsx(f4, { value: r })
  ] });
}, iD = ({
  value: e,
  width: r = "4em",
  height: t = "4em"
}) => /* @__PURE__ */ y.jsx(dh, { src: e, style: {
  width: r,
  height: t
} }), aD = ({ value: e }) => /* @__PURE__ */ y.jsxs(ee, { children: [
  /* @__PURE__ */ y.jsx(lt, { children: e }),
  /* @__PURE__ */ y.jsx(ir, { title: "Follow", onClick: () => window.open(e), children: /* @__PURE__ */ y.jsx(a4, {}) })
] }), sD = () => /* @__PURE__ */ y.jsx(Gt, { children: /* @__PURE__ */ y.jsxs(uo, { cols: 2, my: "lg", children: [
  /* @__PURE__ */ y.jsxs(Ue, { gap: "lg", m: "lg", children: [
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "60%", radius: "xl" }),
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "100%", radius: "xl" })
  ] }),
  /* @__PURE__ */ y.jsxs(Ue, { gap: "lg", m: "lg", children: [
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "60%", radius: "xl" }),
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "100%", radius: "xl" })
  ] }),
  /* @__PURE__ */ y.jsxs(Ue, { gap: "lg", m: "lg", children: [
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "60%", radius: "xl" }),
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "100%", radius: "xl" })
  ] }),
  /* @__PURE__ */ y.jsxs(Ue, { gap: "lg", m: "lg", children: [
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "60%", radius: "xl" }),
    /* @__PURE__ */ y.jsx(Ge, { height: 15, mt: 6, width: "100%", radius: "xl" })
  ] })
] }) });
function j9(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var kg = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n();
  })(h2, function() {
    var t;
    function n() {
      return t.apply(null, arguments);
    }
    function a(u) {
      t = u;
    }
    function i(u) {
      return u instanceof Array || Object.prototype.toString.call(u) === "[object Array]";
    }
    function o(u) {
      return u != null && Object.prototype.toString.call(u) === "[object Object]";
    }
    function l(u, c) {
      return Object.prototype.hasOwnProperty.call(u, c);
    }
    function h(u) {
      if (Object.getOwnPropertyNames)
        return Object.getOwnPropertyNames(u).length === 0;
      var c;
      for (c in u)
        if (l(u, c))
          return !1;
      return !0;
    }
    function s(u) {
      return u === void 0;
    }
    function f(u) {
      return typeof u == "number" || Object.prototype.toString.call(u) === "[object Number]";
    }
    function p(u) {
      return u instanceof Date || Object.prototype.toString.call(u) === "[object Date]";
    }
    function m(u, c) {
      var d = [], g, v = u.length;
      for (g = 0; g < v; ++g)
        d.push(c(u[g], g));
      return d;
    }
    function w(u, c) {
      for (var d in c)
        l(c, d) && (u[d] = c[d]);
      return l(c, "toString") && (u.toString = c.toString), l(c, "valueOf") && (u.valueOf = c.valueOf), u;
    }
    function S(u, c, d, g) {
      return Wc(u, c, d, g, !0).utc();
    }
    function E() {
      return {
        empty: !1,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: !1,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: !1,
        userInvalidated: !1,
        iso: !1,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: !1,
        weekdayMismatch: !1
      };
    }
    function x(u) {
      return u._pf == null && (u._pf = E()), u._pf;
    }
    var j;
    Array.prototype.some ? j = Array.prototype.some : j = function(u) {
      var c = Object(this), d = c.length >>> 0, g;
      for (g = 0; g < d; g++)
        if (g in c && u.call(this, c[g], g, c))
          return !0;
      return !1;
    };
    function O(u) {
      var c = null, d = !1, g = u._d && !isNaN(u._d.getTime());
      if (g && (c = x(u), d = j.call(c.parsedDateParts, function(v) {
        return v != null;
      }), g = c.overflow < 0 && !c.empty && !c.invalidEra && !c.invalidMonth && !c.invalidWeekday && !c.weekdayMismatch && !c.nullInput && !c.invalidFormat && !c.userInvalidated && (!c.meridiem || c.meridiem && d), u._strict && (g = g && c.charsLeftOver === 0 && c.unusedTokens.length === 0 && c.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(u))
        u._isValid = g;
      else
        return g;
      return u._isValid;
    }
    function I(u) {
      var c = S(NaN);
      return u != null ? w(x(c), u) : x(c).userInvalidated = !0, c;
    }
    var M = n.momentProperties = [], k = !1;
    function fe(u, c) {
      var d, g, v, _ = M.length;
      if (s(c._isAMomentObject) || (u._isAMomentObject = c._isAMomentObject), s(c._i) || (u._i = c._i), s(c._f) || (u._f = c._f), s(c._l) || (u._l = c._l), s(c._strict) || (u._strict = c._strict), s(c._tzm) || (u._tzm = c._tzm), s(c._isUTC) || (u._isUTC = c._isUTC), s(c._offset) || (u._offset = c._offset), s(c._pf) || (u._pf = x(c)), s(c._locale) || (u._locale = c._locale), _ > 0)
        for (d = 0; d < _; d++)
          g = M[d], v = c[g], s(v) || (u[g] = v);
      return u;
    }
    function ae(u) {
      fe(this, u), this._d = new Date(u._d != null ? u._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), k === !1 && (k = !0, n.updateOffset(this), k = !1);
    }
    function B(u) {
      return u instanceof ae || u != null && u._isAMomentObject != null;
    }
    function ue(u) {
      n.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + u);
    }
    function be(u, c) {
      var d = !0;
      return w(function() {
        if (n.deprecationHandler != null && n.deprecationHandler(null, u), d) {
          var g = [], v, _, C, $ = arguments.length;
          for (_ = 0; _ < $; _++) {
            if (v = "", typeof arguments[_] == "object") {
              v += `
[` + _ + "] ";
              for (C in arguments[0])
                l(arguments[0], C) && (v += C + ": " + arguments[0][C] + ", ");
              v = v.slice(0, -2);
            } else
              v = arguments[_];
            g.push(v);
          }
          ue(
            u + `
Arguments: ` + Array.prototype.slice.call(g).join("") + `
` + new Error().stack
          ), d = !1;
        }
        return c.apply(this, arguments);
      }, c);
    }
    var K = {};
    function ve(u, c) {
      n.deprecationHandler != null && n.deprecationHandler(u, c), K[u] || (ue(c), K[u] = !0);
    }
    n.suppressDeprecationWarnings = !1, n.deprecationHandler = null;
    function q(u) {
      return typeof Function < "u" && u instanceof Function || Object.prototype.toString.call(u) === "[object Function]";
    }
    function qe(u) {
      var c, d;
      for (d in u)
        l(u, d) && (c = u[d], q(c) ? this[d] = c : this["_" + d] = c);
      this._config = u, this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
      );
    }
    function at(u, c) {
      var d = w({}, u), g;
      for (g in c)
        l(c, g) && (o(u[g]) && o(c[g]) ? (d[g] = {}, w(d[g], u[g]), w(d[g], c[g])) : c[g] != null ? d[g] = c[g] : delete d[g]);
      for (g in u)
        l(u, g) && !l(c, g) && o(u[g]) && (d[g] = w({}, d[g]));
      return d;
    }
    function xt(u) {
      u != null && this.set(u);
    }
    var st;
    Object.keys ? st = Object.keys : st = function(u) {
      var c, d = [];
      for (c in u)
        l(u, c) && d.push(c);
      return d;
    };
    var je = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function $t(u, c, d) {
      var g = this._calendar[u] || this._calendar.sameElse;
      return q(g) ? g.call(c, d) : g;
    }
    function Fe(u, c, d) {
      var g = "" + Math.abs(u), v = c - g.length, _ = u >= 0;
      return (_ ? d ? "+" : "" : "-") + Math.pow(10, Math.max(0, v)).toString().substr(1) + g;
    }
    var or = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Yt = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Tt = {}, Ut = {};
    function z(u, c, d, g) {
      var v = g;
      typeof g == "string" && (v = function() {
        return this[g]();
      }), u && (Ut[u] = v), c && (Ut[c[0]] = function() {
        return Fe(v.apply(this, arguments), c[1], c[2]);
      }), d && (Ut[d] = function() {
        return this.localeData().ordinal(
          v.apply(this, arguments),
          u
        );
      });
    }
    function wr(u) {
      return u.match(/\[[\s\S]/) ? u.replace(/^\[|\]$/g, "") : u.replace(/\\/g, "");
    }
    function Sr(u) {
      var c = u.match(or), d, g;
      for (d = 0, g = c.length; d < g; d++)
        Ut[c[d]] ? c[d] = Ut[c[d]] : c[d] = wr(c[d]);
      return function(v) {
        var _ = "", C;
        for (C = 0; C < g; C++)
          _ += q(c[C]) ? c[C].call(v, u) : c[C];
        return _;
      };
    }
    function Pt(u, c) {
      return u.isValid() ? (c = Jt(c, u.localeData()), Tt[c] = Tt[c] || Sr(c), Tt[c](u)) : u.localeData().invalidDate();
    }
    function Jt(u, c) {
      var d = 5;
      function g(v) {
        return c.longDateFormat(v) || v;
      }
      for (Yt.lastIndex = 0; d >= 0 && Yt.test(u); )
        u = u.replace(
          Yt,
          g
        ), Yt.lastIndex = 0, d -= 1;
      return u;
    }
    var xr = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function yn(u) {
      var c = this._longDateFormat[u], d = this._longDateFormat[u.toUpperCase()];
      return c || !d ? c : (this._longDateFormat[u] = d.match(or).map(function(g) {
        return g === "MMMM" || g === "MM" || g === "DD" || g === "dddd" ? g.slice(1) : g;
      }).join(""), this._longDateFormat[u]);
    }
    var W = "Invalid date";
    function Yr() {
      return this._invalidDate;
    }
    var Tr = "%d", ur = /\d{1,2}/;
    function Ur(u) {
      return this._ordinal.replace("%d", u);
    }
    var gn = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function Ti(u, c, d, g) {
      var v = this._relativeTime[d];
      return q(v) ? v(u, c, d, g) : v.replace(/%d/i, u);
    }
    function pn(u, c) {
      var d = this._relativeTime[u > 0 ? "future" : "past"];
      return q(d) ? d(c) : d.replace(/%s/i, c);
    }
    var T = {
      D: "date",
      dates: "date",
      date: "date",
      d: "day",
      days: "day",
      day: "day",
      e: "weekday",
      weekdays: "weekday",
      weekday: "weekday",
      E: "isoWeekday",
      isoweekdays: "isoWeekday",
      isoweekday: "isoWeekday",
      DDD: "dayOfYear",
      dayofyears: "dayOfYear",
      dayofyear: "dayOfYear",
      h: "hour",
      hours: "hour",
      hour: "hour",
      ms: "millisecond",
      milliseconds: "millisecond",
      millisecond: "millisecond",
      m: "minute",
      minutes: "minute",
      minute: "minute",
      M: "month",
      months: "month",
      month: "month",
      Q: "quarter",
      quarters: "quarter",
      quarter: "quarter",
      s: "second",
      seconds: "second",
      second: "second",
      gg: "weekYear",
      weekyears: "weekYear",
      weekyear: "weekYear",
      GG: "isoWeekYear",
      isoweekyears: "isoWeekYear",
      isoweekyear: "isoWeekYear",
      w: "week",
      weeks: "week",
      week: "week",
      W: "isoWeek",
      isoweeks: "isoWeek",
      isoweek: "isoWeek",
      y: "year",
      years: "year",
      year: "year"
    };
    function N(u) {
      return typeof u == "string" ? T[u] || T[u.toLowerCase()] : void 0;
    }
    function U(u) {
      var c = {}, d, g;
      for (g in u)
        l(u, g) && (d = N(g), d && (c[d] = u[g]));
      return c;
    }
    var G = {
      date: 9,
      day: 11,
      weekday: 11,
      isoWeekday: 11,
      dayOfYear: 4,
      hour: 13,
      millisecond: 16,
      minute: 14,
      month: 8,
      quarter: 7,
      second: 15,
      weekYear: 1,
      isoWeekYear: 1,
      week: 5,
      isoWeek: 5,
      year: 1
    };
    function J(u) {
      var c = [], d;
      for (d in u)
        l(u, d) && c.push({ unit: d, priority: G[d] });
      return c.sort(function(g, v) {
        return g.priority - v.priority;
      }), c;
    }
    var ie = /\d/, le = /\d\d/, Ze = /\d{3}/, zr = /\d{4}/, lr = /[+-]?\d{6}/, _e = /\d\d?/, vn = /\d\d\d\d?/, Yn = /\d\d\d\d\d\d?/, mn = /\d{1,3}/, oa = /\d{1,4}/, Ei = /[+-]?\d{1,6}/, bn = /\d+/, Oi = /[+-]?\d+/, Vo = /Z|[+-]\d\d:?\d\d/gi, _n = /Z|[+-]\d\d(?::?\d\d)?/gi, rs = /[+-]?\d+(\.\d{1,3})?/, Xt = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Er = /^[1-9]\d?/, Un = /^([1-9]\d|\d)/, zn;
    zn = {};
    function F(u, c, d) {
      zn[u] = q(c) ? c : function(g, v) {
        return g && d ? d : c;
      };
    }
    function ns(u, c) {
      return l(zn, u) ? zn[u](c._strict, c._locale) : new RegExp(Ko(u));
    }
    function Ko(u) {
      return Qt(
        u.replace("\\", "").replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function(c, d, g, v, _) {
            return d || g || v || _;
          }
        )
      );
    }
    function Qt(u) {
      return u.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function Et(u) {
      return u < 0 ? Math.ceil(u) || 0 : Math.floor(u);
    }
    function re(u) {
      var c = +u, d = 0;
      return c !== 0 && isFinite(c) && (d = Et(c)), d;
    }
    var ua = {};
    function me(u, c) {
      var d, g = c, v;
      for (typeof u == "string" && (u = [u]), f(c) && (g = function(_, C) {
        C[c] = re(_);
      }), v = u.length, d = 0; d < v; d++)
        ua[u[d]] = g;
    }
    function wn(u, c) {
      me(u, function(d, g, v, _) {
        v._w = v._w || {}, c(d, v._w, v, _);
      });
    }
    function qo(u, c, d) {
      c != null && l(ua, u) && ua[u](c, d._a, d, u);
    }
    function Ci(u) {
      return u % 4 === 0 && u % 100 !== 0 || u % 400 === 0;
    }
    var tt = 0, cr = 1, b = 2, D = 3, R = 4, H = 5, te = 6, xe = 7, se = 8;
    z("Y", 0, 0, function() {
      var u = this.year();
      return u <= 9999 ? Fe(u, 4) : "+" + u;
    }), z(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    }), z(0, ["YYYY", 4], 0, "year"), z(0, ["YYYYY", 5], 0, "year"), z(0, ["YYYYYY", 6, !0], 0, "year"), F("Y", Oi), F("YY", _e, le), F("YYYY", oa, zr), F("YYYYY", Ei, lr), F("YYYYYY", Ei, lr), me(["YYYYY", "YYYYYY"], tt), me("YYYY", function(u, c) {
      c[tt] = u.length === 2 ? n.parseTwoDigitYear(u) : re(u);
    }), me("YY", function(u, c) {
      c[tt] = n.parseTwoDigitYear(u);
    }), me("Y", function(u, c) {
      c[tt] = parseInt(u, 10);
    });
    function X(u) {
      return Ci(u) ? 366 : 365;
    }
    n.parseTwoDigitYear = function(u) {
      return re(u) + (re(u) > 68 ? 1900 : 2e3);
    };
    var rt = Oe("FullYear", !0);
    function $e() {
      return Ci(this.year());
    }
    function Oe(u, c) {
      return function(d) {
        return d != null ? (Wr(this, u, d), n.updateOffset(this, c), this) : nt(this, u);
      };
    }
    function nt(u, c) {
      if (!u.isValid())
        return NaN;
      var d = u._d, g = u._isUTC;
      switch (c) {
        case "Milliseconds":
          return g ? d.getUTCMilliseconds() : d.getMilliseconds();
        case "Seconds":
          return g ? d.getUTCSeconds() : d.getSeconds();
        case "Minutes":
          return g ? d.getUTCMinutes() : d.getMinutes();
        case "Hours":
          return g ? d.getUTCHours() : d.getHours();
        case "Date":
          return g ? d.getUTCDate() : d.getDate();
        case "Day":
          return g ? d.getUTCDay() : d.getDay();
        case "Month":
          return g ? d.getUTCMonth() : d.getMonth();
        case "FullYear":
          return g ? d.getUTCFullYear() : d.getFullYear();
        default:
          return NaN;
      }
    }
    function Wr(u, c, d) {
      var g, v, _, C, $;
      if (!(!u.isValid() || isNaN(d))) {
        switch (g = u._d, v = u._isUTC, c) {
          case "Milliseconds":
            return void (v ? g.setUTCMilliseconds(d) : g.setMilliseconds(d));
          case "Seconds":
            return void (v ? g.setUTCSeconds(d) : g.setSeconds(d));
          case "Minutes":
            return void (v ? g.setUTCMinutes(d) : g.setMinutes(d));
          case "Hours":
            return void (v ? g.setUTCHours(d) : g.setHours(d));
          case "Date":
            return void (v ? g.setUTCDate(d) : g.setDate(d));
          case "FullYear":
            break;
          default:
            return;
        }
        _ = d, C = u.month(), $ = u.date(), $ = $ === 29 && C === 1 && !Ci(_) ? 28 : $, v ? g.setUTCFullYear(_, C, $) : g.setFullYear(_, C, $);
      }
    }
    function Br(u) {
      return u = N(u), q(this[u]) ? this[u]() : this;
    }
    function ct(u, c) {
      if (typeof u == "object") {
        u = U(u);
        var d = J(u), g, v = d.length;
        for (g = 0; g < v; g++)
          this[d[g].unit](u[d[g].unit]);
      } else if (u = N(u), q(this[u]))
        return this[u](c);
      return this;
    }
    function la(u, c) {
      return (u % c + c) % c;
    }
    var Ye;
    Array.prototype.indexOf ? Ye = Array.prototype.indexOf : Ye = function(u) {
      var c;
      for (c = 0; c < this.length; ++c)
        if (this[c] === u)
          return c;
      return -1;
    };
    function ca(u, c) {
      if (isNaN(u) || isNaN(c))
        return NaN;
      var d = la(c, 12);
      return u += (c - d) / 12, d === 1 ? Ci(u) ? 29 : 28 : 31 - d % 7 % 2;
    }
    z("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    }), z("MMM", 0, 0, function(u) {
      return this.localeData().monthsShort(this, u);
    }), z("MMMM", 0, 0, function(u) {
      return this.localeData().months(this, u);
    }), F("M", _e, Er), F("MM", _e, le), F("MMM", function(u, c) {
      return c.monthsShortRegex(u);
    }), F("MMMM", function(u, c) {
      return c.monthsRegex(u);
    }), me(["M", "MM"], function(u, c) {
      c[cr] = re(u) - 1;
    }), me(["MMM", "MMMM"], function(u, c, d, g) {
      var v = d._locale.monthsParse(u, g, d._strict);
      v != null ? c[cr] = v : x(d).invalidMonth = u;
    });
    var Dg = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ), Dc = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), jc = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, jg = Xt, Mg = Xt;
    function Pg(u, c) {
      return u ? i(this._months) ? this._months[u.month()] : this._months[(this._months.isFormat || jc).test(c) ? "format" : "standalone"][u.month()] : i(this._months) ? this._months : this._months.standalone;
    }
    function Ag(u, c) {
      return u ? i(this._monthsShort) ? this._monthsShort[u.month()] : this._monthsShort[jc.test(c) ? "format" : "standalone"][u.month()] : i(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
    }
    function Rg(u, c, d) {
      var g, v, _, C = u.toLocaleLowerCase();
      if (!this._monthsParse)
        for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], g = 0; g < 12; ++g)
          _ = S([2e3, g]), this._shortMonthsParse[g] = this.monthsShort(
            _,
            ""
          ).toLocaleLowerCase(), this._longMonthsParse[g] = this.months(_, "").toLocaleLowerCase();
      return d ? c === "MMM" ? (v = Ye.call(this._shortMonthsParse, C), v !== -1 ? v : null) : (v = Ye.call(this._longMonthsParse, C), v !== -1 ? v : null) : c === "MMM" ? (v = Ye.call(this._shortMonthsParse, C), v !== -1 ? v : (v = Ye.call(this._longMonthsParse, C), v !== -1 ? v : null)) : (v = Ye.call(this._longMonthsParse, C), v !== -1 ? v : (v = Ye.call(this._shortMonthsParse, C), v !== -1 ? v : null));
    }
    function Ig(u, c, d) {
      var g, v, _;
      if (this._monthsParseExact)
        return Rg.call(this, u, c, d);
      for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), g = 0; g < 12; g++) {
        if (v = S([2e3, g]), d && !this._longMonthsParse[g] && (this._longMonthsParse[g] = new RegExp(
          "^" + this.months(v, "").replace(".", "") + "$",
          "i"
        ), this._shortMonthsParse[g] = new RegExp(
          "^" + this.monthsShort(v, "").replace(".", "") + "$",
          "i"
        )), !d && !this._monthsParse[g] && (_ = "^" + this.months(v, "") + "|^" + this.monthsShort(v, ""), this._monthsParse[g] = new RegExp(_.replace(".", ""), "i")), d && c === "MMMM" && this._longMonthsParse[g].test(u))
          return g;
        if (d && c === "MMM" && this._shortMonthsParse[g].test(u))
          return g;
        if (!d && this._monthsParse[g].test(u))
          return g;
      }
    }
    function Mc(u, c) {
      if (!u.isValid())
        return u;
      if (typeof c == "string") {
        if (/^\d+$/.test(c))
          c = re(c);
        else if (c = u.localeData().monthsParse(c), !f(c))
          return u;
      }
      var d = c, g = u.date();
      return g = g < 29 ? g : Math.min(g, ca(u.year(), d)), u._isUTC ? u._d.setUTCMonth(d, g) : u._d.setMonth(d, g), u;
    }
    function Pc(u) {
      return u != null ? (Mc(this, u), n.updateOffset(this, !0), this) : nt(this, "Month");
    }
    function Ng() {
      return ca(this.year(), this.month());
    }
    function Lg(u) {
      return this._monthsParseExact ? (l(this, "_monthsRegex") || Ac.call(this), u ? this._monthsShortStrictRegex : this._monthsShortRegex) : (l(this, "_monthsShortRegex") || (this._monthsShortRegex = jg), this._monthsShortStrictRegex && u ? this._monthsShortStrictRegex : this._monthsShortRegex);
    }
    function Fg(u) {
      return this._monthsParseExact ? (l(this, "_monthsRegex") || Ac.call(this), u ? this._monthsStrictRegex : this._monthsRegex) : (l(this, "_monthsRegex") || (this._monthsRegex = Mg), this._monthsStrictRegex && u ? this._monthsStrictRegex : this._monthsRegex);
    }
    function Ac() {
      function u(Z, ce) {
        return ce.length - Z.length;
      }
      var c = [], d = [], g = [], v, _, C, $;
      for (v = 0; v < 12; v++)
        _ = S([2e3, v]), C = Qt(this.monthsShort(_, "")), $ = Qt(this.months(_, "")), c.push(C), d.push($), g.push($), g.push(C);
      c.sort(u), d.sort(u), g.sort(u), this._monthsRegex = new RegExp("^(" + g.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
        "^(" + d.join("|") + ")",
        "i"
      ), this._monthsShortStrictRegex = new RegExp(
        "^(" + c.join("|") + ")",
        "i"
      );
    }
    function $g(u, c, d, g, v, _, C) {
      var $;
      return u < 100 && u >= 0 ? ($ = new Date(u + 400, c, d, g, v, _, C), isFinite($.getFullYear()) && $.setFullYear(u)) : $ = new Date(u, c, d, g, v, _, C), $;
    }
    function fa(u) {
      var c, d;
      return u < 100 && u >= 0 ? (d = Array.prototype.slice.call(arguments), d[0] = u + 400, c = new Date(Date.UTC.apply(null, d)), isFinite(c.getUTCFullYear()) && c.setUTCFullYear(u)) : c = new Date(Date.UTC.apply(null, arguments)), c;
    }
    function is(u, c, d) {
      var g = 7 + c - d, v = (7 + fa(u, 0, g).getUTCDay() - c) % 7;
      return -v + g - 1;
    }
    function Rc(u, c, d, g, v) {
      var _ = (7 + d - g) % 7, C = is(u, g, v), $ = 1 + 7 * (c - 1) + _ + C, Z, ce;
      return $ <= 0 ? (Z = u - 1, ce = X(Z) + $) : $ > X(u) ? (Z = u + 1, ce = $ - X(u)) : (Z = u, ce = $), {
        year: Z,
        dayOfYear: ce
      };
    }
    function da(u, c, d) {
      var g = is(u.year(), c, d), v = Math.floor((u.dayOfYear() - g - 1) / 7) + 1, _, C;
      return v < 1 ? (C = u.year() - 1, _ = v + Hr(C, c, d)) : v > Hr(u.year(), c, d) ? (_ = v - Hr(u.year(), c, d), C = u.year() + 1) : (C = u.year(), _ = v), {
        week: _,
        year: C
      };
    }
    function Hr(u, c, d) {
      var g = is(u, c, d), v = is(u + 1, c, d);
      return (X(u) - g + v) / 7;
    }
    z("w", ["ww", 2], "wo", "week"), z("W", ["WW", 2], "Wo", "isoWeek"), F("w", _e, Er), F("ww", _e, le), F("W", _e, Er), F("WW", _e, le), wn(
      ["w", "ww", "W", "WW"],
      function(u, c, d, g) {
        c[g.substr(0, 1)] = re(u);
      }
    );
    function Yg(u) {
      return da(u, this._week.dow, this._week.doy).week;
    }
    var Ug = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    };
    function zg() {
      return this._week.dow;
    }
    function Wg() {
      return this._week.doy;
    }
    function Bg(u) {
      var c = this.localeData().week(this);
      return u == null ? c : this.add((u - c) * 7, "d");
    }
    function Hg(u) {
      var c = da(this, 1, 4).week;
      return u == null ? c : this.add((u - c) * 7, "d");
    }
    z("d", 0, "do", "day"), z("dd", 0, 0, function(u) {
      return this.localeData().weekdaysMin(this, u);
    }), z("ddd", 0, 0, function(u) {
      return this.localeData().weekdaysShort(this, u);
    }), z("dddd", 0, 0, function(u) {
      return this.localeData().weekdays(this, u);
    }), z("e", 0, 0, "weekday"), z("E", 0, 0, "isoWeekday"), F("d", _e), F("e", _e), F("E", _e), F("dd", function(u, c) {
      return c.weekdaysMinRegex(u);
    }), F("ddd", function(u, c) {
      return c.weekdaysShortRegex(u);
    }), F("dddd", function(u, c) {
      return c.weekdaysRegex(u);
    }), wn(["dd", "ddd", "dddd"], function(u, c, d, g) {
      var v = d._locale.weekdaysParse(u, g, d._strict);
      v != null ? c.d = v : x(d).invalidWeekday = u;
    }), wn(["d", "e", "E"], function(u, c, d, g) {
      c[g] = re(u);
    });
    function Gg(u, c) {
      return typeof u != "string" ? u : isNaN(u) ? (u = c.weekdaysParse(u), typeof u == "number" ? u : null) : parseInt(u, 10);
    }
    function Vg(u, c) {
      return typeof u == "string" ? c.weekdaysParse(u) % 7 || 7 : isNaN(u) ? null : u;
    }
    function Zo(u, c) {
      return u.slice(c, 7).concat(u.slice(0, c));
    }
    var Kg = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Ic = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), qg = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Zg = Xt, Jg = Xt, Xg = Xt;
    function Qg(u, c) {
      var d = i(this._weekdays) ? this._weekdays : this._weekdays[u && u !== !0 && this._weekdays.isFormat.test(c) ? "format" : "standalone"];
      return u === !0 ? Zo(d, this._week.dow) : u ? d[u.day()] : d;
    }
    function ep(u) {
      return u === !0 ? Zo(this._weekdaysShort, this._week.dow) : u ? this._weekdaysShort[u.day()] : this._weekdaysShort;
    }
    function tp(u) {
      return u === !0 ? Zo(this._weekdaysMin, this._week.dow) : u ? this._weekdaysMin[u.day()] : this._weekdaysMin;
    }
    function rp(u, c, d) {
      var g, v, _, C = u.toLocaleLowerCase();
      if (!this._weekdaysParse)
        for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], g = 0; g < 7; ++g)
          _ = S([2e3, 1]).day(g), this._minWeekdaysParse[g] = this.weekdaysMin(
            _,
            ""
          ).toLocaleLowerCase(), this._shortWeekdaysParse[g] = this.weekdaysShort(
            _,
            ""
          ).toLocaleLowerCase(), this._weekdaysParse[g] = this.weekdays(_, "").toLocaleLowerCase();
      return d ? c === "dddd" ? (v = Ye.call(this._weekdaysParse, C), v !== -1 ? v : null) : c === "ddd" ? (v = Ye.call(this._shortWeekdaysParse, C), v !== -1 ? v : null) : (v = Ye.call(this._minWeekdaysParse, C), v !== -1 ? v : null) : c === "dddd" ? (v = Ye.call(this._weekdaysParse, C), v !== -1 || (v = Ye.call(this._shortWeekdaysParse, C), v !== -1) ? v : (v = Ye.call(this._minWeekdaysParse, C), v !== -1 ? v : null)) : c === "ddd" ? (v = Ye.call(this._shortWeekdaysParse, C), v !== -1 || (v = Ye.call(this._weekdaysParse, C), v !== -1) ? v : (v = Ye.call(this._minWeekdaysParse, C), v !== -1 ? v : null)) : (v = Ye.call(this._minWeekdaysParse, C), v !== -1 || (v = Ye.call(this._weekdaysParse, C), v !== -1) ? v : (v = Ye.call(this._shortWeekdaysParse, C), v !== -1 ? v : null));
    }
    function np(u, c, d) {
      var g, v, _;
      if (this._weekdaysParseExact)
        return rp.call(this, u, c, d);
      for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), g = 0; g < 7; g++) {
        if (v = S([2e3, 1]).day(g), d && !this._fullWeekdaysParse[g] && (this._fullWeekdaysParse[g] = new RegExp(
          "^" + this.weekdays(v, "").replace(".", "\\.?") + "$",
          "i"
        ), this._shortWeekdaysParse[g] = new RegExp(
          "^" + this.weekdaysShort(v, "").replace(".", "\\.?") + "$",
          "i"
        ), this._minWeekdaysParse[g] = new RegExp(
          "^" + this.weekdaysMin(v, "").replace(".", "\\.?") + "$",
          "i"
        )), this._weekdaysParse[g] || (_ = "^" + this.weekdays(v, "") + "|^" + this.weekdaysShort(v, "") + "|^" + this.weekdaysMin(v, ""), this._weekdaysParse[g] = new RegExp(_.replace(".", ""), "i")), d && c === "dddd" && this._fullWeekdaysParse[g].test(u))
          return g;
        if (d && c === "ddd" && this._shortWeekdaysParse[g].test(u))
          return g;
        if (d && c === "dd" && this._minWeekdaysParse[g].test(u))
          return g;
        if (!d && this._weekdaysParse[g].test(u))
          return g;
      }
    }
    function ip(u) {
      if (!this.isValid())
        return u != null ? this : NaN;
      var c = nt(this, "Day");
      return u != null ? (u = Gg(u, this.localeData()), this.add(u - c, "d")) : c;
    }
    function ap(u) {
      if (!this.isValid())
        return u != null ? this : NaN;
      var c = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return u == null ? c : this.add(u - c, "d");
    }
    function sp(u) {
      if (!this.isValid())
        return u != null ? this : NaN;
      if (u != null) {
        var c = Vg(u, this.localeData());
        return this.day(this.day() % 7 ? c : c - 7);
      } else
        return this.day() || 7;
    }
    function op(u) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Jo.call(this), u ? this._weekdaysStrictRegex : this._weekdaysRegex) : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = Zg), this._weekdaysStrictRegex && u ? this._weekdaysStrictRegex : this._weekdaysRegex);
    }
    function up(u) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Jo.call(this), u ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (l(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Jg), this._weekdaysShortStrictRegex && u ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
    }
    function lp(u) {
      return this._weekdaysParseExact ? (l(this, "_weekdaysRegex") || Jo.call(this), u ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (l(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Xg), this._weekdaysMinStrictRegex && u ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
    }
    function Jo() {
      function u(Ot, Zr) {
        return Zr.length - Ot.length;
      }
      var c = [], d = [], g = [], v = [], _, C, $, Z, ce;
      for (_ = 0; _ < 7; _++)
        C = S([2e3, 1]).day(_), $ = Qt(this.weekdaysMin(C, "")), Z = Qt(this.weekdaysShort(C, "")), ce = Qt(this.weekdays(C, "")), c.push($), d.push(Z), g.push(ce), v.push($), v.push(Z), v.push(ce);
      c.sort(u), d.sort(u), g.sort(u), v.sort(u), this._weekdaysRegex = new RegExp("^(" + v.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
        "^(" + g.join("|") + ")",
        "i"
      ), this._weekdaysShortStrictRegex = new RegExp(
        "^(" + d.join("|") + ")",
        "i"
      ), this._weekdaysMinStrictRegex = new RegExp(
        "^(" + c.join("|") + ")",
        "i"
      );
    }
    function Xo() {
      return this.hours() % 12 || 12;
    }
    function cp() {
      return this.hours() || 24;
    }
    z("H", ["HH", 2], 0, "hour"), z("h", ["hh", 2], 0, Xo), z("k", ["kk", 2], 0, cp), z("hmm", 0, 0, function() {
      return "" + Xo.apply(this) + Fe(this.minutes(), 2);
    }), z("hmmss", 0, 0, function() {
      return "" + Xo.apply(this) + Fe(this.minutes(), 2) + Fe(this.seconds(), 2);
    }), z("Hmm", 0, 0, function() {
      return "" + this.hours() + Fe(this.minutes(), 2);
    }), z("Hmmss", 0, 0, function() {
      return "" + this.hours() + Fe(this.minutes(), 2) + Fe(this.seconds(), 2);
    });
    function Nc(u, c) {
      z(u, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          c
        );
      });
    }
    Nc("a", !0), Nc("A", !1);
    function Lc(u, c) {
      return c._meridiemParse;
    }
    F("a", Lc), F("A", Lc), F("H", _e, Un), F("h", _e, Er), F("k", _e, Er), F("HH", _e, le), F("hh", _e, le), F("kk", _e, le), F("hmm", vn), F("hmmss", Yn), F("Hmm", vn), F("Hmmss", Yn), me(["H", "HH"], D), me(["k", "kk"], function(u, c, d) {
      var g = re(u);
      c[D] = g === 24 ? 0 : g;
    }), me(["a", "A"], function(u, c, d) {
      d._isPm = d._locale.isPM(u), d._meridiem = u;
    }), me(["h", "hh"], function(u, c, d) {
      c[D] = re(u), x(d).bigHour = !0;
    }), me("hmm", function(u, c, d) {
      var g = u.length - 2;
      c[D] = re(u.substr(0, g)), c[R] = re(u.substr(g)), x(d).bigHour = !0;
    }), me("hmmss", function(u, c, d) {
      var g = u.length - 4, v = u.length - 2;
      c[D] = re(u.substr(0, g)), c[R] = re(u.substr(g, 2)), c[H] = re(u.substr(v)), x(d).bigHour = !0;
    }), me("Hmm", function(u, c, d) {
      var g = u.length - 2;
      c[D] = re(u.substr(0, g)), c[R] = re(u.substr(g));
    }), me("Hmmss", function(u, c, d) {
      var g = u.length - 4, v = u.length - 2;
      c[D] = re(u.substr(0, g)), c[R] = re(u.substr(g, 2)), c[H] = re(u.substr(v));
    });
    function fp(u) {
      return (u + "").toLowerCase().charAt(0) === "p";
    }
    var dp = /[ap]\.?m?\.?/i, hp = Oe("Hours", !0);
    function yp(u, c, d) {
      return u > 11 ? d ? "pm" : "PM" : d ? "am" : "AM";
    }
    var Fc = {
      calendar: je,
      longDateFormat: xr,
      invalidDate: W,
      ordinal: Tr,
      dayOfMonthOrdinalParse: ur,
      relativeTime: gn,
      months: Dg,
      monthsShort: Dc,
      week: Ug,
      weekdays: Kg,
      weekdaysMin: qg,
      weekdaysShort: Ic,
      meridiemParse: dp
    }, Ie = {}, ha = {}, ya;
    function gp(u, c) {
      var d, g = Math.min(u.length, c.length);
      for (d = 0; d < g; d += 1)
        if (u[d] !== c[d])
          return d;
      return g;
    }
    function $c(u) {
      return u && u.toLowerCase().replace("_", "-");
    }
    function pp(u) {
      for (var c = 0, d, g, v, _; c < u.length; ) {
        for (_ = $c(u[c]).split("-"), d = _.length, g = $c(u[c + 1]), g = g ? g.split("-") : null; d > 0; ) {
          if (v = as(_.slice(0, d).join("-")), v)
            return v;
          if (g && g.length >= d && gp(_, g) >= d - 1)
            break;
          d--;
        }
        c++;
      }
      return ya;
    }
    function vp(u) {
      return !!(u && u.match("^[^/\\\\]*$"));
    }
    function as(u) {
      var c = null, d;
      if (Ie[u] === void 0 && e && e.exports && vp(u))
        try {
          c = ya._abbr, d = j9, d("./locale/" + u), Sn(c);
        } catch {
          Ie[u] = null;
        }
      return Ie[u];
    }
    function Sn(u, c) {
      var d;
      return u && (s(c) ? d = Gr(u) : d = Qo(u, c), d ? ya = d : typeof console < "u" && console.warn && console.warn(
        "Locale " + u + " not found. Did you forget to load it?"
      )), ya._abbr;
    }
    function Qo(u, c) {
      if (c !== null) {
        var d, g = Fc;
        if (c.abbr = u, Ie[u] != null)
          ve(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          ), g = Ie[u]._config;
        else if (c.parentLocale != null)
          if (Ie[c.parentLocale] != null)
            g = Ie[c.parentLocale]._config;
          else if (d = as(c.parentLocale), d != null)
            g = d._config;
          else
            return ha[c.parentLocale] || (ha[c.parentLocale] = []), ha[c.parentLocale].push({
              name: u,
              config: c
            }), null;
        return Ie[u] = new xt(at(g, c)), ha[u] && ha[u].forEach(function(v) {
          Qo(v.name, v.config);
        }), Sn(u), Ie[u];
      } else
        return delete Ie[u], null;
    }
    function mp(u, c) {
      if (c != null) {
        var d, g, v = Fc;
        Ie[u] != null && Ie[u].parentLocale != null ? Ie[u].set(at(Ie[u]._config, c)) : (g = as(u), g != null && (v = g._config), c = at(v, c), g == null && (c.abbr = u), d = new xt(c), d.parentLocale = Ie[u], Ie[u] = d), Sn(u);
      } else
        Ie[u] != null && (Ie[u].parentLocale != null ? (Ie[u] = Ie[u].parentLocale, u === Sn() && Sn(u)) : Ie[u] != null && delete Ie[u]);
      return Ie[u];
    }
    function Gr(u) {
      var c;
      if (u && u._locale && u._locale._abbr && (u = u._locale._abbr), !u)
        return ya;
      if (!i(u)) {
        if (c = as(u), c)
          return c;
        u = [u];
      }
      return pp(u);
    }
    function bp() {
      return st(Ie);
    }
    function eu(u) {
      var c, d = u._a;
      return d && x(u).overflow === -2 && (c = d[cr] < 0 || d[cr] > 11 ? cr : d[b] < 1 || d[b] > ca(d[tt], d[cr]) ? b : d[D] < 0 || d[D] > 24 || d[D] === 24 && (d[R] !== 0 || d[H] !== 0 || d[te] !== 0) ? D : d[R] < 0 || d[R] > 59 ? R : d[H] < 0 || d[H] > 59 ? H : d[te] < 0 || d[te] > 999 ? te : -1, x(u)._overflowDayOfYear && (c < tt || c > b) && (c = b), x(u)._overflowWeeks && c === -1 && (c = xe), x(u)._overflowWeekday && c === -1 && (c = se), x(u).overflow = c), u;
    }
    var _p = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, wp = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Sp = /Z|[+-]\d\d(?::?\d\d)?/, ss = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, !1],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, !1],
      ["YYYY", /\d{4}/, !1]
    ], tu = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ], xp = /^\/?Date\((-?\d+)/i, Tp = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Ep = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };
    function Yc(u) {
      var c, d, g = u._i, v = _p.exec(g) || wp.exec(g), _, C, $, Z, ce = ss.length, Ot = tu.length;
      if (v) {
        for (x(u).iso = !0, c = 0, d = ce; c < d; c++)
          if (ss[c][1].exec(v[1])) {
            C = ss[c][0], _ = ss[c][2] !== !1;
            break;
          }
        if (C == null) {
          u._isValid = !1;
          return;
        }
        if (v[3]) {
          for (c = 0, d = Ot; c < d; c++)
            if (tu[c][1].exec(v[3])) {
              $ = (v[2] || " ") + tu[c][0];
              break;
            }
          if ($ == null) {
            u._isValid = !1;
            return;
          }
        }
        if (!_ && $ != null) {
          u._isValid = !1;
          return;
        }
        if (v[4])
          if (Sp.exec(v[4]))
            Z = "Z";
          else {
            u._isValid = !1;
            return;
          }
        u._f = C + ($ || "") + (Z || ""), nu(u);
      } else
        u._isValid = !1;
    }
    function Op(u, c, d, g, v, _) {
      var C = [
        Cp(u),
        Dc.indexOf(c),
        parseInt(d, 10),
        parseInt(g, 10),
        parseInt(v, 10)
      ];
      return _ && C.push(parseInt(_, 10)), C;
    }
    function Cp(u) {
      var c = parseInt(u, 10);
      return c <= 49 ? 2e3 + c : c <= 999 ? 1900 + c : c;
    }
    function kp(u) {
      return u.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function Dp(u, c, d) {
      if (u) {
        var g = Ic.indexOf(u), v = new Date(
          c[0],
          c[1],
          c[2]
        ).getDay();
        if (g !== v)
          return x(d).weekdayMismatch = !0, d._isValid = !1, !1;
      }
      return !0;
    }
    function jp(u, c, d) {
      if (u)
        return Ep[u];
      if (c)
        return 0;
      var g = parseInt(d, 10), v = g % 100, _ = (g - v) / 100;
      return _ * 60 + v;
    }
    function Uc(u) {
      var c = Tp.exec(kp(u._i)), d;
      if (c) {
        if (d = Op(
          c[4],
          c[3],
          c[2],
          c[5],
          c[6],
          c[7]
        ), !Dp(c[1], d, u))
          return;
        u._a = d, u._tzm = jp(c[8], c[9], c[10]), u._d = fa.apply(null, u._a), u._d.setUTCMinutes(u._d.getUTCMinutes() - u._tzm), x(u).rfc2822 = !0;
      } else
        u._isValid = !1;
    }
    function Mp(u) {
      var c = xp.exec(u._i);
      if (c !== null) {
        u._d = /* @__PURE__ */ new Date(+c[1]);
        return;
      }
      if (Yc(u), u._isValid === !1)
        delete u._isValid;
      else
        return;
      if (Uc(u), u._isValid === !1)
        delete u._isValid;
      else
        return;
      u._strict ? u._isValid = !1 : n.createFromInputFallback(u);
    }
    n.createFromInputFallback = be(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(u) {
        u._d = /* @__PURE__ */ new Date(u._i + (u._useUTC ? " UTC" : ""));
      }
    );
    function ki(u, c, d) {
      return u ?? c ?? d;
    }
    function Pp(u) {
      var c = new Date(n.now());
      return u._useUTC ? [
        c.getUTCFullYear(),
        c.getUTCMonth(),
        c.getUTCDate()
      ] : [c.getFullYear(), c.getMonth(), c.getDate()];
    }
    function ru(u) {
      var c, d, g = [], v, _, C;
      if (!u._d) {
        for (v = Pp(u), u._w && u._a[b] == null && u._a[cr] == null && Ap(u), u._dayOfYear != null && (C = ki(u._a[tt], v[tt]), (u._dayOfYear > X(C) || u._dayOfYear === 0) && (x(u)._overflowDayOfYear = !0), d = fa(C, 0, u._dayOfYear), u._a[cr] = d.getUTCMonth(), u._a[b] = d.getUTCDate()), c = 0; c < 3 && u._a[c] == null; ++c)
          u._a[c] = g[c] = v[c];
        for (; c < 7; c++)
          u._a[c] = g[c] = u._a[c] == null ? c === 2 ? 1 : 0 : u._a[c];
        u._a[D] === 24 && u._a[R] === 0 && u._a[H] === 0 && u._a[te] === 0 && (u._nextDay = !0, u._a[D] = 0), u._d = (u._useUTC ? fa : $g).apply(
          null,
          g
        ), _ = u._useUTC ? u._d.getUTCDay() : u._d.getDay(), u._tzm != null && u._d.setUTCMinutes(u._d.getUTCMinutes() - u._tzm), u._nextDay && (u._a[D] = 24), u._w && typeof u._w.d < "u" && u._w.d !== _ && (x(u).weekdayMismatch = !0);
      }
    }
    function Ap(u) {
      var c, d, g, v, _, C, $, Z, ce;
      c = u._w, c.GG != null || c.W != null || c.E != null ? (_ = 1, C = 4, d = ki(
        c.GG,
        u._a[tt],
        da(Me(), 1, 4).year
      ), g = ki(c.W, 1), v = ki(c.E, 1), (v < 1 || v > 7) && (Z = !0)) : (_ = u._locale._week.dow, C = u._locale._week.doy, ce = da(Me(), _, C), d = ki(c.gg, u._a[tt], ce.year), g = ki(c.w, ce.week), c.d != null ? (v = c.d, (v < 0 || v > 6) && (Z = !0)) : c.e != null ? (v = c.e + _, (c.e < 0 || c.e > 6) && (Z = !0)) : v = _), g < 1 || g > Hr(d, _, C) ? x(u)._overflowWeeks = !0 : Z != null ? x(u)._overflowWeekday = !0 : ($ = Rc(d, g, v, _, C), u._a[tt] = $.year, u._dayOfYear = $.dayOfYear);
    }
    n.ISO_8601 = function() {
    }, n.RFC_2822 = function() {
    };
    function nu(u) {
      if (u._f === n.ISO_8601) {
        Yc(u);
        return;
      }
      if (u._f === n.RFC_2822) {
        Uc(u);
        return;
      }
      u._a = [], x(u).empty = !0;
      var c = "" + u._i, d, g, v, _, C, $ = c.length, Z = 0, ce, Ot;
      for (v = Jt(u._f, u._locale).match(or) || [], Ot = v.length, d = 0; d < Ot; d++)
        _ = v[d], g = (c.match(ns(_, u)) || [])[0], g && (C = c.substr(0, c.indexOf(g)), C.length > 0 && x(u).unusedInput.push(C), c = c.slice(
          c.indexOf(g) + g.length
        ), Z += g.length), Ut[_] ? (g ? x(u).empty = !1 : x(u).unusedTokens.push(_), qo(_, g, u)) : u._strict && !g && x(u).unusedTokens.push(_);
      x(u).charsLeftOver = $ - Z, c.length > 0 && x(u).unusedInput.push(c), u._a[D] <= 12 && x(u).bigHour === !0 && u._a[D] > 0 && (x(u).bigHour = void 0), x(u).parsedDateParts = u._a.slice(0), x(u).meridiem = u._meridiem, u._a[D] = Rp(
        u._locale,
        u._a[D],
        u._meridiem
      ), ce = x(u).era, ce !== null && (u._a[tt] = u._locale.erasConvertYear(ce, u._a[tt])), ru(u), eu(u);
    }
    function Rp(u, c, d) {
      var g;
      return d == null ? c : u.meridiemHour != null ? u.meridiemHour(c, d) : (u.isPM != null && (g = u.isPM(d), g && c < 12 && (c += 12), !g && c === 12 && (c = 0)), c);
    }
    function Ip(u) {
      var c, d, g, v, _, C, $ = !1, Z = u._f.length;
      if (Z === 0) {
        x(u).invalidFormat = !0, u._d = /* @__PURE__ */ new Date(NaN);
        return;
      }
      for (v = 0; v < Z; v++)
        _ = 0, C = !1, c = fe({}, u), u._useUTC != null && (c._useUTC = u._useUTC), c._f = u._f[v], nu(c), O(c) && (C = !0), _ += x(c).charsLeftOver, _ += x(c).unusedTokens.length * 10, x(c).score = _, $ ? _ < g && (g = _, d = c) : (g == null || _ < g || C) && (g = _, d = c, C && ($ = !0));
      w(u, d || c);
    }
    function Np(u) {
      if (!u._d) {
        var c = U(u._i), d = c.day === void 0 ? c.date : c.day;
        u._a = m(
          [c.year, c.month, d, c.hour, c.minute, c.second, c.millisecond],
          function(g) {
            return g && parseInt(g, 10);
          }
        ), ru(u);
      }
    }
    function Lp(u) {
      var c = new ae(eu(zc(u)));
      return c._nextDay && (c.add(1, "d"), c._nextDay = void 0), c;
    }
    function zc(u) {
      var c = u._i, d = u._f;
      return u._locale = u._locale || Gr(u._l), c === null || d === void 0 && c === "" ? I({ nullInput: !0 }) : (typeof c == "string" && (u._i = c = u._locale.preparse(c)), B(c) ? new ae(eu(c)) : (p(c) ? u._d = c : i(d) ? Ip(u) : d ? nu(u) : Fp(u), O(u) || (u._d = null), u));
    }
    function Fp(u) {
      var c = u._i;
      s(c) ? u._d = new Date(n.now()) : p(c) ? u._d = new Date(c.valueOf()) : typeof c == "string" ? Mp(u) : i(c) ? (u._a = m(c.slice(0), function(d) {
        return parseInt(d, 10);
      }), ru(u)) : o(c) ? Np(u) : f(c) ? u._d = new Date(c) : n.createFromInputFallback(u);
    }
    function Wc(u, c, d, g, v) {
      var _ = {};
      return (c === !0 || c === !1) && (g = c, c = void 0), (d === !0 || d === !1) && (g = d, d = void 0), (o(u) && h(u) || i(u) && u.length === 0) && (u = void 0), _._isAMomentObject = !0, _._useUTC = _._isUTC = v, _._l = d, _._i = u, _._f = c, _._strict = g, Lp(_);
    }
    function Me(u, c, d, g) {
      return Wc(u, c, d, g, !1);
    }
    var $p = be(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var u = Me.apply(null, arguments);
        return this.isValid() && u.isValid() ? u < this ? this : u : I();
      }
    ), Yp = be(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var u = Me.apply(null, arguments);
        return this.isValid() && u.isValid() ? u > this ? this : u : I();
      }
    );
    function Bc(u, c) {
      var d, g;
      if (c.length === 1 && i(c[0]) && (c = c[0]), !c.length)
        return Me();
      for (d = c[0], g = 1; g < c.length; ++g)
        (!c[g].isValid() || c[g][u](d)) && (d = c[g]);
      return d;
    }
    function Up() {
      var u = [].slice.call(arguments, 0);
      return Bc("isBefore", u);
    }
    function zp() {
      var u = [].slice.call(arguments, 0);
      return Bc("isAfter", u);
    }
    var Wp = function() {
      return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
    }, ga = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];
    function Bp(u) {
      var c, d = !1, g, v = ga.length;
      for (c in u)
        if (l(u, c) && !(Ye.call(ga, c) !== -1 && (u[c] == null || !isNaN(u[c]))))
          return !1;
      for (g = 0; g < v; ++g)
        if (u[ga[g]]) {
          if (d)
            return !1;
          parseFloat(u[ga[g]]) !== re(u[ga[g]]) && (d = !0);
        }
      return !0;
    }
    function Hp() {
      return this._isValid;
    }
    function Gp() {
      return fr(NaN);
    }
    function os(u) {
      var c = U(u), d = c.year || 0, g = c.quarter || 0, v = c.month || 0, _ = c.week || c.isoWeek || 0, C = c.day || 0, $ = c.hour || 0, Z = c.minute || 0, ce = c.second || 0, Ot = c.millisecond || 0;
      this._isValid = Bp(c), this._milliseconds = +Ot + ce * 1e3 + // 1000
      Z * 6e4 + // 1000 * 60
      $ * 1e3 * 60 * 60, this._days = +C + _ * 7, this._months = +v + g * 3 + d * 12, this._data = {}, this._locale = Gr(), this._bubble();
    }
    function us(u) {
      return u instanceof os;
    }
    function iu(u) {
      return u < 0 ? Math.round(-1 * u) * -1 : Math.round(u);
    }
    function Vp(u, c, d) {
      var g = Math.min(u.length, c.length), v = Math.abs(u.length - c.length), _ = 0, C;
      for (C = 0; C < g; C++)
        (d && u[C] !== c[C] || !d && re(u[C]) !== re(c[C])) && _++;
      return _ + v;
    }
    function Hc(u, c) {
      z(u, 0, 0, function() {
        var d = this.utcOffset(), g = "+";
        return d < 0 && (d = -d, g = "-"), g + Fe(~~(d / 60), 2) + c + Fe(~~d % 60, 2);
      });
    }
    Hc("Z", ":"), Hc("ZZ", ""), F("Z", _n), F("ZZ", _n), me(["Z", "ZZ"], function(u, c, d) {
      d._useUTC = !0, d._tzm = au(_n, u);
    });
    var Kp = /([\+\-]|\d\d)/gi;
    function au(u, c) {
      var d = (c || "").match(u), g, v, _;
      return d === null ? null : (g = d[d.length - 1] || [], v = (g + "").match(Kp) || ["-", 0, 0], _ = +(v[1] * 60) + re(v[2]), _ === 0 ? 0 : v[0] === "+" ? _ : -_);
    }
    function su(u, c) {
      var d, g;
      return c._isUTC ? (d = c.clone(), g = (B(u) || p(u) ? u.valueOf() : Me(u).valueOf()) - d.valueOf(), d._d.setTime(d._d.valueOf() + g), n.updateOffset(d, !1), d) : Me(u).local();
    }
    function ou(u) {
      return -Math.round(u._d.getTimezoneOffset());
    }
    n.updateOffset = function() {
    };
    function qp(u, c, d) {
      var g = this._offset || 0, v;
      if (!this.isValid())
        return u != null ? this : NaN;
      if (u != null) {
        if (typeof u == "string") {
          if (u = au(_n, u), u === null)
            return this;
        } else
          Math.abs(u) < 16 && !d && (u = u * 60);
        return !this._isUTC && c && (v = ou(this)), this._offset = u, this._isUTC = !0, v != null && this.add(v, "m"), g !== u && (!c || this._changeInProgress ? qc(
          this,
          fr(u - g, "m"),
          1,
          !1
        ) : this._changeInProgress || (this._changeInProgress = !0, n.updateOffset(this, !0), this._changeInProgress = null)), this;
      } else
        return this._isUTC ? g : ou(this);
    }
    function Zp(u, c) {
      return u != null ? (typeof u != "string" && (u = -u), this.utcOffset(u, c), this) : -this.utcOffset();
    }
    function Jp(u) {
      return this.utcOffset(0, u);
    }
    function Xp(u) {
      return this._isUTC && (this.utcOffset(0, u), this._isUTC = !1, u && this.subtract(ou(this), "m")), this;
    }
    function Qp() {
      if (this._tzm != null)
        this.utcOffset(this._tzm, !1, !0);
      else if (typeof this._i == "string") {
        var u = au(Vo, this._i);
        u != null ? this.utcOffset(u) : this.utcOffset(0, !0);
      }
      return this;
    }
    function e1(u) {
      return this.isValid() ? (u = u ? Me(u).utcOffset() : 0, (this.utcOffset() - u) % 60 === 0) : !1;
    }
    function t1() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function r1() {
      if (!s(this._isDSTShifted))
        return this._isDSTShifted;
      var u = {}, c;
      return fe(u, this), u = zc(u), u._a ? (c = u._isUTC ? S(u._a) : Me(u._a), this._isDSTShifted = this.isValid() && Vp(u._a, c.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
    }
    function n1() {
      return this.isValid() ? !this._isUTC : !1;
    }
    function i1() {
      return this.isValid() ? this._isUTC : !1;
    }
    function Gc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : !1;
    }
    var a1 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, s1 = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function fr(u, c) {
      var d = u, g = null, v, _, C;
      return us(u) ? d = {
        ms: u._milliseconds,
        d: u._days,
        M: u._months
      } : f(u) || !isNaN(+u) ? (d = {}, c ? d[c] = +u : d.milliseconds = +u) : (g = a1.exec(u)) ? (v = g[1] === "-" ? -1 : 1, d = {
        y: 0,
        d: re(g[b]) * v,
        h: re(g[D]) * v,
        m: re(g[R]) * v,
        s: re(g[H]) * v,
        ms: re(iu(g[te] * 1e3)) * v
        // the millisecond decimal point is included in the match
      }) : (g = s1.exec(u)) ? (v = g[1] === "-" ? -1 : 1, d = {
        y: Wn(g[2], v),
        M: Wn(g[3], v),
        w: Wn(g[4], v),
        d: Wn(g[5], v),
        h: Wn(g[6], v),
        m: Wn(g[7], v),
        s: Wn(g[8], v)
      }) : d == null ? d = {} : typeof d == "object" && ("from" in d || "to" in d) && (C = o1(
        Me(d.from),
        Me(d.to)
      ), d = {}, d.ms = C.milliseconds, d.M = C.months), _ = new os(d), us(u) && l(u, "_locale") && (_._locale = u._locale), us(u) && l(u, "_isValid") && (_._isValid = u._isValid), _;
    }
    fr.fn = os.prototype, fr.invalid = Gp;
    function Wn(u, c) {
      var d = u && parseFloat(u.replace(",", "."));
      return (isNaN(d) ? 0 : d) * c;
    }
    function Vc(u, c) {
      var d = {};
      return d.months = c.month() - u.month() + (c.year() - u.year()) * 12, u.clone().add(d.months, "M").isAfter(c) && --d.months, d.milliseconds = +c - +u.clone().add(d.months, "M"), d;
    }
    function o1(u, c) {
      var d;
      return u.isValid() && c.isValid() ? (c = su(c, u), u.isBefore(c) ? d = Vc(u, c) : (d = Vc(c, u), d.milliseconds = -d.milliseconds, d.months = -d.months), d) : { milliseconds: 0, months: 0 };
    }
    function Kc(u, c) {
      return function(d, g) {
        var v, _;
        return g !== null && !isNaN(+g) && (ve(
          c,
          "moment()." + c + "(period, number) is deprecated. Please use moment()." + c + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
        ), _ = d, d = g, g = _), v = fr(d, g), qc(this, v, u), this;
      };
    }
    function qc(u, c, d, g) {
      var v = c._milliseconds, _ = iu(c._days), C = iu(c._months);
      u.isValid() && (g = g ?? !0, C && Mc(u, nt(u, "Month") + C * d), _ && Wr(u, "Date", nt(u, "Date") + _ * d), v && u._d.setTime(u._d.valueOf() + v * d), g && n.updateOffset(u, _ || C));
    }
    var u1 = Kc(1, "add"), l1 = Kc(-1, "subtract");
    function Zc(u) {
      return typeof u == "string" || u instanceof String;
    }
    function c1(u) {
      return B(u) || p(u) || Zc(u) || f(u) || d1(u) || f1(u) || u === null || u === void 0;
    }
    function f1(u) {
      var c = o(u) && !h(u), d = !1, g = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms"
      ], v, _, C = g.length;
      for (v = 0; v < C; v += 1)
        _ = g[v], d = d || l(u, _);
      return c && d;
    }
    function d1(u) {
      var c = i(u), d = !1;
      return c && (d = u.filter(function(g) {
        return !f(g) && Zc(u);
      }).length === 0), c && d;
    }
    function h1(u) {
      var c = o(u) && !h(u), d = !1, g = [
        "sameDay",
        "nextDay",
        "lastDay",
        "nextWeek",
        "lastWeek",
        "sameElse"
      ], v, _;
      for (v = 0; v < g.length; v += 1)
        _ = g[v], d = d || l(u, _);
      return c && d;
    }
    function y1(u, c) {
      var d = u.diff(c, "days", !0);
      return d < -6 ? "sameElse" : d < -1 ? "lastWeek" : d < 0 ? "lastDay" : d < 1 ? "sameDay" : d < 2 ? "nextDay" : d < 7 ? "nextWeek" : "sameElse";
    }
    function g1(u, c) {
      arguments.length === 1 && (arguments[0] ? c1(arguments[0]) ? (u = arguments[0], c = void 0) : h1(arguments[0]) && (c = arguments[0], u = void 0) : (u = void 0, c = void 0));
      var d = u || Me(), g = su(d, this).startOf("day"), v = n.calendarFormat(this, g) || "sameElse", _ = c && (q(c[v]) ? c[v].call(this, d) : c[v]);
      return this.format(
        _ || this.localeData().calendar(v, this, Me(d))
      );
    }
    function p1() {
      return new ae(this);
    }
    function v1(u, c) {
      var d = B(u) ? u : Me(u);
      return this.isValid() && d.isValid() ? (c = N(c) || "millisecond", c === "millisecond" ? this.valueOf() > d.valueOf() : d.valueOf() < this.clone().startOf(c).valueOf()) : !1;
    }
    function m1(u, c) {
      var d = B(u) ? u : Me(u);
      return this.isValid() && d.isValid() ? (c = N(c) || "millisecond", c === "millisecond" ? this.valueOf() < d.valueOf() : this.clone().endOf(c).valueOf() < d.valueOf()) : !1;
    }
    function b1(u, c, d, g) {
      var v = B(u) ? u : Me(u), _ = B(c) ? c : Me(c);
      return this.isValid() && v.isValid() && _.isValid() ? (g = g || "()", (g[0] === "(" ? this.isAfter(v, d) : !this.isBefore(v, d)) && (g[1] === ")" ? this.isBefore(_, d) : !this.isAfter(_, d))) : !1;
    }
    function _1(u, c) {
      var d = B(u) ? u : Me(u), g;
      return this.isValid() && d.isValid() ? (c = N(c) || "millisecond", c === "millisecond" ? this.valueOf() === d.valueOf() : (g = d.valueOf(), this.clone().startOf(c).valueOf() <= g && g <= this.clone().endOf(c).valueOf())) : !1;
    }
    function w1(u, c) {
      return this.isSame(u, c) || this.isAfter(u, c);
    }
    function S1(u, c) {
      return this.isSame(u, c) || this.isBefore(u, c);
    }
    function x1(u, c, d) {
      var g, v, _;
      if (!this.isValid())
        return NaN;
      if (g = su(u, this), !g.isValid())
        return NaN;
      switch (v = (g.utcOffset() - this.utcOffset()) * 6e4, c = N(c), c) {
        case "year":
          _ = ls(this, g) / 12;
          break;
        case "month":
          _ = ls(this, g);
          break;
        case "quarter":
          _ = ls(this, g) / 3;
          break;
        case "second":
          _ = (this - g) / 1e3;
          break;
        case "minute":
          _ = (this - g) / 6e4;
          break;
        case "hour":
          _ = (this - g) / 36e5;
          break;
        case "day":
          _ = (this - g - v) / 864e5;
          break;
        case "week":
          _ = (this - g - v) / 6048e5;
          break;
        default:
          _ = this - g;
      }
      return d ? _ : Et(_);
    }
    function ls(u, c) {
      if (u.date() < c.date())
        return -ls(c, u);
      var d = (c.year() - u.year()) * 12 + (c.month() - u.month()), g = u.clone().add(d, "months"), v, _;
      return c - g < 0 ? (v = u.clone().add(d - 1, "months"), _ = (c - g) / (g - v)) : (v = u.clone().add(d + 1, "months"), _ = (c - g) / (v - g)), -(d + _) || 0;
    }
    n.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", n.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function T1() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function E1(u) {
      if (!this.isValid())
        return null;
      var c = u !== !0, d = c ? this.clone().utc() : this;
      return d.year() < 0 || d.year() > 9999 ? Pt(
        d,
        c ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
      ) : q(Date.prototype.toISOString) ? c ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Pt(d, "Z")) : Pt(
        d,
        c ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    function O1() {
      if (!this.isValid())
        return "moment.invalid(/* " + this._i + " */)";
      var u = "moment", c = "", d, g, v, _;
      return this.isLocal() || (u = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", c = "Z"), d = "[" + u + '("]', g = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", v = "-MM-DD[T]HH:mm:ss.SSS", _ = c + '[")]', this.format(d + g + v + _);
    }
    function C1(u) {
      u || (u = this.isUtc() ? n.defaultFormatUtc : n.defaultFormat);
      var c = Pt(this, u);
      return this.localeData().postformat(c);
    }
    function k1(u, c) {
      return this.isValid() && (B(u) && u.isValid() || Me(u).isValid()) ? fr({ to: this, from: u }).locale(this.locale()).humanize(!c) : this.localeData().invalidDate();
    }
    function D1(u) {
      return this.from(Me(), u);
    }
    function j1(u, c) {
      return this.isValid() && (B(u) && u.isValid() || Me(u).isValid()) ? fr({ from: this, to: u }).locale(this.locale()).humanize(!c) : this.localeData().invalidDate();
    }
    function M1(u) {
      return this.to(Me(), u);
    }
    function Jc(u) {
      var c;
      return u === void 0 ? this._locale._abbr : (c = Gr(u), c != null && (this._locale = c), this);
    }
    var Xc = be(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(u) {
        return u === void 0 ? this.localeData() : this.locale(u);
      }
    );
    function Qc() {
      return this._locale;
    }
    var cs = 1e3, Di = 60 * cs, fs = 60 * Di, ef = (365 * 400 + 97) * 24 * fs;
    function ji(u, c) {
      return (u % c + c) % c;
    }
    function tf(u, c, d) {
      return u < 100 && u >= 0 ? new Date(u + 400, c, d) - ef : new Date(u, c, d).valueOf();
    }
    function rf(u, c, d) {
      return u < 100 && u >= 0 ? Date.UTC(u + 400, c, d) - ef : Date.UTC(u, c, d);
    }
    function P1(u) {
      var c, d;
      if (u = N(u), u === void 0 || u === "millisecond" || !this.isValid())
        return this;
      switch (d = this._isUTC ? rf : tf, u) {
        case "year":
          c = d(this.year(), 0, 1);
          break;
        case "quarter":
          c = d(
            this.year(),
            this.month() - this.month() % 3,
            1
          );
          break;
        case "month":
          c = d(this.year(), this.month(), 1);
          break;
        case "week":
          c = d(
            this.year(),
            this.month(),
            this.date() - this.weekday()
          );
          break;
        case "isoWeek":
          c = d(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1)
          );
          break;
        case "day":
        case "date":
          c = d(this.year(), this.month(), this.date());
          break;
        case "hour":
          c = this._d.valueOf(), c -= ji(
            c + (this._isUTC ? 0 : this.utcOffset() * Di),
            fs
          );
          break;
        case "minute":
          c = this._d.valueOf(), c -= ji(c, Di);
          break;
        case "second":
          c = this._d.valueOf(), c -= ji(c, cs);
          break;
      }
      return this._d.setTime(c), n.updateOffset(this, !0), this;
    }
    function A1(u) {
      var c, d;
      if (u = N(u), u === void 0 || u === "millisecond" || !this.isValid())
        return this;
      switch (d = this._isUTC ? rf : tf, u) {
        case "year":
          c = d(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          c = d(
            this.year(),
            this.month() - this.month() % 3 + 3,
            1
          ) - 1;
          break;
        case "month":
          c = d(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          c = d(
            this.year(),
            this.month(),
            this.date() - this.weekday() + 7
          ) - 1;
          break;
        case "isoWeek":
          c = d(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7
          ) - 1;
          break;
        case "day":
        case "date":
          c = d(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          c = this._d.valueOf(), c += fs - ji(
            c + (this._isUTC ? 0 : this.utcOffset() * Di),
            fs
          ) - 1;
          break;
        case "minute":
          c = this._d.valueOf(), c += Di - ji(c, Di) - 1;
          break;
        case "second":
          c = this._d.valueOf(), c += cs - ji(c, cs) - 1;
          break;
      }
      return this._d.setTime(c), n.updateOffset(this, !0), this;
    }
    function R1() {
      return this._d.valueOf() - (this._offset || 0) * 6e4;
    }
    function I1() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function N1() {
      return new Date(this.valueOf());
    }
    function L1() {
      var u = this;
      return [
        u.year(),
        u.month(),
        u.date(),
        u.hour(),
        u.minute(),
        u.second(),
        u.millisecond()
      ];
    }
    function F1() {
      var u = this;
      return {
        years: u.year(),
        months: u.month(),
        date: u.date(),
        hours: u.hours(),
        minutes: u.minutes(),
        seconds: u.seconds(),
        milliseconds: u.milliseconds()
      };
    }
    function $1() {
      return this.isValid() ? this.toISOString() : null;
    }
    function Y1() {
      return O(this);
    }
    function U1() {
      return w({}, x(this));
    }
    function z1() {
      return x(this).overflow;
    }
    function W1() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    z("N", 0, 0, "eraAbbr"), z("NN", 0, 0, "eraAbbr"), z("NNN", 0, 0, "eraAbbr"), z("NNNN", 0, 0, "eraName"), z("NNNNN", 0, 0, "eraNarrow"), z("y", ["y", 1], "yo", "eraYear"), z("y", ["yy", 2], 0, "eraYear"), z("y", ["yyy", 3], 0, "eraYear"), z("y", ["yyyy", 4], 0, "eraYear"), F("N", uu), F("NN", uu), F("NNN", uu), F("NNNN", ev), F("NNNNN", tv), me(
      ["N", "NN", "NNN", "NNNN", "NNNNN"],
      function(u, c, d, g) {
        var v = d._locale.erasParse(u, g, d._strict);
        v ? x(d).era = v : x(d).invalidEra = u;
      }
    ), F("y", bn), F("yy", bn), F("yyy", bn), F("yyyy", bn), F("yo", rv), me(["y", "yy", "yyy", "yyyy"], tt), me(["yo"], function(u, c, d, g) {
      var v;
      d._locale._eraYearOrdinalRegex && (v = u.match(d._locale._eraYearOrdinalRegex)), d._locale.eraYearOrdinalParse ? c[tt] = d._locale.eraYearOrdinalParse(u, v) : c[tt] = parseInt(u, 10);
    });
    function B1(u, c) {
      var d, g, v, _ = this._eras || Gr("en")._eras;
      for (d = 0, g = _.length; d < g; ++d) {
        switch (typeof _[d].since) {
          case "string":
            v = n(_[d].since).startOf("day"), _[d].since = v.valueOf();
            break;
        }
        switch (typeof _[d].until) {
          case "undefined":
            _[d].until = 1 / 0;
            break;
          case "string":
            v = n(_[d].until).startOf("day").valueOf(), _[d].until = v.valueOf();
            break;
        }
      }
      return _;
    }
    function H1(u, c, d) {
      var g, v, _ = this.eras(), C, $, Z;
      for (u = u.toUpperCase(), g = 0, v = _.length; g < v; ++g)
        if (C = _[g].name.toUpperCase(), $ = _[g].abbr.toUpperCase(), Z = _[g].narrow.toUpperCase(), d)
          switch (c) {
            case "N":
            case "NN":
            case "NNN":
              if ($ === u)
                return _[g];
              break;
            case "NNNN":
              if (C === u)
                return _[g];
              break;
            case "NNNNN":
              if (Z === u)
                return _[g];
              break;
          }
        else if ([C, $, Z].indexOf(u) >= 0)
          return _[g];
    }
    function G1(u, c) {
      var d = u.since <= u.until ? 1 : -1;
      return c === void 0 ? n(u.since).year() : n(u.since).year() + (c - u.offset) * d;
    }
    function V1() {
      var u, c, d, g = this.localeData().eras();
      for (u = 0, c = g.length; u < c; ++u)
        if (d = this.clone().startOf("day").valueOf(), g[u].since <= d && d <= g[u].until || g[u].until <= d && d <= g[u].since)
          return g[u].name;
      return "";
    }
    function K1() {
      var u, c, d, g = this.localeData().eras();
      for (u = 0, c = g.length; u < c; ++u)
        if (d = this.clone().startOf("day").valueOf(), g[u].since <= d && d <= g[u].until || g[u].until <= d && d <= g[u].since)
          return g[u].narrow;
      return "";
    }
    function q1() {
      var u, c, d, g = this.localeData().eras();
      for (u = 0, c = g.length; u < c; ++u)
        if (d = this.clone().startOf("day").valueOf(), g[u].since <= d && d <= g[u].until || g[u].until <= d && d <= g[u].since)
          return g[u].abbr;
      return "";
    }
    function Z1() {
      var u, c, d, g, v = this.localeData().eras();
      for (u = 0, c = v.length; u < c; ++u)
        if (d = v[u].since <= v[u].until ? 1 : -1, g = this.clone().startOf("day").valueOf(), v[u].since <= g && g <= v[u].until || v[u].until <= g && g <= v[u].since)
          return (this.year() - n(v[u].since).year()) * d + v[u].offset;
      return this.year();
    }
    function J1(u) {
      return l(this, "_erasNameRegex") || lu.call(this), u ? this._erasNameRegex : this._erasRegex;
    }
    function X1(u) {
      return l(this, "_erasAbbrRegex") || lu.call(this), u ? this._erasAbbrRegex : this._erasRegex;
    }
    function Q1(u) {
      return l(this, "_erasNarrowRegex") || lu.call(this), u ? this._erasNarrowRegex : this._erasRegex;
    }
    function uu(u, c) {
      return c.erasAbbrRegex(u);
    }
    function ev(u, c) {
      return c.erasNameRegex(u);
    }
    function tv(u, c) {
      return c.erasNarrowRegex(u);
    }
    function rv(u, c) {
      return c._eraYearOrdinalRegex || bn;
    }
    function lu() {
      var u = [], c = [], d = [], g = [], v, _, C, $, Z, ce = this.eras();
      for (v = 0, _ = ce.length; v < _; ++v)
        C = Qt(ce[v].name), $ = Qt(ce[v].abbr), Z = Qt(ce[v].narrow), c.push(C), u.push($), d.push(Z), g.push(C), g.push($), g.push(Z);
      this._erasRegex = new RegExp("^(" + g.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
        "^(" + d.join("|") + ")",
        "i"
      );
    }
    z(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    }), z(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });
    function ds(u, c) {
      z(0, [u, u.length], 0, c);
    }
    ds("gggg", "weekYear"), ds("ggggg", "weekYear"), ds("GGGG", "isoWeekYear"), ds("GGGGG", "isoWeekYear"), F("G", Oi), F("g", Oi), F("GG", _e, le), F("gg", _e, le), F("GGGG", oa, zr), F("gggg", oa, zr), F("GGGGG", Ei, lr), F("ggggg", Ei, lr), wn(
      ["gggg", "ggggg", "GGGG", "GGGGG"],
      function(u, c, d, g) {
        c[g.substr(0, 2)] = re(u);
      }
    ), wn(["gg", "GG"], function(u, c, d, g) {
      c[g] = n.parseTwoDigitYear(u);
    });
    function nv(u) {
      return nf.call(
        this,
        u,
        this.week(),
        this.weekday() + this.localeData()._week.dow,
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }
    function iv(u) {
      return nf.call(
        this,
        u,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }
    function av() {
      return Hr(this.year(), 1, 4);
    }
    function sv() {
      return Hr(this.isoWeekYear(), 1, 4);
    }
    function ov() {
      var u = this.localeData()._week;
      return Hr(this.year(), u.dow, u.doy);
    }
    function uv() {
      var u = this.localeData()._week;
      return Hr(this.weekYear(), u.dow, u.doy);
    }
    function nf(u, c, d, g, v) {
      var _;
      return u == null ? da(this, g, v).year : (_ = Hr(u, g, v), c > _ && (c = _), lv.call(this, u, c, d, g, v));
    }
    function lv(u, c, d, g, v) {
      var _ = Rc(u, c, d, g, v), C = fa(_.year, 0, _.dayOfYear);
      return this.year(C.getUTCFullYear()), this.month(C.getUTCMonth()), this.date(C.getUTCDate()), this;
    }
    z("Q", 0, "Qo", "quarter"), F("Q", ie), me("Q", function(u, c) {
      c[cr] = (re(u) - 1) * 3;
    });
    function cv(u) {
      return u == null ? Math.ceil((this.month() + 1) / 3) : this.month((u - 1) * 3 + this.month() % 3);
    }
    z("D", ["DD", 2], "Do", "date"), F("D", _e, Er), F("DD", _e, le), F("Do", function(u, c) {
      return u ? c._dayOfMonthOrdinalParse || c._ordinalParse : c._dayOfMonthOrdinalParseLenient;
    }), me(["D", "DD"], b), me("Do", function(u, c) {
      c[b] = re(u.match(_e)[0]);
    });
    var af = Oe("Date", !0);
    z("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), F("DDD", mn), F("DDDD", Ze), me(["DDD", "DDDD"], function(u, c, d) {
      d._dayOfYear = re(u);
    });
    function fv(u) {
      var c = Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
      ) + 1;
      return u == null ? c : this.add(u - c, "d");
    }
    z("m", ["mm", 2], 0, "minute"), F("m", _e, Un), F("mm", _e, le), me(["m", "mm"], R);
    var dv = Oe("Minutes", !1);
    z("s", ["ss", 2], 0, "second"), F("s", _e, Un), F("ss", _e, le), me(["s", "ss"], H);
    var hv = Oe("Seconds", !1);
    z("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    }), z(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    }), z(0, ["SSS", 3], 0, "millisecond"), z(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    }), z(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    }), z(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1e3;
    }), z(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 1e4;
    }), z(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 1e5;
    }), z(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1e6;
    }), F("S", mn, ie), F("SS", mn, le), F("SSS", mn, Ze);
    var xn, sf;
    for (xn = "SSSS"; xn.length <= 9; xn += "S")
      F(xn, bn);
    function yv(u, c) {
      c[te] = re(("0." + u) * 1e3);
    }
    for (xn = "S"; xn.length <= 9; xn += "S")
      me(xn, yv);
    sf = Oe("Milliseconds", !1), z("z", 0, 0, "zoneAbbr"), z("zz", 0, 0, "zoneName");
    function gv() {
      return this._isUTC ? "UTC" : "";
    }
    function pv() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var P = ae.prototype;
    P.add = u1, P.calendar = g1, P.clone = p1, P.diff = x1, P.endOf = A1, P.format = C1, P.from = k1, P.fromNow = D1, P.to = j1, P.toNow = M1, P.get = Br, P.invalidAt = z1, P.isAfter = v1, P.isBefore = m1, P.isBetween = b1, P.isSame = _1, P.isSameOrAfter = w1, P.isSameOrBefore = S1, P.isValid = Y1, P.lang = Xc, P.locale = Jc, P.localeData = Qc, P.max = Yp, P.min = $p, P.parsingFlags = U1, P.set = ct, P.startOf = P1, P.subtract = l1, P.toArray = L1, P.toObject = F1, P.toDate = N1, P.toISOString = E1, P.inspect = O1, typeof Symbol < "u" && Symbol.for != null && (P[Symbol.for("nodejs.util.inspect.custom")] = function() {
      return "Moment<" + this.format() + ">";
    }), P.toJSON = $1, P.toString = T1, P.unix = I1, P.valueOf = R1, P.creationData = W1, P.eraName = V1, P.eraNarrow = K1, P.eraAbbr = q1, P.eraYear = Z1, P.year = rt, P.isLeapYear = $e, P.weekYear = nv, P.isoWeekYear = iv, P.quarter = P.quarters = cv, P.month = Pc, P.daysInMonth = Ng, P.week = P.weeks = Bg, P.isoWeek = P.isoWeeks = Hg, P.weeksInYear = ov, P.weeksInWeekYear = uv, P.isoWeeksInYear = av, P.isoWeeksInISOWeekYear = sv, P.date = af, P.day = P.days = ip, P.weekday = ap, P.isoWeekday = sp, P.dayOfYear = fv, P.hour = P.hours = hp, P.minute = P.minutes = dv, P.second = P.seconds = hv, P.millisecond = P.milliseconds = sf, P.utcOffset = qp, P.utc = Jp, P.local = Xp, P.parseZone = Qp, P.hasAlignedHourOffset = e1, P.isDST = t1, P.isLocal = n1, P.isUtcOffset = i1, P.isUtc = Gc, P.isUTC = Gc, P.zoneAbbr = gv, P.zoneName = pv, P.dates = be(
      "dates accessor is deprecated. Use date instead.",
      af
    ), P.months = be(
      "months accessor is deprecated. Use month instead",
      Pc
    ), P.years = be(
      "years accessor is deprecated. Use year instead",
      rt
    ), P.zone = be(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      Zp
    ), P.isDSTShifted = be(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      r1
    );
    function vv(u) {
      return Me(u * 1e3);
    }
    function mv() {
      return Me.apply(null, arguments).parseZone();
    }
    function of(u) {
      return u;
    }
    var ye = xt.prototype;
    ye.calendar = $t, ye.longDateFormat = yn, ye.invalidDate = Yr, ye.ordinal = Ur, ye.preparse = of, ye.postformat = of, ye.relativeTime = Ti, ye.pastFuture = pn, ye.set = qe, ye.eras = B1, ye.erasParse = H1, ye.erasConvertYear = G1, ye.erasAbbrRegex = X1, ye.erasNameRegex = J1, ye.erasNarrowRegex = Q1, ye.months = Pg, ye.monthsShort = Ag, ye.monthsParse = Ig, ye.monthsRegex = Fg, ye.monthsShortRegex = Lg, ye.week = Yg, ye.firstDayOfYear = Wg, ye.firstDayOfWeek = zg, ye.weekdays = Qg, ye.weekdaysMin = tp, ye.weekdaysShort = ep, ye.weekdaysParse = np, ye.weekdaysRegex = op, ye.weekdaysShortRegex = up, ye.weekdaysMinRegex = lp, ye.isPM = fp, ye.meridiem = yp;
    function hs(u, c, d, g) {
      var v = Gr(), _ = S().set(g, c);
      return v[d](_, u);
    }
    function uf(u, c, d) {
      if (f(u) && (c = u, u = void 0), u = u || "", c != null)
        return hs(u, c, d, "month");
      var g, v = [];
      for (g = 0; g < 12; g++)
        v[g] = hs(u, g, d, "month");
      return v;
    }
    function cu(u, c, d, g) {
      typeof u == "boolean" ? (f(c) && (d = c, c = void 0), c = c || "") : (c = u, d = c, u = !1, f(c) && (d = c, c = void 0), c = c || "");
      var v = Gr(), _ = u ? v._week.dow : 0, C, $ = [];
      if (d != null)
        return hs(c, (d + _) % 7, g, "day");
      for (C = 0; C < 7; C++)
        $[C] = hs(c, (C + _) % 7, g, "day");
      return $;
    }
    function bv(u, c) {
      return uf(u, c, "months");
    }
    function _v(u, c) {
      return uf(u, c, "monthsShort");
    }
    function wv(u, c, d) {
      return cu(u, c, d, "weekdays");
    }
    function Sv(u, c, d) {
      return cu(u, c, d, "weekdaysShort");
    }
    function xv(u, c, d) {
      return cu(u, c, d, "weekdaysMin");
    }
    Sn("en", {
      eras: [
        {
          since: "0001-01-01",
          until: 1 / 0,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        },
        {
          since: "0000-12-31",
          until: -1 / 0,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }
      ],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(u) {
        var c = u % 10, d = re(u % 100 / 10) === 1 ? "th" : c === 1 ? "st" : c === 2 ? "nd" : c === 3 ? "rd" : "th";
        return u + d;
      }
    }), n.lang = be(
      "moment.lang is deprecated. Use moment.locale instead.",
      Sn
    ), n.langData = be(
      "moment.langData is deprecated. Use moment.localeData instead.",
      Gr
    );
    var Vr = Math.abs;
    function Tv() {
      var u = this._data;
      return this._milliseconds = Vr(this._milliseconds), this._days = Vr(this._days), this._months = Vr(this._months), u.milliseconds = Vr(u.milliseconds), u.seconds = Vr(u.seconds), u.minutes = Vr(u.minutes), u.hours = Vr(u.hours), u.months = Vr(u.months), u.years = Vr(u.years), this;
    }
    function lf(u, c, d, g) {
      var v = fr(c, d);
      return u._milliseconds += g * v._milliseconds, u._days += g * v._days, u._months += g * v._months, u._bubble();
    }
    function Ev(u, c) {
      return lf(this, u, c, 1);
    }
    function Ov(u, c) {
      return lf(this, u, c, -1);
    }
    function cf(u) {
      return u < 0 ? Math.floor(u) : Math.ceil(u);
    }
    function Cv() {
      var u = this._milliseconds, c = this._days, d = this._months, g = this._data, v, _, C, $, Z;
      return u >= 0 && c >= 0 && d >= 0 || u <= 0 && c <= 0 && d <= 0 || (u += cf(fu(d) + c) * 864e5, c = 0, d = 0), g.milliseconds = u % 1e3, v = Et(u / 1e3), g.seconds = v % 60, _ = Et(v / 60), g.minutes = _ % 60, C = Et(_ / 60), g.hours = C % 24, c += Et(C / 24), Z = Et(ff(c)), d += Z, c -= cf(fu(Z)), $ = Et(d / 12), d %= 12, g.days = c, g.months = d, g.years = $, this;
    }
    function ff(u) {
      return u * 4800 / 146097;
    }
    function fu(u) {
      return u * 146097 / 4800;
    }
    function kv(u) {
      if (!this.isValid())
        return NaN;
      var c, d, g = this._milliseconds;
      if (u = N(u), u === "month" || u === "quarter" || u === "year")
        switch (c = this._days + g / 864e5, d = this._months + ff(c), u) {
          case "month":
            return d;
          case "quarter":
            return d / 3;
          case "year":
            return d / 12;
        }
      else
        switch (c = this._days + Math.round(fu(this._months)), u) {
          case "week":
            return c / 7 + g / 6048e5;
          case "day":
            return c + g / 864e5;
          case "hour":
            return c * 24 + g / 36e5;
          case "minute":
            return c * 1440 + g / 6e4;
          case "second":
            return c * 86400 + g / 1e3;
          case "millisecond":
            return Math.floor(c * 864e5) + g;
          default:
            throw new Error("Unknown unit " + u);
        }
    }
    function Kr(u) {
      return function() {
        return this.as(u);
      };
    }
    var df = Kr("ms"), Dv = Kr("s"), jv = Kr("m"), Mv = Kr("h"), Pv = Kr("d"), Av = Kr("w"), Rv = Kr("M"), Iv = Kr("Q"), Nv = Kr("y"), Lv = df;
    function Fv() {
      return fr(this);
    }
    function $v(u) {
      return u = N(u), this.isValid() ? this[u + "s"]() : NaN;
    }
    function Bn(u) {
      return function() {
        return this.isValid() ? this._data[u] : NaN;
      };
    }
    var Yv = Bn("milliseconds"), Uv = Bn("seconds"), zv = Bn("minutes"), Wv = Bn("hours"), Bv = Bn("days"), Hv = Bn("months"), Gv = Bn("years");
    function Vv() {
      return Et(this.days() / 7);
    }
    var qr = Math.round, Mi = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11
      // months to year
    };
    function Kv(u, c, d, g, v) {
      return v.relativeTime(c || 1, !!d, u, g);
    }
    function qv(u, c, d, g) {
      var v = fr(u).abs(), _ = qr(v.as("s")), C = qr(v.as("m")), $ = qr(v.as("h")), Z = qr(v.as("d")), ce = qr(v.as("M")), Ot = qr(v.as("w")), Zr = qr(v.as("y")), Tn = _ <= d.ss && ["s", _] || _ < d.s && ["ss", _] || C <= 1 && ["m"] || C < d.m && ["mm", C] || $ <= 1 && ["h"] || $ < d.h && ["hh", $] || Z <= 1 && ["d"] || Z < d.d && ["dd", Z];
      return d.w != null && (Tn = Tn || Ot <= 1 && ["w"] || Ot < d.w && ["ww", Ot]), Tn = Tn || ce <= 1 && ["M"] || ce < d.M && ["MM", ce] || Zr <= 1 && ["y"] || ["yy", Zr], Tn[2] = c, Tn[3] = +u > 0, Tn[4] = g, Kv.apply(null, Tn);
    }
    function Zv(u) {
      return u === void 0 ? qr : typeof u == "function" ? (qr = u, !0) : !1;
    }
    function Jv(u, c) {
      return Mi[u] === void 0 ? !1 : c === void 0 ? Mi[u] : (Mi[u] = c, u === "s" && (Mi.ss = c - 1), !0);
    }
    function Xv(u, c) {
      if (!this.isValid())
        return this.localeData().invalidDate();
      var d = !1, g = Mi, v, _;
      return typeof u == "object" && (c = u, u = !1), typeof u == "boolean" && (d = u), typeof c == "object" && (g = Object.assign({}, Mi, c), c.s != null && c.ss == null && (g.ss = c.s - 1)), v = this.localeData(), _ = qv(this, !d, g, v), d && (_ = v.pastFuture(+this, _)), v.postformat(_);
    }
    var du = Math.abs;
    function Pi(u) {
      return (u > 0) - (u < 0) || +u;
    }
    function ys() {
      if (!this.isValid())
        return this.localeData().invalidDate();
      var u = du(this._milliseconds) / 1e3, c = du(this._days), d = du(this._months), g, v, _, C, $ = this.asSeconds(), Z, ce, Ot, Zr;
      return $ ? (g = Et(u / 60), v = Et(g / 60), u %= 60, g %= 60, _ = Et(d / 12), d %= 12, C = u ? u.toFixed(3).replace(/\.?0+$/, "") : "", Z = $ < 0 ? "-" : "", ce = Pi(this._months) !== Pi($) ? "-" : "", Ot = Pi(this._days) !== Pi($) ? "-" : "", Zr = Pi(this._milliseconds) !== Pi($) ? "-" : "", Z + "P" + (_ ? ce + _ + "Y" : "") + (d ? ce + d + "M" : "") + (c ? Ot + c + "D" : "") + (v || g || u ? "T" : "") + (v ? Zr + v + "H" : "") + (g ? Zr + g + "M" : "") + (u ? Zr + C + "S" : "")) : "P0D";
    }
    var de = os.prototype;
    de.isValid = Hp, de.abs = Tv, de.add = Ev, de.subtract = Ov, de.as = kv, de.asMilliseconds = df, de.asSeconds = Dv, de.asMinutes = jv, de.asHours = Mv, de.asDays = Pv, de.asWeeks = Av, de.asMonths = Rv, de.asQuarters = Iv, de.asYears = Nv, de.valueOf = Lv, de._bubble = Cv, de.clone = Fv, de.get = $v, de.milliseconds = Yv, de.seconds = Uv, de.minutes = zv, de.hours = Wv, de.days = Bv, de.weeks = Vv, de.months = Hv, de.years = Gv, de.humanize = Xv, de.toISOString = ys, de.toString = ys, de.toJSON = ys, de.locale = Jc, de.localeData = Qc, de.toIsoString = be(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      ys
    ), de.lang = Xc, z("X", 0, 0, "unix"), z("x", 0, 0, "valueOf"), F("x", Oi), F("X", rs), me("X", function(u, c, d) {
      d._d = new Date(parseFloat(u) * 1e3);
    }), me("x", function(u, c, d) {
      d._d = new Date(re(u));
    });
    //! moment.js
    return n.version = "2.30.1", a(Me), n.fn = P, n.min = Up, n.max = zp, n.now = Wp, n.utc = S, n.unix = vv, n.months = bv, n.isDate = p, n.locale = Sn, n.invalid = I, n.duration = fr, n.isMoment = B, n.weekdays = wv, n.parseZone = mv, n.localeData = Gr, n.isDuration = us, n.monthsShort = _v, n.weekdaysMin = xv, n.defineLocale = Qo, n.updateLocale = mp, n.locales = bp, n.weekdaysShort = Sv, n.normalizeUnits = N, n.relativeTimeRounding = Zv, n.relativeTimeThreshold = Jv, n.calendarFormat = y1, n.prototype = P, n.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      // <input type="datetime-local" step="0.001" />
      DATE: "YYYY-MM-DD",
      // <input type="date" />
      TIME: "HH:mm",
      // <input type="time" />
      TIME_SECONDS: "HH:mm:ss",
      // <input type="time" step="1" />
      TIME_MS: "HH:mm:ss.SSS",
      // <input type="time" step="0.001" />
      WEEK: "GGGG-[W]WW",
      // <input type="week" />
      MONTH: "YYYY-MM"
      // <input type="month" />
    }, n;
  });
})(kg);
var M9 = kg.exports;
const P9 = /* @__PURE__ */ yo(M9), oD = ({ value: e }) => /* @__PURE__ */ y.jsx(y.Fragment, { children: P9(e).format("MMM DD, YYYY HH:mm:ss") }), uD = ({
  tabs: e = [],
  variant: r = "default",
  onTabChange: t
}) => {
  let n = { title: "first" };
  Array.isArray(e) && e.length > 0 && (n = e[0]);
  const a = e.find((i) => i.active === !0);
  return typeof a < "u" && (n = a), /* @__PURE__ */ y.jsxs(ps, { defaultValue: n.title, variant: r, onChange: t, children: [
    /* @__PURE__ */ y.jsx(ps.List, { children: e.map((i) => /* @__PURE__ */ y.jsx(
      ps.Tab,
      {
        leftSection: i.icon,
        value: i.title,
        rightSection: i.badgeContent && /* @__PURE__ */ y.jsx(Sl, { color: "blue", children: i.badgeContent }),
        children: i.title
      },
      i.title
    )) }),
    e.map((i) => /* @__PURE__ */ y.jsx(
      ps.Panel,
      {
        value: i.title,
        pt: "xs",
        children: i.component
      },
      i.title
    ))
  ] });
}, A9 = ({
  settings: e
}) => e && e.length > 0 ? /* @__PURE__ */ y.jsx(ee, { children: e.map((r) => /* @__PURE__ */ y.jsxs(Ue, { gap: "sm", children: [
  /* @__PURE__ */ y.jsx(_t, { order: 6, children: r.label }),
  /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(ir, { onClick: r.onClick, size: "lg", children: /* @__PURE__ */ y.jsx(
    Oo,
    {
      size: "1.5em"
    }
  ) }) })
] })) }) : null, R9 = "_container_1tojy_5", I9 = {
  container: R9
}, N9 = ({
  handleFilterByKeyword: e
}) => /* @__PURE__ */ y.jsxs(Ue, { gap: "sm", className: I9.container, children: [
  /* @__PURE__ */ y.jsx(_t, { order: 6, children: "Search" }),
  /* @__PURE__ */ y.jsx(
    Cg,
    {
      handleFilterByKeyword: e
    },
    "search-tool"
  )
] }), L9 = ({
  handleFilterByKeyword: e,
  extraTools: r
}) => {
  const t = [
    /* @__PURE__ */ y.jsx(N9, { handleFilterByKeyword: e })
  ];
  return typeof r < "u" && r.forEach((n) => {
    t.push(n);
  }), /* @__PURE__ */ y.jsx(ee, { gap: "md", grow: !1, children: t.map((n, a) => /* @__PURE__ */ y.jsx(lt, { children: n }, a)) });
}, F9 = ({
  settings: e = [],
  handleFilterByKeyword: r,
  extraTools: t,
  itemsPerPageDropdown: n
}) => /* @__PURE__ */ y.jsxs(ee, { grow: !1, children: [
  /* @__PURE__ */ y.jsx(
    L9,
    {
      handleFilterByKeyword: r,
      extraTools: t
    }
  ),
  /* @__PURE__ */ y.jsxs(ee, { children: [
    n,
    /* @__PURE__ */ y.jsx(A9, { settings: e })
  ] })
] }), $9 = (e, r, t) => [...Array(Math.ceil((r - e) / t) + 1).keys()].map((n) => n === 0 || n === 0 ? e : n * t), Y9 = ({
  min: e = 6,
  max: r = 90,
  step: t = 12,
  itemsPerPageSelected: n = 6,
  onChangeItemsPerPage: a = (i) => {
    console.debug(`default pageSize ${i}`);
  }
}) => {
  const o = $9(e, r, t).map((l) => ({
    label: l.toString(),
    value: l.toString()
  }));
  return /* @__PURE__ */ y.jsx(
    xl,
    {
      styles: { input: { maxWidth: "7em" } },
      data: o,
      value: n == null ? void 0 : n.toString(),
      onChange: a
    }
  );
}, U9 = ({
  min: e = 6,
  max: r = 90,
  step: t = 12,
  limit: n,
  handleItemsPerPageChange: a
}) => /* @__PURE__ */ y.jsxs(Ue, { gap: "sm", children: [
  /* @__PURE__ */ y.jsx(_t, { order: 6, children: "Items Per Page" }),
  /* @__PURE__ */ y.jsx(
    Y9,
    {
      min: e,
      max: r,
      step: t,
      itemsPerPageSelected: n,
      onChangeItemsPerPage: a
    }
  )
] }), lD = ({
  min: e = 6,
  max: r = 90,
  step: t = 12,
  limit: n,
  handleItemsPerPageChange: a,
  settings: i,
  handleFilterByKeyword: o,
  extraTools: l
}) => /* @__PURE__ */ y.jsx(
  F9,
  {
    settings: i,
    handleFilterByKeyword: o,
    extraTools: l,
    itemsPerPageDropdown: /* @__PURE__ */ y.jsx(
      U9,
      {
        min: e,
        max: r,
        step: t,
        limit: n,
        handleItemsPerPageChange: a
      }
    )
  }
), cD = ({
  totalPages: e,
  totalCount: r,
  handlePageChange: t
}) => /* @__PURE__ */ y.jsxs(uo, { cols: 3, children: [
  /* @__PURE__ */ y.jsxs(_t, { order: 5, children: [
    De.get("Total Records"),
    ": ",
    r
  ] }),
  /* @__PURE__ */ y.jsx(jt, { children: /* @__PURE__ */ y.jsx(
    wm,
    {
      onChange: t,
      total: e
    }
  ) }),
  /* @__PURE__ */ y.jsx(lt, {})
] });
export {
  $7 as ActionBar,
  yk as ActionbarMode,
  W7 as AddRowButton,
  C5 as AllRowsSelectionDataCell,
  ik as DashboardWidget,
  ak as DashboardWidgetBuilder,
  Gk as DeleteRecordsConfirmationButton,
  Y7 as DisplayFormikState,
  Lk as ExpandableSectionsLayout,
  Fk as FormPageLayout,
  gk as FormWithActionBar,
  pk as FormWithButtons,
  Yk as IndexPageLayout,
  G7 as ListRowComponent,
  V7 as ListRowsComponent,
  ok as ManageRecordMenu,
  c4 as NextAddButton,
  Mt as NextButton,
  Yl as NextCancelButton,
  $l as NextCloseButton,
  ek as NextCloseButtonIcon,
  f4 as NextCopyButton,
  d4 as NextDeleteButton,
  tk as NextEditButton,
  h4 as NextEllipsisButton,
  rk as NextReloadButton,
  Y0 as NextSaveButton,
  nk as NextSettingsMenuButton,
  y4 as NextSubmitButton,
  qk as NotificationsButton,
  vk as PacFormikCheckbox,
  mk as PacFormikComponentState,
  bk as PacFormikCreatableSelect,
  _k as PacFormikDropdown,
  wk as PacFormikExpandableJsonInput,
  Sk as PacFormikExpandableTextarea,
  xk as PacFormikImageUploadInput,
  z7 as PacFormikInput,
  Tk as PacFormikInputNumberField,
  Ek as PacFormikList,
  Ok as PacFormikPasswordInput,
  Ck as PacFormikRadioCard,
  kk as PacFormikRadioCardGroup,
  Dk as PacFormikRadioGroup,
  jk as PacFormikRadioInput,
  Mk as PacFormikSingleDatePicker,
  Pk as PacFormikSlider,
  Ak as PacFormikSwitch,
  Rk as PacFormikTextarea,
  Ik as PacFormikTransferList,
  zk as PacTableToolbar,
  Wk as PacTableToolbarFilter,
  Bk as PacTableToolbarKeywordFilter,
  Hk as PacTableToolbarPageSizeSelector,
  Vk as PlatformFieldset,
  Kk as PlatformFooter,
  Jk as PlatformHeader,
  Xk as PlatformHeaderProfileButton,
  p9 as PlatformHeaderToolbar,
  Qk as PlatformLoader,
  g9 as PlatformLogo,
  eD as PlatformNavbar,
  tD as PlatformPropertiesCard,
  rD as PlatformPropertiesCardAvatarFormatter,
  nD as PlatformPropertiesCardCopyButtonDecorator,
  iD as PlatformPropertiesCardImageFormatter,
  aD as PlatformPropertiesCardLinkDecorator,
  sD as PlatformPropertiesCardSkeleton,
  oD as PlatformPropertiesCardTimestampFormatter,
  D9 as PlatformPropertiesGrid,
  uD as PlatformTabbedComponent,
  F7 as PrimaryActionBarAction,
  B7 as RemoveRowButton,
  uk as RowSelectionDataCell,
  hg as SecondaryActionBarAction,
  Zk as SettingsButton,
  $k as SimplePageContentWrapper,
  xc as SimplePageHeader,
  yg as SimplePageLayout,
  lD as SimpleTableBatchAction,
  F9 as SimpleTableBatchActionDefault,
  Y9 as SimpleTableItemsPerPageDropdown,
  cD as SimpleTablePagination,
  L9 as SimpleTableToolbar,
  Nk as SubmitFormGroup,
  lk as TableBody,
  j5 as TableBodyCell,
  M5 as TableBodyRow,
  ck as TableHeaderRow,
  fk as TableOptionsModal,
  dk as TableRowActionsDropdown,
  Os as TableRowSkeleton,
  Cg as TableSearchForm,
  hk as TableToolbar,
  sk as TimeOfDayGreeting,
  Uk as TwoColumnsLayout,
  v4 as WidgetActionsToolbar,
  w4 as WidgetBody,
  m4 as WidgetDataPointItem,
  ld as WidgetDataPoints,
  S4 as WidgetFooter,
  T4 as WidgetHeader,
  _4 as WidgetMetricItem,
  cd as WidgetMetrics,
  U0 as WidgetSkeleton,
  N3 as clearRBACDocument,
  km as evaluateAction,
  Cm as evaluatePolicyStatement,
  V9 as evaluateResource,
  U3 as getPermissionStatements,
  F3 as getPermissions,
  J9 as getPolicies,
  Y3 as getPolicyStatementsForUserRole,
  gi as getRBACDocument,
  Q9 as getRoleNames,
  Z9 as getRoles,
  $3 as getRoutes,
  X9 as getStatements,
  L3 as isAllowed,
  q9 as isRouteAllowed,
  I3 as setRBACDocument,
  K9 as updateRBACDocument
};
//# sourceMappingURL=index.es.js.map
